import {
  useMutation,
  useQuery,
  UseMutationOptions,
  UseQueryOptions,
} from 'react-query';
import { fetcher } from '../utils/fetch';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTimeISO: any;
  JSON: any;
};

export type AcceptInvestigationPlanResult = {
  __typename?: 'AcceptInvestigationPlanResult';
  acceptedAt?: Maybe<Scalars['DateTimeISO']>;
  success: Scalars['Boolean'];
};

export enum AccessScope {
  Departments = 'DEPARTMENTS',
  Organization = 'ORGANIZATION',
}

export type AccountInputType = {
  id?: InputMaybe<Scalars['Int']>;
  kind: Scalars['String'];
  user?: InputMaybe<Scalars['Int']>;
  username: Scalars['String'];
};

export type AccountType = {
  __typename?: 'AccountType';
  Roles?: Maybe<Array<RoleType>>;
  failedAttempts: Scalars['Int'];
  id: Scalars['Int'];
  kind: Scalars['String'];
  notificationsEnabled?: Maybe<Scalars['Boolean']>;
  translationEnabled?: Maybe<Scalars['Boolean']>;
  user: Scalars['Int'];
  username: Scalars['String'];
};

export enum ActivityLogAction {
  BulkQuestionsUpdated = 'BULK_QUESTIONS_UPDATED',
  Created = 'CREATED',
  Deleted = 'DELETED',
  Duplicated = 'DUPLICATED',
  Reordered = 'REORDERED',
  StatusChanged = 'STATUS_CHANGED',
  Updated = 'UPDATED',
}

export enum ActivityLogEntityType {
  Question = 'QUESTION',
  Questionnaire = 'QUESTIONNAIRE',
}

export type ActivityLogFormCategory = {
  __typename?: 'ActivityLogFormCategory';
  categoryKey?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
};

export type ActivityLogPaginationType = {
  __typename?: 'ActivityLogPaginationType';
  hasNext?: Maybe<Scalars['Boolean']>;
  hasPrevious?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  totalItems?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type ActivityLogUser = {
  __typename?: 'ActivityLogUser';
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type AnswerValueInputType = {
  dataGridRows?: InputMaybe<Scalars['JSON']>;
  selectedOptionId?: InputMaybe<Scalars['String']>;
  selectedOptionIds?: InputMaybe<Array<Scalars['String']>>;
  text?: InputMaybe<Scalars['String']>;
  textValues?: InputMaybe<Array<Scalars['String']>>;
};

export type AppliedFiltersType = {
  caseLead?: InputMaybe<Scalars['Boolean']>;
  teamMember?: InputMaybe<Scalars['Boolean']>;
};

export type AssignCasePermissionsType = {
  __typename?: 'AssignCasePermissionsType';
  casePermissions: Array<CasePermissionsType>;
  reportPermissions: Array<ReportPermissionsType>;
};

export type AssociatedCasePermissionsType = {
  __typename?: 'AssociatedCasePermissionsType';
  canAdministerCasePermissions?: Maybe<Scalars['Boolean']>;
  canEditCaseClosedDate?: Maybe<Scalars['Boolean']>;
  canEditCaseCriDates?: Maybe<Scalars['Boolean']>;
  canEditCaseDetails?: Maybe<Scalars['Boolean']>;
  canEditCaseWorkspaceTab?: Maybe<Scalars['Boolean']>;
  canViewCase?: Maybe<Scalars['Boolean']>;
  canViewCaseAuditLogsTab?: Maybe<Scalars['Boolean']>;
  canViewCaseDetails?: Maybe<Scalars['Boolean']>;
  canViewCaseDetailsPii?: Maybe<Scalars['Boolean']>;
  canViewCaseWorkspaceTab?: Maybe<Scalars['Boolean']>;
};

export type AssociatedReportPermissionsType = {
  __typename?: 'AssociatedReportPermissionsType';
  canAddNamedOffender?: Maybe<Scalars['Boolean']>;
  canAdministerReportPermissions?: Maybe<Scalars['Boolean']>;
  canEditReportDetails?: Maybe<Scalars['Boolean']>;
  canSendReportMessages?: Maybe<Scalars['Boolean']>;
  canViewReportDetails?: Maybe<Scalars['Boolean']>;
  canViewReportDetailsPii?: Maybe<Scalars['Boolean']>;
  canViewReportMessages?: Maybe<Scalars['Boolean']>;
};

export type AuditEntryType = {
  __typename?: 'AuditEntryType';
  DescriptiveText: Scalars['String'];
  User?: Maybe<UserType>;
  action?: Maybe<Scalars['String']>;
  completed?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTimeISO']>;
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['Float'];
  organisation: Scalars['Float'];
  updatedAt?: Maybe<Scalars['DateTimeISO']>;
  user?: Maybe<Scalars['Float']>;
};

export type AuditEntryTypeDescriptiveTextArgs = {
  case?: InputMaybe<Scalars['String']>;
};

export type BulkCaseCreationItem = {
  caseCategories: Array<Scalars['String']>;
  caseClosedDate?: InputMaybe<Scalars['String']>;
  caseCreatedDate: Scalars['String'];
  caseImportedId?: InputMaybe<Scalars['String']>;
  caseInvestigatingDate: Scalars['String'];
  caseLeadName?: InputMaybe<Scalars['String']>;
  caseLeadUserId?: InputMaybe<Scalars['Float']>;
  caseName?: InputMaybe<Scalars['String']>;
  caseReadDate: Scalars['String'];
  caseStatus: Scalars['String'];
  caseSubmissionDate: Scalars['String'];
  caseSummary?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  dynamicFields?: InputMaybe<Scalars['JSON']>;
  eventDate?: InputMaybe<Scalars['String']>;
  eventDescription: Array<Scalars['String']>;
  eventEmotions?: InputMaybe<Scalars['String']>;
  eventLocation?: InputMaybe<Scalars['String']>;
  eventTime?: InputMaybe<Scalars['String']>;
  eventWitnesses?: InputMaybe<Scalars['String']>;
  isAnonymous: Scalars['String'];
  namedOffenderExternalUsers: Array<Scalars['String']>;
  namedOffenderInternalUsers: Scalars['JSON'];
  originalIntakeMethod?: InputMaybe<Scalars['String']>;
  regionId?: InputMaybe<Scalars['String']>;
  reporterEid?: InputMaybe<Scalars['String']>;
  reporterEmail?: InputMaybe<Scalars['String']>;
  reporterName?: InputMaybe<Scalars['String']>;
  reporterUserId?: InputMaybe<Scalars['Float']>;
  substantiationStatus: Scalars['String'];
};

export type BulkCaseEvidenceItem = {
  caseImportedId: Scalars['String'];
  fileExtension: Scalars['String'];
  filename?: InputMaybe<Scalars['String']>;
  mimeType: Scalars['String'];
  s3path: Scalars['String'];
  size: Scalars['Float'];
};

export type BulkCasesJobCreated = {
  __typename?: 'BulkCasesJobCreated';
  jobId: Scalars['String'];
  totalCases: Scalars['Float'];
};

export type BulkCasesJobStatus = {
  __typename?: 'BulkCasesJobStatus';
  failedCases: Scalars['Float'];
  fileName: Scalars['String'];
  id: Scalars['String'];
  pendingCases: Scalars['Float'];
  percentComplete: Scalars['Float'];
  processedCases: Scalars['Float'];
  status: Scalars['String'];
  successfulCases: Scalars['Float'];
  totalCases: Scalars['Float'];
};

export type BulkCreateNewCases = {
  __typename?: 'BulkCreateNewCases';
  caseCategories: Array<Scalars['String']>;
  caseClosedDate?: Maybe<Scalars['DateTimeISO']>;
  caseCreatedDate: Scalars['DateTimeISO'];
  caseImportedId?: Maybe<Scalars['String']>;
  caseInvestigatingDate: Scalars['DateTimeISO'];
  caseLeadName?: Maybe<Scalars['String']>;
  caseLeadUserId?: Maybe<Scalars['Float']>;
  caseName?: Maybe<Scalars['String']>;
  caseReadDate: Scalars['DateTimeISO'];
  caseStatus: Scalars['String'];
  caseSubmissionDate: Scalars['DateTimeISO'];
  caseSummary?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  countryName?: Maybe<Scalars['String']>;
  dynamicFields?: Maybe<Scalars['JSON']>;
  eventDate?: Maybe<Scalars['String']>;
  eventDescription: Array<Scalars['String']>;
  eventEmotions?: Maybe<Scalars['String']>;
  eventLocation?: Maybe<Scalars['String']>;
  eventTime?: Maybe<Scalars['String']>;
  eventWitnesses?: Maybe<Scalars['String']>;
  isAnonymous: Scalars['String'];
  namedOffenderExternalUsers: Array<Scalars['String']>;
  namedOffenderInternalUsers: Scalars['JSON'];
  originalIntakeMethod?: Maybe<Scalars['String']>;
  regionId?: Maybe<Scalars['String']>;
  regionName?: Maybe<Scalars['String']>;
  reporterEid?: Maybe<Scalars['String']>;
  reporterEmail?: Maybe<Scalars['String']>;
  reporterName?: Maybe<Scalars['String']>;
  reporterUserId?: Maybe<Scalars['Float']>;
  substantiationStatus: Scalars['String'];
};

export type BulkCreateQuestionsResponse = {
  __typename?: 'BulkCreateQuestionsResponse';
  questions: Array<FormManagementQuestion>;
  summary: BulkUpsertQuestionsSummary;
};

export type BulkFileUploadInput = {
  fileExtension: Scalars['String'];
  filename: Scalars['String'];
  filepath: Scalars['String'];
  mimeType: Scalars['String'];
  size: Scalars['Int'];
};

export type BulkImportCases = {
  caseCategories: Array<ImportCaseObjectType>;
  caseClosedDate?: InputMaybe<Scalars['String']>;
  caseCreatedDate?: InputMaybe<Scalars['String']>;
  caseImportedId?: InputMaybe<Scalars['String']>;
  caseInvestigatingDate?: InputMaybe<Scalars['String']>;
  caseLeadEid?: InputMaybe<Scalars['String']>;
  caseLeadEmail?: InputMaybe<Scalars['String']>;
  caseLeadName?: InputMaybe<Scalars['String']>;
  caseName?: InputMaybe<Scalars['String']>;
  caseStatus: Scalars['String'];
  caseSubmissionDate: Scalars['String'];
  caseSummary?: InputMaybe<Scalars['String']>;
  countryName?: InputMaybe<Scalars['String']>;
  eventDate?: InputMaybe<Scalars['String']>;
  eventDescription: Array<ImportCaseObjectType>;
  eventEmotions?: InputMaybe<Scalars['String']>;
  eventLocation?: InputMaybe<Scalars['String']>;
  eventTime?: InputMaybe<Scalars['String']>;
  eventWitnesses?: InputMaybe<Scalars['String']>;
  isAnonymous: Scalars['String'];
  namedOffenderEid?: InputMaybe<Scalars['String']>;
  namedOffenderEmail?: InputMaybe<Scalars['String']>;
  namedOffenderName?: InputMaybe<Scalars['String']>;
  originalIntakeMethod?: InputMaybe<Scalars['String']>;
  regionName?: InputMaybe<Scalars['String']>;
  reporterEid?: InputMaybe<Scalars['String']>;
  reporterEmail?: InputMaybe<Scalars['String']>;
  reporterName?: InputMaybe<Scalars['String']>;
  reporterUserId?: InputMaybe<Scalars['Float']>;
  substantiationStatus: Scalars['String'];
};

export type BulkImportCasesDynamic = {
  caseClosedDate?: InputMaybe<Scalars['String']>;
  caseCreatedDate?: InputMaybe<Scalars['String']>;
  caseImportedId?: InputMaybe<Scalars['String']>;
  caseInvestigatingDate?: InputMaybe<Scalars['String']>;
  caseLeadEid?: InputMaybe<Scalars['String']>;
  caseLeadEmail?: InputMaybe<Scalars['String']>;
  caseLeadName?: InputMaybe<Scalars['String']>;
  caseName?: InputMaybe<Scalars['String']>;
  caseStatus: Scalars['String'];
  caseSubmissionDate: Scalars['String'];
  caseSummary?: InputMaybe<Scalars['String']>;
  countryName?: InputMaybe<Scalars['String']>;
  custom?: InputMaybe<Scalars['JSON']>;
  dynamicFields?: InputMaybe<Scalars['JSON']>;
  isAnonymous: Scalars['String'];
  namedOffenderEid?: InputMaybe<Scalars['String']>;
  namedOffenderEmail?: InputMaybe<Scalars['String']>;
  namedOffenderName?: InputMaybe<Scalars['String']>;
  originalIntakeMethod?: InputMaybe<Scalars['String']>;
  regionName?: InputMaybe<Scalars['String']>;
  reporterEid?: InputMaybe<Scalars['String']>;
  reporterEmail?: InputMaybe<Scalars['String']>;
  reporterName?: InputMaybe<Scalars['String']>;
  reporterUserId?: InputMaybe<Scalars['Float']>;
  substantiationStatus: Scalars['String'];
};

export type BulkReinvite = {
  __typename?: 'BulkReinvite';
  createdUsers: Array<UserType>;
  deactivatedUsers: Array<UserType>;
  reinvitedUsers: Array<UserType>;
  updatedUsers: Array<UserType>;
};

export type BulkReinviteCreateUser = {
  activateUser?: InputMaybe<Scalars['Boolean']>;
  country: Scalars['String'];
  department: Scalars['String'];
  eid: Scalars['String'];
  email: Scalars['String'];
  name: Scalars['String'];
  role: Scalars['String'];
  site: Scalars['String'];
  terminationDate?: InputMaybe<Scalars['String']>;
};

export type BulkReinviteExistingUser = {
  __typename?: 'BulkReinviteExistingUser';
  country?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  eid?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  site?: Maybe<Scalars['String']>;
  terminationDate?: Maybe<Scalars['String']>;
};

export type BulkReinviteNewUser = {
  __typename?: 'BulkReinviteNewUser';
  country: Scalars['String'];
  department: Scalars['String'];
  eid: Scalars['String'];
  email: Scalars['String'];
  name: Scalars['String'];
  role: Scalars['String'];
  site: Scalars['String'];
  terminationDate?: Maybe<Scalars['String']>;
};

export type BulkReinviteUpdateUser = {
  country?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  eid?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  name?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<Scalars['String']>;
  terminationDate?: InputMaybe<Scalars['String']>;
};

export type BulkUploadResult = {
  __typename?: 'BulkUploadResult';
  errors: Array<Scalars['String']>;
  failedFiles: Scalars['Int'];
  message?: Maybe<Scalars['String']>;
  processedFolders: Array<FolderProcessingResult>;
  success: Scalars['Boolean'];
  successfulFiles: Scalars['Int'];
  totalFiles: Scalars['Int'];
};

export type BulkUpsertQuestionsInput = {
  questions: Array<CreateQuestionInput>;
};

export type BulkUpsertQuestionsSummary = {
  __typename?: 'BulkUpsertQuestionsSummary';
  created: Scalars['Int'];
  deleted: Scalars['Int'];
  total: Scalars['Int'];
  updated: Scalars['Int'];
};

export type CallRecordingUrlType = {
  __typename?: 'CallRecordingUrlType';
  dataDeletedAt?: Maybe<Scalars['DateTimeISO']>;
  step: CallStep;
  url: Scalars['String'];
};

export enum CallStep {
  Date = 'DATE',
  Description = 'DESCRIPTION',
  Emotion = 'EMOTION',
  Location = 'LOCATION',
  Name = 'NAME',
  Perpetrator = 'PERPETRATOR',
  Question = 'QUESTION',
  Time = 'TIME',
  Witness = 'WITNESS',
}

export type CaseAttributesType = {
  __typename?: 'CaseAttributesType';
  case: Scalars['String'];
  closedAt?: Maybe<Scalars['DateTimeISO']>;
  companyCreatedAt?: Maybe<Scalars['DateTimeISO']>;
  countryCode?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTimeISO'];
  investigatingAt?: Maybe<Scalars['DateTimeISO']>;
  overdueMitigationAt?: Maybe<Scalars['DateTimeISO']>;
  pendingMitigationAt?: Maybe<Scalars['DateTimeISO']>;
  readAt?: Maybe<Scalars['DateTimeISO']>;
  regionId?: Maybe<Scalars['String']>;
  underReviewAt?: Maybe<Scalars['DateTimeISO']>;
  updatedAt: Scalars['DateTimeISO'];
};

export type CaseCountryRegionType = {
  __typename?: 'CaseCountryRegionType';
  country?: Maybe<CountryType>;
  region?: Maybe<RegionType>;
};

export type CaseCustomFieldOptionType = {
  __typename?: 'CaseCustomFieldOptionType';
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  label: Scalars['String'];
};

export type CaseCustomFieldValueType = {
  __typename?: 'CaseCustomFieldValueType';
  customFieldId: Scalars['String'];
  displayOrder: Scalars['Int'];
  fieldType: Scalars['String'];
  identifier: Scalars['String'];
  label: Scalars['String'];
  optionId?: Maybe<Scalars['String']>;
  options: Array<CaseCustomFieldOptionType>;
  sectionId?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  valueText?: Maybe<Scalars['String']>;
};

export type CaseDocumentationType = {
  __typename?: 'CaseDocumentationType';
  Author: UserType;
  Uploads?: Maybe<Array<CaseDocumentationUploadType>>;
  deleted: Scalars['Boolean'];
  firstCreated: Scalars['DateTimeISO'];
  id: Scalars['String'];
  lastEdited: Scalars['DateTimeISO'];
  mimeType?: Maybe<Scalars['String']>;
  s3path?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: Scalars['Float'];
  value?: Maybe<Scalars['String']>;
  version: Scalars['Float'];
};

export type CaseDocumentationUploadType = {
  __typename?: 'CaseDocumentationUploadType';
  createdAt?: Maybe<Scalars['DateTimeISO']>;
  dataDeletedAt?: Maybe<Scalars['DateTimeISO']>;
  dataDeletedBy?: Maybe<Scalars['Int']>;
  filename?: Maybe<Scalars['String']>;
  mimeType?: Maybe<Scalars['String']>;
  s3path: Scalars['String'];
  scanStatus?: Maybe<Scalars['String']>;
  scannedAt?: Maybe<Scalars['DateTimeISO']>;
  size: Scalars['Float'];
  updatedAt?: Maybe<Scalars['DateTimeISO']>;
  uploadSource?: Maybe<UploadSource>;
};

export type CaseImporterJobDetails = {
  __typename?: 'CaseImporterJobDetails';
  failedCases: Array<CaseImporterJobDetailsItem>;
  importedCases: Array<CaseImporterJobDetailsItem>;
};

export type CaseImporterJobDetailsItem = {
  __typename?: 'CaseImporterJobDetailsItem';
  error?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  importedId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  readableId?: Maybe<Scalars['String']>;
};

export type CaseImporterJobHistoryItem = {
  __typename?: 'CaseImporterJobHistoryItem';
  createdAt: Scalars['DateTimeISO'];
  createdByName?: Maybe<Scalars['String']>;
  failedCases: Scalars['Float'];
  id: Scalars['String'];
  importFileName: Scalars['String'];
  status: Scalars['String'];
  successfulCases: Scalars['Float'];
  totalCases: Scalars['Float'];
  updatedAt: Scalars['DateTimeISO'];
};

export type CaseImporterJobHistoryResponse = {
  __typename?: 'CaseImporterJobHistoryResponse';
  jobs: Array<CaseImporterJobHistoryItem>;
  total: Scalars['Float'];
};

export type CaseLinkDataType = {
  __typename?: 'CaseLinkDataType';
  CreatedByUser?: Maybe<UserType>;
  SourceCase?: Maybe<CaseType>;
  TargetCase?: Maybe<CaseType>;
  createdAt: Scalars['DateTimeISO'];
  createdBy: Scalars['Int'];
  id: Scalars['String'];
  linkType: CaseLinkType;
  notes?: Maybe<Scalars['String']>;
  organisation: Scalars['Int'];
  sourceCaseId: Scalars['String'];
  targetCaseId: Scalars['String'];
  updatedAt: Scalars['DateTimeISO'];
};

export type CaseLinkDataTypeCreatedByUserArgs = {
  viewedCaseId: Scalars['String'];
};

export enum CaseLinkType {
  Duplicate = 'DUPLICATE',
  Related = 'RELATED',
  SameIncident = 'SAME_INCIDENT',
  SameLocation = 'SAME_LOCATION',
  SameOffender = 'SAME_OFFENDER',
  SeriesOverTime = 'SERIES_OVER_TIME',
}

export type CaseMetricsType = {
  __typename?: 'CaseMetricsType';
  caseLeadCount: Scalars['Int'];
  teamMemberCount: Scalars['Int'];
  waitingForResponseCount: Scalars['Int'];
};

export type CasePermissionsType = {
  __typename?: 'CasePermissionsType';
  account: Scalars['Int'];
  case: Scalars['String'];
  createdAt: Scalars['DateTimeISO'];
  id: Scalars['Int'];
  organisation: Scalars['Int'];
  permission: Scalars['String'];
  updatedAt: Scalars['DateTimeISO'];
};

export type CaseRetentionQueueType = {
  __typename?: 'CaseRetentionQueueType';
  Case?: Maybe<CaseType>;
  RetentionRule?: Maybe<RetentionRuleType>;
  caseId: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTimeISO']>;
  createdAt: Scalars['DateTimeISO'];
  dueAt: Scalars['DateTimeISO'];
  id: Scalars['String'];
  retentionApproved: Scalars['Boolean'];
  ruleId: Scalars['String'];
  status: RetentionQueueStatusEnum;
  updatedAt: Scalars['DateTimeISO'];
};

export type CaseTeamMemberType = {
  __typename?: 'CaseTeamMemberType';
  Accounts?: Maybe<Array<AccountType>>;
  Manager?: Maybe<UserType>;
  Note?: Maybe<CaseTeamNoteType>;
  Organisation?: Maybe<OrganisationType>;
  Reportees?: Maybe<Array<UserType>>;
  Roles?: Maybe<Array<Scalars['String']>>;
  SystemRoles?: Maybe<Array<OrganisationRoleType>>;
  accounts?: Maybe<Array<AccountType>>;
  available?: Maybe<Scalars['Boolean']>;
  caseId: Scalars['String'];
  contactEmail?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  eid?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  firstAccessedAt?: Maybe<Scalars['DateTimeISO']>;
  givenName?: Maybe<Scalars['String']>;
  id: Scalars['Float'];
  invitedAt: Scalars['DateTimeISO'];
  managerId?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  organisation?: Maybe<Scalars['Float']>;
  permissions?: Maybe<Array<Scalars['String']>>;
  relationshipToCompany?: Maybe<Scalars['Float']>;
  relationshipToOrganisation?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  site?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  tags?: Maybe<Array<Scalars['String']>>;
  translationEnabled?: Maybe<Scalars['Boolean']>;
  uuid?: Maybe<Scalars['String']>;
};

export type CaseTeamNoteType = {
  __typename?: 'CaseTeamNoteType';
  caseId: Scalars['String'];
  createdAt: Scalars['DateTimeISO'];
  id: Scalars['String'];
  inviteeUserId: Scalars['Float'];
  inviterUser?: Maybe<UserType>;
  inviterUserId: Scalars['Float'];
  readAt?: Maybe<Scalars['DateTimeISO']>;
  value: Scalars['String'];
  version: Scalars['Float'];
};

export type CaseTeamPermissionType = {
  __typename?: 'CaseTeamPermissionType';
  kind: Scalars['String'];
  permissions?: Maybe<Scalars['JSON']>;
  username: Scalars['String'];
};

export type CaseType = {
  __typename?: 'CaseType';
  AllCaseLeads?: Maybe<Array<UserType>>;
  AllCaseTeamMembers?: Maybe<Array<UserType>>;
  AssociatedPermissions?: Maybe<AssociatedCasePermissionsType>;
  CaseAttributes?: Maybe<CaseAttributesType>;
  CaseCountryRegion?: Maybe<CaseCountryRegionType>;
  CaseCustomFieldValues: Array<CaseCustomFieldValueType>;
  CaseDocuments?: Maybe<Array<CaseDocumentationType>>;
  CaseLead?: Maybe<UserType>;
  CaseTags: Array<TagType>;
  CaseTeam: Array<CaseTeamMemberType>;
  Categories: Array<CategoryDisplayType>;
  DisclosuresCaseData?: Maybe<DisclosuresCaseDataType>;
  Reports?: Maybe<Array<ReportType>>;
  caseLinksCount?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTimeISO']>;
  deletedAt?: Maybe<Scalars['DateTimeISO']>;
  description?: Maybe<Scalars['String']>;
  descriptionUpdatedAt?: Maybe<Scalars['DateTimeISO']>;
  hasDynamicQuestions?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  importedId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  organisation: Scalars['Float'];
  readableId: Scalars['String'];
  sanitizedAt?: Maybe<Scalars['DateTimeISO']>;
  status: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTimeISO']>;
};

export type CasesOverTimeDataType = {
  __typename?: 'CasesOverTimeDataType';
  bar: Scalars['String'];
  closed: Scalars['Float'];
  open: Scalars['Float'];
  total: Scalars['Float'];
};

export type CasesOverTimeType = {
  __typename?: 'CasesOverTimeType';
  data: Array<CasesOverTimeDataType>;
  stackLabels: Array<Scalars['String']>;
  xTitle: Scalars['String'];
  yTitle: Scalars['String'];
};

export enum CategoryConfigurationStatus {
  Active = 'active',
  FormRequired = 'form_required',
  Inactive = 'inactive',
}

export type CategoryDisplayType = {
  __typename?: 'CategoryDisplayType';
  allowGoTogether: Scalars['Boolean'];
  body: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  order: Scalars['Float'];
  question: Scalars['Boolean'];
  requestOpenPerpetrators?: Maybe<Scalars['Boolean']>;
  title: Scalars['String'];
};

export type CategoryOrderType = {
  __typename?: 'CategoryOrderType';
  id: Scalars['String'];
  order: Scalars['Float'];
};

export type CategoryType = {
  __typename?: 'CategoryType';
  Author?: Maybe<UserType>;
  allowGoTogether: Scalars['Boolean'];
  author?: Maybe<Scalars['Float']>;
  createdAt: Scalars['DateTimeISO'];
  displayInApp: Scalars['Boolean'];
  displayInCollaborationToolIntegration: Scalars['Boolean'];
  displayInManualIntake: Scalars['Boolean'];
  displayInOpenReporting: Scalars['Boolean'];
  displayInVaultTalk: Scalars['Boolean'];
  hasActiveLinkedForm?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  isCOI: Scalars['Boolean'];
  isCustomQuestions: Scalars['Boolean'];
  isDeterminedCategory: Scalars['Boolean'];
  isReportedCategory: Scalars['Boolean'];
  issueTypeId?: Maybe<Scalars['Float']>;
  locales: Scalars['JSON'];
  order: Scalars['Float'];
  organisation: Scalars['Float'];
  question: Scalars['Boolean'];
  requestOpenPerpetrators: Scalars['Boolean'];
  status: CategoryConfigurationStatus;
  submissionTypeId?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['DateTimeISO'];
};

export enum CoiCaseStatus {
  AutoClosed = 'AUTO_CLOSED',
  Closed = 'CLOSED',
  New = 'NEW',
  OverdueMitigation = 'OVERDUE_MITIGATION',
  PendingMitigation = 'PENDING_MITIGATION',
  UnderReview = 'UNDER_REVIEW',
}

export type CoiFilterOptionType = {
  __typename?: 'CoiFilterOptionType';
  label: Scalars['String'];
  value: Scalars['String'];
};

export type CoiFilterOptionsType = {
  __typename?: 'CoiFilterOptionsType';
  categories: Array<CoiFilterOptionType>;
  formTitles: Array<CoiFilterOptionType>;
  reviewers: Array<CoiFilterOptionType>;
  statuses: Array<CoiFilterOptionType>;
};

export type ColumnMappingInput = {
  custom_column_name?: InputMaybe<Scalars['String']>;
  is_custom?: InputMaybe<Scalars['Boolean']>;
  is_multi_mappable?: InputMaybe<Scalars['Boolean']>;
  is_unmapped?: InputMaybe<Scalars['Boolean']>;
  sheet_column_name: Scalars['String'];
  template_column_key?: InputMaybe<Scalars['String']>;
  template_column_name?: InputMaybe<Scalars['String']>;
};

export type CountryInputType = {
  countryCode: Scalars['String'];
  countryName?: InputMaybe<Scalars['String']>;
};

export enum CountryRuleEnum {
  Case = 'CASE',
  Offender = 'OFFENDER',
  Reporter = 'REPORTER',
}

export type CountryType = {
  __typename?: 'CountryType';
  code: Scalars['String'];
  name: Scalars['String'];
};

export type CreateCaseLinkInput = {
  linkType: CaseLinkType;
  notes?: InputMaybe<Scalars['String']>;
  sourceCaseId: Scalars['String'];
  targetCaseId: Scalars['String'];
};

export type CreateCategoryType = {
  allowGoTogether: Scalars['Boolean'];
  displayInApp: Scalars['Boolean'];
  displayInCollaborationToolIntegration: Scalars['Boolean'];
  displayInManualIntake: Scalars['Boolean'];
  displayInOpenReporting: Scalars['Boolean'];
  displayInVaultTalk: Scalars['Boolean'];
  isCOI: Scalars['Boolean'];
  isCustomQuestions?: InputMaybe<Scalars['Boolean']>;
  isDeterminedCategory: Scalars['Boolean'];
  isReportedCategory: Scalars['Boolean'];
  locales: Scalars['JSON'];
  order: Scalars['Float'];
  question: Scalars['Boolean'];
  requestOpenPerpetrators: Scalars['Boolean'];
};

export type CreateCustomFieldInputType = {
  description?: InputMaybe<Scalars['String']>;
  fieldType: Scalars['String'];
  identifier?: InputMaybe<Scalars['String']>;
  label: Scalars['String'];
  options?: InputMaybe<Array<Scalars['String']>>;
  sectionId?: InputMaybe<Scalars['String']>;
};

export type CreateCustomFieldSectionInputType = {
  description?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
};

export type CreateDraftReportResponseType = {
  __typename?: 'CreateDraftReportResponseType';
  caseId: Scalars['String'];
  report: DraftReportData;
};

export type CreateMitigationPlanInput = {
  caseId: Scalars['String'];
  deadline: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  noApprovalRequired?: InputMaybe<Scalars['Boolean']>;
  reminderFrequency: Scalars['Int'];
  reminderMaxCount?: InputMaybe<Scalars['Int']>;
  signatoryUserIds?: InputMaybe<Array<Scalars['Int']>>;
  title: Scalars['String'];
  uploadIds?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateQuestionInput = {
  allowMultiSelect?: InputMaybe<Scalars['Boolean']>;
  attachmentAllowed: Scalars['Boolean'];
  dataGridConfig?: InputMaybe<DataGridConfigInput>;
  databaseFieldSubTypeId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  interestTypeId?: InputMaybe<Scalars['String']>;
  isRequired: Scalars['Boolean'];
  options?: InputMaybe<Array<QuestionOptionInput>>;
  questionText: Scalars['String'];
  questionType: QuestionTypeKey;
  shouldAutoFlagIfAnswered?: InputMaybe<Scalars['Boolean']>;
  translations?: InputMaybe<Array<QuestionTranslationInput>>;
};

export type CreateQuestionnaireInput = {
  accessScope: AccessScope;
  autoReviewEnabled?: InputMaybe<Scalars['Boolean']>;
  category: Scalars['String'];
  categoryId?: InputMaybe<Scalars['Int']>;
  countries?: InputMaybe<Array<CountryInputType>>;
  description?: InputMaybe<Scalars['String']>;
  formCategoryId: Scalars['String'];
  internalName: Scalars['String'];
  introduction?: InputMaybe<Scalars['String']>;
  languages?: InputMaybe<Array<LanguageInputType>>;
  publicTitle: Scalars['String'];
  status?: InputMaybe<QuestionnaireStatus>;
  targetDepartmentIds?: InputMaybe<Array<Scalars['String']>>;
  translations?: InputMaybe<Array<QuestionnaireTranslationInputType>>;
};

export type CreateQuestionnaireResponsePayload = {
  __typename?: 'CreateQuestionnaireResponsePayload';
  responseId: Scalars['String'];
};

export type CreateRetentionRuleInput = {
  conditions: Scalars['JSON'];
  country?: InputMaybe<Scalars['String']>;
  countryRule?: InputMaybe<CountryRuleEnum>;
  dateReference: DateReferenceEnum;
  fallbackRule?: Scalars['Boolean'];
  requiresManualApproval?: Scalars['Boolean'];
  ruleApproved?: Scalars['Boolean'];
  ruleType?: InputMaybe<RuleTypeEnum>;
};

export type CreateRoutingRule = {
  destinationGroup?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  groupAssignment?: Scalars['Boolean'];
  isCOI?: Scalars['Boolean'];
  name: Scalars['String'];
  priority?: Scalars['Float'];
  rule: Scalars['JSON'];
};

export type CreateTagType = {
  name: Scalars['String'];
  type: Scalars['String'];
};

export type CreatedByType = {
  __typename?: 'CreatedByType';
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type CustomFieldAuthorType = {
  __typename?: 'CustomFieldAuthorType';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type CustomFieldOptionInputType = {
  id?: InputMaybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  label: Scalars['String'];
};

export type CustomFieldOptionType = {
  __typename?: 'CustomFieldOptionType';
  createdAt: Scalars['DateTimeISO'];
  customFieldId: Scalars['String'];
  displayOrder: Scalars['Int'];
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  label: Scalars['String'];
  updatedAt: Scalars['DateTimeISO'];
};

export type CustomFieldOrderInputType = {
  displayOrder: Scalars['Int'];
  id: Scalars['String'];
};

export type CustomFieldOrderType = {
  __typename?: 'CustomFieldOrderType';
  displayOrder: Scalars['Int'];
  id: Scalars['String'];
};

export type CustomFieldSectionOrderInputType = {
  displayOrder: Scalars['Int'];
  id: Scalars['String'];
};

export type CustomFieldSectionType = {
  __typename?: 'CustomFieldSectionType';
  createdAt: Scalars['DateTimeISO'];
  description?: Maybe<Scalars['String']>;
  displayOrder: Scalars['Int'];
  fieldCount: Scalars['Int'];
  fields?: Maybe<Array<SectionFieldType>>;
  id: Scalars['String'];
  isDefault: Scalars['Boolean'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTimeISO'];
};

export type CustomFieldSectionsResponseType = {
  __typename?: 'CustomFieldSectionsResponseType';
  sections: Array<CustomFieldSectionType>;
};

export type CustomFieldType = {
  __typename?: 'CustomFieldType';
  author?: Maybe<CustomFieldAuthorType>;
  createdAt: Scalars['DateTimeISO'];
  description?: Maybe<Scalars['String']>;
  displayOrder: Scalars['Int'];
  fieldType: Scalars['String'];
  id: Scalars['String'];
  identifier: Scalars['String'];
  isStandard: Scalars['Boolean'];
  label: Scalars['String'];
  optionDetails?: Maybe<Array<CustomFieldOptionType>>;
  options: Array<Scalars['String']>;
  sectionId?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  updatedAt: Scalars['DateTimeISO'];
};

export type CustomFieldsResponseType = {
  __typename?: 'CustomFieldsResponseType';
  customFields: Array<CustomFieldType>;
  total: Scalars['Int'];
};

export type DataDeletionType = {
  anonymiseReporter: Scalars['Boolean'];
  auditLogs: Array<Scalars['Int']>;
  caseDocumentNotePayload: Array<TextRange>;
  description: Array<TextRange>;
  emotion: Array<TextRange>;
  eventDeletions?: InputMaybe<Array<EventDeletionType>>;
  externalNamedOffenders: Array<TextRange>;
  location: Array<TextRange>;
  messages: Array<Scalars['String']>;
  postExternalNamedOffendersIds: Array<Scalars['String']>;
  postInternalNamedOffendersIds: Array<Scalars['String']>;
  postSubmissionS3Paths: Array<Scalars['String']>;
  preExternalNamedOffendersIds: Array<Scalars['String']>;
  preInternalNamedOffendersIds: Array<Scalars['String']>;
  preSubmissionS3Paths: Array<Scalars['String']>;
  reporterId: Scalars['Float'];
  reporterNotes: Array<TextRange>;
  tags: Array<Scalars['String']>;
  witnesses: Array<TextRange>;
};

export type DataGridColumnInput = {
  key: Scalars['String'];
  label: Scalars['String'];
  max?: InputMaybe<Scalars['Float']>;
  maxLength?: InputMaybe<Scalars['Int']>;
  min?: InputMaybe<Scalars['Float']>;
  options?: InputMaybe<Array<Scalars['String']>>;
  required?: InputMaybe<Scalars['Boolean']>;
  translations?: InputMaybe<Array<DataGridColumnTranslationInput>>;
  type: Scalars['String'];
};

export type DataGridColumnTranslationInput = {
  label: Scalars['String'];
  languageCode: Scalars['String'];
};

export type DataGridColumnTranslationType = {
  __typename?: 'DataGridColumnTranslationType';
  label?: Maybe<Scalars['String']>;
  languageCode?: Maybe<Scalars['String']>;
};

export type DataGridColumnType = {
  __typename?: 'DataGridColumnType';
  key: Scalars['String'];
  label: Scalars['String'];
  max?: Maybe<Scalars['Float']>;
  maxLength?: Maybe<Scalars['Int']>;
  min?: Maybe<Scalars['Float']>;
  options?: Maybe<Array<Scalars['String']>>;
  required?: Maybe<Scalars['Boolean']>;
  translations?: Maybe<Array<DataGridColumnTranslationType>>;
  type: Scalars['String'];
};

export type DataGridConfigInput = {
  addRowLabel?: InputMaybe<Scalars['String']>;
  columns: Array<DataGridColumnInput>;
  maxRows?: InputMaybe<Scalars['Int']>;
  minRows?: InputMaybe<Scalars['Int']>;
  removeRowLabel?: InputMaybe<Scalars['String']>;
};

export type DataGridConfigType = {
  __typename?: 'DataGridConfigType';
  addRowLabel?: Maybe<Scalars['String']>;
  columns: Array<DataGridColumnType>;
  maxRows?: Maybe<Scalars['Int']>;
  minRows?: Maybe<Scalars['Int']>;
  removeRowLabel?: Maybe<Scalars['String']>;
};

export enum DateReferenceEnum {
  CaseClosure = 'CASE_CLOSURE',
  CaseCreation = 'CASE_CREATION',
  CaseLastUpdate = 'CASE_LAST_UPDATE',
  CaseSubmission = 'CASE_SUBMISSION',
  CaseUnsubstantiation = 'CASE_UNSUBSTANTIATION',
  Immediate = 'IMMEDIATE',
}

export type DeactivateCustomFieldInputType = {
  id: Scalars['String'];
};

export type DeclineRetentionRuleInput = {
  id: Scalars['String'];
};

export type DecryptedEvidenceType = {
  __typename?: 'DecryptedEvidenceType';
  Events?: Maybe<Array<ParsedEventsType>>;
  category: Scalars['String'];
  evidence: EvidenceType;
  perpetrators?: Maybe<PerpetratorType>;
  relationshipToCompany?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
  user?: Maybe<Scalars['String']>;
};

export type DeleteCustomFieldSectionInputType = {
  id: Scalars['String'];
};

export type DeleteCustomFieldSectionResponseType = {
  __typename?: 'DeleteCustomFieldSectionResponseType';
  deleted: Scalars['Boolean'];
  id: Scalars['String'];
};

export type DeleteSessionResponse = {
  __typename?: 'DeleteSessionResponse';
  d1pLogoutUrl?: Maybe<Scalars['String']>;
};

export type DisclosureAnswerType = {
  __typename?: 'DisclosureAnswerType';
  createdAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  questionId?: Maybe<Scalars['String']>;
  questionText?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['JSON']>;
};

export type DisclosureAuditEntryType = {
  __typename?: 'DisclosureAuditEntryType';
  createdAt?: Maybe<Scalars['String']>;
  eventDetails?: Maybe<Scalars['JSON']>;
  eventType?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  user?: Maybe<DisclosureAuditUserType>;
};

export type DisclosureAuditPaginationType = {
  __typename?: 'DisclosureAuditPaginationType';
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  totalItems?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type DisclosureAuditType = {
  __typename?: 'DisclosureAuditType';
  entries?: Maybe<Array<DisclosureAuditEntryType>>;
  pagination?: Maybe<DisclosureAuditPaginationType>;
};

export type DisclosureAuditUserType = {
  __typename?: 'DisclosureAuditUserType';
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type DisclosureResponseType = {
  __typename?: 'DisclosureResponseType';
  answers?: Maybe<Array<DisclosureAnswerType>>;
  attestationAccepted?: Maybe<Scalars['Boolean']>;
  attestationAcceptedAt?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isFlagged?: Maybe<Scalars['Boolean']>;
  organizationId?: Maybe<Scalars['String']>;
  questionnaire?: Maybe<QuestionnaireType>;
  questionnaireId?: Maybe<Scalars['String']>;
  reporter?: Maybe<UserType>;
  respondent?: Maybe<RespondentType>;
  status?: Maybe<Scalars['String']>;
  submittedAt?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type DisclosuresCaseDataType = {
  __typename?: 'DisclosuresCaseDataType';
  caseId: Scalars['String'];
  createdAt: Scalars['DateTimeISO'];
  flags: Scalars['Float'];
  id: Scalars['String'];
  importType: Scalars['String'];
  organisation: Scalars['Float'];
  questionnaireId: Scalars['String'];
  reporterD1pId: Scalars['String'];
  responseId: Scalars['String'];
  updatedAt: Scalars['DateTimeISO'];
};

export type DocumentationInput = {
  filename: Scalars['String'];
  mimeType: Scalars['String'];
  s3path: Scalars['String'];
  size: Scalars['Float'];
};

export type DonutAndBarChartCategoryDataType = {
  __typename?: 'DonutAndBarChartCategoryDataType';
  category: Scalars['String'];
  total: Scalars['Float'];
};

export type DonutAndBarChartDataType = {
  __typename?: 'DonutAndBarChartDataType';
  categories: Array<DonutAndBarChartCategoryDataType>;
  donutSegment: Scalars['String'];
  total: Scalars['Float'];
};

export type DonutAndBarChartType = {
  __typename?: 'DonutAndBarChartType';
  centerText: Scalars['String'];
  data: Array<DonutAndBarChartDataType>;
  maxCategoryTotal: Scalars['Float'];
  xTitle: Scalars['String'];
  yTitle: Scalars['String'];
};

export type DraftReportData = {
  __typename?: 'DraftReportData';
  Assignee?: Maybe<UserType>;
  AssociatedPermissions?: Maybe<AssociatedReportPermissionsType>;
  AudioRecordings: Array<CallRecordingUrlType>;
  DeterminedCategory?: Maybe<CategoryDisplayType>;
  Evidence?: Maybe<DecryptedEvidenceType>;
  Perpetrators?: Maybe<Array<UserType>>;
  PhoneLineType?: Maybe<Scalars['String']>;
  ReportEvents: Array<ReportEventType>;
  ReportNotes?: Maybe<ReportNotesType>;
  ReportedCategory?: Maybe<CategoryDisplayType>;
  Reporter?: Maybe<UserType>;
  anonymous?: Maybe<Scalars['Boolean']>;
  assignee: Scalars['Float'];
  category: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTimeISO']>;
  determinedCategory?: Maybe<Scalars['Float']>;
  dominantLanguage: Scalars['String'];
  existingReport: Scalars['Boolean'];
  id: Scalars['String'];
  miReportSource?: Maybe<Scalars['String']>;
  postSubmissionFiles?: Maybe<Array<UploadType>>;
  readableId?: Maybe<Scalars['String']>;
  report: Scalars['String'];
  reportedCategory?: Maybe<Scalars['Float']>;
  reporter?: Maybe<Scalars['String']>;
  reporterExists: Scalars['Boolean'];
  source: Scalars['String'];
  status: Scalars['String'];
  submissionMode?: Maybe<Scalars['Int']>;
  submittedAt?: Maybe<Scalars['DateTimeISO']>;
  substantiation?: Maybe<Scalars['String']>;
  unreadMessagesCount?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['DateTimeISO'];
};

export type DraftReportDataEvidenceArgs = {
  translation?: InputMaybe<Scalars['String']>;
};

export type DuplicateCaseType = {
  __typename?: 'DuplicateCaseType';
  CaseAttribute: CaseAttributesType;
  id: Scalars['String'];
  importedId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  status?: Maybe<ReportStatus>;
};

export enum DuplicateLanguagesMode {
  All = 'ALL',
  Default = 'DEFAULT',
}

export type DuplicateQuestionnaireInput = {
  accessScope?: InputMaybe<AccessScope>;
  description?: InputMaybe<Scalars['String']>;
  duplicateLanguages?: InputMaybe<DuplicateLanguagesMode>;
  internalName: Scalars['String'];
  introduction?: InputMaybe<Scalars['String']>;
  publicTitle?: InputMaybe<Scalars['String']>;
  signatureSection?: InputMaybe<SignatureSectionInput>;
  targetDepartmentIds?: InputMaybe<Array<Scalars['String']>>;
};

export type EventDataInput = {
  answer?: InputMaybe<Scalars['String']>;
  callRecordingId?: InputMaybe<Scalars['String']>;
  dataDeletedAt?: InputMaybe<Scalars['DateTimeISO']>;
  dataDeletedBy?: InputMaybe<Scalars['String']>;
  event: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  question: Scalars['String'];
  questionAnswerId: Scalars['String'];
  submittedVersion?: InputMaybe<Scalars['Int']>;
  version?: InputMaybe<Scalars['Int']>;
};

export type EventDataType = {
  __typename?: 'EventDataType';
  Question: Array<QuestionType>;
  answer?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTimeISO'];
  dataDeletedAt?: Maybe<Scalars['DateTimeISO']>;
  dataDeletedBy?: Maybe<Scalars['String']>;
  event: Scalars['String'];
  id: Scalars['String'];
  order?: Maybe<Scalars['String']>;
  organisation: Scalars['Float'];
  question: Scalars['String'];
  questionAnswerId: Scalars['String'];
  submittedVersion?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTimeISO'];
  version?: Maybe<Scalars['String']>;
};

export type EventDeletionType = {
  description: Array<TextRange>;
  emotion: Array<TextRange>;
  eventId: Scalars['String'];
  externalNamedOffenders?: InputMaybe<Array<TextRange>>;
  location: Array<TextRange>;
  preSubmissionS3Paths: Array<Scalars['String']>;
  witnesses: Array<TextRange>;
};

export type EventMediaInput = {
  event: Scalars['String'];
  fileExtension: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  mimeType: Scalars['String'];
  question: Scalars['String'];
  s3path: Scalars['String'];
  scanStatus: Scalars['String'];
  size: Scalars['Int'];
  toDelete?: Scalars['Boolean'];
  type: Scalars['String'];
  uploadSource: Scalars['String'];
};

export type EventMediaType = {
  __typename?: 'EventMediaType';
  Media: Array<MediaType>;
  Question: Array<QuestionType>;
  createdAt: Scalars['DateTimeISO'];
  event: Scalars['String'];
  id: Scalars['String'];
  media: Scalars['String'];
  organisation: Scalars['Float'];
  question: Scalars['String'];
  updatedAt: Scalars['DateTimeISO'];
};

export type EventNamedOffenderExternalInput = {
  callRecordingId?: InputMaybe<Scalars['String']>;
  event: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  originalId?: InputMaybe<Scalars['String']>;
  postSubmission?: InputMaybe<Scalars['Boolean']>;
  toDelete?: Scalars['Boolean'];
};

export type EventNamedOffenderInternalInput = {
  event: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  linkedPresubmissionOffender?: InputMaybe<Scalars['String']>;
  postSubmission?: InputMaybe<Scalars['Boolean']>;
  toDelete?: Scalars['Boolean'];
  user: Scalars['Int'];
};

export type EventsEntityType = {
  __typename?: 'EventsEntityType';
  created: Scalars['String'];
  id: Scalars['String'];
  report: Scalars['String'];
  timestamp?: Maybe<Scalars['String']>;
  updated: Scalars['String'];
};

export type EvidenceEntityType = {
  __typename?: 'EvidenceEntityType';
  created: Scalars['String'];
  event: Scalars['String'];
  id: Scalars['String'];
  report: Scalars['String'];
  timestamp: Scalars['String'];
  type: Scalars['String'];
  updated: Scalars['String'];
  value: Scalars['JSON'];
};

export type EvidenceType = {
  __typename?: 'EvidenceType';
  events?: Maybe<Array<EventsEntityType>>;
  evidence?: Maybe<Array<EvidenceEntityType>>;
  report: ReportCategoryObjectType;
};

export type ExternalNamedOffender = {
  __typename?: 'ExternalNamedOffender';
  createdAt: Scalars['DateTimeISO'];
  dataDeletedAt?: Maybe<Scalars['DateTimeISO']>;
  event: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  organisation: Scalars['Float'];
  originalId?: Maybe<Scalars['String']>;
  postSubmission: Scalars['Boolean'];
  reportId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTimeISO'];
};

export type FeatureType = {
  __typename?: 'FeatureType';
  description?: Maybe<Scalars['String']>;
  enabled: Scalars['Boolean'];
  expiresAt?: Maybe<Scalars['DateTimeISO']>;
  id: Scalars['Int'];
  jiraTicket?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  ownerTeam?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type FileEvidenceDetailsType = {
  __typename?: 'FileEvidenceDetailsType';
  createdAt: Scalars['String'];
  dataDeletedAt?: Maybe<Scalars['DateTimeISO']>;
  fileSize?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  scanStatus?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
  value: Scalars['JSON'];
};

export type FileUploadResult = {
  __typename?: 'FileUploadResult';
  error?: Maybe<Scalars['String']>;
  fileExtension: Scalars['String'];
  filename: Scalars['String'];
  filepath: Scalars['String'];
  mimeType: Scalars['String'];
  presignedUrl?: Maybe<Scalars['String']>;
  s3path?: Maybe<Scalars['String']>;
  size: Scalars['Float'];
  uploadStatus: Scalars['String'];
  validated: Scalars['Boolean'];
};

export enum FlagInfoCategory {
  ConflictOfInterest = 'CONFLICT_OF_INTEREST',
  FinancialInterest = 'FINANCIAL_INTEREST',
  Other = 'OTHER',
  OutsideEmployment = 'OUTSIDE_EMPLOYMENT',
  Relationship = 'RELATIONSHIP',
}

export type FlagInfoType = {
  __typename?: 'FlagInfoType';
  category?: Maybe<FlagInfoCategory>;
  flaggedAt?: Maybe<Scalars['String']>;
  flaggedBy?: Maybe<FlaggedByType>;
  reason?: Maybe<Scalars['String']>;
};

export type FlaggedByType = {
  __typename?: 'FlaggedByType';
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type FolderProcessingResult = {
  __typename?: 'FolderProcessingResult';
  caseId: Scalars['String'];
  error?: Maybe<Scalars['String']>;
  files: Array<FileUploadResult>;
  folderName: Scalars['String'];
  success: Scalars['Boolean'];
};

export type FormCategoriesListResponse = {
  __typename?: 'FormCategoriesListResponse';
  count: Scalars['Int'];
  formCategories: Array<FormCategory>;
};

export type FormCategory = {
  __typename?: 'FormCategory';
  categoryKey?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type FormCategoryType = {
  __typename?: 'FormCategoryType';
  categoryKey?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
};

export type FormManagementActivityLogEntry = {
  __typename?: 'FormManagementActivityLogEntry';
  action?: Maybe<ActivityLogAction>;
  entityId?: Maybe<Scalars['String']>;
  entityName?: Maybe<Scalars['String']>;
  entityType?: Maybe<ActivityLogEntityType>;
  eventDisplayName?: Maybe<Scalars['String']>;
  formCategory?: Maybe<ActivityLogFormCategory>;
  id?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSON']>;
  parentEntityId?: Maybe<Scalars['String']>;
  parentEntityName?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['String']>;
  user?: Maybe<ActivityLogUser>;
};

export type FormManagementDatabaseFieldSubType = {
  __typename?: 'FormManagementDatabaseFieldSubType';
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  label: Scalars['String'];
  subTypeKey: Scalars['String'];
};

export type FormManagementQuestion = {
  __typename?: 'FormManagementQuestion';
  allowMultiSelect?: Maybe<Scalars['Boolean']>;
  attachmentAllowed?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  dataGridConfig?: Maybe<DataGridConfigType>;
  databaseFieldSubTypeId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  interestTypeId?: Maybe<Scalars['String']>;
  isRequired?: Maybe<Scalars['Boolean']>;
  languageId?: Maybe<Scalars['String']>;
  options?: Maybe<Array<FormManagementQuestionOption>>;
  orderIndex?: Maybe<Scalars['Int']>;
  questionText?: Maybe<Scalars['String']>;
  questionType?: Maybe<FormManagementQuestionType>;
  questionnaireId?: Maybe<Scalars['String']>;
  shouldAutoFlagIfAnswered?: Maybe<Scalars['Boolean']>;
  translations?: Maybe<Array<FormManagementQuestionTranslation>>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type FormManagementQuestionOption = {
  __typename?: 'FormManagementQuestionOption';
  id?: Maybe<Scalars['String']>;
  navigationAction?: Maybe<Scalars['String']>;
  optionOrder?: Maybe<Scalars['Int']>;
  optionText?: Maybe<Scalars['String']>;
  shouldAutoFlag?: Maybe<Scalars['Boolean']>;
  targetQuestionId?: Maybe<Scalars['String']>;
  translations?: Maybe<Array<FormManagementQuestionOptionTranslation>>;
};

export type FormManagementQuestionOptionTranslation = {
  __typename?: 'FormManagementQuestionOptionTranslation';
  id?: Maybe<Scalars['String']>;
  languageCode?: Maybe<Scalars['String']>;
  optionText?: Maybe<Scalars['String']>;
};

export type FormManagementQuestionTranslation = {
  __typename?: 'FormManagementQuestionTranslation';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  languageCode?: Maybe<Scalars['String']>;
  questionText?: Maybe<Scalars['String']>;
};

export type FormManagementQuestionType = {
  __typename?: 'FormManagementQuestionType';
  allowsOptions?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  typeKey?: Maybe<Scalars['String']>;
};

export type FormManagementQuestionTypeDetail = {
  __typename?: 'FormManagementQuestionTypeDetail';
  allowsOptions: Scalars['Boolean'];
  databaseFieldSubTypes?: Maybe<Array<FormManagementDatabaseFieldSubType>>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  label: Scalars['String'];
  typeKey: Scalars['String'];
};

export type FormManagementQuestionTypesListResponse = {
  __typename?: 'FormManagementQuestionTypesListResponse';
  count: Scalars['Int'];
  questionTypes: Array<FormManagementQuestionTypeDetail>;
};

export type FormManagementQuestionnaire = {
  __typename?: 'FormManagementQuestionnaire';
  accessScope?: Maybe<Scalars['String']>;
  autoReviewEnabled?: Maybe<Scalars['Boolean']>;
  category?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['Int']>;
  countries?: Maybe<Array<QuestionnaireCountryType>>;
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<CreatedByType>;
  description?: Maybe<Scalars['String']>;
  formCategory?: Maybe<FormCategoryType>;
  id?: Maybe<Scalars['String']>;
  internalName?: Maybe<Scalars['String']>;
  introduction?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  languages?: Maybe<Array<LanguageType>>;
  masterQuestionnaireId?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['String']>;
  publicTitle?: Maybe<Scalars['String']>;
  questionnaireTranslations?: Maybe<Array<QuestionnaireTranslationType>>;
  stats?: Maybe<QuestionnaireStatsType>;
  status?: Maybe<Scalars['String']>;
  targetDepartmentIds?: Maybe<Array<Scalars['String']>>;
  updatedAt?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type FormManagementQuestionnaireListItem = {
  __typename?: 'FormManagementQuestionnaireListItem';
  accessScope?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['Int']>;
  countries?: Maybe<Array<QuestionnaireCountryType>>;
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<CreatedByType>;
  description?: Maybe<Scalars['String']>;
  formCategory?: Maybe<FormCategoryType>;
  id?: Maybe<Scalars['String']>;
  internalName?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  languages?: Maybe<Array<LanguageType>>;
  publicTitle?: Maybe<Scalars['String']>;
  stats?: Maybe<QuestionnaireStatsType>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type FormResponseAppliedFiltersType = {
  __typename?: 'FormResponseAppliedFiltersType';
  isFlagged?: Maybe<Scalars['Boolean']>;
  questionnaireId?: Maybe<Scalars['String']>;
  respondentEmail?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  submittedFrom?: Maybe<Scalars['String']>;
  submittedTo?: Maybe<Scalars['String']>;
};

export type FormResponseQueryParamsType = {
  formCategoryKey?: InputMaybe<Scalars['String']>;
  formId?: InputMaybe<Scalars['String']>;
  isFlagged?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  respondentEmail?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<ResponseStatus>;
  submittedFrom?: InputMaybe<Scalars['String']>;
  submittedTo?: InputMaybe<Scalars['String']>;
};

export type FormResponseType = {
  __typename?: 'FormResponseType';
  attestationAccepted?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['String']>;
  flagInfo?: Maybe<FlagInfoType>;
  id?: Maybe<Scalars['String']>;
  isFlagged?: Maybe<Scalars['Boolean']>;
  organizationId?: Maybe<Scalars['String']>;
  progress?: Maybe<ProgressType>;
  questionnaire?: Maybe<QuestionnaireType>;
  questionnaireId?: Maybe<Scalars['String']>;
  respondent?: Maybe<RespondentType>;
  status?: Maybe<Scalars['String']>;
  submittedAt?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type FuzzySearchInputType = {
  value: Scalars['String'];
};

export type GetOrganisationCustomFieldsInputType = {
  fieldType?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export type GroupCreationType = {
  attributes?: InputMaybe<Scalars['JSON']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type GroupType = {
  __typename?: 'GroupType';
  ActiveCMCount: Scalars['Float'];
  ActiveCoiReviewerCount: Scalars['Float'];
  CreatedBy?: Maybe<UserType>;
  Groups?: Maybe<Array<GroupType>>;
  Users?: Maybe<Array<UserType>>;
  attributes?: Maybe<Scalars['JSON']>;
  createdAt: Scalars['DateTimeISO'];
  createdBy: Scalars['Float'];
  description?: Maybe<Scalars['String']>;
  hasNonCOIReviewerMembers?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  organisation?: Maybe<Scalars['Float']>;
};

export type GroupUpdateType = {
  attributes?: InputMaybe<Scalars['JSON']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};

export type HeroMetricMetricType = {
  __typename?: 'HeroMetricMetricType';
  category: Scalars['String'];
  count: Scalars['Float'];
  optional?: Maybe<Scalars['String']>;
};

export type HeroMetricType = {
  __typename?: 'HeroMetricType';
  category: Scalars['String'];
  descriptor?: Maybe<Scalars['String']>;
  subCategory: Array<HeroMetricMetricType>;
  tooltip?: Maybe<Scalars['String']>;
};

export type HorizontalBarChartDataType = {
  __typename?: 'HorizontalBarChartDataType';
  bar: Scalars['Int'];
  label: Scalars['String'];
  value: Scalars['Float'];
};

export type HorizontalBarChartType = {
  __typename?: 'HorizontalBarChartType';
  data: Array<HorizontalBarChartDataType>;
  xTitle: Scalars['String'];
  yTitle: Scalars['String'];
};

export type ImportCaseObjectType = {
  column_index: Scalars['Float'];
  value: Scalars['String'];
};

export type InsightsCaseCountryRegionsResultType = {
  __typename?: 'InsightsCaseCountryRegionsResultType';
  countries: Array<CountryType>;
  regions: Array<InsightsCaseRegionType>;
};

export type InsightsCaseRegionType = {
  __typename?: 'InsightsCaseRegionType';
  countryCodes: Array<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type InsightsInput = {
  type: InsightsTimeOptions;
  year?: InputMaybe<Scalars['Int']>;
};

export enum InsightsTimeOptions {
  All = 'all',
  Month = 'month',
  Year = 'year',
}

export type InternalNamedOffender = {
  __typename?: 'InternalNamedOffender';
  User?: Maybe<UserType>;
  createdAt: Scalars['DateTimeISO'];
  dataDeletedAt?: Maybe<Scalars['DateTimeISO']>;
  event: Scalars['String'];
  id: Scalars['String'];
  linkedPresubmissionOffender?: Maybe<Scalars['String']>;
  organisation: Scalars['Float'];
  postSubmission: Scalars['Boolean'];
  reportId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTimeISO'];
  user: Scalars['Float'];
};

export type InvestigationJobType = {
  __typename?: 'InvestigationJobType';
  generationStatus: Scalars['String'];
  jobId?: Maybe<Scalars['String']>;
};

export type InvestigationPlanDocument = {
  __typename?: 'InvestigationPlanDocument';
  id: Scalars['String'];
  lastEdited?: Maybe<Scalars['DateTimeISO']>;
  title: Scalars['String'];
  value: Scalars['String'];
  version: Scalars['Int'];
};

export type InvestigationPlanJobStatus = {
  __typename?: 'InvestigationPlanJobStatus';
  jobId?: Maybe<Scalars['String']>;
  status: InvestigationPlanStatus;
};

export enum InvestigationPlanStatus {
  Completed = 'completed',
  Failed = 'failed',
  InProgress = 'in_progress',
  Pending = 'pending',
}

export enum InvestigationStepStatus {
  Complete = 'COMPLETE',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING',
  Skipped = 'SKIPPED',
}

export type KeysetCursorInputType = {
  id: Scalars['String'];
  sortValue: Scalars['String'];
  tieBreakerValue?: InputMaybe<Scalars['String']>;
};

export type KeysetPaginationInputType = {
  cursor?: InputMaybe<KeysetCursorInputType>;
  limit: Scalars['Int'];
  offset?: InputMaybe<Scalars['Int']>;
};

export type LanguageInputType = {
  isDefault: Scalars['Boolean'];
  languageCode: Scalars['String'];
  languageName?: InputMaybe<Scalars['String']>;
};

export type LanguageType = {
  __typename?: 'LanguageType';
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type LineChartDataType = {
  __typename?: 'LineChartDataType';
  category: Scalars['String'];
  linePlot: Array<MonthlyDataType>;
};

export type LineChartType = {
  __typename?: 'LineChartType';
  data: Array<LineChartDataType>;
  xTitle: Scalars['String'];
  yTitle: Scalars['String'];
};

export type LinkExternalNamedOffender = {
  event: Scalars['String'];
  name: Scalars['String'];
  organisation: Scalars['Float'];
  originalId?: InputMaybe<Scalars['String']>;
};

export type LinkInternalNamedOffender = {
  event: Scalars['String'];
  linkedPresubmissionOffender?: InputMaybe<Scalars['String']>;
  organisation: Scalars['Float'];
  user: Scalars['Float'];
};

export type ManagedChannelType = {
  __typename?: 'ManagedChannelType';
  User: UserType;
  caseId: Scalars['String'];
  channel: Scalars['String'];
  createdAt: Scalars['DateTimeISO'];
  enteredChannel?: Maybe<Scalars['DateTimeISO']>;
  exitedChannel?: Maybe<Scalars['DateTimeISO']>;
  id: Scalars['Int'];
  isCaseLead?: Maybe<Scalars['Boolean']>;
  isReportAssignee?: Maybe<Scalars['Boolean']>;
  manager: Scalars['Int'];
  updatedAt: Scalars['DateTimeISO'];
};

export type MediaFilterInput = {
  scanStatus?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type MediaInput = {
  fileExtension: Scalars['String'];
  mimeType: Scalars['String'];
  s3path: Scalars['String'];
  size: Scalars['Int'];
  type: Scalars['String'];
  uploadSource: Scalars['String'];
};

export type MediaType = {
  __typename?: 'MediaType';
  createdAt: Scalars['DateTimeISO'];
  dataDeletedAt?: Maybe<Scalars['DateTimeISO']>;
  dataDeletedBy?: Maybe<Scalars['Int']>;
  fileExtension: Scalars['String'];
  id: Scalars['String'];
  mimeType: Scalars['String'];
  organisation: Scalars['Int'];
  s3path: Scalars['String'];
  scanStatus: Scalars['String'];
  scannedAt?: Maybe<Scalars['DateTimeISO']>;
  size: Scalars['Int'];
  type: Scalars['String'];
  updatedAt: Scalars['DateTimeISO'];
  uploadSource: Scalars['String'];
  url: Scalars['String'];
  userId: Scalars['Int'];
};

export enum MiReportSource {
  Box = 'BOX',
  CollaborationApp = 'COLLABORATION_APP',
  Email = 'EMAIL',
  FaceToFace = 'FACE_TO_FACE',
  Other = 'OTHER',
  Phone = 'PHONE',
  Postal = 'POSTAL',
  VideoConferencing = 'VIDEO_CONFERENCING',
}

export type MitigationPlanSignatoryType = {
  __typename?: 'MitigationPlanSignatoryType';
  createdAt: Scalars['DateTimeISO'];
  id: Scalars['String'];
  isSubject: Scalars['Boolean'];
  mitigationPlanId: Scalars['String'];
  rejectedAt?: Maybe<Scalars['DateTimeISO']>;
  rejectionNote?: Maybe<Scalars['String']>;
  signedAt?: Maybe<Scalars['DateTimeISO']>;
  updatedAt: Scalars['DateTimeISO'];
  user?: Maybe<UserType>;
  userId: Scalars['Int'];
};

export enum MitigationPlanStatus {
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT',
  NoApprovalRequired = 'NO_APPROVAL_REQUIRED',
  Overdue = 'OVERDUE',
  Pending = 'PENDING',
  Signed = 'SIGNED',
}

export type MitigationPlanType = {
  __typename?: 'MitigationPlanType';
  caseId: Scalars['String'];
  completedAt?: Maybe<Scalars['DateTimeISO']>;
  createdAt: Scalars['DateTimeISO'];
  createdBy: Scalars['Int'];
  createdByName?: Maybe<Scalars['String']>;
  deadline: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  noApprovalRequired: Scalars['Boolean'];
  reminderFrequency: Scalars['Int'];
  reminderMaxCount?: Maybe<Scalars['Int']>;
  reviewerSignatories: Array<MitigationPlanSignatoryType>;
  signatories: Array<MitigationPlanSignatoryType>;
  status: MitigationPlanStatus;
  title: Scalars['String'];
  updatedAt: Scalars['DateTimeISO'];
  uploads: Array<MitigationPlanUploadType>;
};

export type MitigationPlanUploadType = {
  __typename?: 'MitigationPlanUploadType';
  fileExtension?: Maybe<Scalars['String']>;
  mitigationPlanId: Scalars['String'];
  scanStatus?: Maybe<Scalars['String']>;
  uploadId: Scalars['String'];
  uploadOrder: Scalars['Int'];
};

export type MonthlyDataType = {
  __typename?: 'MonthlyDataType';
  count: Scalars['Float'];
  month: Scalars['String'];
};

export type MonthlyReportsBySource = {
  __typename?: 'MonthlyReportsBySource';
  app: Scalars['Int'];
  imported: Scalars['Int'];
  manualCaseCreation: Scalars['Int'];
  month: Scalars['String'];
  openReporting: Scalars['Int'];
  slack: Scalars['Int'];
  vaultTalk: Scalars['Int'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptInvestigationPlan: AcceptInvestigationPlanResult;
  addAccountRoles: RoleType;
  addCaseCategory: Array<CategoryDisplayType>;
  addCaseTeamNote?: Maybe<CaseTeamNoteType>;
  addExternalNamedOffender?: Maybe<ExternalNamedOffender>;
  addInternalNamedOffender?: Maybe<InternalNamedOffender>;
  addReportDocumentationUpload: ReportType;
  addTagToCase?: Maybe<TagType>;
  addUploadsToReport?: Maybe<Array<UploadType>>;
  applyReportDeletions: Scalars['Boolean'];
  approveRetentionRule: RetentionRuleType;
  bulkCaseCreation: BulkCasesJobCreated;
  bulkCreateFormManagementQuestions: BulkCreateQuestionsResponse;
  bulkReinvite?: Maybe<BulkReinvite>;
  cancelMitigationPlan: Scalars['Boolean'];
  cancelRetentionQueueItem: CaseRetentionQueueType;
  changePassword: PasswordType;
  completeAuditEntry?: Maybe<AuditEntryType>;
  connectSlackAccount: Scalars['String'];
  createAuditEntry?: Maybe<AuditEntryType>;
  createCaseDocumentUpload: CaseDocumentationUploadType;
  createCaseDocumentUploadURL: PreSignedUrlType;
  createCaseLink?: Maybe<CaseLinkDataType>;
  createCategory?: Maybe<CategoryType>;
  createCustomField: CustomFieldType;
  createCustomFieldSection: CustomFieldSectionType;
  createDraftReport: CreateDraftReportResponseType;
  createFormManagementQuestion: FormManagementQuestion;
  createFormManagementQuestionnaire: FormManagementQuestionnaire;
  createGroup: GroupType;
  createMedia: MediaType;
  createMitigationPlan?: Maybe<MitigationPlanType>;
  createMitigationPlanUpload: UploadType;
  createOrUpdateCaseDocument: CaseDocumentationType;
  createQuestionnaireResponse: CreateQuestionnaireResponsePayload;
  createReportDocumentationUploadUrl: PreSignedUrlType;
  createReset: Scalars['Boolean'];
  createRetentionRule?: Maybe<RetentionRuleType>;
  createRoutingRule: RoutingRuleType;
  createTag?: Maybe<TagType>;
  deactivateCustomField: Scalars['Boolean'];
  declineRetentionRule: RetentionRuleType;
  deleteAllTags: Scalars['Float'];
  deleteCustomFieldSection: DeleteCustomFieldSectionResponseType;
  deleteDraftReport: Scalars['Boolean'];
  deleteFormManagementQuestion: SuccessResponse;
  deleteFormManagementQuestionnaire: QuestionnaireSuccessResponse;
  deleteGroup: Scalars['Float'];
  deleteMedia: Scalars['Boolean'];
  deleteMitigationPlanUpload: Scalars['Boolean'];
  deleteQuestionnaireResponse: Scalars['Boolean'];
  deleteQuestionnaireResponseAttachment: Scalars['Boolean'];
  deleteRoutingRule: Scalars['Float'];
  deleteSession: DeleteSessionResponse;
  deleteTag: Scalars['Float'];
  disableRule: Array<Scalars['Float']>;
  duplicateFormManagementQuestionnaire: FormManagementQuestionnaire;
  editCaseAccess: AssignCasePermissionsType;
  flagQuestionnaireResponse: Scalars['Boolean'];
  generateInvestigationPlan: InvestigationJobType;
  getCaseDocumentUploadURL: PreSignedUrlType;
  getMitigationPlanDownloadURL: PreSignedUrlType;
  getMitigationPlanUploadURL: PreSignedUrlType;
  getReportDocumentUploadURL: PreSignedUrlType;
  getReportUploadReadURLForReporter: PreSignedUrlType;
  inviteToCase: Array<CaseTeamMemberType>;
  markAllChannelMessagesAsRead?: Maybe<Array<ResponseMessageType>>;
  markCaseAsRead?: Maybe<Scalars['Boolean']>;
  markCaseTeamNoteAsRead: CaseTeamNoteType;
  putUser?: Maybe<UserType>;
  reactivateCustomField: Scalars['Boolean'];
  reassignCaseLead: CaseType;
  reassignReportAssignee: ReportType;
  recallMitigationPlan: Scalars['Boolean'];
  registerQuestionnaireResponseAttachment: RegisterQuestionnaireResponseAttachmentPayload;
  registerUser?: Maybe<AccountType>;
  rejectMitigationPlan: Scalars['Boolean'];
  removeCaseCategory: Array<CategoryDisplayType>;
  removeCaseDocument: Array<CaseDocumentationType>;
  removeEntityPermission: PermissionType;
  removeFromCase: UserType;
  removeTagFromCase?: Maybe<TagType>;
  reorderCustomFieldSections: CustomFieldSectionsResponseType;
  reorderCustomFields: Array<CustomFieldOrderType>;
  reorderFormManagementQuestion: ReorderQuestionResponse;
  requestMergeLinkToken: Scalars['String'];
  requestOpenReportingPasswordReset: Scalars['Boolean'];
  resetPassword: PasswordType;
  restoreSanitizedCase: CaseType;
  saveResponseAnswers: Scalars['Boolean'];
  sendMessage?: Maybe<ResponseMessageType>;
  sendUserMessage?: Maybe<ResponseMessageType>;
  setCaseCountryRegion?: Maybe<CaseCountryRegionType>;
  setCaseCustomFieldValue: CaseCustomFieldValueType;
  setCoiDefaultGroup?: Maybe<Scalars['String']>;
  setDefaultGroup?: Maybe<Scalars['String']>;
  signMitigationPlan: Scalars['Boolean'];
  softDeleteMessagesByIds?: Maybe<Scalars['Boolean']>;
  stopCaseImporterJob: Scalars['Boolean'];
  submitDraftReport: ReportType;
  submitPublicToken: Scalars['Boolean'];
  submitQuestionnaireResponse: Scalars['Boolean'];
  translateFormDraftContent: TranslateFormDraftContentPayload;
  unlinkCases: Scalars['Boolean'];
  updateAnonymousStatus: ReportType;
  updateCaseAttributes?: Maybe<CaseAttributesType>;
  updateCaseDescription?: Maybe<Scalars['String']>;
  updateCaseStatus: CaseType;
  updateCaseTitle: CaseType;
  updateCategory?: Maybe<CategoryType>;
  updateCategoryLocale?: Maybe<CategoryType>;
  updateCategoryOrders: Array<CategoryOrderType>;
  updateCoiCaseStatus: CaseType;
  updateContactEmail?: Maybe<Scalars['String']>;
  updateCustomField: CustomFieldType;
  updateCustomFieldOptions: Array<CustomFieldOptionType>;
  updateCustomFieldSection: CustomFieldSectionType;
  updateDeterminedCategory: ReportType;
  updateDraftReportDetails: ReportType;
  updateFormManagementQuestion: FormManagementQuestion;
  updateFormManagementQuestionnaire: FormManagementQuestionnaire;
  updateFormManagementQuestionnaireStatus: FormManagementQuestionnaire;
  updateGroup: GroupType;
  updateInvestigationChecklist: UpdateInvestigationChecklistResult;
  updateInvestigationPlan: UpdateInvestigationPlanResult;
  updateInvestigationStep: UpdateInvestigationStepResult;
  updateMiReportSource: ReportType;
  updateMitigationPlan?: Maybe<MitigationPlanType>;
  updateMitigationPlanSignatories?: Maybe<Array<MitigationPlanSignatoryType>>;
  updateNotifications: Array<NotificationType>;
  updateReportRelationshipToOrganisation: ReportType;
  updateReportedCategory: ReportType;
  updateReporterUserSettings?: Maybe<UserType>;
  updateRetentionRule?: Maybe<RetentionRuleType>;
  updateRoutingRule: Array<Scalars['Float']>;
  updateRoutingRulePriorities: Array<RoutingRulePriorities>;
  updateSubmissionDate: Scalars['DateTimeISO'];
  updateSubstantiationStatus: ReportType;
  updateTag: Array<Scalars['Float']>;
  updateTagOrders: Array<TagOrderType>;
  updateTagTypeOrders: Array<TagTypeOrderType>;
  updateTagTypeStatus: Array<Scalars['Float']>;
  validateBulkCaseUploadAndGenerateUrl: BulkUploadResult;
  validateCasesCsvUpload: ValidatedCases;
  validateUsersCsvUpload: ValidatedUsers;
};

export type MutationAcceptInvestigationPlanArgs = {
  caseId: Scalars['String'];
  planDocumentId: Scalars['String'];
};

export type MutationAddAccountRolesArgs = {
  accountId: Scalars['Float'];
  roles: Array<Scalars['String']>;
};

export type MutationAddCaseCategoryArgs = {
  caseId: Scalars['String'];
  categoryId: Scalars['Int'];
};

export type MutationAddCaseTeamNoteArgs = {
  caseId: Scalars['String'];
  userId: Scalars['Int'];
  value: Scalars['String'];
};

export type MutationAddExternalNamedOffenderArgs = {
  caseId: Scalars['String'];
  reportId: Scalars['String'];
  user: LinkExternalNamedOffender;
};

export type MutationAddInternalNamedOffenderArgs = {
  caseId: Scalars['String'];
  reportId: Scalars['String'];
  user: LinkInternalNamedOffender;
};

export type MutationAddReportDocumentationUploadArgs = {
  documentation: DocumentationInput;
  event: Scalars['String'];
  report: Scalars['String'];
  uploadSource: UploadSource;
};

export type MutationAddTagToCaseArgs = {
  caseId: Scalars['String'];
  tagId: Scalars['String'];
};

export type MutationAddUploadsToReportArgs = {
  report: Scalars['String'];
  uploadSource: UploadSource;
  uploads: Array<UploadInput>;
};

export type MutationApplyReportDeletionsArgs = {
  data: DataDeletionType;
  noteId?: InputMaybe<Scalars['String']>;
  reportId: Scalars['String'];
};

export type MutationApproveRetentionRuleArgs = {
  id: Scalars['String'];
};

export type MutationBulkCaseCreationArgs = {
  casesToCreate: Array<BulkCaseCreationItem>;
  importFileName: Scalars['String'];
  uploadEvidences: Array<BulkCaseEvidenceItem>;
};

export type MutationBulkCreateFormManagementQuestionsArgs = {
  input: BulkUpsertQuestionsInput;
  questionnaireId: Scalars['String'];
};

export type MutationBulkReinviteArgs = {
  usersToCreate: Array<BulkReinviteCreateUser>;
  usersToDeactivate: Array<BulkReinviteUpdateUser>;
  usersToReinvite: Array<BulkReinviteUpdateUser>;
  usersToUpdate: Array<BulkReinviteUpdateUser>;
};

export type MutationCancelMitigationPlanArgs = {
  planId: Scalars['String'];
};

export type MutationCancelRetentionQueueItemArgs = {
  queueItemId: Scalars['String'];
};

export type MutationChangePasswordArgs = {
  input: UpdatePasswordInput;
};

export type MutationCompleteAuditEntryArgs = {
  id: Scalars['Float'];
};

export type MutationConnectSlackAccountArgs = {
  authCode: Scalars['String'];
};

export type MutationCreateAuditEntryArgs = {
  auditAction: Scalars['String'];
  auditData: Scalars['JSON'];
  completed: Scalars['Boolean'];
};

export type MutationCreateCaseDocumentUploadArgs = {
  caseDocument?: InputMaybe<Scalars['String']>;
  caseId?: InputMaybe<Scalars['String']>;
  filename: Scalars['String'];
  mimeType: Scalars['String'];
  report?: InputMaybe<Scalars['String']>;
  s3path: Scalars['String'];
  size: Scalars['Float'];
  uploadSource?: InputMaybe<UploadSource>;
};

export type MutationCreateCaseDocumentUploadUrlArgs = {
  caseId: Scalars['String'];
  filename: Scalars['String'];
  size?: InputMaybe<Scalars['Float']>;
  type: Scalars['String'];
  uploadSource?: InputMaybe<UploadSource>;
};

export type MutationCreateCaseLinkArgs = {
  data: CreateCaseLinkInput;
};

export type MutationCreateCategoryArgs = {
  category: CreateCategoryType;
};

export type MutationCreateCustomFieldArgs = {
  input: CreateCustomFieldInputType;
};

export type MutationCreateCustomFieldSectionArgs = {
  input: CreateCustomFieldSectionInputType;
};

export type MutationCreateDraftReportArgs = {
  source: Scalars['String'];
};

export type MutationCreateFormManagementQuestionArgs = {
  input: CreateQuestionInput;
  questionnaireId: Scalars['String'];
};

export type MutationCreateFormManagementQuestionnaireArgs = {
  input: CreateQuestionnaireInput;
};

export type MutationCreateGroupArgs = {
  parameters: GroupCreationType;
};

export type MutationCreateMediaArgs = {
  input: MediaInput;
};

export type MutationCreateMitigationPlanArgs = {
  data: CreateMitigationPlanInput;
};

export type MutationCreateMitigationPlanUploadArgs = {
  filename: Scalars['String'];
  mimeType: Scalars['String'];
  s3path: Scalars['String'];
  size: Scalars['Float'];
};

export type MutationCreateOrUpdateCaseDocumentArgs = {
  caseId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  mimeType?: InputMaybe<Scalars['String']>;
  s3path?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  uploads?: InputMaybe<Array<Scalars['String']>>;
  value?: InputMaybe<Scalars['String']>;
};

export type MutationCreateQuestionnaireResponseArgs = {
  questionnaireId: Scalars['String'];
  reportId?: InputMaybe<Scalars['String']>;
};

export type MutationCreateReportDocumentationUploadUrlArgs = {
  fileType: Scalars['String'];
  filename: Scalars['String'];
  reportId: Scalars['String'];
  size?: InputMaybe<Scalars['Float']>;
  uploadSource: UploadSource;
};

export type MutationCreateResetArgs = {
  email: Scalars['String'];
};

export type MutationCreateRetentionRuleArgs = {
  parameters: CreateRetentionRuleInput;
};

export type MutationCreateRoutingRuleArgs = {
  parameters: CreateRoutingRule;
};

export type MutationCreateTagArgs = {
  parameters: CreateTagType;
};

export type MutationDeactivateCustomFieldArgs = {
  input: DeactivateCustomFieldInputType;
};

export type MutationDeclineRetentionRuleArgs = {
  input: DeclineRetentionRuleInput;
};

export type MutationDeleteAllTagsArgs = {
  tagType: Scalars['String'];
};

export type MutationDeleteCustomFieldSectionArgs = {
  input: DeleteCustomFieldSectionInputType;
};

export type MutationDeleteDraftReportArgs = {
  reportId: Scalars['String'];
};

export type MutationDeleteFormManagementQuestionArgs = {
  id: Scalars['String'];
};

export type MutationDeleteFormManagementQuestionnaireArgs = {
  id: Scalars['String'];
};

export type MutationDeleteGroupArgs = {
  id: Scalars['String'];
};

export type MutationDeleteMediaArgs = {
  id: Scalars['String'];
};

export type MutationDeleteMitigationPlanUploadArgs = {
  planId: Scalars['String'];
  uploadId: Scalars['String'];
};

export type MutationDeleteQuestionnaireResponseArgs = {
  responseId: Scalars['String'];
};

export type MutationDeleteQuestionnaireResponseAttachmentArgs = {
  attachmentId: Scalars['String'];
  reportId?: InputMaybe<Scalars['String']>;
  responseId: Scalars['String'];
};

export type MutationDeleteRoutingRuleArgs = {
  id: Scalars['String'];
};

export type MutationDeleteTagArgs = {
  tagId: Scalars['String'];
};

export type MutationDisableRuleArgs = {
  id: Scalars['String'];
};

export type MutationDuplicateFormManagementQuestionnaireArgs = {
  id: Scalars['String'];
  input: DuplicateQuestionnaireInput;
};

export type MutationEditCaseAccessArgs = {
  caseId: Scalars['String'];
  entityPermissions: Array<Scalars['String']>;
  userId: Scalars['Int'];
};

export type MutationFlagQuestionnaireResponseArgs = {
  flagCategory?: InputMaybe<FlagInfoCategory>;
  flaggedReason?: InputMaybe<Scalars['String']>;
  isFlagged: Scalars['Boolean'];
  responseId: Scalars['String'];
  unflagReason?: InputMaybe<Scalars['String']>;
};

export type MutationGenerateInvestigationPlanArgs = {
  caseId: Scalars['String'];
};

export type MutationGetCaseDocumentUploadUrlArgs = {
  s3path: Scalars['String'];
};

export type MutationGetMitigationPlanDownloadUrlArgs = {
  planId: Scalars['String'];
  uploadId: Scalars['String'];
};

export type MutationGetMitigationPlanUploadUrlArgs = {
  planId: Scalars['String'];
  uploadId: Scalars['String'];
};

export type MutationGetReportDocumentUploadUrlArgs = {
  objectId: Scalars['String'];
  reportId: Scalars['String'];
};

export type MutationGetReportUploadReadUrlForReporterArgs = {
  objectId: Scalars['String'];
  reportId: Scalars['String'];
};

export type MutationInviteToCaseArgs = {
  caseId: Scalars['String'];
  entityPermissions: Array<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  userIds: Array<Scalars['Int']>;
};

export type MutationMarkAllChannelMessagesAsReadArgs = {
  channel: Scalars['String'];
  translate?: InputMaybe<Scalars['Boolean']>;
};

export type MutationMarkCaseAsReadArgs = {
  caseId: Scalars['String'];
  userId: Scalars['Int'];
};

export type MutationMarkCaseTeamNoteAsReadArgs = {
  noteId: Scalars['String'];
  readAt: Scalars['DateTimeISO'];
};

export type MutationPutUserArgs = {
  id?: InputMaybe<Scalars['Int']>;
  userData: PutUserType;
};

export type MutationReactivateCustomFieldArgs = {
  input: ReactivateCustomFieldInputType;
};

export type MutationReassignCaseLeadArgs = {
  caseId: Scalars['String'];
  location?: InputMaybe<Scalars['String']>;
  newCaseLeadId: Scalars['Float'];
};

export type MutationReassignReportAssigneeArgs = {
  caseId: Scalars['String'];
  newReportAssigneeId: Scalars['Float'];
  report: Scalars['String'];
};

export type MutationRecallMitigationPlanArgs = {
  planId: Scalars['String'];
};

export type MutationRegisterQuestionnaireResponseAttachmentArgs = {
  evidenceS3Path: Scalars['String'];
  questionId: Scalars['String'];
  reportId: Scalars['String'];
  responseId: Scalars['String'];
};

export type MutationRegisterUserArgs = {
  password: Scalars['String'];
  token: Scalars['String'];
};

export type MutationRejectMitigationPlanArgs = {
  note: Scalars['String'];
  planId: Scalars['String'];
};

export type MutationRemoveCaseCategoryArgs = {
  caseId: Scalars['String'];
  categoryId: Scalars['Int'];
};

export type MutationRemoveCaseDocumentArgs = {
  caseId: Scalars['String'];
  selectedDocumentIds: Array<Scalars['String']>;
};

export type MutationRemoveEntityPermissionArgs = {
  parameters: RemovePermissionType;
};

export type MutationRemoveFromCaseArgs = {
  caseId: Scalars['String'];
  userId: Scalars['Int'];
};

export type MutationRemoveTagFromCaseArgs = {
  caseId: Scalars['String'];
  tagId: Scalars['String'];
};

export type MutationReorderCustomFieldSectionsArgs = {
  input: ReorderCustomFieldSectionsInputType;
};

export type MutationReorderCustomFieldsArgs = {
  input: ReorderCustomFieldsInputType;
};

export type MutationReorderFormManagementQuestionArgs = {
  id: Scalars['String'];
  input: ReorderQuestionInput;
};

export type MutationRequestOpenReportingPasswordResetArgs = {
  input: OprPasswordResetRequestInput;
};

export type MutationResetPasswordArgs = {
  password: Scalars['String'];
  token: Scalars['String'];
};

export type MutationRestoreSanitizedCaseArgs = {
  caseId: Scalars['String'];
};

export type MutationSaveResponseAnswersArgs = {
  answers: Array<SaveAnswerInputType>;
  reportId?: InputMaybe<Scalars['String']>;
  responseId: Scalars['String'];
};

export type MutationSendMessageArgs = {
  caseId: Scalars['String'];
  channel: Scalars['String'];
  value: Scalars['String'];
};

export type MutationSendUserMessageArgs = {
  channel: Scalars['String'];
  value: Scalars['String'];
};

export type MutationSetCaseCountryRegionArgs = {
  input: SetCaseCountryRegionInput;
};

export type MutationSetCaseCustomFieldValueArgs = {
  input: SetCaseCustomFieldValueInputType;
};

export type MutationSetCoiDefaultGroupArgs = {
  groupId?: InputMaybe<Scalars['String']>;
};

export type MutationSetDefaultGroupArgs = {
  groupId?: InputMaybe<Scalars['String']>;
};

export type MutationSignMitigationPlanArgs = {
  planId: Scalars['String'];
};

export type MutationSoftDeleteMessagesByIdsArgs = {
  messageIds: Array<Scalars['String']>;
};

export type MutationStopCaseImporterJobArgs = {
  jobId: Scalars['String'];
};

export type MutationSubmitDraftReportArgs = {
  attestationAccepted?: InputMaybe<Scalars['Boolean']>;
  autoAssignCaseManagerViaRouting?: InputMaybe<Scalars['Boolean']>;
  caseLead?: InputMaybe<Scalars['Float']>;
  questionnaireAnswers?: InputMaybe<Array<SaveAnswerInputType>>;
  reportId: Scalars['String'];
  responseId?: InputMaybe<Scalars['String']>;
  submissionMode: Scalars['Int'];
};

export type MutationSubmitPublicTokenArgs = {
  publicToken: Scalars['String'];
};

export type MutationSubmitQuestionnaireResponseArgs = {
  answers?: InputMaybe<Array<SaveAnswerInputType>>;
  attestationAccepted: Scalars['Boolean'];
  responseId: Scalars['String'];
};

export type MutationTranslateFormDraftContentArgs = {
  input: TranslateFormDraftContentInput;
};

export type MutationUnlinkCasesArgs = {
  linkId: Scalars['String'];
};

export type MutationUpdateAnonymousStatusArgs = {
  anonymous: Scalars['Boolean'];
  report: Scalars['String'];
};

export type MutationUpdateCaseAttributesArgs = {
  caseAttributes: UpdateCaseAttributes;
  postSubmission?: InputMaybe<Scalars['Boolean']>;
};

export type MutationUpdateCaseDescriptionArgs = {
  caseId: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
};

export type MutationUpdateCaseStatusArgs = {
  caseId: Scalars['String'];
  newCaseStatus: ReportStatus;
};

export type MutationUpdateCaseTitleArgs = {
  caseId: Scalars['String'];
  newCaseTitle: Scalars['String'];
};

export type MutationUpdateCategoryArgs = {
  category: UpdateCategoryType;
};

export type MutationUpdateCategoryLocaleArgs = {
  category: UpdateCategoryLocaleType;
};

export type MutationUpdateCategoryOrdersArgs = {
  categories: Array<UpdateCategoryOrderType>;
  draggedCategoryId: Scalars['Int'];
};

export type MutationUpdateCoiCaseStatusArgs = {
  caseId: Scalars['String'];
  newCoiCaseStatus: CoiCaseStatus;
};

export type MutationUpdateContactEmailArgs = {
  contactEmail: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  reportId?: InputMaybe<Scalars['String']>;
};

export type MutationUpdateCustomFieldArgs = {
  input: UpdateCustomFieldInputType;
};

export type MutationUpdateCustomFieldOptionsArgs = {
  input: UpdateCustomFieldOptionsInputType;
};

export type MutationUpdateCustomFieldSectionArgs = {
  input: UpdateCustomFieldSectionInputType;
};

export type MutationUpdateDeterminedCategoryArgs = {
  determinedCategoryId: Scalars['Int'];
  report: Scalars['String'];
};

export type MutationUpdateDraftReportDetailsArgs = {
  attributes: UpdateDraftReportDetailsInput;
};

export type MutationUpdateFormManagementQuestionArgs = {
  id: Scalars['String'];
  input: UpdateQuestionInput;
};

export type MutationUpdateFormManagementQuestionnaireArgs = {
  id: Scalars['String'];
  input: UpdateQuestionnaireInput;
};

export type MutationUpdateFormManagementQuestionnaireStatusArgs = {
  id: Scalars['String'];
  input: UpdateQuestionnaireStatusInput;
};

export type MutationUpdateGroupArgs = {
  parameters: GroupUpdateType;
};

export type MutationUpdateInvestigationChecklistArgs = {
  caseId: Scalars['String'];
  checklist: Scalars['String'];
  planDocumentId: Scalars['String'];
};

export type MutationUpdateInvestigationPlanArgs = {
  caseId: Scalars['String'];
  plan: Scalars['String'];
  planDocumentId: Scalars['String'];
  submittedVersion: Scalars['Int'];
};

export type MutationUpdateInvestigationStepArgs = {
  caseId: Scalars['String'];
  planDocumentId: Scalars['String'];
  status: InvestigationStepStatus;
  stepId: Scalars['String'];
};

export type MutationUpdateMiReportSourceArgs = {
  miReportSource: MiReportSource;
  report: Scalars['String'];
};

export type MutationUpdateMitigationPlanArgs = {
  data: UpdateMitigationPlanInput;
};

export type MutationUpdateMitigationPlanSignatoriesArgs = {
  data: UpdateMitigationPlanSignatoriesInput;
};

export type MutationUpdateNotificationsArgs = {
  notifications: UpdateNotificationInput;
};

export type MutationUpdateReportRelationshipToOrganisationArgs = {
  relationshipToOrganisation: Scalars['Int'];
  report: Scalars['String'];
};

export type MutationUpdateReportedCategoryArgs = {
  report: Scalars['String'];
  reportedCategoryId: Scalars['Int'];
};

export type MutationUpdateReporterUserSettingsArgs = {
  patchData: ReporterUserSettingsType;
};

export type MutationUpdateRetentionRuleArgs = {
  input: UpdateRetentionRuleInput;
};

export type MutationUpdateRoutingRuleArgs = {
  parameters: UpdateRoutingRule;
};

export type MutationUpdateRoutingRulePrioritiesArgs = {
  rules: Array<UpdateRoutingRulePriorities>;
};

export type MutationUpdateSubmissionDateArgs = {
  report: Scalars['String'];
  submittedAt: Scalars['DateTimeISO'];
};

export type MutationUpdateSubstantiationStatusArgs = {
  caseId: Scalars['String'];
  newSubstantiationStatus: Scalars['String'];
  report: Scalars['String'];
};

export type MutationUpdateTagArgs = {
  parameters: UpdateTagType;
};

export type MutationUpdateTagOrdersArgs = {
  draggedTagId: Scalars['String'];
  tags: Array<UpdateTagOrdersType>;
};

export type MutationUpdateTagTypeOrdersArgs = {
  draggedTagTypeId: Scalars['String'];
  tagTypes: Array<UpdateTagTypeOrdersType>;
};

export type MutationUpdateTagTypeStatusArgs = {
  parameters: UpdateTagTypeStatusType;
};

export type MutationValidateBulkCaseUploadAndGenerateUrlArgs = {
  files: Array<BulkFileUploadInput>;
  importedCaseIds?: InputMaybe<Array<Scalars['String']>>;
  uploadSource?: InputMaybe<UploadSource>;
};

export type MutationValidateCasesCsvUploadArgs = {
  columnMapping: Array<ColumnMappingInput>;
  dynamicCategory?: InputMaybe<Scalars['String']>;
  dynamicFormId?: InputMaybe<Scalars['String']>;
  embedId: Scalars['Int'];
  importFileName: Scalars['String'];
  newCases?: InputMaybe<Array<BulkImportCases>>;
  newCasesDynamic?: InputMaybe<Array<BulkImportCasesDynamic>>;
  sheetId: Scalars['Int'];
};

export type MutationValidateUsersCsvUploadArgs = {
  embedId: Scalars['Int'];
  newUsers: Array<BulkReinviteCreateUser>;
  sheetId: Scalars['Int'];
};

export type NamedOffender = ExternalNamedOffender | InternalNamedOffender;

export type NotificationType = {
  __typename?: 'NotificationType';
  assignedFrom?: Maybe<Scalars['String']>;
  case?: Maybe<Scalars['String']>;
  createdAt: Scalars['String'];
  details?: Maybe<Scalars['String']>;
  emailDate?: Maybe<Scalars['DateTimeISO']>;
  id: Scalars['Float'];
  importType?: Maybe<Scalars['String']>;
  kind: Scalars['String'];
  report?: Maybe<Scalars['String']>;
  state: Scalars['Float'];
  updatedAt: Scalars['String'];
};

export type OldHeroMetricType = {
  __typename?: 'OldHeroMetricType';
  category: Scalars['String'];
  description: Scalars['String'];
  type: Scalars['String'];
  value: Scalars['Float'];
};

export type OneSchemaJwt = {
  __typename?: 'OneSchemaJwt';
  jwt: Scalars['String'];
};

export type OprPasswordResetRequestInput = {
  email: Scalars['String'];
  slug: Scalars['String'];
  vaultId: Scalars['String'];
};

export type OrderByInputType = {
  direction: Scalars['String'];
  fieldName: Scalars['String'];
};

export type OrgActivityLogFilterInput = {
  action?: InputMaybe<ActivityLogAction>;
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
  entityType?: InputMaybe<ActivityLogEntityType>;
  formCategoryId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};

export type OrganisationHotlineNumberType = {
  __typename?: 'OrganisationHotlineNumberType';
  country: Scalars['String'];
  defaultLanguage: Scalars['String'];
  flagIconCode: Scalars['String'];
  id: Scalars['Int'];
  language: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export type OrganisationMetaDataType = {
  __typename?: 'OrganisationMetaDataType';
  division: Array<Scalars['String']>;
  organization: Array<Scalars['String']>;
  userType: Array<Scalars['String']>;
};

export type OrganisationRoleType = {
  __typename?: 'OrganisationRoleType';
  createdAt?: Maybe<Scalars['DateTimeISO']>;
  description: Scalars['String'];
  id: Scalars['String'];
  isSpecial?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organisation: Scalars['Float'];
  publicSystemPermissions?: Maybe<PublicSystemPermissions>;
  updatedAt?: Maybe<Scalars['DateTimeISO']>;
};

export type OrganisationSlackIntegrationType = {
  __typename?: 'OrganisationSlackIntegrationType';
  id: Scalars['String'];
  installedAt?: Maybe<Scalars['DateTimeISO']>;
  organisation: Scalars['Float'];
  teamId: Scalars['String'];
  workspaceName: Scalars['String'];
};

export type OrganisationType = {
  __typename?: 'OrganisationType';
  country?: Maybe<Array<Scalars['String']>>;
  createdAt?: Maybe<Scalars['DateTimeISO']>;
  department?: Maybe<Array<Scalars['String']>>;
  expiryPeriod?: Maybe<Scalars['Float']>;
  hotlineNumbers?: Maybe<Array<OrganisationHotlineNumberType>>;
  id: Scalars['Float'];
  insightsCaseCountryRegions: InsightsCaseCountryRegionsResultType;
  insightsCategories: Array<Scalars['String']>;
  insightsCountries?: Maybe<Array<Scalars['String']>>;
  insightsDepartments: Array<Scalars['String']>;
  insightsReportCategories?: Maybe<Array<Scalars['String']>>;
  insightsSites: Array<Scalars['String']>;
  name: Scalars['String'];
  oldestReportSubmittedDate: Scalars['DateTimeISO'];
  site?: Maybe<Array<Scalars['String']>>;
  slackIntegrations?: Maybe<Array<OrganisationSlackIntegrationType>>;
  systemRoles?: Maybe<Array<Scalars['JSON']>>;
  team?: Maybe<Array<Scalars['JSON']>>;
  userCountries?: Maybe<Array<Scalars['String']>>;
};

export type PaginatedActivityLogResponse = {
  __typename?: 'PaginatedActivityLogResponse';
  data?: Maybe<Array<FormManagementActivityLogEntry>>;
  pagination?: Maybe<ActivityLogPaginationType>;
};

export type PaginatedAuditEntryTypeResponse = {
  __typename?: 'PaginatedAuditEntryTypeResponse';
  count: Scalars['Int'];
  items: Array<AuditEntryType>;
};

export type PaginatedCaseTypeResponse = {
  __typename?: 'PaginatedCaseTypeResponse';
  count: Scalars['Int'];
  items: Array<CaseType>;
};

export type PaginatedFormResponsesType = {
  __typename?: 'PaginatedFormResponsesType';
  filters?: Maybe<FormResponseAppliedFiltersType>;
  pagination?: Maybe<PaginationMetadataType>;
  responses?: Maybe<Array<FormResponseType>>;
};

export type PaginatedReportTypeResponse = {
  __typename?: 'PaginatedReportTypeResponse';
  count: Scalars['Int'];
  items: Array<ReportType>;
};

export type PaginatedRoutingRuleTypeResponse = {
  __typename?: 'PaginatedRoutingRuleTypeResponse';
  count: Scalars['Int'];
  items: Array<RoutingRuleType>;
};

export type PaginatedUserTypeResponse = {
  __typename?: 'PaginatedUserTypeResponse';
  count: Scalars['Int'];
  items: Array<UserType>;
};

export type PaginationInputType = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};

export type PaginationMetadataType = {
  __typename?: 'PaginationMetadataType';
  hasNext?: Maybe<Scalars['Boolean']>;
  hasPrevious?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  totalItems?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type ParsedEventsType = {
  __typename?: 'ParsedEventsType';
  created: Scalars['String'];
  evidence?: Maybe<ParsedEvidenceType>;
  id: Scalars['String'];
  report: Scalars['String'];
  timestamp?: Maybe<Scalars['String']>;
  updated: Scalars['String'];
};

export type ParsedEvidenceDetailsType = {
  __typename?: 'ParsedEvidenceDetailsType';
  createdAt: Scalars['String'];
  id: Scalars['String'];
  updatedAt: Scalars['String'];
  value: Scalars['JSON'];
};

export type ParsedEvidenceType = {
  __typename?: 'ParsedEvidenceType';
  date?: Maybe<ParsedEvidenceDetailsType>;
  description?: Maybe<ParsedEvidenceDetailsType>;
  emotion?: Maybe<ParsedEvidenceDetailsType>;
  location?: Maybe<ParsedEvidenceDetailsType>;
  perpetrator?: Maybe<Array<ParsedEvidenceDetailsType>>;
  photo?: Maybe<Array<FileEvidenceDetailsType>>;
  time?: Maybe<ParsedEvidenceDetailsType>;
  witness?: Maybe<ParsedEvidenceDetailsType>;
};

export type PasswordType = {
  __typename?: 'PasswordType';
  createdAt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type PermissionType = {
  __typename?: 'PermissionType';
  createdAt: Scalars['DateTimeISO'];
  id: Scalars['String'];
  permission: Scalars['String'];
  updatedAt: Scalars['DateTimeISO'];
};

export type PerpetratorType = {
  __typename?: 'PerpetratorType';
  external?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  site?: Maybe<Scalars['String']>;
};

export type PreSignedUrlType = {
  __typename?: 'PreSignedURLType';
  s3path: Scalars['String'];
  url: Scalars['String'];
};

export type ProgressType = {
  __typename?: 'ProgressType';
  answeredQuestions?: Maybe<Scalars['Float']>;
  answeredRequiredQuestions?: Maybe<Scalars['Float']>;
  completionPercentage?: Maybe<Scalars['Float']>;
  requiredQuestions?: Maybe<Scalars['Float']>;
  totalQuestions?: Maybe<Scalars['Float']>;
};

export type PublicSystemPermissions = {
  __typename?: 'PublicSystemPermissions';
  canBeAssignedAsCaseLead?: Maybe<Scalars['Boolean']>;
  canBeAssignedToCaseTeam?: Maybe<Scalars['Boolean']>;
  canCreateExistingReport?: Maybe<Scalars['Boolean']>;
  canCreateReport?: Maybe<Scalars['Boolean']>;
};

export type PutUserType = {
  SystemRoles?: InputMaybe<Array<SystemRoleType>>;
  accounts: Array<AccountInputType>;
  country?: InputMaybe<Scalars['String']>;
  department: Scalars['String'];
  displayName?: InputMaybe<Scalars['String']>;
  eid: Scalars['String'];
  email: Scalars['String'];
  name: Scalars['String'];
  permissions: Array<Scalars['String']>;
  role: Scalars['String'];
  site: Scalars['String'];
  source?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  accountPermissions: PermissionType;
  accountRoles: RoleType;
  adoptionMetrics: Array<OldHeroMetricType>;
  allMedia: Array<MediaType>;
  auditEntriesByCase?: Maybe<Array<AuditEntryType>>;
  auditEntriesByDraftReport?: Maybe<Array<AuditEntryType>>;
  auditEntriesByReport?: Maybe<Array<AuditEntryType>>;
  auditEntriesPaginated?: Maybe<PaginatedAuditEntryTypeResponse>;
  caseById?: Maybe<CaseType>;
  caseCountryRegion?: Maybe<CaseCountryRegionType>;
  caseDataDownloadAuditEntries?: Maybe<Array<AuditEntryType>>;
  caseMetrics: CaseMetricsType;
  casesAbleToBeLinkedToCase: PaginatedCaseTypeResponse;
  casesCoiPaginated: PaginatedCaseTypeResponse;
  casesPaginated: PaginatedCaseTypeResponse;
  categoriesAuditEntries?: Maybe<Array<AuditEntryType>>;
  coiFilterOptions?: Maybe<CoiFilterOptionsType>;
  countries: Array<CountryType>;
  disclosureAuditById?: Maybe<DisclosureAuditType>;
  disclosureCaseById?: Maybe<DisclosureResponseType>;
  disclosureResponseById?: Maybe<DisclosureResponseType>;
  formCategories: FormCategoriesListResponse;
  formManagementActivityLog: PaginatedActivityLogResponse;
  formManagementCountries: Array<CountryType>;
  formManagementQuestionById: FormManagementQuestion;
  formManagementQuestionnaireActivityLog: PaginatedActivityLogResponse;
  formManagementQuestionnaireById: FormManagementQuestionnaire;
  formManagementQuestionnaires: Array<FormManagementQuestionnaireListItem>;
  formManagementQuestions: QuestionsListResponse;
  formResponsesPaginated: PaginatedFormResponsesType;
  generateJwt?: Maybe<OneSchemaJwt>;
  getActiveCategoriesForCase?: Maybe<Array<CategoryDisplayType>>;
  getCaseAttributes?: Maybe<CaseAttributesType>;
  getCaseAuditEntries?: Maybe<PaginatedAuditEntryTypeResponse>;
  getCaseDocument?: Maybe<CaseDocumentationType>;
  getCaseDocumentation?: Maybe<Array<CaseDocumentationType>>;
  getCaseImporterJobDetails: CaseImporterJobDetails;
  getCaseImporterJobHistory: CaseImporterJobHistoryResponse;
  getCaseImporterJobProgress?: Maybe<BulkCasesJobStatus>;
  getCaseLinksByCaseId?: Maybe<Array<CaseLinkDataType>>;
  getCaseTeamMemberPermissions: Array<Scalars['String']>;
  getCaseTeamNote?: Maybe<CaseTeamNoteType>;
  getCaseTeamPermissions?: Maybe<Array<CaseTeamPermissionType>>;
  getCasesOver90DaysHeroMetric: HeroMetricType;
  getCasesPerWeekBarStacked: CasesOverTimeType;
  getCategoryWithMostReportsHeroMetric: HeroMetricType;
  getChannelEntries?: Maybe<Array<ManagedChannelType>>;
  getCoiDefaultGroup?: Maybe<Scalars['String']>;
  getDefaultGroup?: Maybe<Scalars['String']>;
  getDepartmentWithMostCasesHeroMetric: HeroMetricType;
  getDeterminedCategories?: Maybe<Array<CategoryDisplayType>>;
  getFallbackRetentionRules?: Maybe<Array<RetentionRuleType>>;
  getGlobalFeatures: Array<FeatureType>;
  getIssueCategoriesByAnonymousGraph: DonutAndBarChartType;
  getIssueCategoriesByCountryGraph: DonutAndBarChartType;
  getIssueCategoriesByDepartmentGraph: DonutAndBarChartType;
  getIssueCategoriesByIntakeMethodGraph: DonutAndBarChartType;
  getLocationWithMostCasesHeroMetric: HeroMetricType;
  getManualIntakeReportedCategories?: Maybe<Array<CategoryDisplayType>>;
  getMessagesByReport?: Maybe<Array<ResponseMessageType>>;
  getMonthWithMostReportsHeroMetric: HeroMetricType;
  getOrganisationCategories?: Maybe<Array<CategoryType>>;
  getOrganisationCustomFieldSections: CustomFieldSectionsResponseType;
  getOrganisationCustomFields: CustomFieldsResponseType;
  getOrganisationFeatures: Array<FeatureType>;
  getOrganisationMetaData?: Maybe<OrganisationMetaDataType>;
  getOrganisationRoles: Array<OrganisationRoleType>;
  getOrganisationTagTypes?: Maybe<Array<TagTypeType>>;
  getOrganisationTags?: Maybe<Array<TagType>>;
  getPrivacyStatement?: Maybe<Scalars['String']>;
  getPublicCategories?: Maybe<Array<CategoryDisplayType>>;
  getPublicCountries: Array<CountryType>;
  getPublicFeatures: Array<FeatureType>;
  getPublicSites: Array<SiteType>;
  getQuestionTypes: FormManagementQuestionTypesListResponse;
  getRelationshipType: Array<RelationshipType>;
  getReportById?: Maybe<UserReportFullType>;
  getReportEvents: Array<ReportEventType>;
  getReportedCategories?: Maybe<Array<CategoryDisplayType>>;
  getReportsPerCategoryPerMonthGraph: LineChartType;
  getRetentionRules: Array<RetentionRulesByCountryType>;
  getRetentionRulesCount: Scalars['Int'];
  getRulesByStatus?: Maybe<Array<RetentionRuleType>>;
  getSubmissionDate?: Maybe<Scalars['DateTimeISO']>;
  getSubstantiationStatusCount: HorizontalBarChartType;
  getTimeInStatusHeroMetric: HeroMetricType;
  getTimeToResolutionHeroMetric: HeroMetricType;
  getTotalCasesHeroMetric: HeroMetricType;
  getUpcomingRetentionActions: Array<CaseRetentionQueueType>;
  getUpcomingRetentionActionsCount: Scalars['Int'];
  getUserChannelEntries?: Maybe<Array<ManagedChannelType>>;
  getUserMessagesByReport?: Maybe<Array<ResponseMessageType>>;
  groupById?: Maybe<GroupType>;
  groupUserCount: Scalars['JSON'];
  groupsAttributesData: OrganisationType;
  investigationPlanDocument?: Maybe<InvestigationPlanDocument>;
  investigationPlanJobStatus?: Maybe<InvestigationPlanJobStatus>;
  me: UserType;
  media?: Maybe<MediaType>;
  mitigationPlansForDisclosure: Array<MitigationPlanType>;
  monthlyReportsBySource: Array<MonthlyReportsBySource>;
  myAccount?: Maybe<AccountType>;
  notifications: Array<NotificationType>;
  orgGroups: Array<GroupType>;
  organisation: OrganisationType;
  organisationFormResponsesPaginated?: Maybe<PaginatedFormResponsesType>;
  organisationHotlineNumbers: Array<OrganisationHotlineNumberType>;
  organisationQuestionnaires: Array<QuestionnaireListItemType>;
  questionnaireQuestions: QuestionnaireQuestionsResponseType;
  regionsForOrganisation: Array<RegionType>;
  reportCount: Scalars['Int'];
  reportYears: Array<Scalars['Int']>;
  reportsByCategory: Array<ReportsByCategory>;
  reportsByDepartment: Array<ReportsByDepartment>;
  reportsByStatus: Array<ReportsByStatus>;
  reportsPaginated: PaginatedReportTypeResponse;
  routingAuditEntries?: Maybe<Array<AuditEntryType>>;
  routingRulesPaginated: PaginatedRoutingRuleTypeResponse;
  sanitizedAndDeletedCases: Array<SanitizedOrDeletedCaseType>;
  searchCasesForLinking: PaginatedCaseTypeResponse;
  searchUsersPaginated: PaginatedUserTypeResponse;
  tagsAuditEntries?: Maybe<Array<AuditEntryType>>;
  userById?: Maybe<UserType>;
  userReports?: Maybe<Array<UserReportType>>;
  userRolesAuditEntries?: Maybe<Array<AuditEntryType>>;
  usersPaginated: PaginatedUserTypeResponse;
};

export type QueryAllMediaArgs = {
  filter?: InputMaybe<MediaFilterInput>;
};

export type QueryAuditEntriesByCaseArgs = {
  case: Scalars['String'];
};

export type QueryAuditEntriesByDraftReportArgs = {
  report: Scalars['String'];
};

export type QueryAuditEntriesByReportArgs = {
  report: Scalars['String'];
};

export type QueryAuditEntriesPaginatedArgs = {
  orderBy?: InputMaybe<OrderByInputType>;
  pagination?: InputMaybe<PaginationInputType>;
};

export type QueryCaseByIdArgs = {
  id: Scalars['String'];
};

export type QueryCaseCountryRegionArgs = {
  caseId: Scalars['String'];
};

export type QueryCasesAbleToBeLinkedToCaseArgs = {
  caseId: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
};

export type QueryCasesCoiPaginatedArgs = {
  appliedFilters?: InputMaybe<AppliedFiltersType>;
  fuzzy?: InputMaybe<FuzzySearchInputType>;
  orderBy: OrderByInputType;
  pagination: KeysetPaginationInputType;
  requireEditPermission?: InputMaybe<Scalars['Boolean']>;
  searchBy?: InputMaybe<Array<SearchByInputType>>;
};

export type QueryCasesPaginatedArgs = {
  appliedFilters?: InputMaybe<AppliedFiltersType>;
  fuzzy?: InputMaybe<FuzzySearchInputType>;
  orderBy: OrderByInputType;
  pagination?: InputMaybe<PaginationInputType>;
  requireEditPermission?: InputMaybe<Scalars['Boolean']>;
  searchBy?: InputMaybe<Array<SearchByInputType>>;
};

export type QueryCategoriesAuditEntriesArgs = {
  isCOI?: InputMaybe<Scalars['Boolean']>;
};

export type QueryDisclosureAuditByIdArgs = {
  responseId: Scalars['String'];
};

export type QueryDisclosureCaseByIdArgs = {
  caseId: Scalars['String'];
};

export type QueryDisclosureResponseByIdArgs = {
  responseId: Scalars['String'];
};

export type QueryFormManagementActivityLogArgs = {
  filters?: InputMaybe<OrgActivityLogFilterInput>;
};

export type QueryFormManagementQuestionByIdArgs = {
  id: Scalars['String'];
};

export type QueryFormManagementQuestionnaireActivityLogArgs = {
  filters?: InputMaybe<QuestionnaireActivityLogFilterInput>;
  questionnaireId: Scalars['String'];
};

export type QueryFormManagementQuestionnaireByIdArgs = {
  id: Scalars['String'];
};

export type QueryFormManagementQuestionnairesArgs = {
  filters?: InputMaybe<QuestionnaireFilterInput>;
};

export type QueryFormManagementQuestionsArgs = {
  questionnaireId: Scalars['String'];
};

export type QueryFormResponsesPaginatedArgs = {
  formId: Scalars['String'];
  queryParams?: InputMaybe<FormResponseQueryParamsType>;
};

export type QueryGenerateJwtArgs = {
  dynamicFormId?: InputMaybe<Scalars['String']>;
};

export type QueryGetCaseAttributesArgs = {
  caseId: Scalars['String'];
};

export type QueryGetCaseAuditEntriesArgs = {
  case: Scalars['String'];
  pagination?: InputMaybe<PaginationInputType>;
};

export type QueryGetCaseDocumentArgs = {
  caseDocumentId?: InputMaybe<Scalars['String']>;
};

export type QueryGetCaseDocumentationArgs = {
  caseId: Scalars['String'];
};

export type QueryGetCaseImporterJobDetailsArgs = {
  jobId: Scalars['String'];
};

export type QueryGetCaseImporterJobHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type QueryGetCaseImporterJobProgressArgs = {
  jobId?: InputMaybe<Scalars['String']>;
};

export type QueryGetCaseLinksByCaseIdArgs = {
  caseId: Scalars['String'];
};

export type QueryGetCaseTeamMemberPermissionsArgs = {
  caseId: Scalars['String'];
  userId?: InputMaybe<Scalars['Int']>;
};

export type QueryGetCaseTeamNoteArgs = {
  caseId: Scalars['String'];
  userId: Scalars['Int'];
};

export type QueryGetCaseTeamPermissionsArgs = {
  caseId: Scalars['String'];
};

export type QueryGetCasesOver90DaysHeroMetricArgs = {
  Timeframe?: InputMaybe<TimeframeInput>;
  caseCountryCodes?: InputMaybe<Array<Scalars['String']>>;
  caseRegionIds?: InputMaybe<Array<Scalars['String']>>;
  countries?: InputMaybe<Array<Scalars['String']>>;
  sites?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryGetCasesPerWeekBarStackedArgs = {
  CasesType: BarStackedCasesFiltersTypes;
  Timeframe?: InputMaybe<TimeframeInput>;
  caseCountryCodes?: InputMaybe<Array<Scalars['String']>>;
  caseRegionIds?: InputMaybe<Array<Scalars['String']>>;
  categories?: InputMaybe<Array<Scalars['String']>>;
  countries?: InputMaybe<Array<Scalars['String']>>;
  departments?: InputMaybe<Array<Scalars['String']>>;
  sites?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryGetCategoryWithMostReportsHeroMetricArgs = {
  Timeframe?: InputMaybe<TimeframeInput>;
  caseCountryCodes?: InputMaybe<Array<Scalars['String']>>;
  caseRegionIds?: InputMaybe<Array<Scalars['String']>>;
  countries?: InputMaybe<Array<Scalars['String']>>;
  sites?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryGetChannelEntriesArgs = {
  channel: Scalars['String'];
};

export type QueryGetDepartmentWithMostCasesHeroMetricArgs = {
  Timeframe?: InputMaybe<TimeframeInput>;
  caseCountryCodes?: InputMaybe<Array<Scalars['String']>>;
  caseRegionIds?: InputMaybe<Array<Scalars['String']>>;
  countries?: InputMaybe<Array<Scalars['String']>>;
  sites?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryGetIssueCategoriesByAnonymousGraphArgs = {
  Timeframe?: InputMaybe<TimeframeInput>;
  caseCountryCodes?: InputMaybe<Array<Scalars['String']>>;
  caseRegionIds?: InputMaybe<Array<Scalars['String']>>;
  categories?: InputMaybe<Array<Scalars['String']>>;
  countries?: InputMaybe<Array<Scalars['String']>>;
  departments?: InputMaybe<Array<Scalars['String']>>;
  sites?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryGetIssueCategoriesByCountryGraphArgs = {
  Timeframe?: InputMaybe<TimeframeInput>;
  caseCountryCodes?: InputMaybe<Array<Scalars['String']>>;
  caseRegionIds?: InputMaybe<Array<Scalars['String']>>;
  categories?: InputMaybe<Array<Scalars['String']>>;
  countries?: InputMaybe<Array<Scalars['String']>>;
  departments?: InputMaybe<Array<Scalars['String']>>;
  sites?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryGetIssueCategoriesByDepartmentGraphArgs = {
  Timeframe?: InputMaybe<TimeframeInput>;
  caseCountryCodes?: InputMaybe<Array<Scalars['String']>>;
  caseRegionIds?: InputMaybe<Array<Scalars['String']>>;
  categories?: InputMaybe<Array<Scalars['String']>>;
  countries?: InputMaybe<Array<Scalars['String']>>;
  departments?: InputMaybe<Array<Scalars['String']>>;
  sites?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryGetIssueCategoriesByIntakeMethodGraphArgs = {
  Timeframe?: InputMaybe<TimeframeInput>;
  caseCountryCodes?: InputMaybe<Array<Scalars['String']>>;
  caseRegionIds?: InputMaybe<Array<Scalars['String']>>;
  categories?: InputMaybe<Array<Scalars['String']>>;
  countries?: InputMaybe<Array<Scalars['String']>>;
  departments?: InputMaybe<Array<Scalars['String']>>;
  sites?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryGetLocationWithMostCasesHeroMetricArgs = {
  Timeframe?: InputMaybe<TimeframeInput>;
  caseCountryCodes?: InputMaybe<Array<Scalars['String']>>;
  caseRegionIds?: InputMaybe<Array<Scalars['String']>>;
  countries?: InputMaybe<Array<Scalars['String']>>;
  sites?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryGetMessagesByReportArgs = {
  report: Scalars['String'];
  translate?: InputMaybe<Scalars['Boolean']>;
};

export type QueryGetMonthWithMostReportsHeroMetricArgs = {
  Timeframe?: InputMaybe<TimeframeInput>;
  caseCountryCodes?: InputMaybe<Array<Scalars['String']>>;
  caseRegionIds?: InputMaybe<Array<Scalars['String']>>;
  countries?: InputMaybe<Array<Scalars['String']>>;
  sites?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryGetOrganisationCategoriesArgs = {
  isCOI?: InputMaybe<Scalars['Boolean']>;
};

export type QueryGetOrganisationCustomFieldsArgs = {
  input?: InputMaybe<GetOrganisationCustomFieldsInputType>;
};

export type QueryGetPrivacyStatementArgs = {
  slug: Scalars['String'];
};

export type QueryGetPublicCategoriesArgs = {
  slug: Scalars['String'];
};

export type QueryGetPublicCountriesArgs = {
  slug: Scalars['String'];
};

export type QueryGetPublicFeaturesArgs = {
  slug: Scalars['String'];
};

export type QueryGetPublicSitesArgs = {
  slug: Scalars['String'];
};

export type QueryGetQuestionTypesArgs = {
  formCategoryId?: InputMaybe<Scalars['String']>;
};

export type QueryGetReportByIdArgs = {
  reportId: Scalars['String'];
};

export type QueryGetReportEventsArgs = {
  report: Scalars['String'];
};

export type QueryGetReportedCategoriesArgs = {
  isCOI?: InputMaybe<Scalars['Boolean']>;
};

export type QueryGetReportsPerCategoryPerMonthGraphArgs = {
  Timeframe?: InputMaybe<TimeframeInput>;
  caseCountryCodes?: InputMaybe<Array<Scalars['String']>>;
  caseRegionIds?: InputMaybe<Array<Scalars['String']>>;
  categories?: InputMaybe<Array<Scalars['String']>>;
  countries?: InputMaybe<Array<Scalars['String']>>;
  dateGroup: Scalars['String'];
  departments?: InputMaybe<Array<Scalars['String']>>;
  sites?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryGetRulesByStatusArgs = {
  status: Scalars['String'];
};

export type QueryGetSubmissionDateArgs = {
  report: Scalars['String'];
};

export type QueryGetSubstantiationStatusCountArgs = {
  Timeframe?: InputMaybe<TimeframeInput>;
  caseCountryCodes?: InputMaybe<Array<Scalars['String']>>;
  caseRegionIds?: InputMaybe<Array<Scalars['String']>>;
  categories?: InputMaybe<Array<Scalars['String']>>;
  countries?: InputMaybe<Array<Scalars['String']>>;
  departments?: InputMaybe<Array<Scalars['String']>>;
  sites?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryGetTimeInStatusHeroMetricArgs = {
  Timeframe?: InputMaybe<TimeframeInput>;
  caseCountryCodes?: InputMaybe<Array<Scalars['String']>>;
  caseRegionIds?: InputMaybe<Array<Scalars['String']>>;
  countries?: InputMaybe<Array<Scalars['String']>>;
  sites?: InputMaybe<Array<Scalars['String']>>;
  status: Scalars['String'];
};

export type QueryGetTimeToResolutionHeroMetricArgs = {
  Timeframe?: InputMaybe<TimeframeInput>;
  caseCountryCodes?: InputMaybe<Array<Scalars['String']>>;
  caseRegionIds?: InputMaybe<Array<Scalars['String']>>;
  countries?: InputMaybe<Array<Scalars['String']>>;
  sites?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryGetTotalCasesHeroMetricArgs = {
  Timeframe?: InputMaybe<TimeframeInput>;
  caseCountryCodes?: InputMaybe<Array<Scalars['String']>>;
  caseRegionIds?: InputMaybe<Array<Scalars['String']>>;
  countries?: InputMaybe<Array<Scalars['String']>>;
  sites?: InputMaybe<Array<Scalars['String']>>;
};

export type QueryGetUserChannelEntriesArgs = {
  channel: Scalars['String'];
};

export type QueryGetUserMessagesByReportArgs = {
  report: Scalars['String'];
  translate?: InputMaybe<Scalars['Boolean']>;
};

export type QueryGroupByIdArgs = {
  id: Scalars['String'];
};

export type QueryGroupUserCountArgs = {
  id: Scalars['String'];
};

export type QueryInvestigationPlanDocumentArgs = {
  caseId: Scalars['String'];
};

export type QueryInvestigationPlanJobStatusArgs = {
  caseId: Scalars['String'];
};

export type QueryMediaArgs = {
  id: Scalars['String'];
};

export type QueryMitigationPlansForDisclosureArgs = {
  caseId: Scalars['String'];
};

export type QueryMonthlyReportsBySourceArgs = {
  input: InsightsInput;
};

export type QueryOrganisationFormResponsesPaginatedArgs = {
  queryParams?: InputMaybe<FormResponseQueryParamsType>;
};

export type QueryOrganisationQuestionnairesArgs = {
  queryParams?: InputMaybe<QuestionnairesQueryParamsType>;
};

export type QueryQuestionnaireQuestionsArgs = {
  questionnaireId: Scalars['String'];
};

export type QueryReportCountArgs = {
  input: InsightsInput;
};

export type QueryReportsByCategoryArgs = {
  input: InsightsInput;
};

export type QueryReportsByDepartmentArgs = {
  input: InsightsInput;
};

export type QueryReportsByStatusArgs = {
  input: InsightsInput;
};

export type QueryReportsPaginatedArgs = {
  fuzzy?: InputMaybe<FuzzySearchInputType>;
  orderBy: OrderByInputType;
  pagination: PaginationInputType;
  searchBy?: InputMaybe<Array<SearchByInputType>>;
};

export type QueryRoutingRulesPaginatedArgs = {
  isCOI?: InputMaybe<Scalars['Boolean']>;
  orderBy: OrderByInputType;
  pagination: PaginationInputType;
};

export type QuerySearchCasesForLinkingArgs = {
  caseId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search: Scalars['String'];
};

export type QuerySearchUsersPaginatedArgs = {
  fuzzy?: InputMaybe<FuzzySearchInputType>;
  orderBy: OrderByInputType;
  pagination: PaginationInputType;
  searchBy?: InputMaybe<Array<SearchByInputType>>;
};

export type QueryUserByIdArgs = {
  id: Scalars['Int'];
};

export type QueryUsersPaginatedArgs = {
  orderBy: OrderByInputType;
  pagination: PaginationInputType;
};

export type QuestionLocaleType = {
  __typename?: 'QuestionLocaleType';
  createdAt: Scalars['DateTimeISO'];
  id: Scalars['String'];
  locale: Scalars['String'];
  organisation: Scalars['Float'];
  question: Scalars['String'];
  updatedAt: Scalars['DateTimeISO'];
  value: Scalars['String'];
};

export type QuestionOptionInput = {
  navigationAction?: InputMaybe<Scalars['String']>;
  optionOrder: Scalars['Int'];
  optionText: Scalars['String'];
  shouldAutoFlag?: InputMaybe<Scalars['Boolean']>;
  targetQuestionId?: InputMaybe<Scalars['String']>;
  translations?: InputMaybe<Array<QuestionOptionTranslationInput>>;
};

export type QuestionOptionTranslationInput = {
  languageCode: Scalars['String'];
  optionText: Scalars['String'];
};

export type QuestionTranslationInput = {
  description?: InputMaybe<Scalars['String']>;
  languageCode: Scalars['String'];
  questionText: Scalars['String'];
};

export type QuestionType = {
  __typename?: 'QuestionType';
  Locales: Array<QuestionLocaleType>;
  active: Scalars['Boolean'];
  answerType: Scalars['String'];
  createdAt: Scalars['DateTimeISO'];
  id: Scalars['String'];
  organisation: Scalars['Float'];
  originalType?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTimeISO'];
};

export enum QuestionTypeKey {
  Checkbox = 'CHECKBOX',
  DatabaseField = 'DATABASE_FIELD',
  DataGrid = 'DATA_GRID',
  DateTime = 'DATE_TIME',
  Dropdown = 'DROPDOWN',
  FileUpload = 'FILE_UPLOAD',
  LongText = 'LONG_TEXT',
  MultipleChoice = 'MULTIPLE_CHOICE',
  Number = 'NUMBER',
  Radio = 'RADIO',
  ShortText = 'SHORT_TEXT',
  Time = 'TIME',
}

export type QuestionnaireActivityLogFilterInput = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};

export type QuestionnaireCountryType = {
  __typename?: 'QuestionnaireCountryType';
  countryCode: Scalars['String'];
  countryName: Scalars['String'];
};

export type QuestionnaireDataBaseConfigType = {
  __typename?: 'QuestionnaireDataBaseConfigType';
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  subTypeKey?: Maybe<Scalars['String']>;
};

export type QuestionnaireDataGridColumnType = {
  __typename?: 'QuestionnaireDataGridColumnType';
  key: Scalars['String'];
  label: Scalars['String'];
  type: Scalars['String'];
};

export type QuestionnaireDataGridConfigType = {
  __typename?: 'QuestionnaireDataGridConfigType';
  addRowLabel?: Maybe<Scalars['String']>;
  columns: Array<QuestionnaireDataGridColumnType>;
  maxRows?: Maybe<Scalars['Int']>;
  minRows?: Maybe<Scalars['Int']>;
  removeRowLabel?: Maybe<Scalars['String']>;
};

export type QuestionnaireFilterInput = {
  accessScope?: InputMaybe<AccessScope>;
  category?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['Int']>;
  formCategoryId?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  languageId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<QuestionnaireStatus>;
};

export type QuestionnaireListItemType = {
  __typename?: 'QuestionnaireListItemType';
  accessScope?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  internalName?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  languageId?: Maybe<Scalars['String']>;
  publicTitle?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
};

export type QuestionnaireQuestionOptionType = {
  __typename?: 'QuestionnaireQuestionOptionType';
  id?: Maybe<Scalars['String']>;
  optionOrder?: Maybe<Scalars['Int']>;
  optionText?: Maybe<Scalars['String']>;
};

export type QuestionnaireQuestionType = {
  __typename?: 'QuestionnaireQuestionType';
  allowMultiSelect?: Maybe<Scalars['Boolean']>;
  attachmentAllowed?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  dataGridConfig?: Maybe<QuestionnaireDataGridConfigType>;
  databaseFieldSubType?: Maybe<QuestionnaireDataBaseConfigType>;
  databaseFieldSubTypeId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  interestTypeId?: Maybe<Scalars['String']>;
  isRequired?: Maybe<Scalars['Boolean']>;
  languageId?: Maybe<Scalars['String']>;
  options?: Maybe<Array<QuestionnaireQuestionOptionType>>;
  orderIndex?: Maybe<Scalars['Int']>;
  questionText?: Maybe<Scalars['String']>;
  questionType?: Maybe<QuestionnaireQuestionTypeType>;
  questionnaireId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type QuestionnaireQuestionTypeType = {
  __typename?: 'QuestionnaireQuestionTypeType';
  allowsOptions?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  typeKey?: Maybe<Scalars['String']>;
};

export type QuestionnaireQuestionsResponseType = {
  __typename?: 'QuestionnaireQuestionsResponseType';
  count?: Maybe<Scalars['Int']>;
  questions?: Maybe<Array<QuestionnaireQuestionType>>;
};

export type QuestionnaireResponseAttachmentType = {
  __typename?: 'QuestionnaireResponseAttachmentType';
  answerId?: Maybe<Scalars['String']>;
  fileExtension?: Maybe<Scalars['String']>;
  fileKey?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  fileSize?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  mimeType?: Maybe<Scalars['String']>;
  uploadedAt?: Maybe<Scalars['String']>;
};

export type QuestionnaireStatsType = {
  __typename?: 'QuestionnaireStatsType';
  completedResponses?: Maybe<Scalars['Int']>;
  flaggedResponses?: Maybe<Scalars['Int']>;
  totalQuestions?: Maybe<Scalars['Int']>;
  totalResponses?: Maybe<Scalars['Int']>;
};

export enum QuestionnaireStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Inactive = 'INACTIVE',
}

export type QuestionnaireSuccessResponse = {
  __typename?: 'QuestionnaireSuccessResponse';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type QuestionnaireTranslationInputType = {
  description?: InputMaybe<Scalars['String']>;
  languageCode: Scalars['String'];
  languageName: Scalars['String'];
  publicTitle?: InputMaybe<Scalars['String']>;
};

export type QuestionnaireTranslationType = {
  __typename?: 'QuestionnaireTranslationType';
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  languageCode: Scalars['String'];
  languageName: Scalars['String'];
  publicTitle?: Maybe<Scalars['String']>;
};

export type QuestionnaireType = {
  __typename?: 'QuestionnaireType';
  attestationText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  publicTitle?: Maybe<Scalars['String']>;
};

export type QuestionnairesQueryParamsType = {
  accessScope?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['Int']>;
  formCategoryId?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  languageId?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export type QuestionsListResponse = {
  __typename?: 'QuestionsListResponse';
  count?: Maybe<Scalars['Int']>;
  questions?: Maybe<Array<FormManagementQuestion>>;
};

export type ReactivateCustomFieldInputType = {
  id: Scalars['String'];
};

export type RegionType = {
  __typename?: 'RegionType';
  countries: Array<CountryType>;
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
};

export type RegisterQuestionnaireResponseAttachmentPayload = {
  __typename?: 'RegisterQuestionnaireResponseAttachmentPayload';
  attachment?: Maybe<QuestionnaireResponseAttachmentType>;
};

export type RelationshipType = {
  __typename?: 'RelationshipType';
  id: Scalars['Float'];
  locale: Scalars['String'];
  name: Scalars['String'];
  relationshipType: Scalars['Float'];
};

export type RemovePermissionType = {
  accountId: Scalars['Float'];
  entityId: Scalars['String'];
  permissionId: Scalars['String'];
};

export type ReorderCustomFieldSectionsInputType = {
  orders: Array<CustomFieldSectionOrderInputType>;
};

export type ReorderCustomFieldsInputType = {
  draggedFieldId: Scalars['String'];
  values: Array<CustomFieldOrderInputType>;
};

export type ReorderQuestionInput = {
  newOrderIndex: Scalars['Int'];
};

export type ReorderQuestionResponse = {
  __typename?: 'ReorderQuestionResponse';
  id?: Maybe<Scalars['String']>;
  newOrderIndex?: Maybe<Scalars['Int']>;
  oldOrderIndex?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type ReportCategoryObjectType = {
  __typename?: 'ReportCategoryObjectType';
  category: Scalars['String'];
};

export type ReportEventInput = {
  id: Scalars['String'];
  report?: InputMaybe<Scalars['String']>;
};

export type ReportEventType = {
  __typename?: 'ReportEventType';
  EventData: Array<EventDataType>;
  EventMedia: Array<EventMediaType>;
  NamedOffenders: Array<NamedOffender>;
  createdAt: Scalars['DateTimeISO'];
  id: Scalars['String'];
  organisation: Scalars['Float'];
  report: Scalars['String'];
  updatedAt: Scalars['DateTimeISO'];
};

export type ReportNotesType = {
  __typename?: 'ReportNotesType';
  notes?: Maybe<Scalars['String']>;
};

export type ReportPermissionsType = {
  __typename?: 'ReportPermissionsType';
  account: Scalars['Int'];
  createdAt: Scalars['DateTimeISO'];
  id: Scalars['Int'];
  organisation: Scalars['Int'];
  permission: Scalars['String'];
  report: Scalars['Int'];
  updatedAt: Scalars['DateTimeISO'];
};

export enum ReportStatus {
  Closed = 'CLOSED',
  Draft = 'DRAFT',
  Investigating = 'INVESTIGATING',
  Lodged = 'LODGED',
  New = 'NEW',
  Read = 'READ',
}

export type ReportType = {
  __typename?: 'ReportType';
  Assignee?: Maybe<UserType>;
  AssociatedPermissions?: Maybe<AssociatedReportPermissionsType>;
  AudioRecordings: Array<CallRecordingUrlType>;
  DeterminedCategory?: Maybe<CategoryDisplayType>;
  Evidence?: Maybe<DecryptedEvidenceType>;
  Perpetrators?: Maybe<Array<UserType>>;
  PhoneLineType?: Maybe<Scalars['String']>;
  ReportEvents: Array<ReportEventType>;
  ReportNotes?: Maybe<ReportNotesType>;
  ReportedCategory?: Maybe<CategoryDisplayType>;
  Reporter?: Maybe<UserType>;
  anonymous?: Maybe<Scalars['Boolean']>;
  assignee: Scalars['Float'];
  category: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTimeISO']>;
  determinedCategory?: Maybe<Scalars['Float']>;
  dominantLanguage: Scalars['String'];
  existingReport: Scalars['Boolean'];
  id: Scalars['String'];
  miReportSource?: Maybe<Scalars['String']>;
  postSubmissionFiles?: Maybe<Array<UploadType>>;
  readableId: Scalars['String'];
  reportedCategory?: Maybe<Scalars['Float']>;
  reporter?: Maybe<Scalars['String']>;
  reporterExists: Scalars['Boolean'];
  source: Scalars['String'];
  status: Scalars['String'];
  submissionMode?: Maybe<Scalars['Int']>;
  submittedAt?: Maybe<Scalars['DateTimeISO']>;
  substantiation?: Maybe<Scalars['String']>;
  unreadMessagesCount?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['DateTimeISO'];
};

export type ReportTypeEvidenceArgs = {
  translation?: InputMaybe<Scalars['String']>;
};

export type ReporterUserSettingsType = {
  notificationsEnabled?: InputMaybe<Scalars['Boolean']>;
  translationEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type ReportsByCategory = {
  __typename?: 'ReportsByCategory';
  category: Scalars['String'];
  count: Scalars['Int'];
};

export type ReportsByDepartment = {
  __typename?: 'ReportsByDepartment';
  count: Scalars['Int'];
  department: Scalars['String'];
};

export type ReportsByStatus = {
  __typename?: 'ReportsByStatus';
  count: Scalars['Int'];
  status: VisibleReportStatus;
};

export type RespondentType = {
  __typename?: 'RespondentType';
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type ResponseMessageType = {
  __typename?: 'ResponseMessageType';
  author: Scalars['String'];
  channel: Scalars['String'];
  createdAt: Scalars['DateTimeISO'];
  deletedAt?: Maybe<Scalars['DateTimeISO']>;
  deletedBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isReporter: Scalars['Boolean'];
  state: Scalars['Int'];
  translated: Scalars['Boolean'];
  updatedAt: Scalars['DateTimeISO'];
  value: Scalars['String'];
};

export enum ResponseStatus {
  Approved = 'APPROVED',
  AutoClosed = 'AUTO_CLOSED',
  Draft = 'DRAFT',
  Flagged = 'FLAGGED',
  Submitted = 'SUBMITTED',
  UnderReview = 'UNDER_REVIEW',
}

export enum RetentionQueueStatusEnum {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Queued = 'QUEUED',
}

export type RetentionRuleType = {
  __typename?: 'RetentionRuleType';
  authorId: Scalars['Int'];
  conditions: Scalars['JSON'];
  country?: Maybe<Scalars['String']>;
  countryRule?: Maybe<CountryRuleEnum>;
  createdAt: Scalars['DateTimeISO'];
  dateReference: DateReferenceEnum;
  fallbackRule: Scalars['Boolean'];
  id: Scalars['String'];
  organisationId: Scalars['Int'];
  requiresManualApproval: Scalars['Boolean'];
  ruleApproved: Scalars['Boolean'];
  ruleType?: Maybe<RuleTypeEnum>;
  status: RuleStatusEnum;
  updatedAt: Scalars['DateTimeISO'];
};

export type RetentionRulesByCountryType = {
  __typename?: 'RetentionRulesByCountryType';
  country: Scalars['String'];
  rules: Array<RetentionRuleType>;
};

export type RoleType = {
  __typename?: 'RoleType';
  SystemPermissions?: Maybe<Array<PermissionType>>;
  createdAt: Scalars['DateTimeISO'];
  description: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  organisation: Scalars['Float'];
  updatedAt: Scalars['DateTimeISO'];
};

export type RoutingRulePriorities = {
  __typename?: 'RoutingRulePriorities';
  id: Scalars['String'];
  priority: Scalars['Float'];
};

export type RoutingRuleType = {
  __typename?: 'RoutingRuleType';
  Author?: Maybe<UserType>;
  author: Scalars['Int'];
  createdAt: Scalars['DateTimeISO'];
  destinationGroup?: Maybe<Scalars['String']>;
  disabled: Scalars['Boolean'];
  groupAssignment: Scalars['Boolean'];
  id: Scalars['String'];
  isCOI: Scalars['Boolean'];
  name: Scalars['String'];
  organisation: Scalars['Int'];
  priority: Scalars['Int'];
  rule: Scalars['JSON'];
  updatedAt: Scalars['DateTimeISO'];
};

export enum RuleStatusEnum {
  Awaiting = 'AWAITING',
  Declined = 'DECLINED',
  Draft = 'DRAFT',
  Live = 'LIVE',
}

export enum RuleTypeEnum {
  Anonymization = 'ANONYMIZATION',
  Deletion = 'DELETION',
}

export type SanitizedOrDeletedCaseType = {
  __typename?: 'SanitizedOrDeletedCaseType';
  CaseLead?: Maybe<UserType>;
  RetentionRule?: Maybe<RetentionRuleType>;
  caseLead?: Maybe<Scalars['Int']>;
  closedAt?: Maybe<Scalars['DateTimeISO']>;
  completedAt?: Maybe<Scalars['DateTimeISO']>;
  createdAt: Scalars['DateTimeISO'];
  deletedAt?: Maybe<Scalars['DateTimeISO']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  readableId?: Maybe<Scalars['String']>;
  sanitizedAt?: Maybe<Scalars['DateTimeISO']>;
  status: ReportStatus;
  substantiation?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTimeISO'];
};

export type SaveAnswerInputType = {
  questionId: Scalars['String'];
  value: AnswerValueInputType;
};

export type SearchByInputType = {
  fieldName: Scalars['String'];
  fieldValue: Scalars['String'];
};

export type SectionFieldType = {
  __typename?: 'SectionFieldType';
  id: Scalars['String'];
  label: Scalars['String'];
};

export type SetCaseCountryRegionInput = {
  caseId: Scalars['String'];
  countryCode?: InputMaybe<Scalars['String']>;
  regionId?: InputMaybe<Scalars['String']>;
};

export type SetCaseCustomFieldValueInputType = {
  caseId: Scalars['String'];
  customFieldId: Scalars['String'];
  optionId?: InputMaybe<Scalars['String']>;
  valueText?: InputMaybe<Scalars['String']>;
};

export type SignatureSectionInput = {
  agreementLabel?: InputMaybe<Scalars['String']>;
  attestationText?: InputMaybe<Scalars['String']>;
};

export type SiteType = {
  __typename?: 'SiteType';
  name: Scalars['String'];
};

export type SuccessResponse = {
  __typename?: 'SuccessResponse';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type SystemRoleType = {
  id: Scalars['String'];
  label?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type TagOrderType = {
  __typename?: 'TagOrderType';
  order: Scalars['Float'];
  tagId: Scalars['String'];
};

export type TagType = {
  __typename?: 'TagType';
  id: Scalars['String'];
  name: Scalars['String'];
  order: Scalars['Float'];
  status: Scalars['String'];
  statusUpdatedAt?: Maybe<Scalars['DateTimeISO']>;
  tagType?: Maybe<TagTypeType>;
};

export type TagTypeOrderType = {
  __typename?: 'TagTypeOrderType';
  id: Scalars['String'];
  order: Scalars['Float'];
};

export type TagTypeType = {
  __typename?: 'TagTypeType';
  Author?: Maybe<UserType>;
  Tags?: Maybe<Array<TagType>>;
  colorId: Scalars['Float'];
  createdAt?: Maybe<Scalars['DateTimeISO']>;
  id: Scalars['String'];
  name: Scalars['String'];
  order?: Maybe<Scalars['Float']>;
  status: Scalars['String'];
  statusUpdatedAt?: Maybe<Scalars['DateTimeISO']>;
};

export type TextRange = {
  length: Scalars['Float'];
  offset: Scalars['Float'];
};

export type TimeframeInput = {
  end?: InputMaybe<Scalars['DateTimeISO']>;
  start?: InputMaybe<Scalars['DateTimeISO']>;
};

export type TranslateFormDraftContentInput = {
  formDescription?: InputMaybe<Scalars['String']>;
  formTitle?: InputMaybe<Scalars['String']>;
  introduction?: InputMaybe<Scalars['String']>;
  questions: Array<TranslateFormQuestionInput>;
  /** Canonical form language; must be en-GB. Source text is always read from en-GB fields regardless of UI locale. */
  sourceLanguageCode: Scalars['String'];
  targetLanguageCode: Scalars['String'];
};

export type TranslateFormDraftContentPayload = {
  __typename?: 'TranslateFormDraftContentPayload';
  formDescription?: Maybe<Scalars['String']>;
  formTitle?: Maybe<Scalars['String']>;
  introduction?: Maybe<Scalars['String']>;
  questions: Array<TranslateFormQuestionResult>;
  warnings: Array<Scalars['String']>;
};

export type TranslateFormOptionInput = {
  optionOrder: Scalars['Int'];
  optionText: Scalars['String'];
};

export type TranslateFormOptionResult = {
  __typename?: 'TranslateFormOptionResult';
  optionOrder: Scalars['Int'];
  optionText: Scalars['String'];
};

export type TranslateFormQuestionInput = {
  description?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Array<TranslateFormOptionInput>>;
  orderIndex: Scalars['Int'];
  questionText: Scalars['String'];
};

export type TranslateFormQuestionResult = {
  __typename?: 'TranslateFormQuestionResult';
  description?: Maybe<Scalars['String']>;
  options?: Maybe<Array<TranslateFormOptionResult>>;
  orderIndex: Scalars['Int'];
  questionText: Scalars['String'];
};

export type UpdateCaseAttributes = {
  caseId: Scalars['String'];
  closedAt?: InputMaybe<Scalars['DateTimeISO']>;
  companyCreatedAt?: InputMaybe<Scalars['DateTimeISO']>;
  investigatingAt?: InputMaybe<Scalars['DateTimeISO']>;
  readAt?: InputMaybe<Scalars['DateTimeISO']>;
};

export type UpdateCategoryLocaleType = {
  description: Scalars['String'];
  id: Scalars['Int'];
  locale: Scalars['String'];
  name: Scalars['String'];
};

export type UpdateCategoryOrderType = {
  id: Scalars['String'];
  order: Scalars['Float'];
};

export type UpdateCategoryType = {
  allowGoTogether?: InputMaybe<Scalars['Boolean']>;
  displayInApp?: InputMaybe<Scalars['Boolean']>;
  displayInCollaborationToolIntegration?: InputMaybe<Scalars['Boolean']>;
  displayInManualIntake?: InputMaybe<Scalars['Boolean']>;
  displayInOpenReporting?: InputMaybe<Scalars['Boolean']>;
  displayInVaultTalk?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  isCustomQuestions?: InputMaybe<Scalars['Boolean']>;
  isDeterminedCategory?: InputMaybe<Scalars['Boolean']>;
  isReportedCategory?: InputMaybe<Scalars['Boolean']>;
  locales?: InputMaybe<Scalars['JSON']>;
  order?: InputMaybe<Scalars['Float']>;
  question?: InputMaybe<Scalars['Boolean']>;
  requestOpenPerpetrators?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateCustomFieldInputType = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  label?: InputMaybe<Scalars['String']>;
  sectionId?: InputMaybe<Scalars['String']>;
};

export type UpdateCustomFieldOptionsInputType = {
  customFieldId: Scalars['String'];
  options: Array<CustomFieldOptionInputType>;
};

export type UpdateCustomFieldSectionInputType = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  isDefault?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateDraftReportDetailsInput = {
  anonymous?: InputMaybe<Scalars['Boolean']>;
  assignee?: InputMaybe<Scalars['Int']>;
  determinedCategory?: InputMaybe<Scalars['Int']>;
  eventData?: InputMaybe<Array<EventDataInput>>;
  eventNamedOffenderExternal?: InputMaybe<
    Array<EventNamedOffenderExternalInput>
  >;
  eventNamedOffenderInternal?: InputMaybe<
    Array<EventNamedOffenderInternalInput>
  >;
  id: Scalars['Float'];
  media?: InputMaybe<Array<EventMediaInput>>;
  miReportSource?: InputMaybe<MiReportSource>;
  reportEvents?: InputMaybe<Array<ReportEventInput>>;
  reportedCategory?: InputMaybe<Scalars['Int']>;
  reporter?: InputMaybe<Scalars['Int']>;
  substantiation?: InputMaybe<Scalars['String']>;
};

export type UpdateInvestigationChecklistResult = {
  __typename?: 'UpdateInvestigationChecklistResult';
  success: Scalars['Boolean'];
};

export type UpdateInvestigationPlanResult = {
  __typename?: 'UpdateInvestigationPlanResult';
  conflict?: Maybe<Scalars['Boolean']>;
  success: Scalars['Boolean'];
  version?: Maybe<Scalars['Int']>;
};

export type UpdateInvestigationStepResult = {
  __typename?: 'UpdateInvestigationStepResult';
  conflict?: Maybe<Scalars['Boolean']>;
  success: Scalars['Boolean'];
  updatedStatus?: Maybe<InvestigationStepStatus>;
};

export type UpdateMitigationPlanInput = {
  addSignatoryUserIds?: InputMaybe<Array<Scalars['Int']>>;
  addUploadIds?: InputMaybe<Array<Scalars['String']>>;
  deadline: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  planId: Scalars['String'];
  reminderFrequency: Scalars['Int'];
  reminderMaxCount?: InputMaybe<Scalars['Int']>;
  removeSignatoryIds?: InputMaybe<Array<Scalars['String']>>;
  title: Scalars['String'];
};

export type UpdateMitigationPlanSignatoriesInput = {
  addUserIds?: InputMaybe<Array<Scalars['Int']>>;
  planId: Scalars['String'];
  removeSignatoryIds?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateNotificationInput = {
  ids: Array<Scalars['Int']>;
  state: Scalars['Float'];
};

export type UpdatePasswordInput = {
  confirmation: Scalars['String'];
  current: Scalars['String'];
  password: Scalars['String'];
};

export type UpdateQuestionInput = {
  allowMultiSelect?: InputMaybe<Scalars['Boolean']>;
  attachmentAllowed?: InputMaybe<Scalars['Boolean']>;
  databaseFieldSubTypeId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  interestTypeId?: InputMaybe<Scalars['String']>;
  isRequired?: InputMaybe<Scalars['Boolean']>;
  options?: InputMaybe<Array<QuestionOptionInput>>;
  questionText?: InputMaybe<Scalars['String']>;
  shouldAutoFlagIfAnswered?: InputMaybe<Scalars['Boolean']>;
  translations?: InputMaybe<Array<QuestionTranslationInput>>;
};

export type UpdateQuestionnaireInput = {
  accessScope?: InputMaybe<AccessScope>;
  autoReviewEnabled?: InputMaybe<Scalars['Boolean']>;
  category?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['Int']>;
  countries?: InputMaybe<Array<CountryInputType>>;
  description?: InputMaybe<Scalars['String']>;
  introduction?: InputMaybe<Scalars['String']>;
  languages?: InputMaybe<Array<LanguageInputType>>;
  publicTitle?: InputMaybe<Scalars['String']>;
  targetDepartmentIds?: InputMaybe<Array<Scalars['String']>>;
  translations?: InputMaybe<Array<QuestionnaireTranslationInputType>>;
};

export type UpdateQuestionnaireStatusInput = {
  status: QuestionnaireStatus;
};

export type UpdateRetentionRuleInput = {
  conditions?: InputMaybe<Scalars['JSON']>;
  country?: InputMaybe<Scalars['String']>;
  countryRule?: InputMaybe<CountryRuleEnum>;
  dateReference?: InputMaybe<DateReferenceEnum>;
  id: Scalars['String'];
  requiresManualApproval?: InputMaybe<Scalars['Boolean']>;
  ruleApproved?: InputMaybe<Scalars['Boolean']>;
  ruleType?: InputMaybe<RuleTypeEnum>;
  status?: InputMaybe<RuleStatusEnum>;
};

export type UpdateRoutingRule = {
  destinationGroup?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  groupAssignment?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  priority?: InputMaybe<Scalars['Float']>;
  rule: Scalars['JSON'];
};

export type UpdateRoutingRulePriorities = {
  id: Scalars['String'];
  priority: Scalars['Float'];
};

export type UpdateTagOrdersType = {
  order: Scalars['Float'];
  tagId: Scalars['String'];
};

export type UpdateTagType = {
  name: Scalars['String'];
  status: Scalars['String'];
  tagId: Scalars['String'];
  type: Scalars['String'];
};

export type UpdateTagTypeOrdersType = {
  id: Scalars['String'];
  order: Scalars['Float'];
};

export type UpdateTagTypeStatusType = {
  id: Scalars['String'];
  status: Scalars['String'];
};

export type UploadInput = {
  fileExtension: Scalars['String'];
  mimeType: Scalars['String'];
  s3path: Scalars['String'];
  size: Scalars['Float'];
};

/** The source of uploaded evidence for a report */
export enum UploadSource {
  App = 'APP',
  AppPostsubmission = 'APP_POSTSUBMISSION',
  MitigationPlan = 'MITIGATION_PLAN',
  Opr = 'OPR',
  OprPostsubmission = 'OPR_POSTSUBMISSION',
  ReporterHubPostsubmission = 'REPORTER_HUB_POSTSUBMISSION',
  ReporterPortal = 'REPORTER_PORTAL',
  ReporterPortalPostsubmission = 'REPORTER_PORTAL_POSTSUBMISSION',
  ReshubBulkImport = 'RESHUB_BULK_IMPORT',
  ReshubManualIntake = 'RESHUB_MANUAL_INTAKE',
  ReshubWorkspace = 'RESHUB_WORKSPACE',
  Unknown = 'UNKNOWN',
}

export type UploadType = {
  __typename?: 'UploadType';
  createdAt: Scalars['DateTimeISO'];
  dataDeletedAt?: Maybe<Scalars['DateTimeISO']>;
  dataDeletedBy?: Maybe<Scalars['Int']>;
  fileExtension: Scalars['String'];
  id: Scalars['String'];
  mimeType: Scalars['String'];
  s3path: Scalars['String'];
  scanStatus: Scalars['String'];
  size: Scalars['Float'];
  updatedAt: Scalars['DateTimeISO'];
  uploadSource: Scalars['String'];
};

export type UserReportFullType = {
  __typename?: 'UserReportFullType';
  anonymous?: Maybe<Scalars['Boolean']>;
  category?: Maybe<Scalars['String']>;
  evidence: EvidenceType;
  id: Scalars['String'];
  perpetrators?: Maybe<Array<UserReportPerpetratorType>>;
  postSubmissionFiles?: Maybe<Array<UploadType>>;
  relationshipType?: Maybe<Scalars['String']>;
  report: Scalars['String'];
  reportReadableId: Scalars['String'];
  reportedCategoryLocale?: Maybe<CategoryDisplayType>;
  source: Scalars['String'];
  status: Scalars['String'];
  submissionMode?: Maybe<Scalars['String']>;
  submittedAt?: Maybe<Scalars['DateTimeISO']>;
  unreadMessagesCount: Scalars['Float'];
};

export type UserReportPerpetratorType = {
  __typename?: 'UserReportPerpetratorType';
  dataDeletedAt?: Maybe<Scalars['DateTimeISO']>;
  external: Scalars['Boolean'];
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type UserReportType = {
  __typename?: 'UserReportType';
  category?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  report: Scalars['String'];
  reportReadableId: Scalars['String'];
  reportedCategoryLocale?: Maybe<CategoryDisplayType>;
  status: Scalars['String'];
  submissionMode?: Maybe<Scalars['String']>;
  submittedAt?: Maybe<Scalars['DateTimeISO']>;
  unreadMessagesCount: Scalars['Float'];
};

export type UserType = {
  __typename?: 'UserType';
  Accounts?: Maybe<Array<AccountType>>;
  Manager?: Maybe<UserType>;
  Organisation?: Maybe<OrganisationType>;
  Reportees?: Maybe<Array<UserType>>;
  SystemRoles?: Maybe<Array<OrganisationRoleType>>;
  accounts?: Maybe<Array<AccountType>>;
  available?: Maybe<Scalars['Boolean']>;
  contactEmail?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  eid?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  id: Scalars['Float'];
  managerId?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  organisation?: Maybe<Scalars['Float']>;
  permissions?: Maybe<Array<Scalars['String']>>;
  relationshipToCompany?: Maybe<Scalars['Float']>;
  relationshipToOrganisation?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  site?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  tags?: Maybe<Array<Scalars['String']>>;
  translationEnabled?: Maybe<Scalars['Boolean']>;
  uuid?: Maybe<Scalars['String']>;
};

export type ValidatedCases = {
  __typename?: 'ValidatedCases';
  casesToCreate: Array<BulkCreateNewCases>;
  duplicateCases: Array<DuplicateCaseType>;
  importFileName: Scalars['String'];
  totalCasesInCSV: Scalars['Float'];
};

export type ValidatedUsers = {
  __typename?: 'ValidatedUsers';
  totalUsersInCSV: Scalars['Float'];
  usersToCreate: Array<BulkReinviteNewUser>;
  usersToDeactivate: Array<BulkReinviteExistingUser>;
  usersToReinvite: Array<BulkReinviteExistingUser>;
  usersToUpdate: Array<BulkReinviteExistingUser>;
};

export enum VisibleReportStatus {
  Closed = 'CLOSED',
  Investigating = 'INVESTIGATING',
  New = 'NEW',
  Read = 'READ',
}

export type BarStackedCasesFiltersTypes = {
  closed: Scalars['Boolean'];
  open: Scalars['Boolean'];
};

export type RegisterUserMutationVariables = Exact<{
  token: Scalars['String'];
  password: Scalars['String'];
}>;

export type RegisterUserMutation = {
  __typename?: 'Mutation';
  registerUser?: {
    __typename?: 'AccountType';
    id: number;
    kind: string;
    username: string;
  } | null;
};

export type MyAccountQueryVariables = Exact<{ [key: string]: never }>;

export type MyAccountQuery = {
  __typename?: 'Query';
  myAccount?: {
    __typename?: 'AccountType';
    id: number;
    kind: string;
    notificationsEnabled?: boolean | null;
    translationEnabled?: boolean | null;
  } | null;
};

export type CreateAuditEntryMutationVariables = Exact<{
  auditAction: Scalars['String'];
  auditData: Scalars['JSON'];
  completed: Scalars['Boolean'];
}>;

export type CreateAuditEntryMutation = {
  __typename?: 'Mutation';
  createAuditEntry?: {
    __typename?: 'AuditEntryType';
    id: number;
    completed?: boolean | null;
  } | null;
};

export type CompleteAuditEntryMutationVariables = Exact<{
  id: Scalars['Float'];
}>;

export type CompleteAuditEntryMutation = {
  __typename?: 'Mutation';
  completeAuditEntry?: {
    __typename?: 'AuditEntryType';
    id: number;
    completed?: boolean | null;
  } | null;
};

export type GetRoutingAuditEntriesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetRoutingAuditEntriesQuery = {
  __typename?: 'Query';
  routingAuditEntries?: Array<{
    __typename?: 'AuditEntryType';
    id: number;
    DescriptiveText: string;
    action?: string | null;
    completed?: boolean | null;
    createdAt?: any | null;
    data?: any | null;
    organisation: number;
    updatedAt?: any | null;
    user?: number | null;
    User?: { __typename?: 'UserType'; id: number; name?: string | null } | null;
  }> | null;
};

export type GetCategoriesAuditEntriesQueryVariables = Exact<{
  isCOI?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetCategoriesAuditEntriesQuery = {
  __typename?: 'Query';
  categoriesAuditEntries?: Array<{
    __typename?: 'AuditEntryType';
    id: number;
    action?: string | null;
    completed?: boolean | null;
    createdAt?: any | null;
    data?: any | null;
    organisation: number;
    User?: {
      __typename?: 'UserType';
      id: number;
      name?: string | null;
      displayName?: string | null;
    } | null;
  }> | null;
};

export type GetTagsAuditEntriesQueryVariables = Exact<{ [key: string]: never }>;

export type GetTagsAuditEntriesQuery = {
  __typename?: 'Query';
  tagsAuditEntries?: Array<{
    __typename?: 'AuditEntryType';
    id: number;
    action?: string | null;
    completed?: boolean | null;
    createdAt?: any | null;
    data?: any | null;
    organisation: number;
    User?: {
      __typename?: 'UserType';
      id: number;
      name?: string | null;
      displayName?: string | null;
    } | null;
  }> | null;
};

export type GetCaseDataDownloadAuditEntriesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetCaseDataDownloadAuditEntriesQuery = {
  __typename?: 'Query';
  caseDataDownloadAuditEntries?: Array<{
    __typename?: 'AuditEntryType';
    id: number;
    action?: string | null;
    completed?: boolean | null;
    createdAt?: any | null;
    data?: any | null;
    organisation: number;
    User?: {
      __typename?: 'UserType';
      id: number;
      name?: string | null;
      displayName?: string | null;
    } | null;
  }> | null;
};

export type GetUserRolesAuditEntriesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetUserRolesAuditEntriesQuery = {
  __typename?: 'Query';
  userRolesAuditEntries?: Array<{
    __typename?: 'AuditEntryType';
    id: number;
    action?: string | null;
    completed?: boolean | null;
    createdAt?: any | null;
    data?: any | null;
    organisation: number;
    User?: {
      __typename?: 'UserType';
      id: number;
      name?: string | null;
      displayName?: string | null;
    } | null;
  }> | null;
};

export type GetAuditEntriesByDraftReportQueryVariables = Exact<{
  report: Scalars['String'];
}>;

export type GetAuditEntriesByDraftReportQuery = {
  __typename?: 'Query';
  auditEntriesByDraftReport?: Array<{
    __typename?: 'AuditEntryType';
    id: number;
    action?: string | null;
    completed?: boolean | null;
    createdAt?: any | null;
    updatedAt?: any | null;
    data?: any | null;
    organisation: number;
    User?: {
      __typename?: 'UserType';
      id: number;
      name?: string | null;
      displayName?: string | null;
    } | null;
  }> | null;
};

export type UnlinkCasesMutationVariables = Exact<{
  linkId: Scalars['String'];
}>;

export type UnlinkCasesMutation = {
  __typename?: 'Mutation';
  unlinkCases: boolean;
};

export type CaseByIdQueryVariables = Exact<{
  id: Scalars['String'];
  translation?: InputMaybe<Scalars['String']>;
}>;

export type CaseByIdQuery = {
  __typename?: 'Query';
  caseById?: {
    __typename?: 'CaseType';
    id: string;
    status: string;
    name?: string | null;
    sanitizedAt?: any | null;
    createdAt?: any | null;
    updatedAt?: any | null;
    descriptionUpdatedAt?: any | null;
    organisation: number;
    readableId: string;
    importedId?: string | null;
    description?: string | null;
    AssociatedPermissions?: {
      __typename?: 'AssociatedCasePermissionsType';
      canEditCaseDetails?: boolean | null;
      canViewCaseDetails?: boolean | null;
      canViewCaseDetailsPii?: boolean | null;
      canViewCaseWorkspaceTab?: boolean | null;
      canEditCaseWorkspaceTab?: boolean | null;
      canViewCaseAuditLogsTab?: boolean | null;
      canViewCase?: boolean | null;
      canEditCaseClosedDate?: boolean | null;
      canEditCaseCriDates?: boolean | null;
      canAdministerCasePermissions?: boolean | null;
    } | null;
    AllCaseLeads?: Array<{
      __typename?: 'UserType';
      id: number;
      name?: string | null;
      role?: string | null;
      site?: string | null;
      country?: string | null;
      permissions?: Array<string> | null;
    }> | null;
    AllCaseTeamMembers?: Array<{
      __typename?: 'UserType';
      id: number;
      name?: string | null;
      role?: string | null;
      site?: string | null;
      country?: string | null;
      permissions?: Array<string> | null;
      accounts?: Array<{
        __typename?: 'AccountType';
        Roles?: Array<{
          __typename?: 'RoleType';
          SystemPermissions?: Array<{
            __typename?: 'PermissionType';
            permission: string;
          }> | null;
        }> | null;
      }> | null;
    }> | null;
    CaseLead?: {
      __typename?: 'UserType';
      id: number;
      email?: string | null;
      name?: string | null;
      available?: boolean | null;
      country?: string | null;
      displayName?: string | null;
      permissions?: Array<string> | null;
      site?: string | null;
      accounts?: Array<{
        __typename?: 'AccountType';
        Roles?: Array<{
          __typename?: 'RoleType';
          SystemPermissions?: Array<{
            __typename?: 'PermissionType';
            permission: string;
          }> | null;
        }> | null;
      }> | null;
    } | null;
    Reports?: Array<{
      __typename?: 'ReportType';
      anonymous?: boolean | null;
      category: string;
      createdAt?: any | null;
      dominantLanguage: string;
      source: string;
      submittedAt?: any | null;
      status: string;
      updatedAt: any;
      substantiation?: string | null;
      submissionMode?: number | null;
      unreadMessagesCount?: number | null;
      reporter?: string | null;
      id: string;
      readableId: string;
      reporterExists: boolean;
      PhoneLineType?: string | null;
      miReportSource?: string | null;
      AssociatedPermissions?: {
        __typename?: 'AssociatedReportPermissionsType';
        canEditReportDetails?: boolean | null;
        canSendReportMessages?: boolean | null;
        canViewReportDetails?: boolean | null;
        canViewReportMessages?: boolean | null;
        canViewReportDetailsPii?: boolean | null;
        canAddNamedOffender?: boolean | null;
        canAdministerReportPermissions?: boolean | null;
      } | null;
      DeterminedCategory?: {
        __typename?: 'CategoryDisplayType';
        id: number;
        name: string;
      } | null;
      ReportedCategory?: {
        __typename?: 'CategoryDisplayType';
        id: number;
        name: string;
      } | null;
      ReportNotes?: {
        __typename?: 'ReportNotesType';
        notes?: string | null;
      } | null;
      Assignee?: {
        __typename?: 'UserType';
        id: number;
        name?: string | null;
        expiresAt?: string | null;
        permissions?: Array<string> | null;
        site?: string | null;
      } | null;
      Perpetrators?: Array<{
        __typename?: 'UserType';
        id: number;
        site?: string | null;
        country?: string | null;
        department?: string | null;
        name?: string | null;
      }> | null;
      Evidence?: {
        __typename?: 'DecryptedEvidenceType';
        user?: string | null;
        status?: string | null;
        relationshipToCompany?: number | null;
        Events?: Array<{
          __typename?: 'ParsedEventsType';
          id: string;
          timestamp?: string | null;
          created: string;
          updated: string;
          report: string;
          evidence?: {
            __typename?: 'ParsedEvidenceType';
            date?: {
              __typename?: 'ParsedEvidenceDetailsType';
              value: any;
              createdAt: string;
              updatedAt: string;
              id: string;
            } | null;
            time?: {
              __typename?: 'ParsedEvidenceDetailsType';
              value: any;
              createdAt: string;
              updatedAt: string;
              id: string;
            } | null;
            location?: {
              __typename?: 'ParsedEvidenceDetailsType';
              value: any;
              createdAt: string;
              updatedAt: string;
              id: string;
            } | null;
            witness?: {
              __typename?: 'ParsedEvidenceDetailsType';
              value: any;
              createdAt: string;
              updatedAt: string;
              id: string;
            } | null;
            description?: {
              __typename?: 'ParsedEvidenceDetailsType';
              value: any;
              createdAt: string;
              updatedAt: string;
              id: string;
            } | null;
            emotion?: {
              __typename?: 'ParsedEvidenceDetailsType';
              value: any;
              createdAt: string;
              updatedAt: string;
              id: string;
            } | null;
            photo?: Array<{
              __typename?: 'FileEvidenceDetailsType';
              value: any;
              createdAt: string;
              updatedAt: string;
              id: string;
              scanStatus?: string | null;
              fileSize?: number | null;
              dataDeletedAt?: any | null;
            }> | null;
            perpetrator?: Array<{
              __typename?: 'ParsedEvidenceDetailsType';
              value: any;
              createdAt: string;
              updatedAt: string;
              id: string;
            }> | null;
          } | null;
        }> | null;
      } | null;
      Reporter?: {
        __typename?: 'UserType';
        id: number;
        email?: string | null;
        name?: string | null;
        role?: string | null;
        eid?: string | null;
        contactEmail?: string | null;
        relationshipToOrganisation?: string | null;
        department?: string | null;
        country?: string | null;
        site?: string | null;
      } | null;
      AudioRecordings: Array<{
        __typename?: 'CallRecordingUrlType';
        url: string;
        step: CallStep;
        dataDeletedAt?: any | null;
      }>;
      ReportEvents: Array<{
        __typename?: 'ReportEventType';
        id: string;
        NamedOffenders: Array<
          | {
              __typename?: 'ExternalNamedOffender';
              id: string;
              name: string;
              reportId?: string | null;
              event: string;
              createdAt: any;
              dataDeletedAt?: any | null;
              postSubmission: boolean;
              originalId?: string | null;
            }
          | {
              __typename?: 'InternalNamedOffender';
              id: string;
              reportId?: string | null;
              linkedPresubmissionOffender?: string | null;
              event: string;
              dataDeletedAt?: any | null;
              postSubmission: boolean;
              User?: {
                __typename?: 'UserType';
                id: number;
                name?: string | null;
                department?: string | null;
                site?: string | null;
                country?: string | null;
              } | null;
            }
        >;
      }>;
      postSubmissionFiles?: Array<{
        __typename?: 'UploadType';
        id: string;
        mimeType: string;
        size: number;
        fileExtension: string;
        s3path: string;
        scanStatus: string;
        uploadSource: string;
        createdAt: any;
        updatedAt: any;
        dataDeletedAt?: any | null;
        dataDeletedBy?: number | null;
      }> | null;
    }> | null;
    Categories: Array<{
      __typename?: 'CategoryDisplayType';
      id: number;
      name: string;
    }>;
    CaseDocuments?: Array<{
      __typename?: 'CaseDocumentationType';
      title?: string | null;
      value?: string | null;
      lastEdited: any;
      id: string;
      s3path?: string | null;
      Author: { __typename?: 'UserType'; id: number; name?: string | null };
      Uploads?: Array<{
        __typename?: 'CaseDocumentationUploadType';
        filename?: string | null;
        mimeType?: string | null;
        s3path: string;
        scanStatus?: string | null;
        scannedAt?: any | null;
        uploadSource?: UploadSource | null;
      }> | null;
    }> | null;
    CaseAttributes?: {
      __typename?: 'CaseAttributesType';
      companyCreatedAt?: any | null;
      readAt?: any | null;
      investigatingAt?: any | null;
      closedAt?: any | null;
    } | null;
    CaseCountryRegion?: {
      __typename?: 'CaseCountryRegionType';
      country?: {
        __typename?: 'CountryType';
        code: string;
        name: string;
      } | null;
      region?: {
        __typename?: 'RegionType';
        id: string;
        name: string;
        isActive: boolean;
        countries: Array<{
          __typename?: 'CountryType';
          code: string;
          name: string;
        }>;
      } | null;
    } | null;
    CaseTeam: Array<{
      __typename?: 'CaseTeamMemberType';
      id: number;
      name?: string | null;
      site?: string | null;
      permissions?: Array<string> | null;
      firstAccessedAt?: any | null;
      invitedAt: any;
      Roles?: Array<string> | null;
      Note?: {
        __typename?: 'CaseTeamNoteType';
        value: string;
        createdAt: any;
        inviterUser?: { __typename?: 'UserType'; name?: string | null } | null;
      } | null;
    }>;
    CaseTags: Array<{
      __typename?: 'TagType';
      id: string;
      name: string;
      tagType?: {
        __typename?: 'TagTypeType';
        id: string;
        name: string;
        colorId: number;
      } | null;
    }>;
    DisclosuresCaseData?: {
      __typename?: 'DisclosuresCaseDataType';
      responseId: string;
      importType: string;
    } | null;
  } | null;
};

export type CaseTeamMemberFragmentFragment = {
  __typename?: 'CaseTeamMemberType';
  id: number;
  name?: string | null;
  site?: string | null;
  permissions?: Array<string> | null;
  firstAccessedAt?: any | null;
  invitedAt: any;
  Roles?: Array<string> | null;
  Note?: {
    __typename?: 'CaseTeamNoteType';
    value: string;
    createdAt: any;
    inviterUser?: { __typename?: 'UserType'; name?: string | null } | null;
  } | null;
};

export type AssignableCaseLeadsByCaseIdQueryVariables = Exact<{
  caseByIdId: Scalars['String'];
}>;

export type AssignableCaseLeadsByCaseIdQuery = {
  __typename?: 'Query';
  caseById?: {
    __typename?: 'CaseType';
    id: string;
    AllCaseLeads?: Array<{
      __typename?: 'UserType';
      id: number;
      name?: string | null;
      site?: string | null;
      country?: string | null;
    }> | null;
  } | null;
};

export type CasesQueryVariables = Exact<{
  pagination: PaginationInputType;
  orderBy: OrderByInputType;
  searchBy?: InputMaybe<Array<SearchByInputType> | SearchByInputType>;
  fuzzy?: InputMaybe<FuzzySearchInputType>;
  appliedFilters?: InputMaybe<AppliedFiltersType>;
}>;

export type CasesQuery = {
  __typename?: 'Query';
  casesPaginated: {
    __typename?: 'PaginatedCaseTypeResponse';
    count: number;
    items: Array<{
      __typename?: 'CaseType';
      name?: string | null;
      id: string;
      createdAt?: any | null;
      updatedAt?: any | null;
      status: string;
      readableId: string;
      hasDynamicQuestions?: boolean | null;
      caseLinksCount?: number | null;
      CaseLead?: {
        __typename?: 'UserType';
        id: number;
        name?: string | null;
      } | null;
      Reports?: Array<{
        __typename?: 'ReportType';
        id: string;
        source: string;
        existingReport: boolean;
        Assignee?: { __typename?: 'UserType'; name?: string | null } | null;
        Reporter?: { __typename?: 'UserType'; id: number } | null;
        DeterminedCategory?: {
          __typename?: 'CategoryDisplayType';
          id: number;
          name: string;
        } | null;
        ReportedCategory?: {
          __typename?: 'CategoryDisplayType';
          id: number;
          name: string;
        } | null;
        AssociatedPermissions?: {
          __typename?: 'AssociatedReportPermissionsType';
          canEditReportDetails?: boolean | null;
          canSendReportMessages?: boolean | null;
          canViewReportDetails?: boolean | null;
          canViewReportMessages?: boolean | null;
          canViewReportDetailsPii?: boolean | null;
          canAddNamedOffender?: boolean | null;
          canAdministerReportPermissions?: boolean | null;
        } | null;
      }> | null;
      Categories: Array<{
        __typename?: 'CategoryDisplayType';
        id: number;
        name: string;
      }>;
      CaseAttributes?: {
        __typename?: 'CaseAttributesType';
        companyCreatedAt?: any | null;
      } | null;
      AssociatedPermissions?: {
        __typename?: 'AssociatedCasePermissionsType';
        canEditCaseDetails?: boolean | null;
        canViewCaseDetails?: boolean | null;
        canViewCaseDetailsPii?: boolean | null;
        canViewCaseWorkspaceTab?: boolean | null;
        canEditCaseWorkspaceTab?: boolean | null;
        canViewCaseAuditLogsTab?: boolean | null;
        canViewCase?: boolean | null;
        canAdministerCasePermissions?: boolean | null;
      } | null;
      AllCaseLeads?: Array<{
        __typename?: 'UserType';
        id: number;
        name?: string | null;
        role?: string | null;
        site?: string | null;
        country?: string | null;
        permissions?: Array<string> | null;
      }> | null;
      CaseTags: Array<{
        __typename?: 'TagType';
        id: string;
        name: string;
        tagType?: {
          __typename?: 'TagTypeType';
          id: string;
          name: string;
          colorId: number;
          order?: number | null;
          status: string;
          Tags?: Array<{
            __typename?: 'TagType';
            id: string;
            name: string;
          }> | null;
        } | null;
      }>;
      CaseTeam: Array<{
        __typename?: 'CaseTeamMemberType';
        id: number;
        name?: string | null;
      }>;
    }>;
  };
};

export type CaseMetricsQueryVariables = Exact<{ [key: string]: never }>;

export type CaseMetricsQuery = {
  __typename?: 'Query';
  caseMetrics: {
    __typename?: 'CaseMetricsType';
    caseLeadCount: number;
    teamMemberCount: number;
    waitingForResponseCount: number;
  };
};

export type CasesForLinkingQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  caseId: Scalars['String'];
}>;

export type CasesForLinkingQuery = {
  __typename?: 'Query';
  casesAbleToBeLinkedToCase: {
    __typename?: 'PaginatedCaseTypeResponse';
    count: number;
    items: Array<{
      __typename?: 'CaseType';
      id: string;
      name?: string | null;
      updatedAt?: any | null;
      readableId: string;
      status: string;
    }>;
  };
};

export type SearchCasesForLinkingQueryVariables = Exact<{
  search: Scalars['String'];
  caseId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;

export type SearchCasesForLinkingQuery = {
  __typename?: 'Query';
  searchCasesForLinking: {
    __typename?: 'PaginatedCaseTypeResponse';
    count: number;
    items: Array<{
      __typename?: 'CaseType';
      id: string;
      name?: string | null;
      updatedAt?: any | null;
      readableId: string;
      status: string;
    }>;
  };
};

export type AddCaseCategoryMutationVariables = Exact<{
  categoryId: Scalars['Int'];
  caseId: Scalars['String'];
}>;

export type AddCaseCategoryMutation = {
  __typename?: 'Mutation';
  addCaseCategory: Array<{
    __typename?: 'CategoryDisplayType';
    id: number;
    name: string;
  }>;
};

export type RemoveCaseCategoryMutationVariables = Exact<{
  categoryId: Scalars['Int'];
  caseId: Scalars['String'];
}>;

export type RemoveCaseCategoryMutation = {
  __typename?: 'Mutation';
  removeCaseCategory: Array<{
    __typename?: 'CategoryDisplayType';
    id: number;
    name: string;
  }>;
};

export type ReassignCaseLeadMutationVariables = Exact<{
  newCaseLeadId: Scalars['Float'];
  caseId: Scalars['String'];
  location?: InputMaybe<Scalars['String']>;
}>;

export type ReassignCaseLeadMutation = {
  __typename?: 'Mutation';
  reassignCaseLead: {
    __typename?: 'CaseType';
    CaseLead?: {
      __typename?: 'UserType';
      id: number;
      name?: string | null;
      available?: boolean | null;
      translationEnabled?: boolean | null;
      department?: string | null;
      permissions?: Array<string> | null;
      status: string;
      tags?: Array<string> | null;
      uuid?: string | null;
    } | null;
  };
};

export type UpdateCaseTitleMutationVariables = Exact<{
  newCaseTitle: Scalars['String'];
  caseId: Scalars['String'];
}>;

export type UpdateCaseTitleMutation = {
  __typename?: 'Mutation';
  updateCaseTitle: {
    __typename?: 'CaseType';
    id: string;
    name?: string | null;
  };
};

export type UpdateCaseStatusMutationVariables = Exact<{
  newCaseStatus: ReportStatus;
  caseId: Scalars['String'];
}>;

export type UpdateCaseStatusMutation = {
  __typename?: 'Mutation';
  updateCaseStatus: { __typename?: 'CaseType'; id: string; status: string };
};

export type UpdateCoiCaseStatusMutationVariables = Exact<{
  caseId: Scalars['String'];
  newCoiCaseStatus: CoiCaseStatus;
}>;

export type UpdateCoiCaseStatusMutation = {
  __typename?: 'Mutation';
  updateCoiCaseStatus: { __typename?: 'CaseType'; id: string; status: string };
};

export type MarkCaseAsReadMutationVariables = Exact<{
  userId: Scalars['Int'];
  caseId: Scalars['String'];
}>;

export type MarkCaseAsReadMutation = {
  __typename?: 'Mutation';
  markCaseAsRead?: boolean | null;
};

export type UpdateCaseDescriptionMutationVariables = Exact<{
  description?: InputMaybe<Scalars['String']>;
  caseId: Scalars['String'];
}>;

export type UpdateCaseDescriptionMutation = {
  __typename?: 'Mutation';
  updateCaseDescription?: string | null;
};

export type BulkCaseCreationMutationVariables = Exact<{
  casesToCreate: Array<BulkCaseCreationItem> | BulkCaseCreationItem;
  importFileName: Scalars['String'];
  uploadEvidences: Array<BulkCaseEvidenceItem> | BulkCaseEvidenceItem;
}>;

export type BulkCaseCreationMutation = {
  __typename?: 'Mutation';
  bulkCaseCreation: {
    __typename?: 'BulkCasesJobCreated';
    jobId: string;
    totalCases: number;
  };
};

export type GetCaseImporterJobProgressQueryVariables = Exact<{
  jobId?: InputMaybe<Scalars['String']>;
}>;

export type GetCaseImporterJobProgressQuery = {
  __typename?: 'Query';
  getCaseImporterJobProgress?: {
    __typename?: 'BulkCasesJobStatus';
    id: string;
    status: string;
    totalCases: number;
    processedCases: number;
    successfulCases: number;
    failedCases: number;
    pendingCases: number;
    percentComplete: number;
    fileName: string;
  } | null;
};

export type StopCaseImporterJobMutationVariables = Exact<{
  jobId: Scalars['String'];
}>;

export type StopCaseImporterJobMutation = {
  __typename?: 'Mutation';
  stopCaseImporterJob: boolean;
};

export type GetCaseImporterJobHistoryQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;

export type GetCaseImporterJobHistoryQuery = {
  __typename?: 'Query';
  getCaseImporterJobHistory: {
    __typename?: 'CaseImporterJobHistoryResponse';
    total: number;
    jobs: Array<{
      __typename?: 'CaseImporterJobHistoryItem';
      id: string;
      status: string;
      totalCases: number;
      successfulCases: number;
      failedCases: number;
      importFileName: string;
      createdAt: any;
      updatedAt: any;
      createdByName?: string | null;
    }>;
  };
};

export type GetCaseImporterJobDetailsQueryVariables = Exact<{
  jobId: Scalars['String'];
}>;

export type GetCaseImporterJobDetailsQuery = {
  __typename?: 'Query';
  getCaseImporterJobDetails: {
    __typename?: 'CaseImporterJobDetails';
    importedCases: Array<{
      __typename?: 'CaseImporterJobDetailsItem';
      id: string;
      readableId?: string | null;
      name?: string | null;
      importedId?: string | null;
    }>;
    failedCases: Array<{
      __typename?: 'CaseImporterJobDetailsItem';
      id: string;
      readableId?: string | null;
      name?: string | null;
      importedId?: string | null;
      error?: string | null;
    }>;
  };
};

export type GetCaseDocumentationQueryVariables = Exact<{
  caseId: Scalars['String'];
}>;

export type GetCaseDocumentationQuery = {
  __typename?: 'Query';
  getCaseDocumentation?: Array<{
    __typename?: 'CaseDocumentationType';
    id: string;
    value?: string | null;
    title?: string | null;
    Uploads?: Array<{
      __typename?: 'CaseDocumentationUploadType';
      filename?: string | null;
      mimeType?: string | null;
      s3path: string;
      size: number;
      updatedAt?: any | null;
      createdAt?: any | null;
      scanStatus?: string | null;
      scannedAt?: any | null;
      uploadSource?: UploadSource | null;
    }> | null;
  }> | null;
};

export type GetCaseDocumentQueryVariables = Exact<{
  caseDocumentId?: InputMaybe<Scalars['String']>;
}>;

export type GetCaseDocumentQuery = {
  __typename?: 'Query';
  getCaseDocument?: {
    __typename?: 'CaseDocumentationType';
    id: string;
    title?: string | null;
    value?: string | null;
    type: number;
    Uploads?: Array<{
      __typename?: 'CaseDocumentationUploadType';
      filename?: string | null;
      mimeType?: string | null;
      s3path: string;
      size: number;
      updatedAt?: any | null;
      createdAt?: any | null;
      scanStatus?: string | null;
      scannedAt?: any | null;
      uploadSource?: UploadSource | null;
    }> | null;
  } | null;
};

export type UpdateCaseDocumentationMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
  caseId: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
  uploads?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  s3path?: InputMaybe<Scalars['String']>;
  mimeType?: InputMaybe<Scalars['String']>;
}>;

export type UpdateCaseDocumentationMutation = {
  __typename?: 'Mutation';
  createOrUpdateCaseDocument: {
    __typename?: 'CaseDocumentationType';
    id: string;
    title?: string | null;
    s3path?: string | null;
    mimeType?: string | null;
    value?: string | null;
    Uploads?: Array<{
      __typename?: 'CaseDocumentationUploadType';
      filename?: string | null;
      mimeType?: string | null;
      s3path: string;
      scanStatus?: string | null;
      scannedAt?: any | null;
      uploadSource?: UploadSource | null;
    }> | null;
  };
};

export type RemoveCaseDocumentationMutationVariables = Exact<{
  caseId: Scalars['String'];
  selectedDocumentIds: Array<Scalars['String']> | Scalars['String'];
}>;

export type RemoveCaseDocumentationMutation = {
  __typename?: 'Mutation';
  removeCaseDocument: Array<{
    __typename?: 'CaseDocumentationType';
    id: string;
    title?: string | null;
    value?: string | null;
  }>;
};

export type CreateCaseDocumentationUploadUrlMutationVariables = Exact<{
  type: Scalars['String'];
  filename: Scalars['String'];
  uploadSource?: InputMaybe<UploadSource>;
  caseId: Scalars['String'];
  size?: InputMaybe<Scalars['Float']>;
}>;

export type CreateCaseDocumentationUploadUrlMutation = {
  __typename?: 'Mutation';
  createCaseDocumentUploadURL: {
    __typename?: 'PreSignedURLType';
    url: string;
    s3path: string;
  };
};

export type GetCaseDocumentUploadUrlMutationVariables = Exact<{
  s3Path: Scalars['String'];
}>;

export type GetCaseDocumentUploadUrlMutation = {
  __typename?: 'Mutation';
  getCaseDocumentUploadURL: { __typename?: 'PreSignedURLType'; url: string };
};

export type GetReportDocumentUploadUrlMutationVariables = Exact<{
  reportId: Scalars['String'];
  objectId: Scalars['String'];
}>;

export type GetReportDocumentUploadUrlMutation = {
  __typename?: 'Mutation';
  getReportDocumentUploadURL: { __typename?: 'PreSignedURLType'; url: string };
};

export type CreateCaseDocumentUploadMutationVariables = Exact<{
  mimeType: Scalars['String'];
  size: Scalars['Float'];
  s3path: Scalars['String'];
  filename: Scalars['String'];
  caseId?: InputMaybe<Scalars['String']>;
  uploadSource?: InputMaybe<UploadSource>;
  caseDocument?: InputMaybe<Scalars['String']>;
}>;

export type CreateCaseDocumentUploadMutation = {
  __typename?: 'Mutation';
  createCaseDocumentUpload: {
    __typename?: 'CaseDocumentationUploadType';
    filename?: string | null;
    mimeType?: string | null;
    s3path: string;
    size: number;
    createdAt?: any | null;
    updatedAt?: any | null;
    scanStatus?: string | null;
    scannedAt?: any | null;
    uploadSource?: UploadSource | null;
  };
};

export type GetCaseTeamNoteQueryVariables = Exact<{
  userId: Scalars['Int'];
  caseId: Scalars['String'];
}>;

export type GetCaseTeamNoteQuery = {
  __typename?: 'Query';
  getCaseTeamNote?: {
    __typename?: 'CaseTeamNoteType';
    id: string;
    caseId: string;
    inviterUserId: number;
    inviteeUserId: number;
    value: string;
    createdAt: any;
  } | null;
};

export type CasesCoiPaginatedQueryVariables = Exact<{
  orderBy: OrderByInputType;
  pagination: KeysetPaginationInputType;
  fuzzy?: InputMaybe<FuzzySearchInputType>;
  appliedFilters?: InputMaybe<AppliedFiltersType>;
  searchBy?: InputMaybe<Array<SearchByInputType> | SearchByInputType>;
  requireEditPermission?: InputMaybe<Scalars['Boolean']>;
}>;

export type CasesCoiPaginatedQuery = {
  __typename?: 'Query';
  casesCoiPaginated: {
    __typename?: 'PaginatedCaseTypeResponse';
    count: number;
    items: Array<{
      __typename?: 'CaseType';
      name?: string | null;
      id: string;
      createdAt?: any | null;
      updatedAt?: any | null;
      status: string;
      readableId: string;
      CaseLead?: {
        __typename?: 'UserType';
        id: number;
        name?: string | null;
      } | null;
      Reports?: Array<{
        __typename?: 'ReportType';
        id: string;
        source: string;
        existingReport: boolean;
        Assignee?: { __typename?: 'UserType'; name?: string | null } | null;
        Reporter?: {
          __typename?: 'UserType';
          id: number;
          name?: string | null;
        } | null;
        DeterminedCategory?: {
          __typename?: 'CategoryDisplayType';
          id: number;
          name: string;
        } | null;
        ReportedCategory?: {
          __typename?: 'CategoryDisplayType';
          id: number;
          name: string;
        } | null;
      }> | null;
      Categories: Array<{
        __typename?: 'CategoryDisplayType';
        id: number;
        name: string;
      }>;
      CaseAttributes?: {
        __typename?: 'CaseAttributesType';
        companyCreatedAt?: any | null;
      } | null;
      CaseTeam: Array<{
        __typename?: 'CaseTeamMemberType';
        id: number;
        name?: string | null;
      }>;
      DisclosuresCaseData?: {
        __typename?: 'DisclosuresCaseDataType';
        reporterD1pId: string;
        responseId: string;
        flags: number;
      } | null;
      AssociatedPermissions?: {
        __typename?: 'AssociatedCasePermissionsType';
        canEditCaseDetails?: boolean | null;
        canViewCaseDetails?: boolean | null;
        canViewCaseDetailsPii?: boolean | null;
        canViewCaseWorkspaceTab?: boolean | null;
        canEditCaseWorkspaceTab?: boolean | null;
        canViewCaseAuditLogsTab?: boolean | null;
        canViewCase?: boolean | null;
        canEditCaseClosedDate?: boolean | null;
        canEditCaseCriDates?: boolean | null;
        canAdministerCasePermissions?: boolean | null;
      } | null;
    }>;
  };
};

export type DisclosureCaseByIdQueryVariables = Exact<{
  caseId: Scalars['String'];
}>;

export type DisclosureCaseByIdQuery = {
  __typename?: 'Query';
  disclosureCaseById?: {
    __typename?: 'DisclosureResponseType';
    id?: string | null;
    questionnaireId?: string | null;
    status?: string | null;
    isFlagged?: boolean | null;
    submittedAt?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    respondent?: {
      __typename?: 'RespondentType';
      email?: string | null;
      name?: string | null;
      userId?: string | null;
    } | null;
    questionnaire?: {
      __typename?: 'QuestionnaireType';
      publicTitle?: string | null;
      attestationText?: string | null;
    } | null;
    answers?: Array<{
      __typename?: 'DisclosureAnswerType';
      questionId?: string | null;
      questionText?: string | null;
      value?: any | null;
    }> | null;
  } | null;
};

export type DisclosureResponseByIdQueryVariables = Exact<{
  responseId: Scalars['String'];
}>;

export type DisclosureResponseByIdQuery = {
  __typename?: 'Query';
  disclosureResponseById?: {
    __typename?: 'DisclosureResponseType';
    id?: string | null;
    questionnaireId?: string | null;
    status?: string | null;
    isFlagged?: boolean | null;
    submittedAt?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    respondent?: {
      __typename?: 'RespondentType';
      email?: string | null;
      name?: string | null;
      userId?: string | null;
    } | null;
    questionnaire?: {
      __typename?: 'QuestionnaireType';
      publicTitle?: string | null;
      attestationText?: string | null;
    } | null;
    answers?: Array<{
      __typename?: 'DisclosureAnswerType';
      questionId?: string | null;
      questionText?: string | null;
      value?: any | null;
    }> | null;
    reporter?: {
      __typename?: 'UserType';
      eid?: string | null;
      name?: string | null;
      email?: string | null;
      contactEmail?: string | null;
      role?: string | null;
      country?: string | null;
      department?: string | null;
      site?: string | null;
    } | null;
  } | null;
};

export type DisclosureAuditByIdQueryVariables = Exact<{
  responseId: Scalars['String'];
}>;

export type DisclosureAuditByIdQuery = {
  __typename?: 'Query';
  disclosureAuditById?: {
    __typename?: 'DisclosureAuditType';
    entries?: Array<{
      __typename?: 'DisclosureAuditEntryType';
      id: string;
      eventType?: string | null;
      eventDetails?: any | null;
      createdAt?: string | null;
      user?: {
        __typename?: 'DisclosureAuditUserType';
        userId?: string | null;
        name?: string | null;
        email?: string | null;
      } | null;
    }> | null;
    pagination?: {
      __typename?: 'DisclosureAuditPaginationType';
      page?: number | null;
      limit?: number | null;
      totalPages?: number | null;
      totalItems?: number | null;
    } | null;
  } | null;
};

export type CoiFilterOptionsQueryVariables = Exact<{ [key: string]: never }>;

export type CoiFilterOptionsQuery = {
  __typename?: 'Query';
  coiFilterOptions?: {
    __typename?: 'CoiFilterOptionsType';
    statuses: Array<{
      __typename?: 'CoiFilterOptionType';
      label: string;
      value: string;
    }>;
    reviewers: Array<{
      __typename?: 'CoiFilterOptionType';
      label: string;
      value: string;
    }>;
    formTitles: Array<{
      __typename?: 'CoiFilterOptionType';
      label: string;
      value: string;
    }>;
    categories: Array<{
      __typename?: 'CoiFilterOptionType';
      label: string;
      value: string;
    }>;
  } | null;
};

export type FlagQuestionnaireResponseMutationVariables = Exact<{
  responseId: Scalars['String'];
  isFlagged: Scalars['Boolean'];
  flaggedReason?: InputMaybe<Scalars['String']>;
  flagCategory?: InputMaybe<FlagInfoCategory>;
  unflagReason?: InputMaybe<Scalars['String']>;
}>;

export type FlagQuestionnaireResponseMutation = {
  __typename?: 'Mutation';
  flagQuestionnaireResponse: boolean;
};

export type GetFormResponsesPaginatedQueryVariables = Exact<{
  formId: Scalars['String'];
  queryParams?: InputMaybe<FormResponseQueryParamsType>;
}>;

export type GetFormResponsesPaginatedQuery = {
  __typename?: 'Query';
  formResponsesPaginated: {
    __typename?: 'PaginatedFormResponsesType';
    responses?: Array<{
      __typename?: 'FormResponseType';
      id?: string | null;
      questionnaireId?: string | null;
      organizationId?: string | null;
      submittedAt?: string | null;
      status?: string | null;
      isFlagged?: boolean | null;
      attestationAccepted?: boolean | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      respondent?: {
        __typename?: 'RespondentType';
        userId?: string | null;
        name?: string | null;
        email?: string | null;
      } | null;
      flagInfo?: {
        __typename?: 'FlagInfoType';
        reason?: string | null;
        category?: FlagInfoCategory | null;
        flaggedAt?: string | null;
        flaggedBy?: {
          __typename?: 'FlaggedByType';
          userId?: string | null;
          name?: string | null;
          email?: string | null;
        } | null;
      } | null;
      progress?: {
        __typename?: 'ProgressType';
        totalQuestions?: number | null;
        answeredQuestions?: number | null;
        requiredQuestions?: number | null;
        answeredRequiredQuestions?: number | null;
        completionPercentage?: number | null;
      } | null;
      questionnaire?: {
        __typename?: 'QuestionnaireType';
        id?: string | null;
        publicTitle?: string | null;
        attestationText?: string | null;
      } | null;
    }> | null;
    pagination?: {
      __typename?: 'PaginationMetadataType';
      page?: number | null;
      limit?: number | null;
      totalItems?: number | null;
      totalPages?: number | null;
    } | null;
  };
};

export type GetOrganisationFormResponsesPaginatedQueryVariables = Exact<{
  queryParams?: InputMaybe<FormResponseQueryParamsType>;
}>;

export type GetOrganisationFormResponsesPaginatedQuery = {
  __typename?: 'Query';
  organisationFormResponsesPaginated?: {
    __typename?: 'PaginatedFormResponsesType';
    responses?: Array<{
      __typename?: 'FormResponseType';
      id?: string | null;
      questionnaireId?: string | null;
      organizationId?: string | null;
      submittedAt?: string | null;
      status?: string | null;
      isFlagged?: boolean | null;
      attestationAccepted?: boolean | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      respondent?: {
        __typename?: 'RespondentType';
        userId?: string | null;
        name?: string | null;
        email?: string | null;
      } | null;
      flagInfo?: {
        __typename?: 'FlagInfoType';
        reason?: string | null;
        category?: FlagInfoCategory | null;
        flaggedAt?: string | null;
        flaggedBy?: {
          __typename?: 'FlaggedByType';
          userId?: string | null;
          name?: string | null;
          email?: string | null;
        } | null;
      } | null;
      progress?: {
        __typename?: 'ProgressType';
        totalQuestions?: number | null;
        answeredQuestions?: number | null;
        requiredQuestions?: number | null;
        answeredRequiredQuestions?: number | null;
        completionPercentage?: number | null;
      } | null;
      questionnaire?: {
        __typename?: 'QuestionnaireType';
        id?: string | null;
        publicTitle?: string | null;
        attestationText?: string | null;
      } | null;
    }> | null;
    pagination?: {
      __typename?: 'PaginationMetadataType';
      page?: number | null;
      limit?: number | null;
      totalItems?: number | null;
      totalPages?: number | null;
    } | null;
  } | null;
};

export type MitigationPlansForDisclosureQueryVariables = Exact<{
  caseId: Scalars['String'];
}>;

export type MitigationPlansForDisclosureQuery = {
  __typename?: 'Query';
  mitigationPlansForDisclosure: Array<{
    __typename?: 'MitigationPlanType';
    id: string;
    caseId: string;
    createdBy: number;
    createdByName?: string | null;
    title: string;
    description?: string | null;
    status: MitigationPlanStatus;
    deadline: string;
    reminderFrequency: number;
    reminderMaxCount?: number | null;
    completedAt?: any | null;
    createdAt: any;
    updatedAt: any;
    signatories: Array<{
      __typename?: 'MitigationPlanSignatoryType';
      id: string;
      mitigationPlanId: string;
      userId: number;
      isSubject: boolean;
      signedAt?: any | null;
      rejectedAt?: any | null;
      rejectionNote?: string | null;
      createdAt: any;
      updatedAt: any;
      user?: {
        __typename?: 'UserType';
        name?: string | null;
        displayName?: string | null;
      } | null;
    }>;
    reviewerSignatories: Array<{
      __typename?: 'MitigationPlanSignatoryType';
      id: string;
      mitigationPlanId: string;
      userId: number;
      isSubject: boolean;
      signedAt?: any | null;
      rejectedAt?: any | null;
      rejectionNote?: string | null;
      createdAt: any;
      updatedAt: any;
      user?: {
        __typename?: 'UserType';
        name?: string | null;
        displayName?: string | null;
      } | null;
    }>;
    uploads: Array<{
      __typename?: 'MitigationPlanUploadType';
      mitigationPlanId: string;
      uploadId: string;
      uploadOrder: number;
      fileExtension?: string | null;
      scanStatus?: string | null;
    }>;
  }>;
};

export type CreateMitigationPlanMutationVariables = Exact<{
  data: CreateMitigationPlanInput;
}>;

export type CreateMitigationPlanMutation = {
  __typename?: 'Mutation';
  createMitigationPlan?: {
    __typename?: 'MitigationPlanType';
    id: string;
    caseId: string;
    createdBy: number;
    title: string;
    description?: string | null;
    status: MitigationPlanStatus;
    deadline: string;
    reminderFrequency: number;
    reminderMaxCount?: number | null;
    completedAt?: any | null;
    createdAt: any;
    updatedAt: any;
    signatories: Array<{
      __typename?: 'MitigationPlanSignatoryType';
      id: string;
      mitigationPlanId: string;
      userId: number;
      isSubject: boolean;
      signedAt?: any | null;
      rejectedAt?: any | null;
      rejectionNote?: string | null;
      createdAt: any;
      updatedAt: any;
      user?: {
        __typename?: 'UserType';
        name?: string | null;
        displayName?: string | null;
      } | null;
    }>;
    reviewerSignatories: Array<{
      __typename?: 'MitigationPlanSignatoryType';
      id: string;
      mitigationPlanId: string;
      userId: number;
      isSubject: boolean;
      signedAt?: any | null;
      rejectedAt?: any | null;
      rejectionNote?: string | null;
      createdAt: any;
      updatedAt: any;
      user?: {
        __typename?: 'UserType';
        name?: string | null;
        displayName?: string | null;
      } | null;
    }>;
    uploads: Array<{
      __typename?: 'MitigationPlanUploadType';
      mitigationPlanId: string;
      uploadId: string;
      uploadOrder: number;
      fileExtension?: string | null;
      scanStatus?: string | null;
    }>;
  } | null;
};

export type UpdateMitigationPlanMutationVariables = Exact<{
  data: UpdateMitigationPlanInput;
}>;

export type UpdateMitigationPlanMutation = {
  __typename?: 'Mutation';
  updateMitigationPlan?: {
    __typename?: 'MitigationPlanType';
    id: string;
    caseId: string;
    createdBy: number;
    title: string;
    description?: string | null;
    status: MitigationPlanStatus;
    deadline: string;
    reminderFrequency: number;
    reminderMaxCount?: number | null;
    completedAt?: any | null;
    createdAt: any;
    updatedAt: any;
    signatories: Array<{
      __typename?: 'MitigationPlanSignatoryType';
      id: string;
      mitigationPlanId: string;
      userId: number;
      isSubject: boolean;
      signedAt?: any | null;
      rejectedAt?: any | null;
      rejectionNote?: string | null;
      createdAt: any;
      updatedAt: any;
      user?: {
        __typename?: 'UserType';
        name?: string | null;
        displayName?: string | null;
      } | null;
    }>;
    reviewerSignatories: Array<{
      __typename?: 'MitigationPlanSignatoryType';
      id: string;
      mitigationPlanId: string;
      userId: number;
      isSubject: boolean;
      signedAt?: any | null;
      rejectedAt?: any | null;
      rejectionNote?: string | null;
      createdAt: any;
      updatedAt: any;
      user?: {
        __typename?: 'UserType';
        name?: string | null;
        displayName?: string | null;
      } | null;
    }>;
    uploads: Array<{
      __typename?: 'MitigationPlanUploadType';
      mitigationPlanId: string;
      uploadId: string;
      uploadOrder: number;
      fileExtension?: string | null;
      scanStatus?: string | null;
    }>;
  } | null;
};

export type CancelMitigationPlanMutationVariables = Exact<{
  planId: Scalars['String'];
}>;

export type CancelMitigationPlanMutation = {
  __typename?: 'Mutation';
  cancelMitigationPlan: boolean;
};

export type RecallMitigationPlanMutationVariables = Exact<{
  planId: Scalars['String'];
}>;

export type RecallMitigationPlanMutation = {
  __typename?: 'Mutation';
  recallMitigationPlan: boolean;
};

export type RejectMitigationPlanMutationVariables = Exact<{
  planId: Scalars['String'];
  note: Scalars['String'];
}>;

export type RejectMitigationPlanMutation = {
  __typename?: 'Mutation';
  rejectMitigationPlan: boolean;
};

export type CreateMitigationPlanUploadMutationVariables = Exact<{
  filename: Scalars['String'];
  s3path: Scalars['String'];
  size: Scalars['Float'];
  mimeType: Scalars['String'];
}>;

export type CreateMitigationPlanUploadMutation = {
  __typename?: 'Mutation';
  createMitigationPlanUpload: {
    __typename?: 'UploadType';
    id: string;
    s3path: string;
    mimeType: string;
    size: number;
    fileExtension: string;
    scanStatus: string;
  };
};

export type UpdateMitigationPlanSignatoriesMutationVariables = Exact<{
  data: UpdateMitigationPlanSignatoriesInput;
}>;

export type UpdateMitigationPlanSignatoriesMutation = {
  __typename?: 'Mutation';
  updateMitigationPlanSignatories?: Array<{
    __typename?: 'MitigationPlanSignatoryType';
    id: string;
    mitigationPlanId: string;
    userId: number;
    isSubject: boolean;
    signedAt?: any | null;
    rejectedAt?: any | null;
    rejectionNote?: string | null;
    createdAt: any;
    updatedAt: any;
  }> | null;
};

export type GetMitigationPlanUploadUrlMutationVariables = Exact<{
  uploadId: Scalars['String'];
  planId: Scalars['String'];
}>;

export type GetMitigationPlanUploadUrlMutation = {
  __typename?: 'Mutation';
  getMitigationPlanUploadURL: { __typename?: 'PreSignedURLType'; url: string };
};

export type GetMitigationPlanDownloadUrlMutationVariables = Exact<{
  uploadId: Scalars['String'];
  planId: Scalars['String'];
}>;

export type GetMitigationPlanDownloadUrlMutation = {
  __typename?: 'Mutation';
  getMitigationPlanDownloadURL: {
    __typename?: 'PreSignedURLType';
    url: string;
  };
};

export type SignMitigationPlanMutationVariables = Exact<{
  planId: Scalars['String'];
}>;

export type SignMitigationPlanMutation = {
  __typename?: 'Mutation';
  signMitigationPlan: boolean;
};

export type DeleteMitigationPlanUploadMutationVariables = Exact<{
  planId: Scalars['String'];
  uploadId: Scalars['String'];
}>;

export type DeleteMitigationPlanUploadMutation = {
  __typename?: 'Mutation';
  deleteMitigationPlanUpload: boolean;
};

export type CountriesQueryVariables = Exact<{ [key: string]: never }>;

export type CountriesQuery = {
  __typename?: 'Query';
  countries: Array<{ __typename?: 'CountryType'; code: string; name: string }>;
};

export type RegionsForOrganisationQueryVariables = Exact<{
  [key: string]: never;
}>;

export type RegionsForOrganisationQuery = {
  __typename?: 'Query';
  regionsForOrganisation: Array<{
    __typename?: 'RegionType';
    id: string;
    name: string;
    isActive: boolean;
    countries: Array<{
      __typename?: 'CountryType';
      code: string;
      name: string;
    }>;
  }>;
};

export type SetCaseCountryRegionMutationVariables = Exact<{
  input: SetCaseCountryRegionInput;
}>;

export type SetCaseCountryRegionMutation = {
  __typename?: 'Mutation';
  setCaseCountryRegion?: {
    __typename?: 'CaseCountryRegionType';
    country?: { __typename?: 'CountryType'; code: string; name: string } | null;
    region?: {
      __typename?: 'RegionType';
      id: string;
      name: string;
      isActive: boolean;
      countries: Array<{
        __typename?: 'CountryType';
        code: string;
        name: string;
      }>;
    } | null;
  } | null;
};

export type CreateCaseLinkMutationVariables = Exact<{
  data: CreateCaseLinkInput;
}>;

export type CreateCaseLinkMutation = {
  __typename?: 'Mutation';
  createCaseLink?: {
    __typename?: 'CaseLinkDataType';
    id: string;
    sourceCaseId: string;
    targetCaseId: string;
    linkType: CaseLinkType;
    notes?: string | null;
  } | null;
};

export type EditCaseAccessMutationVariables = Exact<{
  caseId: Scalars['String'];
  userId: Scalars['Int'];
  entityPermissions: Array<Scalars['String']> | Scalars['String'];
}>;

export type EditCaseAccessMutation = {
  __typename?: 'Mutation';
  editCaseAccess: {
    __typename?: 'AssignCasePermissionsType';
    casePermissions: Array<{
      __typename?: 'CasePermissionsType';
      permission: string;
    }>;
    reportPermissions: Array<{
      __typename?: 'ReportPermissionsType';
      permission: string;
    }>;
  };
};

export type GetCaseAttributesQueryVariables = Exact<{
  caseId: Scalars['String'];
}>;

export type GetCaseAttributesQuery = {
  __typename?: 'Query';
  getCaseAttributes?: {
    __typename?: 'CaseAttributesType';
    companyCreatedAt?: any | null;
    readAt?: any | null;
    investigatingAt?: any | null;
    closedAt?: any | null;
  } | null;
};

export type GetCaseAuditEntriesQueryVariables = Exact<{
  case: Scalars['String'];
  pagination?: InputMaybe<PaginationInputType>;
}>;

export type GetCaseAuditEntriesQuery = {
  __typename?: 'Query';
  getCaseAuditEntries?: {
    __typename?: 'PaginatedAuditEntryTypeResponse';
    count: number;
    items: Array<{
      __typename?: 'AuditEntryType';
      DescriptiveText: string;
      action?: string | null;
      id: number;
      createdAt?: any | null;
      data?: any | null;
      completed?: boolean | null;
      User?: {
        __typename?: 'UserType';
        id: number;
        name?: string | null;
        displayName?: string | null;
      } | null;
    }>;
  } | null;
};

export type GetCaseLinksByCaseIdQueryVariables = Exact<{
  caseId: Scalars['String'];
}>;

export type GetCaseLinksByCaseIdQuery = {
  __typename?: 'Query';
  getCaseLinksByCaseId?: Array<{
    __typename?: 'CaseLinkDataType';
    id: string;
    sourceCaseId: string;
    targetCaseId: string;
    linkType: CaseLinkType;
    notes?: string | null;
    createdAt: any;
    updatedAt: any;
    createdBy: number;
    organisation: number;
    CreatedByUser?: {
      __typename?: 'UserType';
      id: number;
      name?: string | null;
    } | null;
    SourceCase?: {
      __typename?: 'CaseType';
      id: string;
      name?: string | null;
      readableId: string;
      status: string;
      AssociatedPermissions?: {
        __typename?: 'AssociatedCasePermissionsType';
        canViewCaseDetails?: boolean | null;
        canEditCaseDetails?: boolean | null;
      } | null;
    } | null;
    TargetCase?: {
      __typename?: 'CaseType';
      id: string;
      name?: string | null;
      readableId: string;
      status: string;
      AssociatedPermissions?: {
        __typename?: 'AssociatedCasePermissionsType';
        canViewCaseDetails?: boolean | null;
        canEditCaseDetails?: boolean | null;
      } | null;
    } | null;
  }> | null;
};

export type GetCaseTeamMemberPermissionsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['Int']>;
  caseId: Scalars['String'];
}>;

export type GetCaseTeamMemberPermissionsQuery = {
  __typename?: 'Query';
  getCaseTeamMemberPermissions: Array<string>;
};

export type GetPublicCountriesQueryVariables = Exact<{
  slug: Scalars['String'];
}>;

export type GetPublicCountriesQuery = {
  __typename?: 'Query';
  getPublicCountries: Array<{
    __typename?: 'CountryType';
    code: string;
    name: string;
  }>;
};

export type GetPublicSitesQueryVariables = Exact<{
  slug: Scalars['String'];
}>;

export type GetPublicSitesQuery = {
  __typename?: 'Query';
  getPublicSites: Array<{ __typename?: 'SiteType'; name: string }>;
};

export type GetSanitizedAndDeletedCasesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetSanitizedAndDeletedCasesQuery = {
  __typename?: 'Query';
  sanitizedAndDeletedCases: Array<{
    __typename?: 'SanitizedOrDeletedCaseType';
    id: string;
    readableId?: string | null;
    name?: string | null;
    status: ReportStatus;
    createdAt: any;
    updatedAt: any;
    sanitizedAt?: any | null;
    deletedAt?: any | null;
    completedAt?: any | null;
    substantiation?: string | null;
    closedAt?: any | null;
    RetentionRule?: {
      __typename?: 'RetentionRuleType';
      id: string;
      ruleType?: RuleTypeEnum | null;
      dateReference: DateReferenceEnum;
      conditions: any;
      fallbackRule: boolean;
      country?: string | null;
    } | null;
  }>;
};

export type InviteToCaseMutationVariables = Exact<{
  caseId: Scalars['String'];
  userIds: Array<Scalars['Int']> | Scalars['Int'];
  entityPermissions: Array<Scalars['String']> | Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
}>;

export type InviteToCaseMutation = {
  __typename?: 'Mutation';
  inviteToCase: Array<{
    __typename?: 'CaseTeamMemberType';
    id: number;
    name?: string | null;
    site?: string | null;
    permissions?: Array<string> | null;
    firstAccessedAt?: any | null;
    invitedAt: any;
    Roles?: Array<string> | null;
    Note?: {
      __typename?: 'CaseTeamNoteType';
      value: string;
      createdAt: any;
      inviterUser?: { __typename?: 'UserType'; name?: string | null } | null;
    } | null;
  }>;
};

export type RemoveFromCaseMutationVariables = Exact<{
  userId: Scalars['Int'];
  caseId: Scalars['String'];
}>;

export type RemoveFromCaseMutation = {
  __typename?: 'Mutation';
  removeFromCase: { __typename?: 'UserType'; id: number };
};

export type RestoreSanitizedCaseMutationVariables = Exact<{
  caseId: Scalars['String'];
}>;

export type RestoreSanitizedCaseMutation = {
  __typename?: 'Mutation';
  restoreSanitizedCase: {
    __typename?: 'CaseType';
    id: string;
    sanitizedAt?: any | null;
  };
};

export type UpdateCaseAttributesMutationVariables = Exact<{
  caseAttributes: UpdateCaseAttributes;
  postSubmission?: InputMaybe<Scalars['Boolean']>;
}>;

export type UpdateCaseAttributesMutation = {
  __typename?: 'Mutation';
  updateCaseAttributes?: {
    __typename?: 'CaseAttributesType';
    companyCreatedAt?: any | null;
    readAt?: any | null;
    investigatingAt?: any | null;
    closedAt?: any | null;
  } | null;
};

export type CreateCategoryMutationVariables = Exact<{
  category: CreateCategoryType;
}>;

export type CreateCategoryMutation = {
  __typename?: 'Mutation';
  createCategory?: { __typename?: 'CategoryType'; id: number } | null;
};

export type GetActiveCategoriesForCaseQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetActiveCategoriesForCaseQuery = {
  __typename?: 'Query';
  getActiveCategoriesForCase?: Array<{
    __typename?: 'CategoryDisplayType';
    allowGoTogether: boolean;
    body: string;
    id: number;
    name: string;
    order: number;
    question: boolean;
    title: string;
  }> | null;
};

export type GetCategoryConfigCategoriesQueryVariables = Exact<{
  isCOI?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetCategoryConfigCategoriesQuery = {
  __typename?: 'Query';
  getOrganisationCategories?: Array<{
    __typename?: 'CategoryType';
    id: number;
    allowGoTogether: boolean;
    displayInApp: boolean;
    displayInOpenReporting: boolean;
    displayInVaultTalk: boolean;
    displayInCollaborationToolIntegration: boolean;
    displayInManualIntake: boolean;
    isDeterminedCategory: boolean;
    isReportedCategory: boolean;
    isCustomQuestions: boolean;
    status: CategoryConfigurationStatus;
    hasActiveLinkedForm?: boolean | null;
    locales: any;
    order: number;
    question: boolean;
    requestOpenPerpetrators: boolean;
    createdAt: any;
    updatedAt: any;
    Author?: {
      __typename?: 'UserType';
      name?: string | null;
      displayName?: string | null;
      id: number;
    } | null;
  }> | null;
};

export type GetDeterminedCategoriesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetDeterminedCategoriesQuery = {
  __typename?: 'Query';
  getDeterminedCategories?: Array<{
    __typename?: 'CategoryDisplayType';
    allowGoTogether: boolean;
    body: string;
    id: number;
    name: string;
    order: number;
    question: boolean;
    title: string;
  }> | null;
};

export type GetManualIntakeReportedCategoriesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetManualIntakeReportedCategoriesQuery = {
  __typename?: 'Query';
  getManualIntakeReportedCategories?: Array<{
    __typename?: 'CategoryDisplayType';
    allowGoTogether: boolean;
    body: string;
    id: number;
    name: string;
    order: number;
    question: boolean;
    title: string;
  }> | null;
};

export type GetOrganisationCategoriesQueryVariables = Exact<{
  isCOI?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetOrganisationCategoriesQuery = {
  __typename?: 'Query';
  getOrganisationCategories?: Array<{
    __typename?: 'CategoryType';
    id: number;
    allowGoTogether: boolean;
    displayInApp: boolean;
    displayInOpenReporting: boolean;
    displayInVaultTalk: boolean;
    displayInCollaborationToolIntegration: boolean;
    displayInManualIntake: boolean;
    isDeterminedCategory: boolean;
    isReportedCategory: boolean;
    isCustomQuestions: boolean;
    status: CategoryConfigurationStatus;
    hasActiveLinkedForm?: boolean | null;
    locales: any;
    order: number;
    question: boolean;
    requestOpenPerpetrators: boolean;
    createdAt: any;
    Author?: {
      __typename?: 'UserType';
      name?: string | null;
      displayName?: string | null;
      id: number;
    } | null;
  }> | null;
};

export type GetPublicCategoriesQueryVariables = Exact<{
  slug: Scalars['String'];
}>;

export type GetPublicCategoriesQuery = {
  __typename?: 'Query';
  getPublicCategories?: Array<{
    __typename?: 'CategoryDisplayType';
    allowGoTogether: boolean;
    body: string;
    id: number;
    name: string;
    order: number;
    question: boolean;
    title: string;
    requestOpenPerpetrators?: boolean | null;
  }> | null;
};

export type GetReportedCategoriesQueryVariables = Exact<{
  isCOI?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetReportedCategoriesQuery = {
  __typename?: 'Query';
  getReportedCategories?: Array<{
    __typename?: 'CategoryDisplayType';
    allowGoTogether: boolean;
    body: string;
    id: number;
    name: string;
    order: number;
    question: boolean;
    title: string;
  }> | null;
};

export type UpdateCategoryMutationVariables = Exact<{
  category: UpdateCategoryType;
}>;

export type UpdateCategoryMutation = {
  __typename?: 'Mutation';
  updateCategory?: { __typename?: 'CategoryType'; id: number } | null;
};

export type UpdateCategoryLocaleMutationVariables = Exact<{
  category: UpdateCategoryLocaleType;
}>;

export type UpdateCategoryLocaleMutation = {
  __typename?: 'Mutation';
  updateCategoryLocale?: { __typename?: 'CategoryType'; id: number } | null;
};

export type UpdateCategoryOrdersMutationVariables = Exact<{
  categories: Array<UpdateCategoryOrderType> | UpdateCategoryOrderType;
  draggedCategoryId: Scalars['Int'];
}>;

export type UpdateCategoryOrdersMutation = {
  __typename?: 'Mutation';
  updateCategoryOrders: Array<{
    __typename?: 'CategoryOrderType';
    id: string;
    order: number;
  }>;
};

export type CaseCustomFieldValuesQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type CaseCustomFieldValuesQuery = {
  __typename?: 'Query';
  caseById?: {
    __typename?: 'CaseType';
    id: string;
    CaseCustomFieldValues: Array<{
      __typename?: 'CaseCustomFieldValueType';
      customFieldId: string;
      label: string;
      identifier: string;
      fieldType: string;
      status: string;
      displayOrder: number;
      sectionId?: string | null;
      valueText?: string | null;
      optionId?: string | null;
      options: Array<{
        __typename?: 'CaseCustomFieldOptionType';
        id: string;
        label: string;
        isActive: boolean;
      }>;
    }>;
  } | null;
};

export type SetCaseCustomFieldValueMutationVariables = Exact<{
  input: SetCaseCustomFieldValueInputType;
}>;

export type SetCaseCustomFieldValueMutation = {
  __typename?: 'Mutation';
  setCaseCustomFieldValue: {
    __typename?: 'CaseCustomFieldValueType';
    customFieldId: string;
    label: string;
    identifier: string;
    fieldType: string;
    status: string;
    displayOrder: number;
    sectionId?: string | null;
    valueText?: string | null;
    optionId?: string | null;
    options: Array<{
      __typename?: 'CaseCustomFieldOptionType';
      id: string;
      label: string;
      isActive: boolean;
    }>;
  };
};

export type GetOrganisationCustomFieldSectionsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetOrganisationCustomFieldSectionsQuery = {
  __typename?: 'Query';
  getOrganisationCustomFieldSections: {
    __typename?: 'CustomFieldSectionsResponseType';
    sections: Array<{
      __typename?: 'CustomFieldSectionType';
      id: string;
      name: string;
      description?: string | null;
      isDefault: boolean;
      displayOrder: number;
      fieldCount: number;
      createdAt: any;
      updatedAt: any;
      fields?: Array<{
        __typename?: 'SectionFieldType';
        id: string;
        label: string;
      }> | null;
    }>;
  };
};

export type CreateCustomFieldSectionMutationVariables = Exact<{
  input: CreateCustomFieldSectionInputType;
}>;

export type CreateCustomFieldSectionMutation = {
  __typename?: 'Mutation';
  createCustomFieldSection: {
    __typename?: 'CustomFieldSectionType';
    id: string;
    name: string;
    description?: string | null;
    isDefault: boolean;
    displayOrder: number;
    fieldCount: number;
    createdAt: any;
    updatedAt: any;
  };
};

export type UpdateCustomFieldSectionMutationVariables = Exact<{
  input: UpdateCustomFieldSectionInputType;
}>;

export type UpdateCustomFieldSectionMutation = {
  __typename?: 'Mutation';
  updateCustomFieldSection: {
    __typename?: 'CustomFieldSectionType';
    id: string;
    name: string;
    description?: string | null;
    isDefault: boolean;
    displayOrder: number;
    fieldCount: number;
    createdAt: any;
    updatedAt: any;
  };
};

export type DeleteCustomFieldSectionMutationVariables = Exact<{
  input: DeleteCustomFieldSectionInputType;
}>;

export type DeleteCustomFieldSectionMutation = {
  __typename?: 'Mutation';
  deleteCustomFieldSection: {
    __typename?: 'DeleteCustomFieldSectionResponseType';
    id: string;
    deleted: boolean;
  };
};

export type ReorderCustomFieldSectionsMutationVariables = Exact<{
  input: ReorderCustomFieldSectionsInputType;
}>;

export type ReorderCustomFieldSectionsMutation = {
  __typename?: 'Mutation';
  reorderCustomFieldSections: {
    __typename?: 'CustomFieldSectionsResponseType';
    sections: Array<{
      __typename?: 'CustomFieldSectionType';
      id: string;
      name: string;
      description?: string | null;
      isDefault: boolean;
      displayOrder: number;
      fieldCount: number;
      createdAt: any;
      updatedAt: any;
    }>;
  };
};

export type GetOrganisationCustomFieldsQueryVariables = Exact<{
  input?: InputMaybe<GetOrganisationCustomFieldsInputType>;
}>;

export type GetOrganisationCustomFieldsQuery = {
  __typename?: 'Query';
  getOrganisationCustomFields: {
    __typename?: 'CustomFieldsResponseType';
    total: number;
    customFields: Array<{
      __typename?: 'CustomFieldType';
      id: string;
      label: string;
      identifier: string;
      description?: string | null;
      fieldType: string;
      status: string;
      displayOrder: number;
      options: Array<string>;
      sectionId?: string | null;
      isStandard: boolean;
      createdAt: any;
      updatedAt: any;
      optionDetails?: Array<{
        __typename?: 'CustomFieldOptionType';
        id: string;
        customFieldId: string;
        label: string;
        displayOrder: number;
        isActive: boolean;
        createdAt: any;
        updatedAt: any;
      }> | null;
      author?: {
        __typename?: 'CustomFieldAuthorType';
        id: number;
        name: string;
      } | null;
    }>;
  };
};

export type CreateCustomFieldMutationVariables = Exact<{
  input: CreateCustomFieldInputType;
}>;

export type CreateCustomFieldMutation = {
  __typename?: 'Mutation';
  createCustomField: {
    __typename?: 'CustomFieldType';
    id: string;
    label: string;
    identifier: string;
    description?: string | null;
    fieldType: string;
    status: string;
    displayOrder: number;
    options: Array<string>;
    sectionId?: string | null;
    isStandard: boolean;
    createdAt: any;
    updatedAt: any;
  };
};

export type UpdateCustomFieldMutationVariables = Exact<{
  input: UpdateCustomFieldInputType;
}>;

export type UpdateCustomFieldMutation = {
  __typename?: 'Mutation';
  updateCustomField: {
    __typename?: 'CustomFieldType';
    id: string;
    label: string;
    identifier: string;
    description?: string | null;
    fieldType: string;
    status: string;
    displayOrder: number;
    options: Array<string>;
    sectionId?: string | null;
    isStandard: boolean;
    createdAt: any;
    updatedAt: any;
  };
};

export type ReorderCustomFieldsMutationVariables = Exact<{
  input: ReorderCustomFieldsInputType;
}>;

export type ReorderCustomFieldsMutation = {
  __typename?: 'Mutation';
  reorderCustomFields: Array<{
    __typename?: 'CustomFieldOrderType';
    id: string;
    displayOrder: number;
  }>;
};

export type DeactivateCustomFieldMutationVariables = Exact<{
  input: DeactivateCustomFieldInputType;
}>;

export type DeactivateCustomFieldMutation = {
  __typename?: 'Mutation';
  deactivateCustomField: boolean;
};

export type UpdateCustomFieldOptionsMutationVariables = Exact<{
  input: UpdateCustomFieldOptionsInputType;
}>;

export type UpdateCustomFieldOptionsMutation = {
  __typename?: 'Mutation';
  updateCustomFieldOptions: Array<{
    __typename?: 'CustomFieldOptionType';
    id: string;
    customFieldId: string;
    label: string;
    displayOrder: number;
    isActive: boolean;
    createdAt: any;
    updatedAt: any;
  }>;
};

export type ReactivateCustomFieldMutationVariables = Exact<{
  input: ReactivateCustomFieldInputType;
}>;

export type ReactivateCustomFieldMutation = {
  __typename?: 'Mutation';
  reactivateCustomField: boolean;
};

export type GetOrganisationQuestionnairesQueryVariables = Exact<{
  queryParams?: InputMaybe<QuestionnairesQueryParamsType>;
}>;

export type GetOrganisationQuestionnairesQuery = {
  __typename?: 'Query';
  organisationQuestionnaires: Array<{
    __typename?: 'QuestionnaireListItemType';
    id?: string | null;
    internalName?: string | null;
    publicTitle?: string | null;
    accessScope?: string | null;
    languageId?: string | null;
    version?: string | null;
    status?: string | null;
    isActive?: boolean | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    description?: string | null;
    categoryId?: number | null;
  }>;
};

export type GetQuestionnaireQuestionsQueryVariables = Exact<{
  questionnaireId: Scalars['String'];
}>;

export type GetQuestionnaireQuestionsQuery = {
  __typename?: 'Query';
  questionnaireQuestions: {
    __typename?: 'QuestionnaireQuestionsResponseType';
    count?: number | null;
    questions?: Array<{
      __typename?: 'QuestionnaireQuestionType';
      id?: string | null;
      questionText?: string | null;
      description?: string | null;
      isRequired?: boolean | null;
      interestTypeId?: string | null;
      attachmentAllowed?: boolean | null;
      databaseFieldSubTypeId?: string | null;
      allowMultiSelect?: boolean | null;
      orderIndex?: number | null;
      languageId?: string | null;
      questionnaireId?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      questionType?: {
        __typename?: 'QuestionnaireQuestionTypeType';
        id?: string | null;
        typeKey?: string | null;
        label?: string | null;
        allowsOptions?: boolean | null;
      } | null;
      options?: Array<{
        __typename?: 'QuestionnaireQuestionOptionType';
        id?: string | null;
        optionText?: string | null;
        optionOrder?: number | null;
      }> | null;
      dataGridConfig?: {
        __typename?: 'QuestionnaireDataGridConfigType';
        minRows?: number | null;
        maxRows?: number | null;
        addRowLabel?: string | null;
        removeRowLabel?: string | null;
        columns: Array<{
          __typename?: 'QuestionnaireDataGridColumnType';
          key: string;
          label: string;
          type: string;
        }>;
      } | null;
      databaseFieldSubType?: {
        __typename?: 'QuestionnaireDataBaseConfigType';
        subTypeKey?: string | null;
      } | null;
    }> | null;
  };
};

export type CreateQuestionnaireResponseMutationVariables = Exact<{
  questionnaireId: Scalars['String'];
  reportId?: InputMaybe<Scalars['String']>;
}>;

export type CreateQuestionnaireResponseMutation = {
  __typename?: 'Mutation';
  createQuestionnaireResponse: {
    __typename?: 'CreateQuestionnaireResponsePayload';
    responseId: string;
  };
};

export type SaveResponseAnswersMutationVariables = Exact<{
  responseId: Scalars['String'];
  answers: Array<SaveAnswerInputType> | SaveAnswerInputType;
  reportId?: InputMaybe<Scalars['String']>;
}>;

export type SaveResponseAnswersMutation = {
  __typename?: 'Mutation';
  saveResponseAnswers: boolean;
};

export type RegisterQuestionnaireResponseAttachmentMutationVariables = Exact<{
  responseId: Scalars['String'];
  reportId: Scalars['String'];
  questionId: Scalars['String'];
  evidenceS3Path: Scalars['String'];
}>;

export type RegisterQuestionnaireResponseAttachmentMutation = {
  __typename?: 'Mutation';
  registerQuestionnaireResponseAttachment: {
    __typename?: 'RegisterQuestionnaireResponseAttachmentPayload';
    attachment?: {
      __typename?: 'QuestionnaireResponseAttachmentType';
      id?: string | null;
      answerId?: string | null;
      fileName?: string | null;
      fileKey?: string | null;
      fileSize?: number | null;
      mimeType?: string | null;
      fileExtension?: string | null;
      uploadedAt?: string | null;
    } | null;
  };
};

export type DeleteQuestionnaireResponseAttachmentMutationVariables = Exact<{
  responseId: Scalars['String'];
  attachmentId: Scalars['String'];
  reportId?: InputMaybe<Scalars['String']>;
}>;

export type DeleteQuestionnaireResponseAttachmentMutation = {
  __typename?: 'Mutation';
  deleteQuestionnaireResponseAttachment: boolean;
};

export type SubmitQuestionnaireResponseMutationVariables = Exact<{
  responseId: Scalars['String'];
  attestationAccepted: Scalars['Boolean'];
}>;

export type SubmitQuestionnaireResponseMutation = {
  __typename?: 'Mutation';
  submitQuestionnaireResponse: boolean;
};

export type DeleteQuestionnaireResponseMutationVariables = Exact<{
  responseId: Scalars['String'];
}>;

export type DeleteQuestionnaireResponseMutation = {
  __typename?: 'Mutation';
  deleteQuestionnaireResponse: boolean;
};

export type GetGlobalFeaturesQueryVariables = Exact<{ [key: string]: never }>;

export type GetGlobalFeaturesQuery = {
  __typename?: 'Query';
  getGlobalFeatures: Array<{
    __typename?: 'FeatureType';
    id: number;
    key: string;
    enabled: boolean;
  }>;
};

export type GetPublicFeaturesQueryVariables = Exact<{
  slug: Scalars['String'];
}>;

export type GetPublicFeaturesQuery = {
  __typename?: 'Query';
  getPublicFeatures: Array<{
    __typename?: 'FeatureType';
    id: number;
    key: string;
    enabled: boolean;
  }>;
};

export type GetOrganisationFeaturesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetOrganisationFeaturesQuery = {
  __typename?: 'Query';
  getOrganisationFeatures: Array<{
    __typename?: 'FeatureType';
    id: number;
    key: string;
    enabled: boolean;
  }>;
};

export type GetFormCategoriesQueryVariables = Exact<{ [key: string]: never }>;

export type GetFormCategoriesQuery = {
  __typename?: 'Query';
  formCategories: {
    __typename?: 'FormCategoriesListResponse';
    count: number;
    formCategories: Array<{
      __typename?: 'FormCategory';
      id?: string | null;
      categoryKey?: string | null;
      label?: string | null;
      description?: string | null;
      isActive?: boolean | null;
    }>;
  };
};

export type FormManagementQuestionnairesQueryVariables = Exact<{
  filters?: InputMaybe<QuestionnaireFilterInput>;
}>;

export type FormManagementQuestionnairesQuery = {
  __typename?: 'Query';
  formManagementQuestionnaires: Array<{
    __typename?: 'FormManagementQuestionnaireListItem';
    id?: string | null;
    internalName?: string | null;
    publicTitle?: string | null;
    description?: string | null;
    accessScope?: string | null;
    version?: string | null;
    status?: string | null;
    isActive?: boolean | null;
    category?: string | null;
    categoryId?: number | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    languages?: Array<{
      __typename?: 'LanguageType';
      id?: string | null;
      code?: string | null;
      name?: string | null;
      isDefault?: boolean | null;
    }> | null;
    createdBy?: {
      __typename?: 'CreatedByType';
      id?: string | null;
      name?: string | null;
      email?: string | null;
    } | null;
    formCategory?: {
      __typename?: 'FormCategoryType';
      id?: string | null;
      categoryKey?: string | null;
      label?: string | null;
    } | null;
    stats?: {
      __typename?: 'QuestionnaireStatsType';
      totalQuestions?: number | null;
    } | null;
    countries?: Array<{
      __typename?: 'QuestionnaireCountryType';
      countryCode: string;
      countryName: string;
    }> | null;
  }>;
};

export type FormManagementQuestionnaireByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;

export type FormManagementQuestionnaireByIdQuery = {
  __typename?: 'Query';
  formManagementQuestionnaireById: {
    __typename?: 'FormManagementQuestionnaire';
    id?: string | null;
    organizationId?: string | null;
    internalName?: string | null;
    publicTitle?: string | null;
    description?: string | null;
    introduction?: string | null;
    accessScope?: string | null;
    targetDepartmentIds?: Array<string> | null;
    version?: string | null;
    status?: string | null;
    isActive?: boolean | null;
    masterQuestionnaireId?: string | null;
    category?: string | null;
    categoryId?: number | null;
    autoReviewEnabled?: boolean | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    languages?: Array<{
      __typename?: 'LanguageType';
      id?: string | null;
      code?: string | null;
      name?: string | null;
      isDefault?: boolean | null;
    }> | null;
    questionnaireTranslations?: Array<{
      __typename?: 'QuestionnaireTranslationType';
      id: string;
      languageCode: string;
      languageName: string;
      publicTitle?: string | null;
      description?: string | null;
    }> | null;
    createdBy?: {
      __typename?: 'CreatedByType';
      id?: string | null;
      name?: string | null;
      email?: string | null;
    } | null;
    formCategory?: {
      __typename?: 'FormCategoryType';
      id?: string | null;
      categoryKey?: string | null;
      label?: string | null;
    } | null;
    countries?: Array<{
      __typename?: 'QuestionnaireCountryType';
      countryCode: string;
      countryName: string;
    }> | null;
  };
};

export type DuplicateFormManagementQuestionnaireMutationVariables = Exact<{
  id: Scalars['String'];
  input: DuplicateQuestionnaireInput;
}>;

export type DuplicateFormManagementQuestionnaireMutation = {
  __typename?: 'Mutation';
  duplicateFormManagementQuestionnaire: {
    __typename?: 'FormManagementQuestionnaire';
    id?: string | null;
    internalName?: string | null;
    publicTitle?: string | null;
    description?: string | null;
    accessScope?: string | null;
    version?: string | null;
    status?: string | null;
    isActive?: boolean | null;
    category?: string | null;
    autoReviewEnabled?: boolean | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    languages?: Array<{
      __typename?: 'LanguageType';
      id?: string | null;
      code?: string | null;
      name?: string | null;
      isDefault?: boolean | null;
    }> | null;
    createdBy?: {
      __typename?: 'CreatedByType';
      id?: string | null;
      name?: string | null;
      email?: string | null;
    } | null;
    formCategory?: {
      __typename?: 'FormCategoryType';
      id?: string | null;
      categoryKey?: string | null;
      label?: string | null;
    } | null;
  };
};

export type UpdateFormManagementQuestionnaireStatusMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateQuestionnaireStatusInput;
}>;

export type UpdateFormManagementQuestionnaireStatusMutation = {
  __typename?: 'Mutation';
  updateFormManagementQuestionnaireStatus: {
    __typename?: 'FormManagementQuestionnaire';
    id?: string | null;
    internalName?: string | null;
    publicTitle?: string | null;
    description?: string | null;
    accessScope?: string | null;
    version?: string | null;
    status?: string | null;
    isActive?: boolean | null;
    category?: string | null;
    autoReviewEnabled?: boolean | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    languages?: Array<{
      __typename?: 'LanguageType';
      id?: string | null;
      code?: string | null;
      name?: string | null;
      isDefault?: boolean | null;
    }> | null;
    createdBy?: {
      __typename?: 'CreatedByType';
      id?: string | null;
      name?: string | null;
      email?: string | null;
    } | null;
    formCategory?: {
      __typename?: 'FormCategoryType';
      id?: string | null;
      categoryKey?: string | null;
      label?: string | null;
    } | null;
  };
};

export type FormManagementQuestionsQueryVariables = Exact<{
  questionnaireId: Scalars['String'];
}>;

export type FormManagementQuestionsQuery = {
  __typename?: 'Query';
  formManagementQuestions: {
    __typename?: 'QuestionsListResponse';
    count?: number | null;
    questions?: Array<{
      __typename?: 'FormManagementQuestion';
      id?: string | null;
      questionnaireId?: string | null;
      orderIndex?: number | null;
      questionText?: string | null;
      description?: string | null;
      isRequired?: boolean | null;
      interestTypeId?: string | null;
      attachmentAllowed?: boolean | null;
      databaseFieldSubTypeId?: string | null;
      allowMultiSelect?: boolean | null;
      shouldAutoFlagIfAnswered?: boolean | null;
      languageId?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      questionType?: {
        __typename?: 'FormManagementQuestionType';
        id?: string | null;
        typeKey?: string | null;
        label?: string | null;
        allowsOptions?: boolean | null;
      } | null;
      translations?: Array<{
        __typename?: 'FormManagementQuestionTranslation';
        id?: string | null;
        languageCode?: string | null;
        questionText?: string | null;
        description?: string | null;
      }> | null;
      options?: Array<{
        __typename?: 'FormManagementQuestionOption';
        id?: string | null;
        optionText?: string | null;
        optionOrder?: number | null;
        navigationAction?: string | null;
        targetQuestionId?: string | null;
        shouldAutoFlag?: boolean | null;
        translations?: Array<{
          __typename?: 'FormManagementQuestionOptionTranslation';
          id?: string | null;
          languageCode?: string | null;
          optionText?: string | null;
        }> | null;
      }> | null;
      dataGridConfig?: {
        __typename?: 'DataGridConfigType';
        minRows?: number | null;
        maxRows?: number | null;
        addRowLabel?: string | null;
        removeRowLabel?: string | null;
        columns: Array<{
          __typename?: 'DataGridColumnType';
          key: string;
          label: string;
          type: string;
          required?: boolean | null;
          maxLength?: number | null;
          options?: Array<string> | null;
          min?: number | null;
          max?: number | null;
          translations?: Array<{
            __typename?: 'DataGridColumnTranslationType';
            languageCode?: string | null;
            label?: string | null;
          }> | null;
        }>;
      } | null;
    }> | null;
  };
};

export type FormManagementActivityLogQueryVariables = Exact<{
  filters?: InputMaybe<OrgActivityLogFilterInput>;
}>;

export type FormManagementActivityLogQuery = {
  __typename?: 'Query';
  formManagementActivityLog: {
    __typename?: 'PaginatedActivityLogResponse';
    data?: Array<{
      __typename?: 'FormManagementActivityLogEntry';
      id?: string | null;
      timestamp?: string | null;
      entityType?: ActivityLogEntityType | null;
      entityId?: string | null;
      entityName?: string | null;
      action?: ActivityLogAction | null;
      eventDisplayName?: string | null;
      parentEntityId?: string | null;
      parentEntityName?: string | null;
      metadata?: any | null;
      user?: {
        __typename?: 'ActivityLogUser';
        userId?: string | null;
        name?: string | null;
        email?: string | null;
      } | null;
      formCategory?: {
        __typename?: 'ActivityLogFormCategory';
        id?: string | null;
        categoryKey?: string | null;
        label?: string | null;
      } | null;
    }> | null;
    pagination?: {
      __typename?: 'ActivityLogPaginationType';
      page?: number | null;
      limit?: number | null;
      totalItems?: number | null;
      totalPages?: number | null;
      hasNext?: boolean | null;
      hasPrevious?: boolean | null;
    } | null;
  };
};

export type FormManagementQuestionnaireActivityLogQueryVariables = Exact<{
  questionnaireId: Scalars['String'];
  filters?: InputMaybe<QuestionnaireActivityLogFilterInput>;
}>;

export type FormManagementQuestionnaireActivityLogQuery = {
  __typename?: 'Query';
  formManagementQuestionnaireActivityLog: {
    __typename?: 'PaginatedActivityLogResponse';
    data?: Array<{
      __typename?: 'FormManagementActivityLogEntry';
      id?: string | null;
      timestamp?: string | null;
      entityType?: ActivityLogEntityType | null;
      entityId?: string | null;
      entityName?: string | null;
      action?: ActivityLogAction | null;
      eventDisplayName?: string | null;
      parentEntityId?: string | null;
      parentEntityName?: string | null;
      metadata?: any | null;
      user?: {
        __typename?: 'ActivityLogUser';
        userId?: string | null;
        name?: string | null;
        email?: string | null;
      } | null;
      formCategory?: {
        __typename?: 'ActivityLogFormCategory';
        id?: string | null;
        categoryKey?: string | null;
        label?: string | null;
      } | null;
    }> | null;
    pagination?: {
      __typename?: 'ActivityLogPaginationType';
      page?: number | null;
      limit?: number | null;
      totalItems?: number | null;
      totalPages?: number | null;
      hasNext?: boolean | null;
      hasPrevious?: boolean | null;
    } | null;
  };
};

export type CreateFormManagementQuestionnaireMutationVariables = Exact<{
  input: CreateQuestionnaireInput;
}>;

export type CreateFormManagementQuestionnaireMutation = {
  __typename?: 'Mutation';
  createFormManagementQuestionnaire: {
    __typename?: 'FormManagementQuestionnaire';
    id?: string | null;
    organizationId?: string | null;
    internalName?: string | null;
    publicTitle?: string | null;
    description?: string | null;
    introduction?: string | null;
    accessScope?: string | null;
    targetDepartmentIds?: Array<string> | null;
    version?: string | null;
    status?: string | null;
    isActive?: boolean | null;
    masterQuestionnaireId?: string | null;
    category?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    languages?: Array<{
      __typename?: 'LanguageType';
      id?: string | null;
      code?: string | null;
      name?: string | null;
      isDefault?: boolean | null;
    }> | null;
    questionnaireTranslations?: Array<{
      __typename?: 'QuestionnaireTranslationType';
      id: string;
      languageCode: string;
      languageName: string;
      publicTitle?: string | null;
      description?: string | null;
    }> | null;
    createdBy?: {
      __typename?: 'CreatedByType';
      id?: string | null;
      name?: string | null;
      email?: string | null;
    } | null;
    formCategory?: {
      __typename?: 'FormCategoryType';
      id?: string | null;
      categoryKey?: string | null;
      label?: string | null;
    } | null;
    countries?: Array<{
      __typename?: 'QuestionnaireCountryType';
      countryCode: string;
      countryName: string;
    }> | null;
  };
};

export type UpdateFormManagementQuestionnaireMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateQuestionnaireInput;
}>;

export type UpdateFormManagementQuestionnaireMutation = {
  __typename?: 'Mutation';
  updateFormManagementQuestionnaire: {
    __typename?: 'FormManagementQuestionnaire';
    id?: string | null;
    organizationId?: string | null;
    internalName?: string | null;
    publicTitle?: string | null;
    description?: string | null;
    introduction?: string | null;
    accessScope?: string | null;
    targetDepartmentIds?: Array<string> | null;
    version?: string | null;
    status?: string | null;
    isActive?: boolean | null;
    masterQuestionnaireId?: string | null;
    category?: string | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    languages?: Array<{
      __typename?: 'LanguageType';
      id?: string | null;
      code?: string | null;
      name?: string | null;
      isDefault?: boolean | null;
    }> | null;
    questionnaireTranslations?: Array<{
      __typename?: 'QuestionnaireTranslationType';
      id: string;
      languageCode: string;
      languageName: string;
      publicTitle?: string | null;
      description?: string | null;
    }> | null;
    createdBy?: {
      __typename?: 'CreatedByType';
      id?: string | null;
      name?: string | null;
      email?: string | null;
    } | null;
    formCategory?: {
      __typename?: 'FormCategoryType';
      id?: string | null;
      categoryKey?: string | null;
      label?: string | null;
    } | null;
    countries?: Array<{
      __typename?: 'QuestionnaireCountryType';
      countryCode: string;
      countryName: string;
    }> | null;
  };
};

export type DeleteFormManagementQuestionnaireMutationVariables = Exact<{
  id: Scalars['String'];
}>;

export type DeleteFormManagementQuestionnaireMutation = {
  __typename?: 'Mutation';
  deleteFormManagementQuestionnaire: {
    __typename?: 'QuestionnaireSuccessResponse';
    success?: boolean | null;
    message?: string | null;
  };
};

export type TranslateFormDraftContentMutationVariables = Exact<{
  input: TranslateFormDraftContentInput;
}>;

export type TranslateFormDraftContentMutation = {
  __typename?: 'Mutation';
  translateFormDraftContent: {
    __typename?: 'TranslateFormDraftContentPayload';
    formTitle?: string | null;
    formDescription?: string | null;
    introduction?: string | null;
    warnings: Array<string>;
    questions: Array<{
      __typename?: 'TranslateFormQuestionResult';
      orderIndex: number;
      questionText: string;
      description?: string | null;
      options?: Array<{
        __typename?: 'TranslateFormOptionResult';
        optionOrder: number;
        optionText: string;
      }> | null;
    }>;
  };
};

export type BulkCreateFormManagementQuestionsMutationVariables = Exact<{
  questionnaireId: Scalars['String'];
  input: BulkUpsertQuestionsInput;
}>;

export type BulkCreateFormManagementQuestionsMutation = {
  __typename?: 'Mutation';
  bulkCreateFormManagementQuestions: {
    __typename?: 'BulkCreateQuestionsResponse';
    summary: {
      __typename?: 'BulkUpsertQuestionsSummary';
      created: number;
      updated: number;
      deleted: number;
      total: number;
    };
    questions: Array<{
      __typename?: 'FormManagementQuestion';
      id?: string | null;
      questionnaireId?: string | null;
      orderIndex?: number | null;
      questionText?: string | null;
      description?: string | null;
      isRequired?: boolean | null;
      interestTypeId?: string | null;
      attachmentAllowed?: boolean | null;
      databaseFieldSubTypeId?: string | null;
      allowMultiSelect?: boolean | null;
      shouldAutoFlagIfAnswered?: boolean | null;
      languageId?: string | null;
      createdAt?: string | null;
      updatedAt?: string | null;
      questionType?: {
        __typename?: 'FormManagementQuestionType';
        id?: string | null;
        typeKey?: string | null;
        label?: string | null;
        allowsOptions?: boolean | null;
      } | null;
      translations?: Array<{
        __typename?: 'FormManagementQuestionTranslation';
        id?: string | null;
        languageCode?: string | null;
        questionText?: string | null;
        description?: string | null;
      }> | null;
      options?: Array<{
        __typename?: 'FormManagementQuestionOption';
        id?: string | null;
        optionText?: string | null;
        optionOrder?: number | null;
        navigationAction?: string | null;
        targetQuestionId?: string | null;
        shouldAutoFlag?: boolean | null;
        translations?: Array<{
          __typename?: 'FormManagementQuestionOptionTranslation';
          id?: string | null;
          languageCode?: string | null;
          optionText?: string | null;
        }> | null;
      }> | null;
      dataGridConfig?: {
        __typename?: 'DataGridConfigType';
        minRows?: number | null;
        maxRows?: number | null;
        addRowLabel?: string | null;
        removeRowLabel?: string | null;
        columns: Array<{
          __typename?: 'DataGridColumnType';
          key: string;
          label: string;
          type: string;
          required?: boolean | null;
          maxLength?: number | null;
          options?: Array<string> | null;
          min?: number | null;
          max?: number | null;
          translations?: Array<{
            __typename?: 'DataGridColumnTranslationType';
            languageCode?: string | null;
            label?: string | null;
          }> | null;
        }>;
      } | null;
    }>;
  };
};

export type GetQuestionTypesQueryVariables = Exact<{
  formCategoryId?: InputMaybe<Scalars['String']>;
}>;

export type GetQuestionTypesQuery = {
  __typename?: 'Query';
  getQuestionTypes: {
    __typename?: 'FormManagementQuestionTypesListResponse';
    count: number;
    questionTypes: Array<{
      __typename?: 'FormManagementQuestionTypeDetail';
      id: string;
      typeKey: string;
      label: string;
      description?: string | null;
      allowsOptions: boolean;
      databaseFieldSubTypes?: Array<{
        __typename?: 'FormManagementDatabaseFieldSubType';
        id: string;
        subTypeKey: string;
        label: string;
        description?: string | null;
      }> | null;
    }>;
  };
};

export type CreateGroupMutationVariables = Exact<{
  parameters: GroupCreationType;
}>;

export type CreateGroupMutation = {
  __typename?: 'Mutation';
  createGroup: {
    __typename?: 'GroupType';
    id: string;
    name?: string | null;
    description?: string | null;
    createdBy: number;
    attributes?: any | null;
  };
};

export type DeleteGroupMutationVariables = Exact<{
  id: Scalars['String'];
}>;

export type DeleteGroupMutation = {
  __typename?: 'Mutation';
  deleteGroup: number;
};

export type GroupUserCountQueryVariables = Exact<{
  groupUserCountId: Scalars['String'];
}>;

export type GroupUserCountQuery = { __typename?: 'Query'; groupUserCount: any };

export type GroupsQueryVariables = Exact<{ [key: string]: never }>;

export type GroupsQuery = {
  __typename?: 'Query';
  orgGroups: Array<{
    __typename?: 'GroupType';
    id: string;
    name?: string | null;
    description?: string | null;
    createdBy: number;
    attributes?: any | null;
    createdAt: any;
    ActiveCMCount: number;
    ActiveCoiReviewerCount: number;
    hasNonCOIReviewerMembers?: boolean | null;
    CreatedBy?: {
      __typename?: 'UserType';
      displayName?: string | null;
      name?: string | null;
    } | null;
  }>;
};

export type GroupsAttributesDataQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GroupsAttributesDataQuery = {
  __typename?: 'Query';
  groupsAttributesData: {
    __typename?: 'OrganisationType';
    department?: Array<string> | null;
    country?: Array<string> | null;
    site?: Array<string> | null;
    team?: Array<any> | null;
    systemRoles?: Array<any> | null;
  };
};

export type UpdateGroupMutationVariables = Exact<{
  parameters: GroupUpdateType;
}>;

export type UpdateGroupMutation = {
  __typename?: 'Mutation';
  updateGroup: {
    __typename?: 'GroupType';
    attributes?: any | null;
    id: string;
    name?: string | null;
    description?: string | null;
  };
};

export type AdoptionMetricsQueryVariables = Exact<{ [key: string]: never }>;

export type AdoptionMetricsQuery = {
  __typename?: 'Query';
  adoptionMetrics: Array<{
    __typename?: 'OldHeroMetricType';
    category: string;
    value: number;
    description: string;
    type: string;
  }>;
};

export type GetCasesPerWeekBarStackedQueryVariables = Exact<{
  casesType: BarStackedCasesFiltersTypes;
  timeframe?: InputMaybe<TimeframeInput>;
  departments?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  sites?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  countries?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  caseCountryCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  caseRegionIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  categories?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;

export type GetCasesPerWeekBarStackedQuery = {
  __typename?: 'Query';
  getCasesPerWeekBarStacked: {
    __typename?: 'CasesOverTimeType';
    stackLabels: Array<string>;
    xTitle: string;
    yTitle: string;
    data: Array<{
      __typename?: 'CasesOverTimeDataType';
      bar: string;
      closed: number;
      open: number;
      total: number;
    }>;
  };
};

export type GetIssueCategoriesByIntakeMethodGraphQueryVariables = Exact<{
  timeframe?: InputMaybe<TimeframeInput>;
  sites?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  countries?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  caseCountryCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  caseRegionIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  departments?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  categories?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;

export type GetIssueCategoriesByIntakeMethodGraphQuery = {
  __typename?: 'Query';
  getIssueCategoriesByIntakeMethodGraph: {
    __typename?: 'DonutAndBarChartType';
    xTitle: string;
    yTitle: string;
    centerText: string;
    maxCategoryTotal: number;
    data: Array<{
      __typename?: 'DonutAndBarChartDataType';
      donutSegment: string;
      total: number;
      categories: Array<{
        __typename?: 'DonutAndBarChartCategoryDataType';
        category: string;
        total: number;
      }>;
    }>;
  };
};

export type GetSubstantiationStatusCountQueryVariables = Exact<{
  departments?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  sites?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  countries?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  caseCountryCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  caseRegionIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  timeframe?: InputMaybe<TimeframeInput>;
  categories?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;

export type GetSubstantiationStatusCountQuery = {
  __typename?: 'Query';
  getSubstantiationStatusCount: {
    __typename?: 'HorizontalBarChartType';
    xTitle: string;
    yTitle: string;
    data: Array<{
      __typename?: 'HorizontalBarChartDataType';
      bar: number;
      label: string;
      value: number;
    }>;
  };
};

export type GetIssueCategoriesByDepartmentGraphQueryVariables = Exact<{
  timeframe?: InputMaybe<TimeframeInput>;
  sites?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  countries?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  caseCountryCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  caseRegionIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  departments?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  categories?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;

export type GetIssueCategoriesByDepartmentGraphQuery = {
  __typename?: 'Query';
  getIssueCategoriesByDepartmentGraph: {
    __typename?: 'DonutAndBarChartType';
    xTitle: string;
    yTitle: string;
    centerText: string;
    maxCategoryTotal: number;
    data: Array<{
      __typename?: 'DonutAndBarChartDataType';
      donutSegment: string;
      total: number;
      categories: Array<{
        __typename?: 'DonutAndBarChartCategoryDataType';
        category: string;
        total: number;
      }>;
    }>;
  };
};

export type GetReportsPerCategoryPerMonthGraphQueryVariables = Exact<{
  dateGroup: Scalars['String'];
  categories?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  departments?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  sites?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  countries?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  caseCountryCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  caseRegionIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  timeframe?: InputMaybe<TimeframeInput>;
}>;

export type GetReportsPerCategoryPerMonthGraphQuery = {
  __typename?: 'Query';
  getReportsPerCategoryPerMonthGraph: {
    __typename?: 'LineChartType';
    xTitle: string;
    yTitle: string;
    data: Array<{
      __typename?: 'LineChartDataType';
      category: string;
      linePlot: Array<{
        __typename?: 'MonthlyDataType';
        count: number;
        month: string;
      }>;
    }>;
  };
};

export type InsightsOrganisationDataQueryVariables = Exact<{
  [key: string]: never;
}>;

export type InsightsOrganisationDataQuery = {
  __typename?: 'Query';
  organisation: {
    __typename?: 'OrganisationType';
    id: number;
    name: string;
    insightsDepartments: Array<string>;
    createdAt?: any | null;
    insightsReportCategories?: Array<string> | null;
    insightsCountries?: Array<string> | null;
    insightsSites: Array<string>;
    oldestReportSubmittedDate: any;
    insightsCategories: Array<string>;
    insightsCaseCountryRegions: {
      __typename?: 'InsightsCaseCountryRegionsResultType';
      regions: Array<{
        __typename?: 'InsightsCaseRegionType';
        id: string;
        name: string;
        countryCodes: Array<string>;
      }>;
      countries: Array<{
        __typename?: 'CountryType';
        code: string;
        name: string;
      }>;
    };
  };
};

export type GetTotalCasesHeroMetricQueryVariables = Exact<{
  timeframe?: InputMaybe<TimeframeInput>;
  sites?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  countries?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  caseCountryCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  caseRegionIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;

export type GetTotalCasesHeroMetricQuery = {
  __typename?: 'Query';
  getTotalCasesHeroMetric: {
    __typename?: 'HeroMetricType';
    category: string;
    tooltip?: string | null;
    descriptor?: string | null;
    subCategory: Array<{
      __typename?: 'HeroMetricMetricType';
      category: string;
      count: number;
    }>;
  };
};

export type GetDepartmentWithMostCasesHeroMetricQueryVariables = Exact<{
  timeframe?: InputMaybe<TimeframeInput>;
  sites?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  countries?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  caseCountryCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  caseRegionIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;

export type GetDepartmentWithMostCasesHeroMetricQuery = {
  __typename?: 'Query';
  getDepartmentWithMostCasesHeroMetric: {
    __typename?: 'HeroMetricType';
    category: string;
    tooltip?: string | null;
    descriptor?: string | null;
    subCategory: Array<{
      __typename?: 'HeroMetricMetricType';
      category: string;
      count: number;
    }>;
  };
};

export type GetTimeToResolutionHeroMetricQueryVariables = Exact<{
  timeframe?: InputMaybe<TimeframeInput>;
  sites?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  countries?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  caseCountryCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  caseRegionIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;

export type GetTimeToResolutionHeroMetricQuery = {
  __typename?: 'Query';
  getTimeToResolutionHeroMetric: {
    __typename?: 'HeroMetricType';
    category: string;
    tooltip?: string | null;
    subCategory: Array<{
      __typename?: 'HeroMetricMetricType';
      category: string;
      count: number;
    }>;
  };
};

export type GetLocationWithMostCasesHeroMetricQueryVariables = Exact<{
  timeframe?: InputMaybe<TimeframeInput>;
  sites?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  countries?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  caseCountryCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  caseRegionIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;

export type GetLocationWithMostCasesHeroMetricQuery = {
  __typename?: 'Query';
  getLocationWithMostCasesHeroMetric: {
    __typename?: 'HeroMetricType';
    tooltip?: string | null;
    descriptor?: string | null;
    category: string;
    subCategory: Array<{
      __typename?: 'HeroMetricMetricType';
      count: number;
      category: string;
    }>;
  };
};

export type GetTimeInStatusHeroMetricQueryVariables = Exact<{
  status: Scalars['String'];
  timeframe?: InputMaybe<TimeframeInput>;
  sites?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  countries?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  caseCountryCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  caseRegionIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;

export type GetTimeInStatusHeroMetricQuery = {
  __typename?: 'Query';
  getTimeInStatusHeroMetric: {
    __typename?: 'HeroMetricType';
    category: string;
    tooltip?: string | null;
    subCategory: Array<{
      __typename?: 'HeroMetricMetricType';
      category: string;
      count: number;
    }>;
  };
};

export type GetCasesOver90DaysHeroMetricQueryVariables = Exact<{
  timeframe?: InputMaybe<TimeframeInput>;
  sites?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  countries?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  caseCountryCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  caseRegionIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;

export type GetCasesOver90DaysHeroMetricQuery = {
  __typename?: 'Query';
  getCasesOver90DaysHeroMetric: {
    __typename?: 'HeroMetricType';
    category: string;
    tooltip?: string | null;
    subCategory: Array<{
      __typename?: 'HeroMetricMetricType';
      category: string;
      count: number;
    }>;
  };
};

export type GetMonthWithMostReportsHeroMetricQueryVariables = Exact<{
  timeframe?: InputMaybe<TimeframeInput>;
  sites?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  countries?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  caseCountryCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  caseRegionIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;

export type GetMonthWithMostReportsHeroMetricQuery = {
  __typename?: 'Query';
  getMonthWithMostReportsHeroMetric: {
    __typename?: 'HeroMetricType';
    category: string;
    descriptor?: string | null;
    tooltip?: string | null;
    subCategory: Array<{
      __typename?: 'HeroMetricMetricType';
      count: number;
      category: string;
    }>;
  };
};

export type GetCategoryWithMostReportsHeroMetricQueryVariables = Exact<{
  timeframe?: InputMaybe<TimeframeInput>;
  sites?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  countries?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  caseCountryCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  caseRegionIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;

export type GetCategoryWithMostReportsHeroMetricQuery = {
  __typename?: 'Query';
  getCategoryWithMostReportsHeroMetric: {
    __typename?: 'HeroMetricType';
    tooltip?: string | null;
    descriptor?: string | null;
    category: string;
    subCategory: Array<{
      __typename?: 'HeroMetricMetricType';
      count: number;
      category: string;
    }>;
  };
};

export type GetOrganisationalHeroMetricsQueryVariables = Exact<{
  timeframe?: InputMaybe<TimeframeInput>;
  sites?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  countries?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  caseCountryCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  caseRegionIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;

export type GetOrganisationalHeroMetricsQuery = {
  __typename?: 'Query';
  getTotalCasesHeroMetric: {
    __typename?: 'HeroMetricType';
    category: string;
    tooltip?: string | null;
    descriptor?: string | null;
    subCategory: Array<{
      __typename?: 'HeroMetricMetricType';
      category: string;
      count: number;
    }>;
  };
  getDepartmentWithMostCasesHeroMetric: {
    __typename?: 'HeroMetricType';
    category: string;
    tooltip?: string | null;
    descriptor?: string | null;
    subCategory: Array<{
      __typename?: 'HeroMetricMetricType';
      category: string;
      count: number;
    }>;
  };
  getLocationWithMostCasesHeroMetric: {
    __typename?: 'HeroMetricType';
    tooltip?: string | null;
    descriptor?: string | null;
    category: string;
    subCategory: Array<{
      __typename?: 'HeroMetricMetricType';
      count: number;
      category: string;
    }>;
  };
  getMonthWithMostReportsHeroMetric: {
    __typename?: 'HeroMetricType';
    category: string;
    descriptor?: string | null;
    tooltip?: string | null;
    subCategory: Array<{
      __typename?: 'HeroMetricMetricType';
      count: number;
      category: string;
    }>;
  };
  getCategoryWithMostReportsHeroMetric: {
    __typename?: 'HeroMetricType';
    tooltip?: string | null;
    descriptor?: string | null;
    category: string;
    subCategory: Array<{
      __typename?: 'HeroMetricMetricType';
      count: number;
      category: string;
    }>;
  };
};

export type GetOperationalHeroMetricsQueryVariables = Exact<{
  firstStatus: Scalars['String'];
  secondStatus: Scalars['String'];
  thirdStatus: Scalars['String'];
  timeframe?: InputMaybe<TimeframeInput>;
  sites?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  countries?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  caseCountryCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  caseRegionIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;

export type GetOperationalHeroMetricsQuery = {
  __typename?: 'Query';
  getTimeToResolutionHeroMetric: {
    __typename?: 'HeroMetricType';
    category: string;
    tooltip?: string | null;
    subCategory: Array<{
      __typename?: 'HeroMetricMetricType';
      category: string;
      count: number;
    }>;
  };
  firstStatus: {
    __typename?: 'HeroMetricType';
    category: string;
    tooltip?: string | null;
    subCategory: Array<{
      __typename?: 'HeroMetricMetricType';
      category: string;
      count: number;
    }>;
  };
  secondStatus: {
    __typename?: 'HeroMetricType';
    category: string;
    tooltip?: string | null;
    subCategory: Array<{
      __typename?: 'HeroMetricMetricType';
      category: string;
      count: number;
    }>;
  };
  thirdStatus: {
    __typename?: 'HeroMetricType';
    category: string;
    tooltip?: string | null;
    subCategory: Array<{
      __typename?: 'HeroMetricMetricType';
      category: string;
      count: number;
    }>;
  };
  getCasesOver90DaysHeroMetric: {
    __typename?: 'HeroMetricType';
    category: string;
    tooltip?: string | null;
    subCategory: Array<{
      __typename?: 'HeroMetricMetricType';
      category: string;
      count: number;
    }>;
  };
};

export type MonthlyReportsBySourceQueryVariables = Exact<{
  input: InsightsInput;
}>;

export type MonthlyReportsBySourceQuery = {
  __typename?: 'Query';
  monthlyReportsBySource: Array<{
    __typename?: 'MonthlyReportsBySource';
    month: string;
    app: number;
    manualCaseCreation: number;
    openReporting: number;
    vaultTalk: number;
    slack: number;
    imported: number;
  }>;
};

export type ReportCountQueryVariables = Exact<{
  input: InsightsInput;
}>;

export type ReportCountQuery = { __typename?: 'Query'; reportCount: number };

export type ReportYearsQueryVariables = Exact<{ [key: string]: never }>;

export type ReportYearsQuery = {
  __typename?: 'Query';
  reportYears: Array<number>;
};

export type ReportsByCategoryQueryVariables = Exact<{
  input: InsightsInput;
}>;

export type ReportsByCategoryQuery = {
  __typename?: 'Query';
  reportsByCategory: Array<{
    __typename?: 'ReportsByCategory';
    category: string;
    count: number;
  }>;
};

export type ReportsByDepartmentQueryVariables = Exact<{
  input: InsightsInput;
}>;

export type ReportsByDepartmentQuery = {
  __typename?: 'Query';
  reportsByDepartment: Array<{
    __typename?: 'ReportsByDepartment';
    department: string;
    count: number;
  }>;
};

export type ReportsByStatusQueryVariables = Exact<{
  input: InsightsInput;
}>;

export type ReportsByStatusQuery = {
  __typename?: 'Query';
  reportsByStatus: Array<{
    __typename?: 'ReportsByStatus';
    status: VisibleReportStatus;
    count: number;
  }>;
};

export type ConnectSlackAccountMutationVariables = Exact<{
  authCode: Scalars['String'];
}>;

export type ConnectSlackAccountMutation = {
  __typename?: 'Mutation';
  connectSlackAccount: string;
};

export type GenerateInvestigationPlanMutationVariables = Exact<{
  caseId: Scalars['String'];
}>;

export type GenerateInvestigationPlanMutation = {
  __typename?: 'Mutation';
  generateInvestigationPlan: {
    __typename?: 'InvestigationJobType';
    generationStatus: string;
    jobId?: string | null;
  };
};

export type InvestigationPlanJobStatusQueryVariables = Exact<{
  caseId: Scalars['String'];
}>;

export type InvestigationPlanJobStatusQuery = {
  __typename?: 'Query';
  investigationPlanJobStatus?: {
    __typename?: 'InvestigationPlanJobStatus';
    status: InvestigationPlanStatus;
    jobId?: string | null;
  } | null;
};

export type AcceptInvestigationPlanMutationVariables = Exact<{
  caseId: Scalars['String'];
  planDocumentId: Scalars['String'];
}>;

export type AcceptInvestigationPlanMutation = {
  __typename?: 'Mutation';
  acceptInvestigationPlan: {
    __typename?: 'AcceptInvestigationPlanResult';
    success: boolean;
    acceptedAt?: any | null;
  };
};

export type UpdateInvestigationStepMutationVariables = Exact<{
  caseId: Scalars['String'];
  planDocumentId: Scalars['String'];
  stepId: Scalars['String'];
  status: InvestigationStepStatus;
}>;

export type UpdateInvestigationStepMutation = {
  __typename?: 'Mutation';
  updateInvestigationStep: {
    __typename?: 'UpdateInvestigationStepResult';
    success: boolean;
    updatedStatus?: InvestigationStepStatus | null;
  };
};

export type InvestigationPlanDocumentQueryVariables = Exact<{
  caseId: Scalars['String'];
}>;

export type InvestigationPlanDocumentQuery = {
  __typename?: 'Query';
  investigationPlanDocument?: {
    __typename?: 'InvestigationPlanDocument';
    id: string;
    title: string;
    value: string;
    lastEdited?: any | null;
  } | null;
};

export type UpdateInvestigationChecklistMutationVariables = Exact<{
  caseId: Scalars['String'];
  planDocumentId: Scalars['String'];
  checklist: Scalars['String'];
}>;

export type UpdateInvestigationChecklistMutation = {
  __typename?: 'Mutation';
  updateInvestigationChecklist: {
    __typename?: 'UpdateInvestigationChecklistResult';
    success: boolean;
  };
};

export type GenerateJwtQueryVariables = Exact<{
  dynamicFormId?: InputMaybe<Scalars['String']>;
}>;

export type GenerateJwtQuery = {
  __typename?: 'Query';
  generateJwt?: { __typename?: 'OneSchemaJwt'; jwt: string } | null;
};

export type RequestMergeLinkMutationVariables = Exact<{ [key: string]: never }>;

export type RequestMergeLinkMutation = {
  __typename?: 'Mutation';
  requestMergeLinkToken: string;
};

export type SubmitPublicTokenMutationVariables = Exact<{
  publicToken: Scalars['String'];
}>;

export type SubmitPublicTokenMutation = {
  __typename?: 'Mutation';
  submitPublicToken: boolean;
};

export type GetChannelEntriesQueryVariables = Exact<{
  channel: Scalars['String'];
}>;

export type GetChannelEntriesQuery = {
  __typename?: 'Query';
  getChannelEntries?: Array<{
    __typename?: 'ManagedChannelType';
    id: number;
    manager: number;
    enteredChannel?: any | null;
    exitedChannel?: any | null;
    User: {
      __typename?: 'UserType';
      name?: string | null;
      displayName?: string | null;
    };
  }> | null;
};

export type GetUserChannelEntriesQueryVariables = Exact<{
  channel: Scalars['String'];
}>;

export type GetUserChannelEntriesQuery = {
  __typename?: 'Query';
  getUserChannelEntries?: Array<{
    __typename?: 'ManagedChannelType';
    id: number;
    manager: number;
    enteredChannel?: any | null;
    exitedChannel?: any | null;
    User: {
      __typename?: 'UserType';
      name?: string | null;
      displayName?: string | null;
    };
  }> | null;
};

export type GetMessagesByReportQueryVariables = Exact<{
  report: Scalars['String'];
  translate?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetMessagesByReportQuery = {
  __typename?: 'Query';
  getMessagesByReport?: Array<{
    __typename?: 'ResponseMessageType';
    id: string;
    value: string;
    state: number;
    channel: string;
    author: string;
    isReporter: boolean;
    createdAt: any;
    updatedAt: any;
    translated: boolean;
    deletedAt?: any | null;
    deletedBy?: string | null;
  }> | null;
};

export type SoftDeleteMessagesByIdsMutationVariables = Exact<{
  messageIds: Array<Scalars['String']> | Scalars['String'];
}>;

export type SoftDeleteMessagesByIdsMutation = {
  __typename?: 'Mutation';
  softDeleteMessagesByIds?: boolean | null;
};

export type SendMessageMutationVariables = Exact<{
  caseId: Scalars['String'];
  value: Scalars['String'];
  channel: Scalars['String'];
}>;

export type SendMessageMutation = {
  __typename?: 'Mutation';
  sendMessage?: {
    __typename?: 'ResponseMessageType';
    id: string;
    channel: string;
    value: string;
  } | null;
};

export type GetUserMessagesByReportQueryVariables = Exact<{
  report: Scalars['String'];
  translate?: InputMaybe<Scalars['Boolean']>;
}>;

export type GetUserMessagesByReportQuery = {
  __typename?: 'Query';
  getUserMessagesByReport?: Array<{
    __typename?: 'ResponseMessageType';
    id: string;
    value: string;
    state: number;
    channel: string;
    author: string;
    isReporter: boolean;
    createdAt: any;
    updatedAt: any;
    translated: boolean;
    deletedAt?: any | null;
    deletedBy?: string | null;
  }> | null;
};

export type MarkAllChannelMessagesAsReadMutationVariables = Exact<{
  channel: Scalars['String'];
  translate?: InputMaybe<Scalars['Boolean']>;
}>;

export type MarkAllChannelMessagesAsReadMutation = {
  __typename?: 'Mutation';
  markAllChannelMessagesAsRead?: Array<{
    __typename?: 'ResponseMessageType';
    id: string;
    value: string;
    state: number;
    channel: string;
    author: string;
    isReporter: boolean;
    createdAt: any;
    updatedAt: any;
    translated: boolean;
  }> | null;
};

export type SendUserMessageMutationVariables = Exact<{
  value: Scalars['String'];
  channel: Scalars['String'];
}>;

export type SendUserMessageMutation = {
  __typename?: 'Mutation';
  sendUserMessage?: {
    __typename?: 'ResponseMessageType';
    id: string;
    channel: string;
    value: string;
  } | null;
};

export type NotificationsQueryVariables = Exact<{ [key: string]: never }>;

export type NotificationsQuery = {
  __typename?: 'Query';
  notifications: Array<{
    __typename?: 'NotificationType';
    id: number;
    state: number;
    kind: string;
    createdAt: string;
    assignedFrom?: string | null;
    report?: string | null;
    case?: string | null;
    details?: string | null;
    importType?: string | null;
  }>;
};

export type UpdateNotificationsMutationVariables = Exact<{
  notifications: UpdateNotificationInput;
}>;

export type UpdateNotificationsMutation = {
  __typename?: 'Mutation';
  updateNotifications: Array<{
    __typename?: 'NotificationType';
    id: number;
    state: number;
    kind: string;
    createdAt: string;
    assignedFrom?: string | null;
    report?: string | null;
    case?: string | null;
  }>;
};

export type GetCoiDefaultGroupQueryVariables = Exact<{ [key: string]: never }>;

export type GetCoiDefaultGroupQuery = {
  __typename?: 'Query';
  getCoiDefaultGroup?: string | null;
};

export type GetDefaultGroupQueryVariables = Exact<{ [key: string]: never }>;

export type GetDefaultGroupQuery = {
  __typename?: 'Query';
  getDefaultGroup?: string | null;
};

export type GetOrganisationQueryVariables = Exact<{ [key: string]: never }>;

export type GetOrganisationQuery = {
  __typename?: 'Query';
  organisation: {
    __typename?: 'OrganisationType';
    id: number;
    slackIntegrations?: Array<{
      __typename?: 'OrganisationSlackIntegrationType';
      id: string;
      teamId: string;
      workspaceName: string;
      installedAt?: any | null;
    }> | null;
    hotlineNumbers?: Array<{
      __typename?: 'OrganisationHotlineNumberType';
      id: number;
      phoneNumber: string;
      country: string;
      language: string;
      flagIconCode: string;
      defaultLanguage: string;
    }> | null;
  };
};

export type GetOrganisationRolesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetOrganisationRolesQuery = {
  __typename?: 'Query';
  getOrganisationRoles: Array<{
    __typename?: 'OrganisationRoleType';
    id: string;
    name: string;
    label?: string | null;
    organisation: number;
    description: string;
    isSpecial?: boolean | null;
    updatedAt?: any | null;
    createdAt?: any | null;
    publicSystemPermissions?: {
      __typename?: 'PublicSystemPermissions';
      canCreateReport?: boolean | null;
      canBeAssignedAsCaseLead?: boolean | null;
      canBeAssignedToCaseTeam?: boolean | null;
    } | null;
  }>;
};

export type GetPrivacyStatementQueryVariables = Exact<{
  slug: Scalars['String'];
}>;

export type GetPrivacyStatementQuery = {
  __typename?: 'Query';
  getPrivacyStatement?: string | null;
};

export type SetCoiDefaultGroupMutationVariables = Exact<{
  groupId?: InputMaybe<Scalars['String']>;
}>;

export type SetCoiDefaultGroupMutation = {
  __typename?: 'Mutation';
  setCoiDefaultGroup?: string | null;
};

export type SetDefaultGroupMutationVariables = Exact<{
  groupId?: InputMaybe<Scalars['String']>;
}>;

export type SetDefaultGroupMutation = {
  __typename?: 'Mutation';
  setDefaultGroup?: string | null;
};

export type ChangePasswordMutationVariables = Exact<{
  input: UpdatePasswordInput;
}>;

export type ChangePasswordMutation = {
  __typename?: 'Mutation';
  changePassword: { __typename?: 'PasswordType'; id?: number | null };
};

export type CreateResetMutationVariables = Exact<{
  email: Scalars['String'];
}>;

export type CreateResetMutation = {
  __typename?: 'Mutation';
  createReset: boolean;
};

export type ResetPasswordMutationVariables = Exact<{
  password: Scalars['String'];
  token: Scalars['String'];
}>;

export type ResetPasswordMutation = {
  __typename?: 'Mutation';
  resetPassword: { __typename?: 'PasswordType'; id?: number | null };
};

export type RequestOpenReportingPasswordResetMutationVariables = Exact<{
  input: OprPasswordResetRequestInput;
}>;

export type RequestOpenReportingPasswordResetMutation = {
  __typename?: 'Mutation';
  requestOpenReportingPasswordReset: boolean;
};

export type RelationshipTypeQueryVariables = Exact<{ [key: string]: never }>;

export type RelationshipTypeQuery = {
  __typename?: 'Query';
  getRelationshipType: Array<{
    __typename?: 'RelationshipType';
    id: number;
    name: string;
  }>;
};

export type AddInternalNamedOffenderMutationVariables = Exact<{
  user: LinkInternalNamedOffender;
  reportId: Scalars['String'];
  caseId: Scalars['String'];
}>;

export type AddInternalNamedOffenderMutation = {
  __typename?: 'Mutation';
  addInternalNamedOffender?: {
    __typename?: 'InternalNamedOffender';
    id: string;
  } | null;
};

export type AddExternalNamedOffenderMutationVariables = Exact<{
  user: LinkExternalNamedOffender;
  reportId: Scalars['String'];
  caseId: Scalars['String'];
}>;

export type AddExternalNamedOffenderMutation = {
  __typename?: 'Mutation';
  addExternalNamedOffender?: {
    __typename?: 'ExternalNamedOffender';
    id: string;
  } | null;
};

export type CreateDraftReportMutationVariables = Exact<{
  source: Scalars['String'];
}>;

export type CreateDraftReportMutation = {
  __typename?: 'Mutation';
  createDraftReport: {
    __typename?: 'CreateDraftReportResponseType';
    caseId: string;
    report: {
      __typename?: 'DraftReportData';
      report: string;
      assignee: number;
      reporter?: string | null;
      id: string;
    };
  };
};

export type DeleteDraftReportMutationVariables = Exact<{
  reportId: Scalars['String'];
}>;

export type DeleteDraftReportMutation = {
  __typename?: 'Mutation';
  deleteDraftReport: boolean;
};

export type SubmitDraftReportMutationVariables = Exact<{
  reportId: Scalars['String'];
  submissionMode: Scalars['Int'];
  caseLead?: InputMaybe<Scalars['Float']>;
  autoAssignCaseManagerViaRouting?: InputMaybe<Scalars['Boolean']>;
  responseId?: InputMaybe<Scalars['String']>;
  attestationAccepted?: InputMaybe<Scalars['Boolean']>;
  questionnaireAnswers?: InputMaybe<
    Array<SaveAnswerInputType> | SaveAnswerInputType
  >;
}>;

export type SubmitDraftReportMutation = {
  __typename?: 'Mutation';
  submitDraftReport: {
    __typename?: 'ReportType';
    id: string;
    status: string;
    readableId: string;
    submissionMode?: number | null;
    reporter?: string | null;
    assignee: number;
    source: string;
    createdAt?: any | null;
  };
};

export type GetSubmissionDateQueryVariables = Exact<{
  report: Scalars['String'];
}>;

export type GetSubmissionDateQuery = {
  __typename?: 'Query';
  getSubmissionDate?: any | null;
};

export type CreateReportDocumentationUploadUrlMutationVariables = Exact<{
  fileType: Scalars['String'];
  filename: Scalars['String'];
  reportId: Scalars['String'];
  uploadSource: UploadSource;
  size?: InputMaybe<Scalars['Float']>;
}>;

export type CreateReportDocumentationUploadUrlMutation = {
  __typename?: 'Mutation';
  createReportDocumentationUploadUrl: {
    __typename?: 'PreSignedURLType';
    s3path: string;
    url: string;
  };
};

export type AddReportDocumentationUploadMutationVariables = Exact<{
  documentation: DocumentationInput;
  report: Scalars['String'];
  event: Scalars['String'];
  uploadSource: UploadSource;
}>;

export type AddReportDocumentationUploadMutation = {
  __typename?: 'Mutation';
  addReportDocumentationUpload: { __typename?: 'ReportType'; id: string };
};

export type GetReportUploadReadUrlForReporterMutationVariables = Exact<{
  reportId: Scalars['String'];
  objectId: Scalars['String'];
}>;

export type GetReportUploadReadUrlForReporterMutation = {
  __typename?: 'Mutation';
  getReportUploadReadURLForReporter: {
    __typename?: 'PreSignedURLType';
    url: string;
  };
};

export type ValidateBulkCaseUploadAndGenerateUrlMutationVariables = Exact<{
  files: Array<BulkFileUploadInput> | BulkFileUploadInput;
  uploadSource: UploadSource;
  importedCaseIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;

export type ValidateBulkCaseUploadAndGenerateUrlMutation = {
  __typename?: 'Mutation';
  validateBulkCaseUploadAndGenerateUrl: {
    __typename?: 'BulkUploadResult';
    success: boolean;
    successfulFiles: number;
    totalFiles: number;
    message?: string | null;
    processedFolders: Array<{
      __typename?: 'FolderProcessingResult';
      folderName: string;
      caseId: string;
      success: boolean;
      error?: string | null;
      files: Array<{
        __typename?: 'FileUploadResult';
        filename: string;
        filepath: string;
        validated: boolean;
        uploadStatus: string;
        presignedUrl?: string | null;
        s3path?: string | null;
        mimeType: string;
        size: number;
        fileExtension: string;
        error?: string | null;
      }>;
    }>;
  };
};

export type ReportsQueryVariables = Exact<{
  pagination: PaginationInputType;
  orderBy: OrderByInputType;
  searchBy?: InputMaybe<Array<SearchByInputType> | SearchByInputType>;
  fuzzy?: InputMaybe<FuzzySearchInputType>;
}>;

export type ReportsQuery = {
  __typename?: 'Query';
  reportsPaginated: {
    __typename?: 'PaginatedReportTypeResponse';
    count: number;
    items: Array<{
      __typename?: 'ReportType';
      id: string;
      createdAt?: any | null;
      status: string;
      category: string;
      anonymous?: boolean | null;
      source: string;
      substantiation?: string | null;
      miReportSource?: string | null;
      ReportedCategory?: {
        __typename?: 'CategoryDisplayType';
        id: number;
        name: string;
      } | null;
      DeterminedCategory?: {
        __typename?: 'CategoryDisplayType';
        id: number;
        name: string;
      } | null;
      Assignee?: {
        __typename?: 'UserType';
        id: number;
        name?: string | null;
      } | null;
      Reporter?: { __typename?: 'UserType'; name?: string | null } | null;
    }>;
  };
};

export type UpdateSubstantiationStatusMutationVariables = Exact<{
  newSubstantiationStatus: Scalars['String'];
  report: Scalars['String'];
  caseId: Scalars['String'];
}>;

export type UpdateSubstantiationStatusMutation = {
  __typename?: 'Mutation';
  updateSubstantiationStatus: {
    __typename?: 'ReportType';
    substantiation?: string | null;
  };
};

export type ReassignReportAssigneeMutationVariables = Exact<{
  newReportAssigneeId: Scalars['Float'];
  report: Scalars['String'];
  caseId: Scalars['String'];
}>;

export type ReassignReportAssigneeMutation = {
  __typename?: 'Mutation';
  reassignReportAssignee: { __typename?: 'ReportType'; assignee: number };
};

export type UpdateReportedCategoryMutationVariables = Exact<{
  reportedCategoryId: Scalars['Int'];
  report: Scalars['String'];
}>;

export type UpdateReportedCategoryMutation = {
  __typename?: 'Mutation';
  updateReportedCategory: {
    __typename?: 'ReportType';
    reportedCategory?: number | null;
  };
};

export type UpdateDeterminedCategoryMutationVariables = Exact<{
  determinedCategoryId: Scalars['Int'];
  report: Scalars['String'];
}>;

export type UpdateDeterminedCategoryMutation = {
  __typename?: 'Mutation';
  updateDeterminedCategory: {
    __typename?: 'ReportType';
    determinedCategory?: number | null;
  };
};

export type UpdateMiReportSourceMutationVariables = Exact<{
  miReportSource: MiReportSource;
  report: Scalars['String'];
}>;

export type UpdateMiReportSourceMutation = {
  __typename?: 'Mutation';
  updateMiReportSource: {
    __typename?: 'ReportType';
    miReportSource?: string | null;
  };
};

export type ApplyReportDeletionsMutationVariables = Exact<{
  reportId: Scalars['String'];
  data: DataDeletionType;
}>;

export type ApplyReportDeletionsMutation = {
  __typename?: 'Mutation';
  applyReportDeletions: boolean;
};

export type UserReportsQueryVariables = Exact<{ [key: string]: never }>;

export type UserReportsQuery = {
  __typename?: 'Query';
  userReports?: Array<{
    __typename?: 'UserReportType';
    report: string;
    reportReadableId: string;
    status: string;
    category?: string | null;
    submittedAt?: any | null;
    submissionMode?: string | null;
    unreadMessagesCount: number;
    reportedCategoryLocale?: {
      __typename?: 'CategoryDisplayType';
      id: number;
      name: string;
    } | null;
  }> | null;
};

export type GetReportByIdQueryVariables = Exact<{
  reportId: Scalars['String'];
}>;

export type GetReportByIdQuery = {
  __typename?: 'Query';
  getReportById?: {
    __typename?: 'UserReportFullType';
    reportReadableId: string;
    anonymous?: boolean | null;
    category?: string | null;
    unreadMessagesCount: number;
    relationshipType?: string | null;
    report: string;
    source: string;
    status: string;
    submissionMode?: string | null;
    submittedAt?: any | null;
    evidence: {
      __typename?: 'EvidenceType';
      events?: Array<{
        __typename?: 'EventsEntityType';
        id: string;
        report: string;
      }> | null;
      evidence?: Array<{
        __typename?: 'EvidenceEntityType';
        id: string;
        event: string;
        type: string;
        timestamp: string;
        value: any;
      }> | null;
    };
    perpetrators?: Array<{
      __typename?: 'UserReportPerpetratorType';
      id?: string | null;
      external: boolean;
      name: string;
      dataDeletedAt?: any | null;
    }> | null;
    postSubmissionFiles?: Array<{
      __typename?: 'UploadType';
      id: string;
      size: number;
      fileExtension: string;
      mimeType: string;
      createdAt: any;
      updatedAt: any;
      s3path: string;
      scanStatus: string;
    }> | null;
    reportedCategoryLocale?: {
      __typename?: 'CategoryDisplayType';
      id: number;
      name: string;
    } | null;
  } | null;
};

export type UpdateReportRelationshipToOrganisationMutationVariables = Exact<{
  relationshipToOrganisation: Scalars['Int'];
  report: Scalars['String'];
}>;

export type UpdateReportRelationshipToOrganisationMutation = {
  __typename?: 'Mutation';
  updateReportRelationshipToOrganisation: {
    __typename?: 'ReportType';
    id: string;
  };
};

export type UpdateSubmissionDateMutationVariables = Exact<{
  submittedAt: Scalars['DateTimeISO'];
  report: Scalars['String'];
}>;

export type UpdateSubmissionDateMutation = {
  __typename?: 'Mutation';
  updateSubmissionDate: any;
};

export type ApproveRetentionRuleMutationVariables = Exact<{
  id: Scalars['String'];
}>;

export type ApproveRetentionRuleMutation = {
  __typename?: 'Mutation';
  approveRetentionRule: {
    __typename?: 'RetentionRuleType';
    id: string;
    status: RuleStatusEnum;
  };
};

export type CancelRetentionQueueItemMutationVariables = Exact<{
  queueItemId: Scalars['String'];
}>;

export type CancelRetentionQueueItemMutation = {
  __typename?: 'Mutation';
  cancelRetentionQueueItem: {
    __typename?: 'CaseRetentionQueueType';
    id: string;
    caseId: string;
    ruleId: string;
    dueAt: any;
    completedAt?: any | null;
    retentionApproved: boolean;
    status: RetentionQueueStatusEnum;
    createdAt: any;
    updatedAt: any;
  };
};

export type CreateRetentionRuleMutationVariables = Exact<{
  parameters: CreateRetentionRuleInput;
}>;

export type CreateRetentionRuleMutation = {
  __typename?: 'Mutation';
  createRetentionRule?: {
    __typename?: 'RetentionRuleType';
    id: string;
    organisationId: number;
    authorId: number;
    country?: string | null;
    countryRule?: CountryRuleEnum | null;
    conditions: any;
    dateReference: DateReferenceEnum;
    ruleType?: RuleTypeEnum | null;
    status: RuleStatusEnum;
    createdAt: any;
    updatedAt: any;
  } | null;
};

export type DeclineRetentionRuleMutationVariables = Exact<{
  input: DeclineRetentionRuleInput;
}>;

export type DeclineRetentionRuleMutation = {
  __typename?: 'Mutation';
  declineRetentionRule: {
    __typename?: 'RetentionRuleType';
    id: string;
    status: RuleStatusEnum;
  };
};

export type GetFallbackRetentionRulesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetFallbackRetentionRulesQuery = {
  __typename?: 'Query';
  getFallbackRetentionRules?: Array<{
    __typename?: 'RetentionRuleType';
    id: string;
    authorId: number;
    organisationId: number;
    fallbackRule: boolean;
    countryRule?: CountryRuleEnum | null;
    conditions: any;
    dateReference: DateReferenceEnum;
    ruleType?: RuleTypeEnum | null;
    ruleApproved: boolean;
    status: RuleStatusEnum;
    requiresManualApproval: boolean;
    createdAt: any;
    updatedAt: any;
  }> | null;
};

export type GetRetentionRulesQueryVariables = Exact<{ [key: string]: never }>;

export type GetRetentionRulesQuery = {
  __typename?: 'Query';
  getRetentionRules: Array<{
    __typename?: 'RetentionRulesByCountryType';
    country: string;
    rules: Array<{
      __typename?: 'RetentionRuleType';
      id: string;
      authorId: number;
      organisationId: number;
      fallbackRule: boolean;
      countryRule?: CountryRuleEnum | null;
      conditions: any;
      dateReference: DateReferenceEnum;
      ruleType?: RuleTypeEnum | null;
      ruleApproved: boolean;
      status: RuleStatusEnum;
      requiresManualApproval: boolean;
      createdAt: any;
      updatedAt: any;
    }>;
  }>;
};

export type GetRetentionRulesCountQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetRetentionRulesCountQuery = {
  __typename?: 'Query';
  getRetentionRulesCount: number;
};

export type GetRulesByStatusQueryVariables = Exact<{
  status: Scalars['String'];
}>;

export type GetRulesByStatusQuery = {
  __typename?: 'Query';
  getRulesByStatus?: Array<{
    __typename?: 'RetentionRuleType';
    id: string;
    organisationId: number;
    authorId: number;
    country?: string | null;
    countryRule?: CountryRuleEnum | null;
    conditions: any;
    dateReference: DateReferenceEnum;
    ruleType?: RuleTypeEnum | null;
    status: RuleStatusEnum;
    createdAt: any;
    updatedAt: any;
  }> | null;
};

export type GetUpcomingRetentionActionsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetUpcomingRetentionActionsQuery = {
  __typename?: 'Query';
  getUpcomingRetentionActions: Array<{
    __typename?: 'CaseRetentionQueueType';
    id: string;
    caseId: string;
    dueAt: any;
    status: RetentionQueueStatusEnum;
    retentionApproved: boolean;
    RetentionRule?: {
      __typename?: 'RetentionRuleType';
      id: string;
      country?: string | null;
      countryRule?: CountryRuleEnum | null;
      conditions: any;
      dateReference: DateReferenceEnum;
      ruleType?: RuleTypeEnum | null;
      createdAt: any;
      updatedAt: any;
    } | null;
    Case?: {
      __typename?: 'CaseType';
      id: string;
      name?: string | null;
      readableId: string;
    } | null;
  }>;
};

export type GetUpcomingRetentionActionsCountQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetUpcomingRetentionActionsCountQuery = {
  __typename?: 'Query';
  getUpcomingRetentionActionsCount: number;
};

export type UpdateRetentionRuleMutationVariables = Exact<{
  input: UpdateRetentionRuleInput;
}>;

export type UpdateRetentionRuleMutation = {
  __typename?: 'Mutation';
  updateRetentionRule?: {
    __typename?: 'RetentionRuleType';
    id: string;
    organisationId: number;
    authorId: number;
    country?: string | null;
    countryRule?: CountryRuleEnum | null;
    conditions: any;
    dateReference: DateReferenceEnum;
    ruleType?: RuleTypeEnum | null;
    status: RuleStatusEnum;
    createdAt: any;
    updatedAt: any;
  } | null;
};

export type UserCountriesQueryVariables = Exact<{ [key: string]: never }>;

export type UserCountriesQuery = {
  __typename?: 'Query';
  organisation: {
    __typename?: 'OrganisationType';
    userCountries?: Array<string> | null;
  };
};

export type CreateRoutingRuleMutationVariables = Exact<{
  parameters: CreateRoutingRule;
}>;

export type CreateRoutingRuleMutation = {
  __typename?: 'Mutation';
  createRoutingRule: { __typename?: 'RoutingRuleType'; id: string };
};

export type DeleteRoutingRuleMutationVariables = Exact<{
  deleteRoutingRuleId: Scalars['String'];
}>;

export type DeleteRoutingRuleMutation = {
  __typename?: 'Mutation';
  deleteRoutingRule: number;
};

export type DisableRuleMutationMutationVariables = Exact<{
  disableRuleId: Scalars['String'];
}>;

export type DisableRuleMutationMutation = {
  __typename?: 'Mutation';
  disableRule: Array<number>;
};

export type RoutingRulesPaginatedQueryVariables = Exact<{
  pagination: PaginationInputType;
  orderBy: OrderByInputType;
  isCOI?: InputMaybe<Scalars['Boolean']>;
}>;

export type RoutingRulesPaginatedQuery = {
  __typename?: 'Query';
  routingRulesPaginated: {
    __typename?: 'PaginatedRoutingRuleTypeResponse';
    count: number;
    items: Array<{
      __typename?: 'RoutingRuleType';
      author: number;
      createdAt: any;
      destinationGroup?: string | null;
      disabled: boolean;
      id: string;
      name: string;
      organisation: number;
      priority: number;
      rule: any;
      updatedAt: any;
      groupAssignment: boolean;
      isCOI: boolean;
      Author?: {
        __typename?: 'UserType';
        name?: string | null;
        displayName?: string | null;
      } | null;
    }>;
  };
};

export type UpdateRoutingRuleMutationVariables = Exact<{
  parameters: UpdateRoutingRule;
}>;

export type UpdateRoutingRuleMutation = {
  __typename?: 'Mutation';
  updateRoutingRule: Array<number>;
};

export type UpdateRoutingRulePrioritiesMutationVariables = Exact<{
  rules: Array<UpdateRoutingRulePriorities> | UpdateRoutingRulePriorities;
}>;

export type UpdateRoutingRulePrioritiesMutation = {
  __typename?: 'Mutation';
  updateRoutingRulePriorities: Array<{
    __typename?: 'RoutingRulePriorities';
    id: string;
    priority: number;
  }>;
};

export type DeleteSessionMutationVariables = Exact<{ [key: string]: never }>;

export type DeleteSessionMutation = {
  __typename?: 'Mutation';
  deleteSession: {
    __typename?: 'DeleteSessionResponse';
    d1pLogoutUrl?: string | null;
  };
};

export type AddTagToCaseMutationVariables = Exact<{
  caseId: Scalars['String'];
  tagId: Scalars['String'];
}>;

export type AddTagToCaseMutation = {
  __typename?: 'Mutation';
  addTagToCase?: {
    __typename?: 'TagType';
    name: string;
    id: string;
    tagType?: {
      __typename?: 'TagTypeType';
      colorId: number;
      name: string;
    } | null;
  } | null;
};

export type CreateTagMutationVariables = Exact<{
  parameters: CreateTagType;
}>;

export type CreateTagMutation = {
  __typename?: 'Mutation';
  createTag?: { __typename?: 'TagType'; id: string; name: string } | null;
};

export type DeleteAllTagsMutationVariables = Exact<{
  tagType: Scalars['String'];
}>;

export type DeleteAllTagsMutation = {
  __typename?: 'Mutation';
  deleteAllTags: number;
};

export type DeleteTagMutationVariables = Exact<{
  tagId: Scalars['String'];
}>;

export type DeleteTagMutation = { __typename?: 'Mutation'; deleteTag: number };

export type GetOrganisationTagsQueryVariables = Exact<{ [key: string]: never }>;

export type GetOrganisationTagsQuery = {
  __typename?: 'Query';
  getOrganisationTags?: Array<{
    __typename?: 'TagType';
    id: string;
    name: string;
    tagType?: {
      __typename?: 'TagTypeType';
      id: string;
      status: string;
      colorId: number;
      name: string;
    } | null;
  }> | null;
};

export type RemoveTagFromCaseMutationVariables = Exact<{
  caseId: Scalars['String'];
  tagId: Scalars['String'];
}>;

export type RemoveTagFromCaseMutation = {
  __typename?: 'Mutation';
  removeTagFromCase?: {
    __typename?: 'TagType';
    name: string;
    id: string;
    tagType?: {
      __typename?: 'TagTypeType';
      colorId: number;
      name: string;
    } | null;
  } | null;
};

export type UpdateTagMutationVariables = Exact<{
  parameters: UpdateTagType;
}>;

export type UpdateTagMutation = {
  __typename?: 'Mutation';
  updateTag: Array<number>;
};

export type UpdateTagOrdersMutationVariables = Exact<{
  tags: Array<UpdateTagOrdersType> | UpdateTagOrdersType;
  draggedTagId: Scalars['String'];
}>;

export type UpdateTagOrdersMutation = {
  __typename?: 'Mutation';
  updateTagOrders: Array<{
    __typename?: 'TagOrderType';
    tagId: string;
    order: number;
  }>;
};

export type GetOrganisationTagTypesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetOrganisationTagTypesQuery = {
  __typename?: 'Query';
  getOrganisationTagTypes?: Array<{
    __typename?: 'TagTypeType';
    id: string;
    name: string;
    colorId: number;
    order?: number | null;
    status: string;
    statusUpdatedAt?: any | null;
    createdAt?: any | null;
    Author?: {
      __typename?: 'UserType';
      displayName?: string | null;
      name?: string | null;
    } | null;
    Tags?: Array<{
      __typename?: 'TagType';
      id: string;
      name: string;
      order: number;
      status: string;
    }> | null;
  }> | null;
};

export type UpdateTagTypeOrdersMutationVariables = Exact<{
  tagTypes: Array<UpdateTagTypeOrdersType> | UpdateTagTypeOrdersType;
  draggedTagTypeId: Scalars['String'];
}>;

export type UpdateTagTypeOrdersMutation = {
  __typename?: 'Mutation';
  updateTagTypeOrders: Array<{
    __typename?: 'TagTypeOrderType';
    id: string;
    order: number;
  }>;
};

export type UpdateTagTypeStatusMutationVariables = Exact<{
  parameters: UpdateTagTypeStatusType;
}>;

export type UpdateTagTypeStatusMutation = {
  __typename?: 'Mutation';
  updateTagTypeStatus: Array<number>;
};

export type AddUploadsToReportMutationVariables = Exact<{
  uploadSource: UploadSource;
  uploads: Array<UploadInput> | UploadInput;
  report: Scalars['String'];
}>;

export type AddUploadsToReportMutation = {
  __typename?: 'Mutation';
  addUploadsToReport?: Array<{
    __typename?: 'UploadType';
    fileExtension: string;
    s3path: string;
    scanStatus: string;
    size: number;
    createdAt: any;
  }> | null;
};

export type BulkReinviteMutationVariables = Exact<{
  usersToDeactivate: Array<BulkReinviteUpdateUser> | BulkReinviteUpdateUser;
  usersToReinvite: Array<BulkReinviteUpdateUser> | BulkReinviteUpdateUser;
  usersToCreate: Array<BulkReinviteCreateUser> | BulkReinviteCreateUser;
  usersToUpdate: Array<BulkReinviteUpdateUser> | BulkReinviteUpdateUser;
}>;

export type BulkReinviteMutation = {
  __typename?: 'Mutation';
  bulkReinvite?: {
    __typename?: 'BulkReinvite';
    createdUsers: Array<{
      __typename?: 'UserType';
      eid?: string | null;
      email?: string | null;
    }>;
    deactivatedUsers: Array<{
      __typename?: 'UserType';
      eid?: string | null;
      email?: string | null;
    }>;
    reinvitedUsers: Array<{
      __typename?: 'UserType';
      eid?: string | null;
      email?: string | null;
    }>;
    updatedUsers: Array<{
      __typename?: 'UserType';
      eid?: string | null;
      email?: string | null;
    }>;
  } | null;
};

export type PutUserMutationVariables = Exact<{
  userData: PutUserType;
  putUserId?: InputMaybe<Scalars['Int']>;
}>;

export type PutUserMutation = {
  __typename?: 'Mutation';
  putUser?: { __typename?: 'UserType'; id: number } | null;
};

export type UpdateContactEmailMutationVariables = Exact<{
  contactEmail: Scalars['String'];
  userId?: InputMaybe<Scalars['Int']>;
  reportId?: InputMaybe<Scalars['String']>;
}>;

export type UpdateContactEmailMutation = {
  __typename?: 'Mutation';
  updateContactEmail?: string | null;
};

export type UsersPaginatedQueryVariables = Exact<{
  orderBy: OrderByInputType;
  pagination: PaginationInputType;
}>;

export type UsersPaginatedQuery = {
  __typename?: 'Query';
  usersPaginated: {
    __typename?: 'PaginatedUserTypeResponse';
    count: number;
    items: Array<{
      __typename?: 'UserType';
      id: number;
      eid?: string | null;
      email?: string | null;
      name?: string | null;
      role?: string | null;
      site?: string | null;
      status: string;
      available?: boolean | null;
      translationEnabled?: boolean | null;
      permissions?: Array<string> | null;
      department?: string | null;
      tags?: Array<string> | null;
      expiresAt?: string | null;
      country?: string | null;
      displayName?: string | null;
      source?: string | null;
      externalId?: string | null;
      givenName?: string | null;
      familyName?: string | null;
      organisation?: number | null;
      Accounts?: Array<{
        __typename?: 'AccountType';
        id: number;
        kind: string;
        username: string;
        user: number;
      }> | null;
    }>;
  };
};

export type SearchUsersPaginatedQueryVariables = Exact<{
  orderBy: OrderByInputType;
  pagination: PaginationInputType;
  searchBy: Array<SearchByInputType> | SearchByInputType;
  fuzzy?: InputMaybe<FuzzySearchInputType>;
}>;

export type SearchUsersPaginatedQuery = {
  __typename?: 'Query';
  searchUsersPaginated: {
    __typename?: 'PaginatedUserTypeResponse';
    count: number;
    items: Array<{
      __typename?: 'UserType';
      id: number;
      eid?: string | null;
      email?: string | null;
      name?: string | null;
      role?: string | null;
      site?: string | null;
      available?: boolean | null;
      translationEnabled?: boolean | null;
      permissions?: Array<string> | null;
      department?: string | null;
      tags?: Array<string> | null;
      expiresAt?: string | null;
      country?: string | null;
      displayName?: string | null;
      source?: string | null;
      externalId?: string | null;
      givenName?: string | null;
      familyName?: string | null;
      organisation?: number | null;
      status: string;
      uuid?: string | null;
      Accounts?: Array<{
        __typename?: 'AccountType';
        id: number;
        kind: string;
        username: string;
        user: number;
        Roles?: Array<{
          __typename?: 'RoleType';
          name: string;
          SystemPermissions?: Array<{
            __typename?: 'PermissionType';
            permission: string;
          }> | null;
        }> | null;
      }> | null;
      SystemRoles?: Array<{
        __typename?: 'OrganisationRoleType';
        id: string;
        name: string;
        label?: string | null;
      }> | null;
    }>;
  };
};

export type MeQueryVariables = Exact<{ [key: string]: never }>;

export type MeQuery = {
  __typename?: 'Query';
  me: {
    __typename?: 'UserType';
    id: number;
    eid?: string | null;
    email?: string | null;
    name?: string | null;
    role?: string | null;
    site?: string | null;
    available?: boolean | null;
    translationEnabled?: boolean | null;
    permissions?: Array<string> | null;
    department?: string | null;
    tags?: Array<string> | null;
    contactEmail?: string | null;
    expiresAt?: string | null;
    country?: string | null;
    displayName?: string | null;
    source?: string | null;
    externalId?: string | null;
    status: string;
    organisation?: number | null;
    uuid?: string | null;
    Organisation?: {
      __typename?: 'OrganisationType';
      id: number;
      expiryPeriod?: number | null;
      name: string;
    } | null;
    accounts?: Array<{
      __typename?: 'AccountType';
      id: number;
      kind: string;
      Roles?: Array<{
        __typename?: 'RoleType';
        name: string;
        SystemPermissions?: Array<{
          __typename?: 'PermissionType';
          permission: string;
        }> | null;
      }> | null;
    }> | null;
  };
};

export type UpdateReporterUserSettingsMutationVariables = Exact<{
  patchData: ReporterUserSettingsType;
}>;

export type UpdateReporterUserSettingsMutation = {
  __typename?: 'Mutation';
  updateReporterUserSettings?: { __typename?: 'UserType'; id: number } | null;
};

export type GetOrganisationMetaDataQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetOrganisationMetaDataQuery = {
  __typename?: 'Query';
  getOrganisationMetaData?: {
    __typename?: 'OrganisationMetaDataType';
    userType: Array<string>;
    organization: Array<string>;
    division: Array<string>;
  } | null;
};

export type ValidateUsersCsvUploadMutationVariables = Exact<{
  sheetId: Scalars['Int'];
  embedId: Scalars['Int'];
  newUsers: Array<BulkReinviteCreateUser> | BulkReinviteCreateUser;
}>;

export type ValidateUsersCsvUploadMutation = {
  __typename?: 'Mutation';
  validateUsersCsvUpload: {
    __typename?: 'ValidatedUsers';
    totalUsersInCSV: number;
    usersToCreate: Array<{
      __typename?: 'BulkReinviteNewUser';
      country: string;
      department: string;
      eid: string;
      email: string;
      name: string;
      role: string;
      site: string;
      terminationDate?: string | null;
    }>;
    usersToDeactivate: Array<{
      __typename?: 'BulkReinviteExistingUser';
      country?: string | null;
      department?: string | null;
      eid?: string | null;
      email?: string | null;
      name?: string | null;
      id: number;
      role?: string | null;
      site?: string | null;
      terminationDate?: string | null;
    }>;
    usersToReinvite: Array<{
      __typename?: 'BulkReinviteExistingUser';
      country?: string | null;
      department?: string | null;
      eid?: string | null;
      email?: string | null;
      id: number;
      name?: string | null;
      role?: string | null;
      site?: string | null;
      terminationDate?: string | null;
    }>;
    usersToUpdate: Array<{
      __typename?: 'BulkReinviteExistingUser';
      country?: string | null;
      eid?: string | null;
      department?: string | null;
      email?: string | null;
      id: number;
      name?: string | null;
      role?: string | null;
      site?: string | null;
      terminationDate?: string | null;
    }>;
  };
};

export type ValidateCasesCsvUploadMutationVariables = Exact<{
  sheetId: Scalars['Int'];
  embedId: Scalars['Int'];
  newCases?: InputMaybe<Array<BulkImportCases> | BulkImportCases>;
  newCasesDynamic?: InputMaybe<
    Array<BulkImportCasesDynamic> | BulkImportCasesDynamic
  >;
  importFileName: Scalars['String'];
  columnMapping: Array<ColumnMappingInput> | ColumnMappingInput;
  dynamicCategory?: InputMaybe<Scalars['String']>;
  dynamicFormId?: InputMaybe<Scalars['String']>;
}>;

export type ValidateCasesCsvUploadMutation = {
  __typename?: 'Mutation';
  validateCasesCsvUpload: {
    __typename?: 'ValidatedCases';
    totalCasesInCSV: number;
    importFileName: string;
    casesToCreate: Array<{
      __typename?: 'BulkCreateNewCases';
      caseName?: string | null;
      caseImportedId?: string | null;
      caseCreatedDate: any;
      caseReadDate: any;
      caseSubmissionDate: any;
      caseInvestigatingDate: any;
      caseClosedDate?: any | null;
      caseLeadName?: string | null;
      caseLeadUserId?: number | null;
      caseCategories: Array<string>;
      caseStatus: string;
      substantiationStatus: string;
      originalIntakeMethod?: string | null;
      isAnonymous: string;
      reporterName?: string | null;
      reporterEmail?: string | null;
      reporterEid?: string | null;
      reporterUserId?: number | null;
      namedOffenderExternalUsers: Array<string>;
      namedOffenderInternalUsers: any;
      eventDate?: string | null;
      eventTime?: string | null;
      eventLocation?: string | null;
      eventDescription: Array<string>;
      eventWitnesses?: string | null;
      eventEmotions?: string | null;
      countryName?: string | null;
      countryCode?: string | null;
      regionName?: string | null;
      regionId?: string | null;
      caseSummary?: string | null;
      dynamicFields?: any | null;
    }>;
    duplicateCases: Array<{
      __typename?: 'DuplicateCaseType';
      id: string;
      name: string;
      importedId?: string | null;
      status?: ReportStatus | null;
      CaseAttribute: {
        __typename?: 'CaseAttributesType';
        createdAt: any;
        readAt?: any | null;
        investigatingAt?: any | null;
        closedAt?: any | null;
      };
    }>;
  };
};

export const CaseTeamMemberFragmentFragmentDoc = `
    fragment CaseTeamMemberFragment on CaseTeamMemberType {
  id
  name
  site
  permissions
  Note {
    value
    inviterUser {
      name
    }
    createdAt
  }
  firstAccessedAt
  invitedAt
  Roles
}
    `;
export const RegisterUserDocument = `
    mutation RegisterUser($token: String!, $password: String!) {
  registerUser(token: $token, password: $password) {
    id
    kind
    username
  }
}
    `;
export const useRegisterUserMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    RegisterUserMutation,
    TError,
    RegisterUserMutationVariables,
    TContext
  >,
) =>
  useMutation<
    RegisterUserMutation,
    TError,
    RegisterUserMutationVariables,
    TContext
  >(
    ['RegisterUser'],
    (variables?: RegisterUserMutationVariables) =>
      fetcher<RegisterUserMutation, RegisterUserMutationVariables>(
        RegisterUserDocument,
        variables,
      )(),
    options,
  );
export const MyAccountDocument = `
    query MyAccount {
  myAccount {
    id
    kind
    notificationsEnabled
    translationEnabled
  }
}
    `;
export const useMyAccountQuery = <TData = MyAccountQuery, TError = unknown>(
  variables?: MyAccountQueryVariables,
  options?: UseQueryOptions<MyAccountQuery, TError, TData>,
) =>
  useQuery<MyAccountQuery, TError, TData>(
    variables === undefined ? ['MyAccount'] : ['MyAccount', variables],
    fetcher<MyAccountQuery, MyAccountQueryVariables>(
      MyAccountDocument,
      variables,
    ),
    options,
  );
export const CreateAuditEntryDocument = `
    mutation CreateAuditEntry($auditAction: String!, $auditData: JSON!, $completed: Boolean!) {
  createAuditEntry(
    auditAction: $auditAction
    auditData: $auditData
    completed: $completed
  ) {
    id
    completed
  }
}
    `;
export const useCreateAuditEntryMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    CreateAuditEntryMutation,
    TError,
    CreateAuditEntryMutationVariables,
    TContext
  >,
) =>
  useMutation<
    CreateAuditEntryMutation,
    TError,
    CreateAuditEntryMutationVariables,
    TContext
  >(
    ['CreateAuditEntry'],
    (variables?: CreateAuditEntryMutationVariables) =>
      fetcher<CreateAuditEntryMutation, CreateAuditEntryMutationVariables>(
        CreateAuditEntryDocument,
        variables,
      )(),
    options,
  );
export const CompleteAuditEntryDocument = `
    mutation CompleteAuditEntry($id: Float!) {
  completeAuditEntry(id: $id) {
    id
    completed
  }
}
    `;
export const useCompleteAuditEntryMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    CompleteAuditEntryMutation,
    TError,
    CompleteAuditEntryMutationVariables,
    TContext
  >,
) =>
  useMutation<
    CompleteAuditEntryMutation,
    TError,
    CompleteAuditEntryMutationVariables,
    TContext
  >(
    ['CompleteAuditEntry'],
    (variables?: CompleteAuditEntryMutationVariables) =>
      fetcher<CompleteAuditEntryMutation, CompleteAuditEntryMutationVariables>(
        CompleteAuditEntryDocument,
        variables,
      )(),
    options,
  );
export const GetRoutingAuditEntriesDocument = `
    query GetRoutingAuditEntries {
  routingAuditEntries {
    id
    DescriptiveText
    User {
      id
      name
    }
    action
    completed
    createdAt
    data
    id
    organisation
    updatedAt
    user
  }
}
    `;
export const useGetRoutingAuditEntriesQuery = <
  TData = GetRoutingAuditEntriesQuery,
  TError = unknown,
>(
  variables?: GetRoutingAuditEntriesQueryVariables,
  options?: UseQueryOptions<GetRoutingAuditEntriesQuery, TError, TData>,
) =>
  useQuery<GetRoutingAuditEntriesQuery, TError, TData>(
    variables === undefined
      ? ['GetRoutingAuditEntries']
      : ['GetRoutingAuditEntries', variables],
    fetcher<GetRoutingAuditEntriesQuery, GetRoutingAuditEntriesQueryVariables>(
      GetRoutingAuditEntriesDocument,
      variables,
    ),
    options,
  );
export const GetCategoriesAuditEntriesDocument = `
    query GetCategoriesAuditEntries($isCOI: Boolean) {
  categoriesAuditEntries(isCOI: $isCOI) {
    id
    User {
      id
      name
      displayName
    }
    action
    completed
    createdAt
    data
    id
    organisation
  }
}
    `;
export const useGetCategoriesAuditEntriesQuery = <
  TData = GetCategoriesAuditEntriesQuery,
  TError = unknown,
>(
  variables?: GetCategoriesAuditEntriesQueryVariables,
  options?: UseQueryOptions<GetCategoriesAuditEntriesQuery, TError, TData>,
) =>
  useQuery<GetCategoriesAuditEntriesQuery, TError, TData>(
    variables === undefined
      ? ['GetCategoriesAuditEntries']
      : ['GetCategoriesAuditEntries', variables],
    fetcher<
      GetCategoriesAuditEntriesQuery,
      GetCategoriesAuditEntriesQueryVariables
    >(GetCategoriesAuditEntriesDocument, variables),
    options,
  );
export const GetTagsAuditEntriesDocument = `
    query GetTagsAuditEntries {
  tagsAuditEntries {
    id
    User {
      id
      name
      displayName
    }
    action
    completed
    createdAt
    data
    id
    organisation
  }
}
    `;
export const useGetTagsAuditEntriesQuery = <
  TData = GetTagsAuditEntriesQuery,
  TError = unknown,
>(
  variables?: GetTagsAuditEntriesQueryVariables,
  options?: UseQueryOptions<GetTagsAuditEntriesQuery, TError, TData>,
) =>
  useQuery<GetTagsAuditEntriesQuery, TError, TData>(
    variables === undefined
      ? ['GetTagsAuditEntries']
      : ['GetTagsAuditEntries', variables],
    fetcher<GetTagsAuditEntriesQuery, GetTagsAuditEntriesQueryVariables>(
      GetTagsAuditEntriesDocument,
      variables,
    ),
    options,
  );
export const GetCaseDataDownloadAuditEntriesDocument = `
    query GetCaseDataDownloadAuditEntries {
  caseDataDownloadAuditEntries {
    id
    User {
      id
      name
      displayName
    }
    action
    completed
    createdAt
    data
    id
    organisation
  }
}
    `;
export const useGetCaseDataDownloadAuditEntriesQuery = <
  TData = GetCaseDataDownloadAuditEntriesQuery,
  TError = unknown,
>(
  variables?: GetCaseDataDownloadAuditEntriesQueryVariables,
  options?: UseQueryOptions<
    GetCaseDataDownloadAuditEntriesQuery,
    TError,
    TData
  >,
) =>
  useQuery<GetCaseDataDownloadAuditEntriesQuery, TError, TData>(
    variables === undefined
      ? ['GetCaseDataDownloadAuditEntries']
      : ['GetCaseDataDownloadAuditEntries', variables],
    fetcher<
      GetCaseDataDownloadAuditEntriesQuery,
      GetCaseDataDownloadAuditEntriesQueryVariables
    >(GetCaseDataDownloadAuditEntriesDocument, variables),
    options,
  );
export const GetUserRolesAuditEntriesDocument = `
    query GetUserRolesAuditEntries {
  userRolesAuditEntries {
    id
    User {
      id
      name
      displayName
    }
    action
    completed
    createdAt
    data
    organisation
  }
}
    `;
export const useGetUserRolesAuditEntriesQuery = <
  TData = GetUserRolesAuditEntriesQuery,
  TError = unknown,
>(
  variables?: GetUserRolesAuditEntriesQueryVariables,
  options?: UseQueryOptions<GetUserRolesAuditEntriesQuery, TError, TData>,
) =>
  useQuery<GetUserRolesAuditEntriesQuery, TError, TData>(
    variables === undefined
      ? ['GetUserRolesAuditEntries']
      : ['GetUserRolesAuditEntries', variables],
    fetcher<
      GetUserRolesAuditEntriesQuery,
      GetUserRolesAuditEntriesQueryVariables
    >(GetUserRolesAuditEntriesDocument, variables),
    options,
  );
export const GetAuditEntriesByDraftReportDocument = `
    query GetAuditEntriesByDraftReport($report: String!) {
  auditEntriesByDraftReport(report: $report) {
    id
    User {
      id
      name
      displayName
    }
    action
    completed
    createdAt
    updatedAt
    data
    organisation
  }
}
    `;
export const useGetAuditEntriesByDraftReportQuery = <
  TData = GetAuditEntriesByDraftReportQuery,
  TError = unknown,
>(
  variables: GetAuditEntriesByDraftReportQueryVariables,
  options?: UseQueryOptions<GetAuditEntriesByDraftReportQuery, TError, TData>,
) =>
  useQuery<GetAuditEntriesByDraftReportQuery, TError, TData>(
    ['GetAuditEntriesByDraftReport', variables],
    fetcher<
      GetAuditEntriesByDraftReportQuery,
      GetAuditEntriesByDraftReportQueryVariables
    >(GetAuditEntriesByDraftReportDocument, variables),
    options,
  );
export const UnlinkCasesDocument = `
    mutation UnlinkCases($linkId: String!) {
  unlinkCases(linkId: $linkId)
}
    `;
export const useUnlinkCasesMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    UnlinkCasesMutation,
    TError,
    UnlinkCasesMutationVariables,
    TContext
  >,
) =>
  useMutation<
    UnlinkCasesMutation,
    TError,
    UnlinkCasesMutationVariables,
    TContext
  >(
    ['UnlinkCases'],
    (variables?: UnlinkCasesMutationVariables) =>
      fetcher<UnlinkCasesMutation, UnlinkCasesMutationVariables>(
        UnlinkCasesDocument,
        variables,
      )(),
    options,
  );
export const CaseByIdDocument = `
    query CaseById($id: String!, $translation: String) {
  caseById(id: $id) {
    id
    status
    name
    sanitizedAt
    createdAt
    updatedAt
    descriptionUpdatedAt
    organisation
    readableId
    importedId
    description
    AssociatedPermissions {
      canEditCaseDetails
      canViewCaseDetails
      canViewCaseDetailsPii
      canViewCaseWorkspaceTab
      canEditCaseWorkspaceTab
      canViewCaseAuditLogsTab
      canViewCase
      canEditCaseClosedDate
      canEditCaseCriDates
      canAdministerCasePermissions
    }
    AllCaseLeads {
      id
      name
      role
      site
      country
      permissions
    }
    AllCaseTeamMembers {
      id
      name
      role
      site
      country
      permissions
      accounts {
        Roles {
          SystemPermissions {
            permission
          }
        }
      }
    }
    CaseLead {
      id
      email
      name
      available
      country
      displayName
      permissions
      site
      accounts {
        Roles {
          SystemPermissions {
            permission
          }
        }
      }
    }
    Reports {
      anonymous
      category
      createdAt
      dominantLanguage
      source
      submittedAt
      status
      updatedAt
      substantiation
      submissionMode
      unreadMessagesCount
      AssociatedPermissions {
        canEditReportDetails
        canSendReportMessages
        canViewReportDetails
        canViewReportMessages
        canViewReportDetailsPii
        canAddNamedOffender
        canAdministerReportPermissions
      }
      DeterminedCategory {
        id
        name
      }
      reporter
      substantiation
      ReportedCategory {
        id
        name
      }
      ReportNotes {
        notes
      }
      id
      readableId
      Assignee {
        id
        name
        expiresAt
        permissions
        site
      }
      Perpetrators {
        id
        site
        country
        department
        name
      }
      Evidence(translation: $translation) {
        user
        status
        relationshipToCompany
        Events {
          id
          timestamp
          created
          updated
          report
          evidence {
            date {
              value
              createdAt
              updatedAt
              id
            }
            time {
              value
              createdAt
              updatedAt
              id
            }
            location {
              value
              createdAt
              updatedAt
              id
            }
            witness {
              value
              createdAt
              updatedAt
              id
            }
            description {
              value
              createdAt
              updatedAt
              id
            }
            emotion {
              value
              createdAt
              updatedAt
              id
            }
            photo {
              value
              createdAt
              updatedAt
              id
              scanStatus
              fileSize
              dataDeletedAt
            }
            perpetrator {
              value
              createdAt
              updatedAt
              id
            }
          }
        }
      }
      Reporter {
        id
        email
        name
        role
        eid
        contactEmail
        relationshipToOrganisation
        department
        country
        site
      }
      reporterExists
      AudioRecordings {
        url
        step
        dataDeletedAt
      }
      PhoneLineType
      ReportEvents {
        id
        NamedOffenders {
          ... on InternalNamedOffender {
            User {
              id
              name
              department
              site
              country
            }
            id
            reportId
            linkedPresubmissionOffender
            event
            dataDeletedAt
            postSubmission
          }
          ... on ExternalNamedOffender {
            id
            name
            reportId
            event
            createdAt
            dataDeletedAt
            postSubmission
            originalId
          }
        }
      }
      postSubmissionFiles {
        id
        mimeType
        size
        fileExtension
        s3path
        scanStatus
        uploadSource
        createdAt
        updatedAt
        dataDeletedAt
        dataDeletedBy
      }
      miReportSource
    }
    Categories {
      id
      name
    }
    CaseDocuments {
      title
      value
      lastEdited
      id
      s3path
      Author {
        id
        name
      }
      Uploads {
        filename
        mimeType
        s3path
        scanStatus
        scannedAt
        uploadSource
      }
    }
    CaseAttributes {
      companyCreatedAt
      readAt
      investigatingAt
      closedAt
    }
    CaseCountryRegion {
      country {
        code
        name
      }
      region {
        id
        name
        isActive
        countries {
          code
          name
        }
      }
    }
    CaseTeam {
      ...CaseTeamMemberFragment
    }
    CaseTags {
      id
      name
      tagType {
        id
        name
        colorId
      }
    }
    DisclosuresCaseData {
      responseId
      importType
    }
  }
}
    ${CaseTeamMemberFragmentFragmentDoc}`;
export const useCaseByIdQuery = <TData = CaseByIdQuery, TError = unknown>(
  variables: CaseByIdQueryVariables,
  options?: UseQueryOptions<CaseByIdQuery, TError, TData>,
) =>
  useQuery<CaseByIdQuery, TError, TData>(
    ['CaseById', variables],
    fetcher<CaseByIdQuery, CaseByIdQueryVariables>(CaseByIdDocument, variables),
    options,
  );
export const AssignableCaseLeadsByCaseIdDocument = `
    query AssignableCaseLeadsByCaseId($caseByIdId: String!) {
  caseById(id: $caseByIdId) {
    AllCaseLeads {
      id
      name
      site
      country
    }
    id
  }
}
    `;
export const useAssignableCaseLeadsByCaseIdQuery = <
  TData = AssignableCaseLeadsByCaseIdQuery,
  TError = unknown,
>(
  variables: AssignableCaseLeadsByCaseIdQueryVariables,
  options?: UseQueryOptions<AssignableCaseLeadsByCaseIdQuery, TError, TData>,
) =>
  useQuery<AssignableCaseLeadsByCaseIdQuery, TError, TData>(
    ['AssignableCaseLeadsByCaseId', variables],
    fetcher<
      AssignableCaseLeadsByCaseIdQuery,
      AssignableCaseLeadsByCaseIdQueryVariables
    >(AssignableCaseLeadsByCaseIdDocument, variables),
    options,
  );
export const CasesDocument = `
    query Cases($pagination: PaginationInputType!, $orderBy: OrderByInputType!, $searchBy: [SearchByInputType!], $fuzzy: FuzzySearchInputType, $appliedFilters: AppliedFiltersType) {
  casesPaginated(
    pagination: $pagination
    orderBy: $orderBy
    searchBy: $searchBy
    fuzzy: $fuzzy
    appliedFilters: $appliedFilters
  ) {
    items {
      name
      id
      createdAt
      updatedAt
      status
      readableId
      hasDynamicQuestions
      CaseLead {
        id
        name
      }
      Reports {
        Assignee {
          name
        }
        Reporter {
          id
        }
        id
        source
        DeterminedCategory {
          id
          name
        }
        ReportedCategory {
          id
          name
        }
        existingReport
        AssociatedPermissions {
          canEditReportDetails
          canSendReportMessages
          canViewReportDetails
          canViewReportMessages
          canViewReportDetailsPii
          canAddNamedOffender
          canAdministerReportPermissions
        }
      }
      Categories {
        id
        name
      }
      CaseAttributes {
        companyCreatedAt
      }
      AssociatedPermissions {
        canEditCaseDetails
        canViewCaseDetails
        canViewCaseDetailsPii
        canViewCaseWorkspaceTab
        canEditCaseWorkspaceTab
        canViewCaseAuditLogsTab
        canViewCase
        canAdministerCasePermissions
      }
      AllCaseLeads {
        id
        name
        role
        site
        country
        permissions
      }
      CaseTags {
        id
        name
        tagType {
          id
          name
          colorId
          order
          status
          Tags {
            id
            name
          }
        }
      }
      CaseTeam {
        id
        name
      }
      caseLinksCount
    }
    count
  }
}
    `;
export const useCasesQuery = <TData = CasesQuery, TError = unknown>(
  variables: CasesQueryVariables,
  options?: UseQueryOptions<CasesQuery, TError, TData>,
) =>
  useQuery<CasesQuery, TError, TData>(
    ['Cases', variables],
    fetcher<CasesQuery, CasesQueryVariables>(CasesDocument, variables),
    options,
  );
export const CaseMetricsDocument = `
    query CaseMetrics {
  caseMetrics {
    caseLeadCount
    teamMemberCount
    waitingForResponseCount
  }
}
    `;
export const useCaseMetricsQuery = <TData = CaseMetricsQuery, TError = unknown>(
  variables?: CaseMetricsQueryVariables,
  options?: UseQueryOptions<CaseMetricsQuery, TError, TData>,
) =>
  useQuery<CaseMetricsQuery, TError, TData>(
    variables === undefined ? ['CaseMetrics'] : ['CaseMetrics', variables],
    fetcher<CaseMetricsQuery, CaseMetricsQueryVariables>(
      CaseMetricsDocument,
      variables,
    ),
    options,
  );
export const CasesForLinkingDocument = `
    query CasesForLinking($search: String, $caseId: String!) {
  casesAbleToBeLinkedToCase(search: $search, caseId: $caseId) {
    count
    items {
      id
      name
      updatedAt
      readableId
      status
    }
  }
}
    `;
export const useCasesForLinkingQuery = <
  TData = CasesForLinkingQuery,
  TError = unknown,
>(
  variables: CasesForLinkingQueryVariables,
  options?: UseQueryOptions<CasesForLinkingQuery, TError, TData>,
) =>
  useQuery<CasesForLinkingQuery, TError, TData>(
    ['CasesForLinking', variables],
    fetcher<CasesForLinkingQuery, CasesForLinkingQueryVariables>(
      CasesForLinkingDocument,
      variables,
    ),
    options,
  );
export const SearchCasesForLinkingDocument = `
    query SearchCasesForLinking($search: String!, $caseId: String!, $limit: Int, $offset: Int) {
  searchCasesForLinking(
    search: $search
    caseId: $caseId
    limit: $limit
    offset: $offset
  ) {
    count
    items {
      id
      name
      updatedAt
      readableId
      status
    }
  }
}
    `;
export const useSearchCasesForLinkingQuery = <
  TData = SearchCasesForLinkingQuery,
  TError = unknown,
>(
  variables: SearchCasesForLinkingQueryVariables,
  options?: UseQueryOptions<SearchCasesForLinkingQuery, TError, TData>,
) =>
  useQuery<SearchCasesForLinkingQuery, TError, TData>(
    ['SearchCasesForLinking', variables],
    fetcher<SearchCasesForLinkingQuery, SearchCasesForLinkingQueryVariables>(
      SearchCasesForLinkingDocument,
      variables,
    ),
    options,
  );
export const AddCaseCategoryDocument = `
    mutation AddCaseCategory($categoryId: Int!, $caseId: String!) {
  addCaseCategory(categoryId: $categoryId, caseId: $caseId) {
    id
    name
  }
}
    `;
export const useAddCaseCategoryMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    AddCaseCategoryMutation,
    TError,
    AddCaseCategoryMutationVariables,
    TContext
  >,
) =>
  useMutation<
    AddCaseCategoryMutation,
    TError,
    AddCaseCategoryMutationVariables,
    TContext
  >(
    ['AddCaseCategory'],
    (variables?: AddCaseCategoryMutationVariables) =>
      fetcher<AddCaseCategoryMutation, AddCaseCategoryMutationVariables>(
        AddCaseCategoryDocument,
        variables,
      )(),
    options,
  );
export const RemoveCaseCategoryDocument = `
    mutation RemoveCaseCategory($categoryId: Int!, $caseId: String!) {
  removeCaseCategory(categoryId: $categoryId, caseId: $caseId) {
    id
    name
  }
}
    `;
export const useRemoveCaseCategoryMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    RemoveCaseCategoryMutation,
    TError,
    RemoveCaseCategoryMutationVariables,
    TContext
  >,
) =>
  useMutation<
    RemoveCaseCategoryMutation,
    TError,
    RemoveCaseCategoryMutationVariables,
    TContext
  >(
    ['RemoveCaseCategory'],
    (variables?: RemoveCaseCategoryMutationVariables) =>
      fetcher<RemoveCaseCategoryMutation, RemoveCaseCategoryMutationVariables>(
        RemoveCaseCategoryDocument,
        variables,
      )(),
    options,
  );
export const ReassignCaseLeadDocument = `
    mutation ReassignCaseLead($newCaseLeadId: Float!, $caseId: String!, $location: String) {
  reassignCaseLead(
    newCaseLeadId: $newCaseLeadId
    caseId: $caseId
    location: $location
  ) {
    CaseLead {
      id
      name
      available
      translationEnabled
      department
      permissions
      status
      tags
      uuid
      name
    }
  }
}
    `;
export const useReassignCaseLeadMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    ReassignCaseLeadMutation,
    TError,
    ReassignCaseLeadMutationVariables,
    TContext
  >,
) =>
  useMutation<
    ReassignCaseLeadMutation,
    TError,
    ReassignCaseLeadMutationVariables,
    TContext
  >(
    ['ReassignCaseLead'],
    (variables?: ReassignCaseLeadMutationVariables) =>
      fetcher<ReassignCaseLeadMutation, ReassignCaseLeadMutationVariables>(
        ReassignCaseLeadDocument,
        variables,
      )(),
    options,
  );
export const UpdateCaseTitleDocument = `
    mutation UpdateCaseTitle($newCaseTitle: String!, $caseId: String!) {
  updateCaseTitle(newCaseTitle: $newCaseTitle, caseId: $caseId) {
    id
    name
  }
}
    `;
export const useUpdateCaseTitleMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateCaseTitleMutation,
    TError,
    UpdateCaseTitleMutationVariables,
    TContext
  >,
) =>
  useMutation<
    UpdateCaseTitleMutation,
    TError,
    UpdateCaseTitleMutationVariables,
    TContext
  >(
    ['UpdateCaseTitle'],
    (variables?: UpdateCaseTitleMutationVariables) =>
      fetcher<UpdateCaseTitleMutation, UpdateCaseTitleMutationVariables>(
        UpdateCaseTitleDocument,
        variables,
      )(),
    options,
  );
export const UpdateCaseStatusDocument = `
    mutation UpdateCaseStatus($newCaseStatus: ReportStatus!, $caseId: String!) {
  updateCaseStatus(newCaseStatus: $newCaseStatus, caseId: $caseId) {
    id
    status
  }
}
    `;
export const useUpdateCaseStatusMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateCaseStatusMutation,
    TError,
    UpdateCaseStatusMutationVariables,
    TContext
  >,
) =>
  useMutation<
    UpdateCaseStatusMutation,
    TError,
    UpdateCaseStatusMutationVariables,
    TContext
  >(
    ['UpdateCaseStatus'],
    (variables?: UpdateCaseStatusMutationVariables) =>
      fetcher<UpdateCaseStatusMutation, UpdateCaseStatusMutationVariables>(
        UpdateCaseStatusDocument,
        variables,
      )(),
    options,
  );
export const UpdateCoiCaseStatusDocument = `
    mutation UpdateCoiCaseStatus($caseId: String!, $newCoiCaseStatus: CoiCaseStatus!) {
  updateCoiCaseStatus(caseId: $caseId, newCoiCaseStatus: $newCoiCaseStatus) {
    id
    status
  }
}
    `;
export const useUpdateCoiCaseStatusMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateCoiCaseStatusMutation,
    TError,
    UpdateCoiCaseStatusMutationVariables,
    TContext
  >,
) =>
  useMutation<
    UpdateCoiCaseStatusMutation,
    TError,
    UpdateCoiCaseStatusMutationVariables,
    TContext
  >(
    ['UpdateCoiCaseStatus'],
    (variables?: UpdateCoiCaseStatusMutationVariables) =>
      fetcher<
        UpdateCoiCaseStatusMutation,
        UpdateCoiCaseStatusMutationVariables
      >(UpdateCoiCaseStatusDocument, variables)(),
    options,
  );
export const MarkCaseAsReadDocument = `
    mutation MarkCaseAsRead($userId: Int!, $caseId: String!) {
  markCaseAsRead(userId: $userId, caseId: $caseId)
}
    `;
export const useMarkCaseAsReadMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    MarkCaseAsReadMutation,
    TError,
    MarkCaseAsReadMutationVariables,
    TContext
  >,
) =>
  useMutation<
    MarkCaseAsReadMutation,
    TError,
    MarkCaseAsReadMutationVariables,
    TContext
  >(
    ['MarkCaseAsRead'],
    (variables?: MarkCaseAsReadMutationVariables) =>
      fetcher<MarkCaseAsReadMutation, MarkCaseAsReadMutationVariables>(
        MarkCaseAsReadDocument,
        variables,
      )(),
    options,
  );
export const UpdateCaseDescriptionDocument = `
    mutation UpdateCaseDescription($description: String, $caseId: String!) {
  updateCaseDescription(description: $description, caseId: $caseId)
}
    `;
export const useUpdateCaseDescriptionMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateCaseDescriptionMutation,
    TError,
    UpdateCaseDescriptionMutationVariables,
    TContext
  >,
) =>
  useMutation<
    UpdateCaseDescriptionMutation,
    TError,
    UpdateCaseDescriptionMutationVariables,
    TContext
  >(
    ['UpdateCaseDescription'],
    (variables?: UpdateCaseDescriptionMutationVariables) =>
      fetcher<
        UpdateCaseDescriptionMutation,
        UpdateCaseDescriptionMutationVariables
      >(UpdateCaseDescriptionDocument, variables)(),
    options,
  );
export const BulkCaseCreationDocument = `
    mutation BulkCaseCreation($casesToCreate: [BulkCaseCreationItem!]!, $importFileName: String!, $uploadEvidences: [BulkCaseEvidenceItem!]!) {
  bulkCaseCreation(
    casesToCreate: $casesToCreate
    importFileName: $importFileName
    uploadEvidences: $uploadEvidences
  ) {
    jobId
    totalCases
  }
}
    `;
export const useBulkCaseCreationMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    BulkCaseCreationMutation,
    TError,
    BulkCaseCreationMutationVariables,
    TContext
  >,
) =>
  useMutation<
    BulkCaseCreationMutation,
    TError,
    BulkCaseCreationMutationVariables,
    TContext
  >(
    ['BulkCaseCreation'],
    (variables?: BulkCaseCreationMutationVariables) =>
      fetcher<BulkCaseCreationMutation, BulkCaseCreationMutationVariables>(
        BulkCaseCreationDocument,
        variables,
      )(),
    options,
  );
export const GetCaseImporterJobProgressDocument = `
    query GetCaseImporterJobProgress($jobId: String) {
  getCaseImporterJobProgress(jobId: $jobId) {
    id
    status
    totalCases
    processedCases
    successfulCases
    failedCases
    pendingCases
    percentComplete
    fileName
  }
}
    `;
export const useGetCaseImporterJobProgressQuery = <
  TData = GetCaseImporterJobProgressQuery,
  TError = unknown,
>(
  variables?: GetCaseImporterJobProgressQueryVariables,
  options?: UseQueryOptions<GetCaseImporterJobProgressQuery, TError, TData>,
) =>
  useQuery<GetCaseImporterJobProgressQuery, TError, TData>(
    variables === undefined
      ? ['GetCaseImporterJobProgress']
      : ['GetCaseImporterJobProgress', variables],
    fetcher<
      GetCaseImporterJobProgressQuery,
      GetCaseImporterJobProgressQueryVariables
    >(GetCaseImporterJobProgressDocument, variables),
    options,
  );
export const StopCaseImporterJobDocument = `
    mutation StopCaseImporterJob($jobId: String!) {
  stopCaseImporterJob(jobId: $jobId)
}
    `;
export const useStopCaseImporterJobMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    StopCaseImporterJobMutation,
    TError,
    StopCaseImporterJobMutationVariables,
    TContext
  >,
) =>
  useMutation<
    StopCaseImporterJobMutation,
    TError,
    StopCaseImporterJobMutationVariables,
    TContext
  >(
    ['StopCaseImporterJob'],
    (variables?: StopCaseImporterJobMutationVariables) =>
      fetcher<
        StopCaseImporterJobMutation,
        StopCaseImporterJobMutationVariables
      >(StopCaseImporterJobDocument, variables)(),
    options,
  );
export const GetCaseImporterJobHistoryDocument = `
    query GetCaseImporterJobHistory($limit: Int, $offset: Int) {
  getCaseImporterJobHistory(limit: $limit, offset: $offset) {
    jobs {
      id
      status
      totalCases
      successfulCases
      failedCases
      importFileName
      createdAt
      updatedAt
      createdByName
    }
    total
  }
}
    `;
export const useGetCaseImporterJobHistoryQuery = <
  TData = GetCaseImporterJobHistoryQuery,
  TError = unknown,
>(
  variables?: GetCaseImporterJobHistoryQueryVariables,
  options?: UseQueryOptions<GetCaseImporterJobHistoryQuery, TError, TData>,
) =>
  useQuery<GetCaseImporterJobHistoryQuery, TError, TData>(
    variables === undefined
      ? ['GetCaseImporterJobHistory']
      : ['GetCaseImporterJobHistory', variables],
    fetcher<
      GetCaseImporterJobHistoryQuery,
      GetCaseImporterJobHistoryQueryVariables
    >(GetCaseImporterJobHistoryDocument, variables),
    options,
  );
export const GetCaseImporterJobDetailsDocument = `
    query GetCaseImporterJobDetails($jobId: String!) {
  getCaseImporterJobDetails(jobId: $jobId) {
    importedCases {
      id
      readableId
      name
      importedId
    }
    failedCases {
      id
      readableId
      name
      importedId
      error
    }
  }
}
    `;
export const useGetCaseImporterJobDetailsQuery = <
  TData = GetCaseImporterJobDetailsQuery,
  TError = unknown,
>(
  variables: GetCaseImporterJobDetailsQueryVariables,
  options?: UseQueryOptions<GetCaseImporterJobDetailsQuery, TError, TData>,
) =>
  useQuery<GetCaseImporterJobDetailsQuery, TError, TData>(
    ['GetCaseImporterJobDetails', variables],
    fetcher<
      GetCaseImporterJobDetailsQuery,
      GetCaseImporterJobDetailsQueryVariables
    >(GetCaseImporterJobDetailsDocument, variables),
    options,
  );
export const GetCaseDocumentationDocument = `
    query GetCaseDocumentation($caseId: String!) {
  getCaseDocumentation(caseId: $caseId) {
    id
    value
    title
    Uploads {
      filename
      mimeType
      s3path
      size
      updatedAt
      createdAt
      scanStatus
      scannedAt
      uploadSource
    }
  }
}
    `;
export const useGetCaseDocumentationQuery = <
  TData = GetCaseDocumentationQuery,
  TError = unknown,
>(
  variables: GetCaseDocumentationQueryVariables,
  options?: UseQueryOptions<GetCaseDocumentationQuery, TError, TData>,
) =>
  useQuery<GetCaseDocumentationQuery, TError, TData>(
    ['GetCaseDocumentation', variables],
    fetcher<GetCaseDocumentationQuery, GetCaseDocumentationQueryVariables>(
      GetCaseDocumentationDocument,
      variables,
    ),
    options,
  );
export const GetCaseDocumentDocument = `
    query GetCaseDocument($caseDocumentId: String) {
  getCaseDocument(caseDocumentId: $caseDocumentId) {
    id
    title
    value
    type
    Uploads {
      filename
      mimeType
      s3path
      size
      updatedAt
      createdAt
      scanStatus
      scannedAt
      uploadSource
    }
  }
}
    `;
export const useGetCaseDocumentQuery = <
  TData = GetCaseDocumentQuery,
  TError = unknown,
>(
  variables?: GetCaseDocumentQueryVariables,
  options?: UseQueryOptions<GetCaseDocumentQuery, TError, TData>,
) =>
  useQuery<GetCaseDocumentQuery, TError, TData>(
    variables === undefined
      ? ['GetCaseDocument']
      : ['GetCaseDocument', variables],
    fetcher<GetCaseDocumentQuery, GetCaseDocumentQueryVariables>(
      GetCaseDocumentDocument,
      variables,
    ),
    options,
  );
export const UpdateCaseDocumentationDocument = `
    mutation UpdateCaseDocumentation($id: String, $caseId: String!, $title: String, $value: String, $uploads: [String!], $s3path: String, $mimeType: String) {
  createOrUpdateCaseDocument(
    id: $id
    caseId: $caseId
    title: $title
    value: $value
    uploads: $uploads
    s3path: $s3path
    mimeType: $mimeType
  ) {
    id
    title
    s3path
    mimeType
    value
    Uploads {
      filename
      mimeType
      s3path
      scanStatus
      scannedAt
      uploadSource
    }
  }
}
    `;
export const useUpdateCaseDocumentationMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateCaseDocumentationMutation,
    TError,
    UpdateCaseDocumentationMutationVariables,
    TContext
  >,
) =>
  useMutation<
    UpdateCaseDocumentationMutation,
    TError,
    UpdateCaseDocumentationMutationVariables,
    TContext
  >(
    ['UpdateCaseDocumentation'],
    (variables?: UpdateCaseDocumentationMutationVariables) =>
      fetcher<
        UpdateCaseDocumentationMutation,
        UpdateCaseDocumentationMutationVariables
      >(UpdateCaseDocumentationDocument, variables)(),
    options,
  );
export const RemoveCaseDocumentationDocument = `
    mutation RemoveCaseDocumentation($caseId: String!, $selectedDocumentIds: [String!]!) {
  removeCaseDocument(caseId: $caseId, selectedDocumentIds: $selectedDocumentIds) {
    id
    title
    value
  }
}
    `;
export const useRemoveCaseDocumentationMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    RemoveCaseDocumentationMutation,
    TError,
    RemoveCaseDocumentationMutationVariables,
    TContext
  >,
) =>
  useMutation<
    RemoveCaseDocumentationMutation,
    TError,
    RemoveCaseDocumentationMutationVariables,
    TContext
  >(
    ['RemoveCaseDocumentation'],
    (variables?: RemoveCaseDocumentationMutationVariables) =>
      fetcher<
        RemoveCaseDocumentationMutation,
        RemoveCaseDocumentationMutationVariables
      >(RemoveCaseDocumentationDocument, variables)(),
    options,
  );
export const CreateCaseDocumentationUploadUrlDocument = `
    mutation CreateCaseDocumentationUploadURL($type: String!, $filename: String!, $uploadSource: UploadSource, $caseId: String!, $size: Float) {
  createCaseDocumentUploadURL(
    type: $type
    filename: $filename
    uploadSource: $uploadSource
    caseId: $caseId
    size: $size
  ) {
    url
    s3path
  }
}
    `;
export const useCreateCaseDocumentationUploadUrlMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    CreateCaseDocumentationUploadUrlMutation,
    TError,
    CreateCaseDocumentationUploadUrlMutationVariables,
    TContext
  >,
) =>
  useMutation<
    CreateCaseDocumentationUploadUrlMutation,
    TError,
    CreateCaseDocumentationUploadUrlMutationVariables,
    TContext
  >(
    ['CreateCaseDocumentationUploadURL'],
    (variables?: CreateCaseDocumentationUploadUrlMutationVariables) =>
      fetcher<
        CreateCaseDocumentationUploadUrlMutation,
        CreateCaseDocumentationUploadUrlMutationVariables
      >(CreateCaseDocumentationUploadUrlDocument, variables)(),
    options,
  );
export const GetCaseDocumentUploadUrlDocument = `
    mutation GetCaseDocumentUploadURL($s3Path: String!) {
  getCaseDocumentUploadURL(s3path: $s3Path) {
    url
  }
}
    `;
export const useGetCaseDocumentUploadUrlMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    GetCaseDocumentUploadUrlMutation,
    TError,
    GetCaseDocumentUploadUrlMutationVariables,
    TContext
  >,
) =>
  useMutation<
    GetCaseDocumentUploadUrlMutation,
    TError,
    GetCaseDocumentUploadUrlMutationVariables,
    TContext
  >(
    ['GetCaseDocumentUploadURL'],
    (variables?: GetCaseDocumentUploadUrlMutationVariables) =>
      fetcher<
        GetCaseDocumentUploadUrlMutation,
        GetCaseDocumentUploadUrlMutationVariables
      >(GetCaseDocumentUploadUrlDocument, variables)(),
    options,
  );
export const GetReportDocumentUploadUrlDocument = `
    mutation GetReportDocumentUploadURL($reportId: String!, $objectId: String!) {
  getReportDocumentUploadURL(reportId: $reportId, objectId: $objectId) {
    url
  }
}
    `;
export const useGetReportDocumentUploadUrlMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    GetReportDocumentUploadUrlMutation,
    TError,
    GetReportDocumentUploadUrlMutationVariables,
    TContext
  >,
) =>
  useMutation<
    GetReportDocumentUploadUrlMutation,
    TError,
    GetReportDocumentUploadUrlMutationVariables,
    TContext
  >(
    ['GetReportDocumentUploadURL'],
    (variables?: GetReportDocumentUploadUrlMutationVariables) =>
      fetcher<
        GetReportDocumentUploadUrlMutation,
        GetReportDocumentUploadUrlMutationVariables
      >(GetReportDocumentUploadUrlDocument, variables)(),
    options,
  );
export const CreateCaseDocumentUploadDocument = `
    mutation CreateCaseDocumentUpload($mimeType: String!, $size: Float!, $s3path: String!, $filename: String!, $caseId: String, $uploadSource: UploadSource, $caseDocument: String) {
  createCaseDocumentUpload(
    mimeType: $mimeType
    size: $size
    s3path: $s3path
    filename: $filename
    caseId: $caseId
    uploadSource: $uploadSource
    caseDocument: $caseDocument
  ) {
    filename
    mimeType
    s3path
    size
    createdAt
    updatedAt
    scanStatus
    scannedAt
    uploadSource
  }
}
    `;
export const useCreateCaseDocumentUploadMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    CreateCaseDocumentUploadMutation,
    TError,
    CreateCaseDocumentUploadMutationVariables,
    TContext
  >,
) =>
  useMutation<
    CreateCaseDocumentUploadMutation,
    TError,
    CreateCaseDocumentUploadMutationVariables,
    TContext
  >(
    ['CreateCaseDocumentUpload'],
    (variables?: CreateCaseDocumentUploadMutationVariables) =>
      fetcher<
        CreateCaseDocumentUploadMutation,
        CreateCaseDocumentUploadMutationVariables
      >(CreateCaseDocumentUploadDocument, variables)(),
    options,
  );
export const GetCaseTeamNoteDocument = `
    query GetCaseTeamNote($userId: Int!, $caseId: String!) {
  getCaseTeamNote(userId: $userId, caseId: $caseId) {
    id
    caseId
    inviterUserId
    inviteeUserId
    value
    createdAt
  }
}
    `;
export const useGetCaseTeamNoteQuery = <
  TData = GetCaseTeamNoteQuery,
  TError = unknown,
>(
  variables: GetCaseTeamNoteQueryVariables,
  options?: UseQueryOptions<GetCaseTeamNoteQuery, TError, TData>,
) =>
  useQuery<GetCaseTeamNoteQuery, TError, TData>(
    ['GetCaseTeamNote', variables],
    fetcher<GetCaseTeamNoteQuery, GetCaseTeamNoteQueryVariables>(
      GetCaseTeamNoteDocument,
      variables,
    ),
    options,
  );
export const CasesCoiPaginatedDocument = `
    query CasesCoiPaginated($orderBy: OrderByInputType!, $pagination: KeysetPaginationInputType!, $fuzzy: FuzzySearchInputType, $appliedFilters: AppliedFiltersType, $searchBy: [SearchByInputType!], $requireEditPermission: Boolean) {
  casesCoiPaginated(
    orderBy: $orderBy
    pagination: $pagination
    fuzzy: $fuzzy
    appliedFilters: $appliedFilters
    searchBy: $searchBy
    requireEditPermission: $requireEditPermission
  ) {
    items {
      name
      id
      createdAt
      updatedAt
      status
      readableId
      CaseLead {
        id
        name
      }
      Reports {
        Assignee {
          name
        }
        Reporter {
          id
          name
        }
        id
        source
        DeterminedCategory {
          id
          name
        }
        ReportedCategory {
          id
          name
        }
        existingReport
      }
      Categories {
        id
        name
      }
      CaseAttributes {
        companyCreatedAt
      }
      CaseTeam {
        id
        name
      }
      DisclosuresCaseData {
        reporterD1pId
        responseId
        flags
      }
      AssociatedPermissions {
        canEditCaseDetails
        canViewCaseDetails
        canViewCaseDetailsPii
        canViewCaseWorkspaceTab
        canEditCaseWorkspaceTab
        canViewCaseAuditLogsTab
        canViewCase
        canEditCaseClosedDate
        canEditCaseCriDates
        canAdministerCasePermissions
      }
    }
    count
  }
}
    `;
export const useCasesCoiPaginatedQuery = <
  TData = CasesCoiPaginatedQuery,
  TError = unknown,
>(
  variables: CasesCoiPaginatedQueryVariables,
  options?: UseQueryOptions<CasesCoiPaginatedQuery, TError, TData>,
) =>
  useQuery<CasesCoiPaginatedQuery, TError, TData>(
    ['CasesCoiPaginated', variables],
    fetcher<CasesCoiPaginatedQuery, CasesCoiPaginatedQueryVariables>(
      CasesCoiPaginatedDocument,
      variables,
    ),
    options,
  );
export const DisclosureCaseByIdDocument = `
    query DisclosureCaseById($caseId: String!) {
  disclosureCaseById(caseId: $caseId) {
    id
    questionnaireId
    respondent {
      email
      name
      userId
    }
    status
    isFlagged
    submittedAt
    createdAt
    updatedAt
    questionnaire {
      publicTitle
      attestationText
    }
    answers {
      questionId
      questionText
      value
    }
  }
}
    `;
export const useDisclosureCaseByIdQuery = <
  TData = DisclosureCaseByIdQuery,
  TError = unknown,
>(
  variables: DisclosureCaseByIdQueryVariables,
  options?: UseQueryOptions<DisclosureCaseByIdQuery, TError, TData>,
) =>
  useQuery<DisclosureCaseByIdQuery, TError, TData>(
    ['DisclosureCaseById', variables],
    fetcher<DisclosureCaseByIdQuery, DisclosureCaseByIdQueryVariables>(
      DisclosureCaseByIdDocument,
      variables,
    ),
    options,
  );
export const DisclosureResponseByIdDocument = `
    query DisclosureResponseById($responseId: String!) {
  disclosureResponseById(responseId: $responseId) {
    id
    questionnaireId
    respondent {
      email
      name
      userId
    }
    status
    isFlagged
    submittedAt
    createdAt
    updatedAt
    questionnaire {
      publicTitle
      attestationText
    }
    answers {
      questionId
      questionText
      value
    }
    reporter {
      eid
      name
      email
      contactEmail
      role
      country
      department
      site
    }
  }
}
    `;
export const useDisclosureResponseByIdQuery = <
  TData = DisclosureResponseByIdQuery,
  TError = unknown,
>(
  variables: DisclosureResponseByIdQueryVariables,
  options?: UseQueryOptions<DisclosureResponseByIdQuery, TError, TData>,
) =>
  useQuery<DisclosureResponseByIdQuery, TError, TData>(
    ['DisclosureResponseById', variables],
    fetcher<DisclosureResponseByIdQuery, DisclosureResponseByIdQueryVariables>(
      DisclosureResponseByIdDocument,
      variables,
    ),
    options,
  );
export const DisclosureAuditByIdDocument = `
    query DisclosureAuditById($responseId: String!) {
  disclosureAuditById(responseId: $responseId) {
    entries {
      id
      eventType
      eventDetails
      user {
        userId
        name
        email
      }
      createdAt
    }
    pagination {
      page
      limit
      totalPages
      totalItems
    }
  }
}
    `;
export const useDisclosureAuditByIdQuery = <
  TData = DisclosureAuditByIdQuery,
  TError = unknown,
>(
  variables: DisclosureAuditByIdQueryVariables,
  options?: UseQueryOptions<DisclosureAuditByIdQuery, TError, TData>,
) =>
  useQuery<DisclosureAuditByIdQuery, TError, TData>(
    ['DisclosureAuditById', variables],
    fetcher<DisclosureAuditByIdQuery, DisclosureAuditByIdQueryVariables>(
      DisclosureAuditByIdDocument,
      variables,
    ),
    options,
  );
export const CoiFilterOptionsDocument = `
    query CoiFilterOptions {
  coiFilterOptions {
    statuses {
      label
      value
    }
    reviewers {
      label
      value
    }
    formTitles {
      label
      value
    }
    categories {
      label
      value
    }
  }
}
    `;
export const useCoiFilterOptionsQuery = <
  TData = CoiFilterOptionsQuery,
  TError = unknown,
>(
  variables?: CoiFilterOptionsQueryVariables,
  options?: UseQueryOptions<CoiFilterOptionsQuery, TError, TData>,
) =>
  useQuery<CoiFilterOptionsQuery, TError, TData>(
    variables === undefined
      ? ['CoiFilterOptions']
      : ['CoiFilterOptions', variables],
    fetcher<CoiFilterOptionsQuery, CoiFilterOptionsQueryVariables>(
      CoiFilterOptionsDocument,
      variables,
    ),
    options,
  );
export const FlagQuestionnaireResponseDocument = `
    mutation FlagQuestionnaireResponse($responseId: String!, $isFlagged: Boolean!, $flaggedReason: String, $flagCategory: FlagInfoCategory, $unflagReason: String) {
  flagQuestionnaireResponse(
    responseId: $responseId
    isFlagged: $isFlagged
    flaggedReason: $flaggedReason
    flagCategory: $flagCategory
    unflagReason: $unflagReason
  )
}
    `;
export const useFlagQuestionnaireResponseMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    FlagQuestionnaireResponseMutation,
    TError,
    FlagQuestionnaireResponseMutationVariables,
    TContext
  >,
) =>
  useMutation<
    FlagQuestionnaireResponseMutation,
    TError,
    FlagQuestionnaireResponseMutationVariables,
    TContext
  >(
    ['FlagQuestionnaireResponse'],
    (variables?: FlagQuestionnaireResponseMutationVariables) =>
      fetcher<
        FlagQuestionnaireResponseMutation,
        FlagQuestionnaireResponseMutationVariables
      >(FlagQuestionnaireResponseDocument, variables)(),
    options,
  );
export const GetFormResponsesPaginatedDocument = `
    query GetFormResponsesPaginated($formId: String!, $queryParams: FormResponseQueryParamsType) {
  formResponsesPaginated(formId: $formId, queryParams: $queryParams) {
    responses {
      id
      questionnaireId
      organizationId
      respondent {
        userId
        name
        email
      }
      submittedAt
      status
      isFlagged
      flagInfo {
        reason
        category
        flaggedBy {
          userId
          name
          email
        }
        flaggedAt
      }
      attestationAccepted
      progress {
        totalQuestions
        answeredQuestions
        requiredQuestions
        answeredRequiredQuestions
        completionPercentage
      }
      questionnaire {
        id
        publicTitle
        attestationText
      }
      createdAt
      updatedAt
    }
    pagination {
      page
      limit
      totalItems
      totalPages
    }
  }
}
    `;
export const useGetFormResponsesPaginatedQuery = <
  TData = GetFormResponsesPaginatedQuery,
  TError = unknown,
>(
  variables: GetFormResponsesPaginatedQueryVariables,
  options?: UseQueryOptions<GetFormResponsesPaginatedQuery, TError, TData>,
) =>
  useQuery<GetFormResponsesPaginatedQuery, TError, TData>(
    ['GetFormResponsesPaginated', variables],
    fetcher<
      GetFormResponsesPaginatedQuery,
      GetFormResponsesPaginatedQueryVariables
    >(GetFormResponsesPaginatedDocument, variables),
    options,
  );
export const GetOrganisationFormResponsesPaginatedDocument = `
    query GetOrganisationFormResponsesPaginated($queryParams: FormResponseQueryParamsType) {
  organisationFormResponsesPaginated(queryParams: $queryParams) {
    responses {
      id
      questionnaireId
      organizationId
      respondent {
        userId
        name
        email
      }
      submittedAt
      status
      isFlagged
      flagInfo {
        reason
        category
        flaggedBy {
          userId
          name
          email
        }
        flaggedAt
      }
      attestationAccepted
      progress {
        totalQuestions
        answeredQuestions
        requiredQuestions
        answeredRequiredQuestions
        completionPercentage
      }
      questionnaire {
        id
        publicTitle
        attestationText
      }
      createdAt
      updatedAt
    }
    pagination {
      page
      limit
      totalItems
      totalPages
    }
  }
}
    `;
export const useGetOrganisationFormResponsesPaginatedQuery = <
  TData = GetOrganisationFormResponsesPaginatedQuery,
  TError = unknown,
>(
  variables?: GetOrganisationFormResponsesPaginatedQueryVariables,
  options?: UseQueryOptions<
    GetOrganisationFormResponsesPaginatedQuery,
    TError,
    TData
  >,
) =>
  useQuery<GetOrganisationFormResponsesPaginatedQuery, TError, TData>(
    variables === undefined
      ? ['GetOrganisationFormResponsesPaginated']
      : ['GetOrganisationFormResponsesPaginated', variables],
    fetcher<
      GetOrganisationFormResponsesPaginatedQuery,
      GetOrganisationFormResponsesPaginatedQueryVariables
    >(GetOrganisationFormResponsesPaginatedDocument, variables),
    options,
  );
export const MitigationPlansForDisclosureDocument = `
    query MitigationPlansForDisclosure($caseId: String!) {
  mitigationPlansForDisclosure(caseId: $caseId) {
    id
    caseId
    createdBy
    createdByName
    title
    description
    status
    deadline
    reminderFrequency
    reminderMaxCount
    completedAt
    createdAt
    updatedAt
    signatories {
      id
      mitigationPlanId
      userId
      isSubject
      signedAt
      rejectedAt
      rejectionNote
      createdAt
      updatedAt
      user {
        name
        displayName
      }
    }
    reviewerSignatories {
      id
      mitigationPlanId
      userId
      isSubject
      signedAt
      rejectedAt
      rejectionNote
      createdAt
      updatedAt
      user {
        name
        displayName
      }
    }
    uploads {
      mitigationPlanId
      uploadId
      uploadOrder
      fileExtension
      scanStatus
    }
  }
}
    `;
export const useMitigationPlansForDisclosureQuery = <
  TData = MitigationPlansForDisclosureQuery,
  TError = unknown,
>(
  variables: MitigationPlansForDisclosureQueryVariables,
  options?: UseQueryOptions<MitigationPlansForDisclosureQuery, TError, TData>,
) =>
  useQuery<MitigationPlansForDisclosureQuery, TError, TData>(
    ['MitigationPlansForDisclosure', variables],
    fetcher<
      MitigationPlansForDisclosureQuery,
      MitigationPlansForDisclosureQueryVariables
    >(MitigationPlansForDisclosureDocument, variables),
    options,
  );
export const CreateMitigationPlanDocument = `
    mutation CreateMitigationPlan($data: CreateMitigationPlanInput!) {
  createMitigationPlan(data: $data) {
    id
    caseId
    createdBy
    title
    description
    status
    deadline
    reminderFrequency
    reminderMaxCount
    completedAt
    createdAt
    updatedAt
    signatories {
      id
      mitigationPlanId
      userId
      isSubject
      signedAt
      rejectedAt
      rejectionNote
      createdAt
      updatedAt
      user {
        name
        displayName
      }
    }
    reviewerSignatories {
      id
      mitigationPlanId
      userId
      isSubject
      signedAt
      rejectedAt
      rejectionNote
      createdAt
      updatedAt
      user {
        name
        displayName
      }
    }
    uploads {
      mitigationPlanId
      uploadId
      uploadOrder
      fileExtension
      scanStatus
    }
  }
}
    `;
export const useCreateMitigationPlanMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    CreateMitigationPlanMutation,
    TError,
    CreateMitigationPlanMutationVariables,
    TContext
  >,
) =>
  useMutation<
    CreateMitigationPlanMutation,
    TError,
    CreateMitigationPlanMutationVariables,
    TContext
  >(
    ['CreateMitigationPlan'],
    (variables?: CreateMitigationPlanMutationVariables) =>
      fetcher<
        CreateMitigationPlanMutation,
        CreateMitigationPlanMutationVariables
      >(CreateMitigationPlanDocument, variables)(),
    options,
  );
export const UpdateMitigationPlanDocument = `
    mutation UpdateMitigationPlan($data: UpdateMitigationPlanInput!) {
  updateMitigationPlan(data: $data) {
    id
    caseId
    createdBy
    title
    description
    status
    deadline
    reminderFrequency
    reminderMaxCount
    completedAt
    createdAt
    updatedAt
    signatories {
      id
      mitigationPlanId
      userId
      isSubject
      signedAt
      rejectedAt
      rejectionNote
      createdAt
      updatedAt
      user {
        name
        displayName
      }
    }
    reviewerSignatories {
      id
      mitigationPlanId
      userId
      isSubject
      signedAt
      rejectedAt
      rejectionNote
      createdAt
      updatedAt
      user {
        name
        displayName
      }
    }
    uploads {
      mitigationPlanId
      uploadId
      uploadOrder
      fileExtension
      scanStatus
    }
  }
}
    `;
export const useUpdateMitigationPlanMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateMitigationPlanMutation,
    TError,
    UpdateMitigationPlanMutationVariables,
    TContext
  >,
) =>
  useMutation<
    UpdateMitigationPlanMutation,
    TError,
    UpdateMitigationPlanMutationVariables,
    TContext
  >(
    ['UpdateMitigationPlan'],
    (variables?: UpdateMitigationPlanMutationVariables) =>
      fetcher<
        UpdateMitigationPlanMutation,
        UpdateMitigationPlanMutationVariables
      >(UpdateMitigationPlanDocument, variables)(),
    options,
  );
export const CancelMitigationPlanDocument = `
    mutation CancelMitigationPlan($planId: String!) {
  cancelMitigationPlan(planId: $planId)
}
    `;
export const useCancelMitigationPlanMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    CancelMitigationPlanMutation,
    TError,
    CancelMitigationPlanMutationVariables,
    TContext
  >,
) =>
  useMutation<
    CancelMitigationPlanMutation,
    TError,
    CancelMitigationPlanMutationVariables,
    TContext
  >(
    ['CancelMitigationPlan'],
    (variables?: CancelMitigationPlanMutationVariables) =>
      fetcher<
        CancelMitigationPlanMutation,
        CancelMitigationPlanMutationVariables
      >(CancelMitigationPlanDocument, variables)(),
    options,
  );
export const RecallMitigationPlanDocument = `
    mutation RecallMitigationPlan($planId: String!) {
  recallMitigationPlan(planId: $planId)
}
    `;
export const useRecallMitigationPlanMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    RecallMitigationPlanMutation,
    TError,
    RecallMitigationPlanMutationVariables,
    TContext
  >,
) =>
  useMutation<
    RecallMitigationPlanMutation,
    TError,
    RecallMitigationPlanMutationVariables,
    TContext
  >(
    ['RecallMitigationPlan'],
    (variables?: RecallMitigationPlanMutationVariables) =>
      fetcher<
        RecallMitigationPlanMutation,
        RecallMitigationPlanMutationVariables
      >(RecallMitigationPlanDocument, variables)(),
    options,
  );
export const RejectMitigationPlanDocument = `
    mutation RejectMitigationPlan($planId: String!, $note: String!) {
  rejectMitigationPlan(planId: $planId, note: $note)
}
    `;
export const useRejectMitigationPlanMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    RejectMitigationPlanMutation,
    TError,
    RejectMitigationPlanMutationVariables,
    TContext
  >,
) =>
  useMutation<
    RejectMitigationPlanMutation,
    TError,
    RejectMitigationPlanMutationVariables,
    TContext
  >(
    ['RejectMitigationPlan'],
    (variables?: RejectMitigationPlanMutationVariables) =>
      fetcher<
        RejectMitigationPlanMutation,
        RejectMitigationPlanMutationVariables
      >(RejectMitigationPlanDocument, variables)(),
    options,
  );
export const CreateMitigationPlanUploadDocument = `
    mutation CreateMitigationPlanUpload($filename: String!, $s3path: String!, $size: Float!, $mimeType: String!) {
  createMitigationPlanUpload(
    filename: $filename
    s3path: $s3path
    size: $size
    mimeType: $mimeType
  ) {
    id
    s3path
    mimeType
    size
    fileExtension
    scanStatus
  }
}
    `;
export const useCreateMitigationPlanUploadMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    CreateMitigationPlanUploadMutation,
    TError,
    CreateMitigationPlanUploadMutationVariables,
    TContext
  >,
) =>
  useMutation<
    CreateMitigationPlanUploadMutation,
    TError,
    CreateMitigationPlanUploadMutationVariables,
    TContext
  >(
    ['CreateMitigationPlanUpload'],
    (variables?: CreateMitigationPlanUploadMutationVariables) =>
      fetcher<
        CreateMitigationPlanUploadMutation,
        CreateMitigationPlanUploadMutationVariables
      >(CreateMitigationPlanUploadDocument, variables)(),
    options,
  );
export const UpdateMitigationPlanSignatoriesDocument = `
    mutation UpdateMitigationPlanSignatories($data: UpdateMitigationPlanSignatoriesInput!) {
  updateMitigationPlanSignatories(data: $data) {
    id
    mitigationPlanId
    userId
    isSubject
    signedAt
    rejectedAt
    rejectionNote
    createdAt
    updatedAt
  }
}
    `;
export const useUpdateMitigationPlanSignatoriesMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateMitigationPlanSignatoriesMutation,
    TError,
    UpdateMitigationPlanSignatoriesMutationVariables,
    TContext
  >,
) =>
  useMutation<
    UpdateMitigationPlanSignatoriesMutation,
    TError,
    UpdateMitigationPlanSignatoriesMutationVariables,
    TContext
  >(
    ['UpdateMitigationPlanSignatories'],
    (variables?: UpdateMitigationPlanSignatoriesMutationVariables) =>
      fetcher<
        UpdateMitigationPlanSignatoriesMutation,
        UpdateMitigationPlanSignatoriesMutationVariables
      >(UpdateMitigationPlanSignatoriesDocument, variables)(),
    options,
  );
export const GetMitigationPlanUploadUrlDocument = `
    mutation GetMitigationPlanUploadURL($uploadId: String!, $planId: String!) {
  getMitigationPlanUploadURL(uploadId: $uploadId, planId: $planId) {
    url
  }
}
    `;
export const useGetMitigationPlanUploadUrlMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    GetMitigationPlanUploadUrlMutation,
    TError,
    GetMitigationPlanUploadUrlMutationVariables,
    TContext
  >,
) =>
  useMutation<
    GetMitigationPlanUploadUrlMutation,
    TError,
    GetMitigationPlanUploadUrlMutationVariables,
    TContext
  >(
    ['GetMitigationPlanUploadURL'],
    (variables?: GetMitigationPlanUploadUrlMutationVariables) =>
      fetcher<
        GetMitigationPlanUploadUrlMutation,
        GetMitigationPlanUploadUrlMutationVariables
      >(GetMitigationPlanUploadUrlDocument, variables)(),
    options,
  );
export const GetMitigationPlanDownloadUrlDocument = `
    mutation GetMitigationPlanDownloadURL($uploadId: String!, $planId: String!) {
  getMitigationPlanDownloadURL(uploadId: $uploadId, planId: $planId) {
    url
  }
}
    `;
export const useGetMitigationPlanDownloadUrlMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    GetMitigationPlanDownloadUrlMutation,
    TError,
    GetMitigationPlanDownloadUrlMutationVariables,
    TContext
  >,
) =>
  useMutation<
    GetMitigationPlanDownloadUrlMutation,
    TError,
    GetMitigationPlanDownloadUrlMutationVariables,
    TContext
  >(
    ['GetMitigationPlanDownloadURL'],
    (variables?: GetMitigationPlanDownloadUrlMutationVariables) =>
      fetcher<
        GetMitigationPlanDownloadUrlMutation,
        GetMitigationPlanDownloadUrlMutationVariables
      >(GetMitigationPlanDownloadUrlDocument, variables)(),
    options,
  );
export const SignMitigationPlanDocument = `
    mutation SignMitigationPlan($planId: String!) {
  signMitigationPlan(planId: $planId)
}
    `;
export const useSignMitigationPlanMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    SignMitigationPlanMutation,
    TError,
    SignMitigationPlanMutationVariables,
    TContext
  >,
) =>
  useMutation<
    SignMitigationPlanMutation,
    TError,
    SignMitigationPlanMutationVariables,
    TContext
  >(
    ['SignMitigationPlan'],
    (variables?: SignMitigationPlanMutationVariables) =>
      fetcher<SignMitigationPlanMutation, SignMitigationPlanMutationVariables>(
        SignMitigationPlanDocument,
        variables,
      )(),
    options,
  );
export const DeleteMitigationPlanUploadDocument = `
    mutation DeleteMitigationPlanUpload($planId: String!, $uploadId: String!) {
  deleteMitigationPlanUpload(planId: $planId, uploadId: $uploadId)
}
    `;
export const useDeleteMitigationPlanUploadMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    DeleteMitigationPlanUploadMutation,
    TError,
    DeleteMitigationPlanUploadMutationVariables,
    TContext
  >,
) =>
  useMutation<
    DeleteMitigationPlanUploadMutation,
    TError,
    DeleteMitigationPlanUploadMutationVariables,
    TContext
  >(
    ['DeleteMitigationPlanUpload'],
    (variables?: DeleteMitigationPlanUploadMutationVariables) =>
      fetcher<
        DeleteMitigationPlanUploadMutation,
        DeleteMitigationPlanUploadMutationVariables
      >(DeleteMitigationPlanUploadDocument, variables)(),
    options,
  );
export const CountriesDocument = `
    query Countries {
  countries {
    code
    name
  }
}
    `;
export const useCountriesQuery = <TData = CountriesQuery, TError = unknown>(
  variables?: CountriesQueryVariables,
  options?: UseQueryOptions<CountriesQuery, TError, TData>,
) =>
  useQuery<CountriesQuery, TError, TData>(
    variables === undefined ? ['Countries'] : ['Countries', variables],
    fetcher<CountriesQuery, CountriesQueryVariables>(
      CountriesDocument,
      variables,
    ),
    options,
  );
export const RegionsForOrganisationDocument = `
    query RegionsForOrganisation {
  regionsForOrganisation {
    id
    name
    isActive
    countries {
      code
      name
    }
  }
}
    `;
export const useRegionsForOrganisationQuery = <
  TData = RegionsForOrganisationQuery,
  TError = unknown,
>(
  variables?: RegionsForOrganisationQueryVariables,
  options?: UseQueryOptions<RegionsForOrganisationQuery, TError, TData>,
) =>
  useQuery<RegionsForOrganisationQuery, TError, TData>(
    variables === undefined
      ? ['RegionsForOrganisation']
      : ['RegionsForOrganisation', variables],
    fetcher<RegionsForOrganisationQuery, RegionsForOrganisationQueryVariables>(
      RegionsForOrganisationDocument,
      variables,
    ),
    options,
  );
export const SetCaseCountryRegionDocument = `
    mutation SetCaseCountryRegion($input: SetCaseCountryRegionInput!) {
  setCaseCountryRegion(input: $input) {
    country {
      code
      name
    }
    region {
      id
      name
      isActive
      countries {
        code
        name
      }
    }
  }
}
    `;
export const useSetCaseCountryRegionMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    SetCaseCountryRegionMutation,
    TError,
    SetCaseCountryRegionMutationVariables,
    TContext
  >,
) =>
  useMutation<
    SetCaseCountryRegionMutation,
    TError,
    SetCaseCountryRegionMutationVariables,
    TContext
  >(
    ['SetCaseCountryRegion'],
    (variables?: SetCaseCountryRegionMutationVariables) =>
      fetcher<
        SetCaseCountryRegionMutation,
        SetCaseCountryRegionMutationVariables
      >(SetCaseCountryRegionDocument, variables)(),
    options,
  );
export const CreateCaseLinkDocument = `
    mutation CreateCaseLink($data: CreateCaseLinkInput!) {
  createCaseLink(data: $data) {
    id
    sourceCaseId
    targetCaseId
    linkType
    notes
  }
}
    `;
export const useCreateCaseLinkMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    CreateCaseLinkMutation,
    TError,
    CreateCaseLinkMutationVariables,
    TContext
  >,
) =>
  useMutation<
    CreateCaseLinkMutation,
    TError,
    CreateCaseLinkMutationVariables,
    TContext
  >(
    ['CreateCaseLink'],
    (variables?: CreateCaseLinkMutationVariables) =>
      fetcher<CreateCaseLinkMutation, CreateCaseLinkMutationVariables>(
        CreateCaseLinkDocument,
        variables,
      )(),
    options,
  );
export const EditCaseAccessDocument = `
    mutation EditCaseAccess($caseId: String!, $userId: Int!, $entityPermissions: [String!]!) {
  editCaseAccess(
    caseId: $caseId
    userId: $userId
    entityPermissions: $entityPermissions
  ) {
    casePermissions {
      permission
    }
    reportPermissions {
      permission
    }
  }
}
    `;
export const useEditCaseAccessMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    EditCaseAccessMutation,
    TError,
    EditCaseAccessMutationVariables,
    TContext
  >,
) =>
  useMutation<
    EditCaseAccessMutation,
    TError,
    EditCaseAccessMutationVariables,
    TContext
  >(
    ['EditCaseAccess'],
    (variables?: EditCaseAccessMutationVariables) =>
      fetcher<EditCaseAccessMutation, EditCaseAccessMutationVariables>(
        EditCaseAccessDocument,
        variables,
      )(),
    options,
  );
export const GetCaseAttributesDocument = `
    query GetCaseAttributes($caseId: String!) {
  getCaseAttributes(caseId: $caseId) {
    companyCreatedAt
    readAt
    investigatingAt
    closedAt
  }
}
    `;
export const useGetCaseAttributesQuery = <
  TData = GetCaseAttributesQuery,
  TError = unknown,
>(
  variables: GetCaseAttributesQueryVariables,
  options?: UseQueryOptions<GetCaseAttributesQuery, TError, TData>,
) =>
  useQuery<GetCaseAttributesQuery, TError, TData>(
    ['GetCaseAttributes', variables],
    fetcher<GetCaseAttributesQuery, GetCaseAttributesQueryVariables>(
      GetCaseAttributesDocument,
      variables,
    ),
    options,
  );
export const GetCaseAuditEntriesDocument = `
    query GetCaseAuditEntries($case: String!, $pagination: PaginationInputType) {
  getCaseAuditEntries(case: $case, pagination: $pagination) {
    count
    items {
      DescriptiveText(case: $case)
      action
      id
      createdAt
      data
      completed
      User {
        id
        name
        displayName
      }
    }
  }
}
    `;
export const useGetCaseAuditEntriesQuery = <
  TData = GetCaseAuditEntriesQuery,
  TError = unknown,
>(
  variables: GetCaseAuditEntriesQueryVariables,
  options?: UseQueryOptions<GetCaseAuditEntriesQuery, TError, TData>,
) =>
  useQuery<GetCaseAuditEntriesQuery, TError, TData>(
    ['GetCaseAuditEntries', variables],
    fetcher<GetCaseAuditEntriesQuery, GetCaseAuditEntriesQueryVariables>(
      GetCaseAuditEntriesDocument,
      variables,
    ),
    options,
  );
export const GetCaseLinksByCaseIdDocument = `
    query GetCaseLinksByCaseId($caseId: String!) {
  getCaseLinksByCaseId(caseId: $caseId) {
    id
    sourceCaseId
    targetCaseId
    linkType
    notes
    createdAt
    updatedAt
    createdBy
    CreatedByUser(viewedCaseId: $caseId) {
      id
      name
    }
    organisation
    SourceCase {
      id
      name
      readableId
      status
      AssociatedPermissions {
        canViewCaseDetails
        canEditCaseDetails
      }
    }
    TargetCase {
      id
      name
      readableId
      status
      AssociatedPermissions {
        canViewCaseDetails
        canEditCaseDetails
      }
    }
  }
}
    `;
export const useGetCaseLinksByCaseIdQuery = <
  TData = GetCaseLinksByCaseIdQuery,
  TError = unknown,
>(
  variables: GetCaseLinksByCaseIdQueryVariables,
  options?: UseQueryOptions<GetCaseLinksByCaseIdQuery, TError, TData>,
) =>
  useQuery<GetCaseLinksByCaseIdQuery, TError, TData>(
    ['GetCaseLinksByCaseId', variables],
    fetcher<GetCaseLinksByCaseIdQuery, GetCaseLinksByCaseIdQueryVariables>(
      GetCaseLinksByCaseIdDocument,
      variables,
    ),
    options,
  );
export const GetCaseTeamMemberPermissionsDocument = `
    query GetCaseTeamMemberPermissions($userId: Int, $caseId: String!) {
  getCaseTeamMemberPermissions(userId: $userId, caseId: $caseId)
}
    `;
export const useGetCaseTeamMemberPermissionsQuery = <
  TData = GetCaseTeamMemberPermissionsQuery,
  TError = unknown,
>(
  variables: GetCaseTeamMemberPermissionsQueryVariables,
  options?: UseQueryOptions<GetCaseTeamMemberPermissionsQuery, TError, TData>,
) =>
  useQuery<GetCaseTeamMemberPermissionsQuery, TError, TData>(
    ['GetCaseTeamMemberPermissions', variables],
    fetcher<
      GetCaseTeamMemberPermissionsQuery,
      GetCaseTeamMemberPermissionsQueryVariables
    >(GetCaseTeamMemberPermissionsDocument, variables),
    options,
  );
export const GetPublicCountriesDocument = `
    query GetPublicCountries($slug: String!) {
  getPublicCountries(slug: $slug) {
    code
    name
  }
}
    `;
export const useGetPublicCountriesQuery = <
  TData = GetPublicCountriesQuery,
  TError = unknown,
>(
  variables: GetPublicCountriesQueryVariables,
  options?: UseQueryOptions<GetPublicCountriesQuery, TError, TData>,
) =>
  useQuery<GetPublicCountriesQuery, TError, TData>(
    ['GetPublicCountries', variables],
    fetcher<GetPublicCountriesQuery, GetPublicCountriesQueryVariables>(
      GetPublicCountriesDocument,
      variables,
    ),
    options,
  );
export const GetPublicSitesDocument = `
    query GetPublicSites($slug: String!) {
  getPublicSites(slug: $slug) {
    name
  }
}
    `;
export const useGetPublicSitesQuery = <
  TData = GetPublicSitesQuery,
  TError = unknown,
>(
  variables: GetPublicSitesQueryVariables,
  options?: UseQueryOptions<GetPublicSitesQuery, TError, TData>,
) =>
  useQuery<GetPublicSitesQuery, TError, TData>(
    ['GetPublicSites', variables],
    fetcher<GetPublicSitesQuery, GetPublicSitesQueryVariables>(
      GetPublicSitesDocument,
      variables,
    ),
    options,
  );
export const GetSanitizedAndDeletedCasesDocument = `
    query GetSanitizedAndDeletedCases {
  sanitizedAndDeletedCases {
    id
    readableId
    name
    status
    createdAt
    updatedAt
    sanitizedAt
    deletedAt
    RetentionRule {
      id
      ruleType
      dateReference
      conditions
      fallbackRule
      country
    }
    completedAt
    substantiation
    closedAt
  }
}
    `;
export const useGetSanitizedAndDeletedCasesQuery = <
  TData = GetSanitizedAndDeletedCasesQuery,
  TError = unknown,
>(
  variables?: GetSanitizedAndDeletedCasesQueryVariables,
  options?: UseQueryOptions<GetSanitizedAndDeletedCasesQuery, TError, TData>,
) =>
  useQuery<GetSanitizedAndDeletedCasesQuery, TError, TData>(
    variables === undefined
      ? ['GetSanitizedAndDeletedCases']
      : ['GetSanitizedAndDeletedCases', variables],
    fetcher<
      GetSanitizedAndDeletedCasesQuery,
      GetSanitizedAndDeletedCasesQueryVariables
    >(GetSanitizedAndDeletedCasesDocument, variables),
    options,
  );
export const InviteToCaseDocument = `
    mutation InviteToCase($caseId: String!, $userIds: [Int!]!, $entityPermissions: [String!]!, $note: String) {
  inviteToCase(
    caseId: $caseId
    userIds: $userIds
    entityPermissions: $entityPermissions
    note: $note
  ) {
    ...CaseTeamMemberFragment
  }
}
    ${CaseTeamMemberFragmentFragmentDoc}`;
export const useInviteToCaseMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    InviteToCaseMutation,
    TError,
    InviteToCaseMutationVariables,
    TContext
  >,
) =>
  useMutation<
    InviteToCaseMutation,
    TError,
    InviteToCaseMutationVariables,
    TContext
  >(
    ['InviteToCase'],
    (variables?: InviteToCaseMutationVariables) =>
      fetcher<InviteToCaseMutation, InviteToCaseMutationVariables>(
        InviteToCaseDocument,
        variables,
      )(),
    options,
  );
export const RemoveFromCaseDocument = `
    mutation RemoveFromCase($userId: Int!, $caseId: String!) {
  removeFromCase(userId: $userId, caseId: $caseId) {
    id
  }
}
    `;
export const useRemoveFromCaseMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    RemoveFromCaseMutation,
    TError,
    RemoveFromCaseMutationVariables,
    TContext
  >,
) =>
  useMutation<
    RemoveFromCaseMutation,
    TError,
    RemoveFromCaseMutationVariables,
    TContext
  >(
    ['RemoveFromCase'],
    (variables?: RemoveFromCaseMutationVariables) =>
      fetcher<RemoveFromCaseMutation, RemoveFromCaseMutationVariables>(
        RemoveFromCaseDocument,
        variables,
      )(),
    options,
  );
export const RestoreSanitizedCaseDocument = `
    mutation RestoreSanitizedCase($caseId: String!) {
  restoreSanitizedCase(caseId: $caseId) {
    id
    sanitizedAt
  }
}
    `;
export const useRestoreSanitizedCaseMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    RestoreSanitizedCaseMutation,
    TError,
    RestoreSanitizedCaseMutationVariables,
    TContext
  >,
) =>
  useMutation<
    RestoreSanitizedCaseMutation,
    TError,
    RestoreSanitizedCaseMutationVariables,
    TContext
  >(
    ['RestoreSanitizedCase'],
    (variables?: RestoreSanitizedCaseMutationVariables) =>
      fetcher<
        RestoreSanitizedCaseMutation,
        RestoreSanitizedCaseMutationVariables
      >(RestoreSanitizedCaseDocument, variables)(),
    options,
  );
export const UpdateCaseAttributesDocument = `
    mutation UpdateCaseAttributes($caseAttributes: UpdateCaseAttributes!, $postSubmission: Boolean) {
  updateCaseAttributes(
    caseAttributes: $caseAttributes
    postSubmission: $postSubmission
  ) {
    companyCreatedAt
    readAt
    investigatingAt
    closedAt
  }
}
    `;
export const useUpdateCaseAttributesMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateCaseAttributesMutation,
    TError,
    UpdateCaseAttributesMutationVariables,
    TContext
  >,
) =>
  useMutation<
    UpdateCaseAttributesMutation,
    TError,
    UpdateCaseAttributesMutationVariables,
    TContext
  >(
    ['UpdateCaseAttributes'],
    (variables?: UpdateCaseAttributesMutationVariables) =>
      fetcher<
        UpdateCaseAttributesMutation,
        UpdateCaseAttributesMutationVariables
      >(UpdateCaseAttributesDocument, variables)(),
    options,
  );
export const CreateCategoryDocument = `
    mutation CreateCategory($category: CreateCategoryType!) {
  createCategory(category: $category) {
    id
  }
}
    `;
export const useCreateCategoryMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    CreateCategoryMutation,
    TError,
    CreateCategoryMutationVariables,
    TContext
  >,
) =>
  useMutation<
    CreateCategoryMutation,
    TError,
    CreateCategoryMutationVariables,
    TContext
  >(
    ['CreateCategory'],
    (variables?: CreateCategoryMutationVariables) =>
      fetcher<CreateCategoryMutation, CreateCategoryMutationVariables>(
        CreateCategoryDocument,
        variables,
      )(),
    options,
  );
export const GetActiveCategoriesForCaseDocument = `
    query GetActiveCategoriesForCase {
  getActiveCategoriesForCase {
    allowGoTogether
    body
    id
    name
    order
    question
    title
  }
}
    `;
export const useGetActiveCategoriesForCaseQuery = <
  TData = GetActiveCategoriesForCaseQuery,
  TError = unknown,
>(
  variables?: GetActiveCategoriesForCaseQueryVariables,
  options?: UseQueryOptions<GetActiveCategoriesForCaseQuery, TError, TData>,
) =>
  useQuery<GetActiveCategoriesForCaseQuery, TError, TData>(
    variables === undefined
      ? ['GetActiveCategoriesForCase']
      : ['GetActiveCategoriesForCase', variables],
    fetcher<
      GetActiveCategoriesForCaseQuery,
      GetActiveCategoriesForCaseQueryVariables
    >(GetActiveCategoriesForCaseDocument, variables),
    options,
  );
export const GetCategoryConfigCategoriesDocument = `
    query GetCategoryConfigCategories($isCOI: Boolean) {
  getOrganisationCategories(isCOI: $isCOI) {
    id
    allowGoTogether
    displayInApp
    displayInOpenReporting
    displayInVaultTalk
    displayInCollaborationToolIntegration
    displayInManualIntake
    isDeterminedCategory
    isReportedCategory
    isCustomQuestions
    status
    hasActiveLinkedForm
    locales
    order
    question
    requestOpenPerpetrators
    createdAt
    updatedAt
    Author {
      name
      displayName
      id
    }
  }
}
    `;
export const useGetCategoryConfigCategoriesQuery = <
  TData = GetCategoryConfigCategoriesQuery,
  TError = unknown,
>(
  variables?: GetCategoryConfigCategoriesQueryVariables,
  options?: UseQueryOptions<GetCategoryConfigCategoriesQuery, TError, TData>,
) =>
  useQuery<GetCategoryConfigCategoriesQuery, TError, TData>(
    variables === undefined
      ? ['GetCategoryConfigCategories']
      : ['GetCategoryConfigCategories', variables],
    fetcher<
      GetCategoryConfigCategoriesQuery,
      GetCategoryConfigCategoriesQueryVariables
    >(GetCategoryConfigCategoriesDocument, variables),
    options,
  );
export const GetDeterminedCategoriesDocument = `
    query GetDeterminedCategories {
  getDeterminedCategories {
    allowGoTogether
    body
    id
    name
    order
    question
    title
  }
}
    `;
export const useGetDeterminedCategoriesQuery = <
  TData = GetDeterminedCategoriesQuery,
  TError = unknown,
>(
  variables?: GetDeterminedCategoriesQueryVariables,
  options?: UseQueryOptions<GetDeterminedCategoriesQuery, TError, TData>,
) =>
  useQuery<GetDeterminedCategoriesQuery, TError, TData>(
    variables === undefined
      ? ['GetDeterminedCategories']
      : ['GetDeterminedCategories', variables],
    fetcher<
      GetDeterminedCategoriesQuery,
      GetDeterminedCategoriesQueryVariables
    >(GetDeterminedCategoriesDocument, variables),
    options,
  );
export const GetManualIntakeReportedCategoriesDocument = `
    query GetManualIntakeReportedCategories {
  getManualIntakeReportedCategories {
    allowGoTogether
    body
    id
    name
    order
    question
    title
  }
}
    `;
export const useGetManualIntakeReportedCategoriesQuery = <
  TData = GetManualIntakeReportedCategoriesQuery,
  TError = unknown,
>(
  variables?: GetManualIntakeReportedCategoriesQueryVariables,
  options?: UseQueryOptions<
    GetManualIntakeReportedCategoriesQuery,
    TError,
    TData
  >,
) =>
  useQuery<GetManualIntakeReportedCategoriesQuery, TError, TData>(
    variables === undefined
      ? ['GetManualIntakeReportedCategories']
      : ['GetManualIntakeReportedCategories', variables],
    fetcher<
      GetManualIntakeReportedCategoriesQuery,
      GetManualIntakeReportedCategoriesQueryVariables
    >(GetManualIntakeReportedCategoriesDocument, variables),
    options,
  );
export const GetOrganisationCategoriesDocument = `
    query GetOrganisationCategories($isCOI: Boolean) {
  getOrganisationCategories(isCOI: $isCOI) {
    id
    allowGoTogether
    displayInApp
    displayInOpenReporting
    displayInVaultTalk
    displayInCollaborationToolIntegration
    displayInManualIntake
    isDeterminedCategory
    isReportedCategory
    isCustomQuestions
    status
    hasActiveLinkedForm
    locales
    order
    question
    requestOpenPerpetrators
    createdAt
    Author {
      name
      displayName
      id
    }
  }
}
    `;
export const useGetOrganisationCategoriesQuery = <
  TData = GetOrganisationCategoriesQuery,
  TError = unknown,
>(
  variables?: GetOrganisationCategoriesQueryVariables,
  options?: UseQueryOptions<GetOrganisationCategoriesQuery, TError, TData>,
) =>
  useQuery<GetOrganisationCategoriesQuery, TError, TData>(
    variables === undefined
      ? ['GetOrganisationCategories']
      : ['GetOrganisationCategories', variables],
    fetcher<
      GetOrganisationCategoriesQuery,
      GetOrganisationCategoriesQueryVariables
    >(GetOrganisationCategoriesDocument, variables),
    options,
  );
export const GetPublicCategoriesDocument = `
    query GetPublicCategories($slug: String!) {
  getPublicCategories(slug: $slug) {
    allowGoTogether
    body
    id
    name
    order
    question
    title
    requestOpenPerpetrators
  }
}
    `;
export const useGetPublicCategoriesQuery = <
  TData = GetPublicCategoriesQuery,
  TError = unknown,
>(
  variables: GetPublicCategoriesQueryVariables,
  options?: UseQueryOptions<GetPublicCategoriesQuery, TError, TData>,
) =>
  useQuery<GetPublicCategoriesQuery, TError, TData>(
    ['GetPublicCategories', variables],
    fetcher<GetPublicCategoriesQuery, GetPublicCategoriesQueryVariables>(
      GetPublicCategoriesDocument,
      variables,
    ),
    options,
  );
export const GetReportedCategoriesDocument = `
    query GetReportedCategories($isCOI: Boolean) {
  getReportedCategories(isCOI: $isCOI) {
    allowGoTogether
    body
    id
    name
    order
    question
    title
  }
}
    `;
export const useGetReportedCategoriesQuery = <
  TData = GetReportedCategoriesQuery,
  TError = unknown,
>(
  variables?: GetReportedCategoriesQueryVariables,
  options?: UseQueryOptions<GetReportedCategoriesQuery, TError, TData>,
) =>
  useQuery<GetReportedCategoriesQuery, TError, TData>(
    variables === undefined
      ? ['GetReportedCategories']
      : ['GetReportedCategories', variables],
    fetcher<GetReportedCategoriesQuery, GetReportedCategoriesQueryVariables>(
      GetReportedCategoriesDocument,
      variables,
    ),
    options,
  );
export const UpdateCategoryDocument = `
    mutation UpdateCategory($category: UpdateCategoryType!) {
  updateCategory(category: $category) {
    id
  }
}
    `;
export const useUpdateCategoryMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    UpdateCategoryMutation,
    TError,
    UpdateCategoryMutationVariables,
    TContext
  >,
) =>
  useMutation<
    UpdateCategoryMutation,
    TError,
    UpdateCategoryMutationVariables,
    TContext
  >(
    ['UpdateCategory'],
    (variables?: UpdateCategoryMutationVariables) =>
      fetcher<UpdateCategoryMutation, UpdateCategoryMutationVariables>(
        UpdateCategoryDocument,
        variables,
      )(),
    options,
  );
export const UpdateCategoryLocaleDocument = `
    mutation UpdateCategoryLocale($category: UpdateCategoryLocaleType!) {
  updateCategoryLocale(category: $category) {
    id
  }
}
    `;
export const useUpdateCategoryLocaleMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateCategoryLocaleMutation,
    TError,
    UpdateCategoryLocaleMutationVariables,
    TContext
  >,
) =>
  useMutation<
    UpdateCategoryLocaleMutation,
    TError,
    UpdateCategoryLocaleMutationVariables,
    TContext
  >(
    ['UpdateCategoryLocale'],
    (variables?: UpdateCategoryLocaleMutationVariables) =>
      fetcher<
        UpdateCategoryLocaleMutation,
        UpdateCategoryLocaleMutationVariables
      >(UpdateCategoryLocaleDocument, variables)(),
    options,
  );
export const UpdateCategoryOrdersDocument = `
    mutation UpdateCategoryOrders($categories: [UpdateCategoryOrderType!]!, $draggedCategoryId: Int!) {
  updateCategoryOrders(
    categories: $categories
    draggedCategoryId: $draggedCategoryId
  ) {
    id
    order
  }
}
    `;
export const useUpdateCategoryOrdersMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateCategoryOrdersMutation,
    TError,
    UpdateCategoryOrdersMutationVariables,
    TContext
  >,
) =>
  useMutation<
    UpdateCategoryOrdersMutation,
    TError,
    UpdateCategoryOrdersMutationVariables,
    TContext
  >(
    ['UpdateCategoryOrders'],
    (variables?: UpdateCategoryOrdersMutationVariables) =>
      fetcher<
        UpdateCategoryOrdersMutation,
        UpdateCategoryOrdersMutationVariables
      >(UpdateCategoryOrdersDocument, variables)(),
    options,
  );
export const CaseCustomFieldValuesDocument = `
    query CaseCustomFieldValues($id: String!) {
  caseById(id: $id) {
    id
    CaseCustomFieldValues {
      customFieldId
      label
      identifier
      fieldType
      status
      displayOrder
      sectionId
      options {
        id
        label
        isActive
      }
      valueText
      optionId
    }
  }
}
    `;
export const useCaseCustomFieldValuesQuery = <
  TData = CaseCustomFieldValuesQuery,
  TError = unknown,
>(
  variables: CaseCustomFieldValuesQueryVariables,
  options?: UseQueryOptions<CaseCustomFieldValuesQuery, TError, TData>,
) =>
  useQuery<CaseCustomFieldValuesQuery, TError, TData>(
    ['CaseCustomFieldValues', variables],
    fetcher<CaseCustomFieldValuesQuery, CaseCustomFieldValuesQueryVariables>(
      CaseCustomFieldValuesDocument,
      variables,
    ),
    options,
  );
export const SetCaseCustomFieldValueDocument = `
    mutation SetCaseCustomFieldValue($input: SetCaseCustomFieldValueInputType!) {
  setCaseCustomFieldValue(input: $input) {
    customFieldId
    label
    identifier
    fieldType
    status
    displayOrder
    sectionId
    options {
      id
      label
      isActive
    }
    valueText
    optionId
  }
}
    `;
export const useSetCaseCustomFieldValueMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    SetCaseCustomFieldValueMutation,
    TError,
    SetCaseCustomFieldValueMutationVariables,
    TContext
  >,
) =>
  useMutation<
    SetCaseCustomFieldValueMutation,
    TError,
    SetCaseCustomFieldValueMutationVariables,
    TContext
  >(
    ['SetCaseCustomFieldValue'],
    (variables?: SetCaseCustomFieldValueMutationVariables) =>
      fetcher<
        SetCaseCustomFieldValueMutation,
        SetCaseCustomFieldValueMutationVariables
      >(SetCaseCustomFieldValueDocument, variables)(),
    options,
  );
export const GetOrganisationCustomFieldSectionsDocument = `
    query GetOrganisationCustomFieldSections {
  getOrganisationCustomFieldSections {
    sections {
      id
      name
      description
      isDefault
      displayOrder
      fieldCount
      fields {
        id
        label
      }
      createdAt
      updatedAt
    }
  }
}
    `;
export const useGetOrganisationCustomFieldSectionsQuery = <
  TData = GetOrganisationCustomFieldSectionsQuery,
  TError = unknown,
>(
  variables?: GetOrganisationCustomFieldSectionsQueryVariables,
  options?: UseQueryOptions<
    GetOrganisationCustomFieldSectionsQuery,
    TError,
    TData
  >,
) =>
  useQuery<GetOrganisationCustomFieldSectionsQuery, TError, TData>(
    variables === undefined
      ? ['GetOrganisationCustomFieldSections']
      : ['GetOrganisationCustomFieldSections', variables],
    fetcher<
      GetOrganisationCustomFieldSectionsQuery,
      GetOrganisationCustomFieldSectionsQueryVariables
    >(GetOrganisationCustomFieldSectionsDocument, variables),
    options,
  );
export const CreateCustomFieldSectionDocument = `
    mutation CreateCustomFieldSection($input: CreateCustomFieldSectionInputType!) {
  createCustomFieldSection(input: $input) {
    id
    name
    description
    isDefault
    displayOrder
    fieldCount
    createdAt
    updatedAt
  }
}
    `;
export const useCreateCustomFieldSectionMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    CreateCustomFieldSectionMutation,
    TError,
    CreateCustomFieldSectionMutationVariables,
    TContext
  >,
) =>
  useMutation<
    CreateCustomFieldSectionMutation,
    TError,
    CreateCustomFieldSectionMutationVariables,
    TContext
  >(
    ['CreateCustomFieldSection'],
    (variables?: CreateCustomFieldSectionMutationVariables) =>
      fetcher<
        CreateCustomFieldSectionMutation,
        CreateCustomFieldSectionMutationVariables
      >(CreateCustomFieldSectionDocument, variables)(),
    options,
  );
export const UpdateCustomFieldSectionDocument = `
    mutation UpdateCustomFieldSection($input: UpdateCustomFieldSectionInputType!) {
  updateCustomFieldSection(input: $input) {
    id
    name
    description
    isDefault
    displayOrder
    fieldCount
    createdAt
    updatedAt
  }
}
    `;
export const useUpdateCustomFieldSectionMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateCustomFieldSectionMutation,
    TError,
    UpdateCustomFieldSectionMutationVariables,
    TContext
  >,
) =>
  useMutation<
    UpdateCustomFieldSectionMutation,
    TError,
    UpdateCustomFieldSectionMutationVariables,
    TContext
  >(
    ['UpdateCustomFieldSection'],
    (variables?: UpdateCustomFieldSectionMutationVariables) =>
      fetcher<
        UpdateCustomFieldSectionMutation,
        UpdateCustomFieldSectionMutationVariables
      >(UpdateCustomFieldSectionDocument, variables)(),
    options,
  );
export const DeleteCustomFieldSectionDocument = `
    mutation DeleteCustomFieldSection($input: DeleteCustomFieldSectionInputType!) {
  deleteCustomFieldSection(input: $input) {
    id
    deleted
  }
}
    `;
export const useDeleteCustomFieldSectionMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    DeleteCustomFieldSectionMutation,
    TError,
    DeleteCustomFieldSectionMutationVariables,
    TContext
  >,
) =>
  useMutation<
    DeleteCustomFieldSectionMutation,
    TError,
    DeleteCustomFieldSectionMutationVariables,
    TContext
  >(
    ['DeleteCustomFieldSection'],
    (variables?: DeleteCustomFieldSectionMutationVariables) =>
      fetcher<
        DeleteCustomFieldSectionMutation,
        DeleteCustomFieldSectionMutationVariables
      >(DeleteCustomFieldSectionDocument, variables)(),
    options,
  );
export const ReorderCustomFieldSectionsDocument = `
    mutation ReorderCustomFieldSections($input: ReorderCustomFieldSectionsInputType!) {
  reorderCustomFieldSections(input: $input) {
    sections {
      id
      name
      description
      isDefault
      displayOrder
      fieldCount
      createdAt
      updatedAt
    }
  }
}
    `;
export const useReorderCustomFieldSectionsMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    ReorderCustomFieldSectionsMutation,
    TError,
    ReorderCustomFieldSectionsMutationVariables,
    TContext
  >,
) =>
  useMutation<
    ReorderCustomFieldSectionsMutation,
    TError,
    ReorderCustomFieldSectionsMutationVariables,
    TContext
  >(
    ['ReorderCustomFieldSections'],
    (variables?: ReorderCustomFieldSectionsMutationVariables) =>
      fetcher<
        ReorderCustomFieldSectionsMutation,
        ReorderCustomFieldSectionsMutationVariables
      >(ReorderCustomFieldSectionsDocument, variables)(),
    options,
  );
export const GetOrganisationCustomFieldsDocument = `
    query GetOrganisationCustomFields($input: GetOrganisationCustomFieldsInputType) {
  getOrganisationCustomFields(input: $input) {
    customFields {
      id
      label
      identifier
      description
      fieldType
      status
      displayOrder
      options
      optionDetails {
        id
        customFieldId
        label
        displayOrder
        isActive
        createdAt
        updatedAt
      }
      sectionId
      isStandard
      author {
        id
        name
      }
      createdAt
      updatedAt
    }
    total
  }
}
    `;
export const useGetOrganisationCustomFieldsQuery = <
  TData = GetOrganisationCustomFieldsQuery,
  TError = unknown,
>(
  variables?: GetOrganisationCustomFieldsQueryVariables,
  options?: UseQueryOptions<GetOrganisationCustomFieldsQuery, TError, TData>,
) =>
  useQuery<GetOrganisationCustomFieldsQuery, TError, TData>(
    variables === undefined
      ? ['GetOrganisationCustomFields']
      : ['GetOrganisationCustomFields', variables],
    fetcher<
      GetOrganisationCustomFieldsQuery,
      GetOrganisationCustomFieldsQueryVariables
    >(GetOrganisationCustomFieldsDocument, variables),
    options,
  );
export const CreateCustomFieldDocument = `
    mutation CreateCustomField($input: CreateCustomFieldInputType!) {
  createCustomField(input: $input) {
    id
    label
    identifier
    description
    fieldType
    status
    displayOrder
    options
    sectionId
    isStandard
    createdAt
    updatedAt
  }
}
    `;
export const useCreateCustomFieldMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    CreateCustomFieldMutation,
    TError,
    CreateCustomFieldMutationVariables,
    TContext
  >,
) =>
  useMutation<
    CreateCustomFieldMutation,
    TError,
    CreateCustomFieldMutationVariables,
    TContext
  >(
    ['CreateCustomField'],
    (variables?: CreateCustomFieldMutationVariables) =>
      fetcher<CreateCustomFieldMutation, CreateCustomFieldMutationVariables>(
        CreateCustomFieldDocument,
        variables,
      )(),
    options,
  );
export const UpdateCustomFieldDocument = `
    mutation UpdateCustomField($input: UpdateCustomFieldInputType!) {
  updateCustomField(input: $input) {
    id
    label
    identifier
    description
    fieldType
    status
    displayOrder
    options
    sectionId
    isStandard
    createdAt
    updatedAt
  }
}
    `;
export const useUpdateCustomFieldMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateCustomFieldMutation,
    TError,
    UpdateCustomFieldMutationVariables,
    TContext
  >,
) =>
  useMutation<
    UpdateCustomFieldMutation,
    TError,
    UpdateCustomFieldMutationVariables,
    TContext
  >(
    ['UpdateCustomField'],
    (variables?: UpdateCustomFieldMutationVariables) =>
      fetcher<UpdateCustomFieldMutation, UpdateCustomFieldMutationVariables>(
        UpdateCustomFieldDocument,
        variables,
      )(),
    options,
  );
export const ReorderCustomFieldsDocument = `
    mutation ReorderCustomFields($input: ReorderCustomFieldsInputType!) {
  reorderCustomFields(input: $input) {
    id
    displayOrder
  }
}
    `;
export const useReorderCustomFieldsMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    ReorderCustomFieldsMutation,
    TError,
    ReorderCustomFieldsMutationVariables,
    TContext
  >,
) =>
  useMutation<
    ReorderCustomFieldsMutation,
    TError,
    ReorderCustomFieldsMutationVariables,
    TContext
  >(
    ['ReorderCustomFields'],
    (variables?: ReorderCustomFieldsMutationVariables) =>
      fetcher<
        ReorderCustomFieldsMutation,
        ReorderCustomFieldsMutationVariables
      >(ReorderCustomFieldsDocument, variables)(),
    options,
  );
export const DeactivateCustomFieldDocument = `
    mutation DeactivateCustomField($input: DeactivateCustomFieldInputType!) {
  deactivateCustomField(input: $input)
}
    `;
export const useDeactivateCustomFieldMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    DeactivateCustomFieldMutation,
    TError,
    DeactivateCustomFieldMutationVariables,
    TContext
  >,
) =>
  useMutation<
    DeactivateCustomFieldMutation,
    TError,
    DeactivateCustomFieldMutationVariables,
    TContext
  >(
    ['DeactivateCustomField'],
    (variables?: DeactivateCustomFieldMutationVariables) =>
      fetcher<
        DeactivateCustomFieldMutation,
        DeactivateCustomFieldMutationVariables
      >(DeactivateCustomFieldDocument, variables)(),
    options,
  );
export const UpdateCustomFieldOptionsDocument = `
    mutation UpdateCustomFieldOptions($input: UpdateCustomFieldOptionsInputType!) {
  updateCustomFieldOptions(input: $input) {
    id
    customFieldId
    label
    displayOrder
    isActive
    createdAt
    updatedAt
  }
}
    `;
export const useUpdateCustomFieldOptionsMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateCustomFieldOptionsMutation,
    TError,
    UpdateCustomFieldOptionsMutationVariables,
    TContext
  >,
) =>
  useMutation<
    UpdateCustomFieldOptionsMutation,
    TError,
    UpdateCustomFieldOptionsMutationVariables,
    TContext
  >(
    ['UpdateCustomFieldOptions'],
    (variables?: UpdateCustomFieldOptionsMutationVariables) =>
      fetcher<
        UpdateCustomFieldOptionsMutation,
        UpdateCustomFieldOptionsMutationVariables
      >(UpdateCustomFieldOptionsDocument, variables)(),
    options,
  );
export const ReactivateCustomFieldDocument = `
    mutation ReactivateCustomField($input: ReactivateCustomFieldInputType!) {
  reactivateCustomField(input: $input)
}
    `;
export const useReactivateCustomFieldMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    ReactivateCustomFieldMutation,
    TError,
    ReactivateCustomFieldMutationVariables,
    TContext
  >,
) =>
  useMutation<
    ReactivateCustomFieldMutation,
    TError,
    ReactivateCustomFieldMutationVariables,
    TContext
  >(
    ['ReactivateCustomField'],
    (variables?: ReactivateCustomFieldMutationVariables) =>
      fetcher<
        ReactivateCustomFieldMutation,
        ReactivateCustomFieldMutationVariables
      >(ReactivateCustomFieldDocument, variables)(),
    options,
  );
export const GetOrganisationQuestionnairesDocument = `
    query GetOrganisationQuestionnaires($queryParams: QuestionnairesQueryParamsType) {
  organisationQuestionnaires(queryParams: $queryParams) {
    id
    internalName
    publicTitle
    accessScope
    languageId
    version
    status
    isActive
    createdAt
    updatedAt
    description
    categoryId
  }
}
    `;
export const useGetOrganisationQuestionnairesQuery = <
  TData = GetOrganisationQuestionnairesQuery,
  TError = unknown,
>(
  variables?: GetOrganisationQuestionnairesQueryVariables,
  options?: UseQueryOptions<GetOrganisationQuestionnairesQuery, TError, TData>,
) =>
  useQuery<GetOrganisationQuestionnairesQuery, TError, TData>(
    variables === undefined
      ? ['GetOrganisationQuestionnaires']
      : ['GetOrganisationQuestionnaires', variables],
    fetcher<
      GetOrganisationQuestionnairesQuery,
      GetOrganisationQuestionnairesQueryVariables
    >(GetOrganisationQuestionnairesDocument, variables),
    options,
  );
export const GetQuestionnaireQuestionsDocument = `
    query GetQuestionnaireQuestions($questionnaireId: String!) {
  questionnaireQuestions(questionnaireId: $questionnaireId) {
    questions {
      id
      questionText
      description
      questionType {
        id
        typeKey
        label
        allowsOptions
      }
      isRequired
      interestTypeId
      attachmentAllowed
      databaseFieldSubTypeId
      allowMultiSelect
      orderIndex
      languageId
      questionnaireId
      options {
        id
        optionText
        optionOrder
      }
      dataGridConfig {
        columns {
          key
          label
          type
        }
        minRows
        maxRows
        addRowLabel
        removeRowLabel
      }
      databaseFieldSubType {
        subTypeKey
      }
      createdAt
      updatedAt
    }
    count
  }
}
    `;
export const useGetQuestionnaireQuestionsQuery = <
  TData = GetQuestionnaireQuestionsQuery,
  TError = unknown,
>(
  variables: GetQuestionnaireQuestionsQueryVariables,
  options?: UseQueryOptions<GetQuestionnaireQuestionsQuery, TError, TData>,
) =>
  useQuery<GetQuestionnaireQuestionsQuery, TError, TData>(
    ['GetQuestionnaireQuestions', variables],
    fetcher<
      GetQuestionnaireQuestionsQuery,
      GetQuestionnaireQuestionsQueryVariables
    >(GetQuestionnaireQuestionsDocument, variables),
    options,
  );
export const CreateQuestionnaireResponseDocument = `
    mutation CreateQuestionnaireResponse($questionnaireId: String!, $reportId: String) {
  createQuestionnaireResponse(
    questionnaireId: $questionnaireId
    reportId: $reportId
  ) {
    responseId
  }
}
    `;
export const useCreateQuestionnaireResponseMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    CreateQuestionnaireResponseMutation,
    TError,
    CreateQuestionnaireResponseMutationVariables,
    TContext
  >,
) =>
  useMutation<
    CreateQuestionnaireResponseMutation,
    TError,
    CreateQuestionnaireResponseMutationVariables,
    TContext
  >(
    ['CreateQuestionnaireResponse'],
    (variables?: CreateQuestionnaireResponseMutationVariables) =>
      fetcher<
        CreateQuestionnaireResponseMutation,
        CreateQuestionnaireResponseMutationVariables
      >(CreateQuestionnaireResponseDocument, variables)(),
    options,
  );
export const SaveResponseAnswersDocument = `
    mutation SaveResponseAnswers($responseId: String!, $answers: [SaveAnswerInputType!]!, $reportId: String) {
  saveResponseAnswers(
    responseId: $responseId
    answers: $answers
    reportId: $reportId
  )
}
    `;
export const useSaveResponseAnswersMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    SaveResponseAnswersMutation,
    TError,
    SaveResponseAnswersMutationVariables,
    TContext
  >,
) =>
  useMutation<
    SaveResponseAnswersMutation,
    TError,
    SaveResponseAnswersMutationVariables,
    TContext
  >(
    ['SaveResponseAnswers'],
    (variables?: SaveResponseAnswersMutationVariables) =>
      fetcher<
        SaveResponseAnswersMutation,
        SaveResponseAnswersMutationVariables
      >(SaveResponseAnswersDocument, variables)(),
    options,
  );
export const RegisterQuestionnaireResponseAttachmentDocument = `
    mutation RegisterQuestionnaireResponseAttachment($responseId: String!, $reportId: String!, $questionId: String!, $evidenceS3Path: String!) {
  registerQuestionnaireResponseAttachment(
    responseId: $responseId
    reportId: $reportId
    questionId: $questionId
    evidenceS3Path: $evidenceS3Path
  ) {
    attachment {
      id
      answerId
      fileName
      fileKey
      fileSize
      mimeType
      fileExtension
      uploadedAt
    }
  }
}
    `;
export const useRegisterQuestionnaireResponseAttachmentMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    RegisterQuestionnaireResponseAttachmentMutation,
    TError,
    RegisterQuestionnaireResponseAttachmentMutationVariables,
    TContext
  >,
) =>
  useMutation<
    RegisterQuestionnaireResponseAttachmentMutation,
    TError,
    RegisterQuestionnaireResponseAttachmentMutationVariables,
    TContext
  >(
    ['RegisterQuestionnaireResponseAttachment'],
    (variables?: RegisterQuestionnaireResponseAttachmentMutationVariables) =>
      fetcher<
        RegisterQuestionnaireResponseAttachmentMutation,
        RegisterQuestionnaireResponseAttachmentMutationVariables
      >(RegisterQuestionnaireResponseAttachmentDocument, variables)(),
    options,
  );
export const DeleteQuestionnaireResponseAttachmentDocument = `
    mutation DeleteQuestionnaireResponseAttachment($responseId: String!, $attachmentId: String!, $reportId: String) {
  deleteQuestionnaireResponseAttachment(
    responseId: $responseId
    attachmentId: $attachmentId
    reportId: $reportId
  )
}
    `;
export const useDeleteQuestionnaireResponseAttachmentMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    DeleteQuestionnaireResponseAttachmentMutation,
    TError,
    DeleteQuestionnaireResponseAttachmentMutationVariables,
    TContext
  >,
) =>
  useMutation<
    DeleteQuestionnaireResponseAttachmentMutation,
    TError,
    DeleteQuestionnaireResponseAttachmentMutationVariables,
    TContext
  >(
    ['DeleteQuestionnaireResponseAttachment'],
    (variables?: DeleteQuestionnaireResponseAttachmentMutationVariables) =>
      fetcher<
        DeleteQuestionnaireResponseAttachmentMutation,
        DeleteQuestionnaireResponseAttachmentMutationVariables
      >(DeleteQuestionnaireResponseAttachmentDocument, variables)(),
    options,
  );
export const SubmitQuestionnaireResponseDocument = `
    mutation SubmitQuestionnaireResponse($responseId: String!, $attestationAccepted: Boolean!) {
  submitQuestionnaireResponse(
    responseId: $responseId
    attestationAccepted: $attestationAccepted
  )
}
    `;
export const useSubmitQuestionnaireResponseMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    SubmitQuestionnaireResponseMutation,
    TError,
    SubmitQuestionnaireResponseMutationVariables,
    TContext
  >,
) =>
  useMutation<
    SubmitQuestionnaireResponseMutation,
    TError,
    SubmitQuestionnaireResponseMutationVariables,
    TContext
  >(
    ['SubmitQuestionnaireResponse'],
    (variables?: SubmitQuestionnaireResponseMutationVariables) =>
      fetcher<
        SubmitQuestionnaireResponseMutation,
        SubmitQuestionnaireResponseMutationVariables
      >(SubmitQuestionnaireResponseDocument, variables)(),
    options,
  );
export const DeleteQuestionnaireResponseDocument = `
    mutation DeleteQuestionnaireResponse($responseId: String!) {
  deleteQuestionnaireResponse(responseId: $responseId)
}
    `;
export const useDeleteQuestionnaireResponseMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    DeleteQuestionnaireResponseMutation,
    TError,
    DeleteQuestionnaireResponseMutationVariables,
    TContext
  >,
) =>
  useMutation<
    DeleteQuestionnaireResponseMutation,
    TError,
    DeleteQuestionnaireResponseMutationVariables,
    TContext
  >(
    ['DeleteQuestionnaireResponse'],
    (variables?: DeleteQuestionnaireResponseMutationVariables) =>
      fetcher<
        DeleteQuestionnaireResponseMutation,
        DeleteQuestionnaireResponseMutationVariables
      >(DeleteQuestionnaireResponseDocument, variables)(),
    options,
  );
export const GetGlobalFeaturesDocument = `
    query GetGlobalFeatures {
  getGlobalFeatures {
    id
    key
    enabled
  }
}
    `;
export const useGetGlobalFeaturesQuery = <
  TData = GetGlobalFeaturesQuery,
  TError = unknown,
>(
  variables?: GetGlobalFeaturesQueryVariables,
  options?: UseQueryOptions<GetGlobalFeaturesQuery, TError, TData>,
) =>
  useQuery<GetGlobalFeaturesQuery, TError, TData>(
    variables === undefined
      ? ['GetGlobalFeatures']
      : ['GetGlobalFeatures', variables],
    fetcher<GetGlobalFeaturesQuery, GetGlobalFeaturesQueryVariables>(
      GetGlobalFeaturesDocument,
      variables,
    ),
    options,
  );
export const GetPublicFeaturesDocument = `
    query GetPublicFeatures($slug: String!) {
  getPublicFeatures(slug: $slug) {
    id
    key
    enabled
  }
}
    `;
export const useGetPublicFeaturesQuery = <
  TData = GetPublicFeaturesQuery,
  TError = unknown,
>(
  variables: GetPublicFeaturesQueryVariables,
  options?: UseQueryOptions<GetPublicFeaturesQuery, TError, TData>,
) =>
  useQuery<GetPublicFeaturesQuery, TError, TData>(
    ['GetPublicFeatures', variables],
    fetcher<GetPublicFeaturesQuery, GetPublicFeaturesQueryVariables>(
      GetPublicFeaturesDocument,
      variables,
    ),
    options,
  );
export const GetOrganisationFeaturesDocument = `
    query GetOrganisationFeatures {
  getOrganisationFeatures {
    id
    key
    enabled
  }
}
    `;
export const useGetOrganisationFeaturesQuery = <
  TData = GetOrganisationFeaturesQuery,
  TError = unknown,
>(
  variables?: GetOrganisationFeaturesQueryVariables,
  options?: UseQueryOptions<GetOrganisationFeaturesQuery, TError, TData>,
) =>
  useQuery<GetOrganisationFeaturesQuery, TError, TData>(
    variables === undefined
      ? ['GetOrganisationFeatures']
      : ['GetOrganisationFeatures', variables],
    fetcher<
      GetOrganisationFeaturesQuery,
      GetOrganisationFeaturesQueryVariables
    >(GetOrganisationFeaturesDocument, variables),
    options,
  );
export const GetFormCategoriesDocument = `
    query GetFormCategories {
  formCategories {
    formCategories {
      id
      categoryKey
      label
      description
      isActive
    }
    count
  }
}
    `;
export const useGetFormCategoriesQuery = <
  TData = GetFormCategoriesQuery,
  TError = unknown,
>(
  variables?: GetFormCategoriesQueryVariables,
  options?: UseQueryOptions<GetFormCategoriesQuery, TError, TData>,
) =>
  useQuery<GetFormCategoriesQuery, TError, TData>(
    variables === undefined
      ? ['GetFormCategories']
      : ['GetFormCategories', variables],
    fetcher<GetFormCategoriesQuery, GetFormCategoriesQueryVariables>(
      GetFormCategoriesDocument,
      variables,
    ),
    options,
  );
export const FormManagementQuestionnairesDocument = `
    query FormManagementQuestionnaires($filters: QuestionnaireFilterInput) {
  formManagementQuestionnaires(filters: $filters) {
    id
    internalName
    publicTitle
    description
    accessScope
    languages {
      id
      code
      name
      isDefault
    }
    version
    status
    isActive
    createdBy {
      id
      name
      email
    }
    formCategory {
      id
      categoryKey
      label
    }
    category
    categoryId
    stats {
      totalQuestions
    }
    countries {
      countryCode
      countryName
    }
    createdAt
    updatedAt
  }
}
    `;
export const useFormManagementQuestionnairesQuery = <
  TData = FormManagementQuestionnairesQuery,
  TError = unknown,
>(
  variables?: FormManagementQuestionnairesQueryVariables,
  options?: UseQueryOptions<FormManagementQuestionnairesQuery, TError, TData>,
) =>
  useQuery<FormManagementQuestionnairesQuery, TError, TData>(
    variables === undefined
      ? ['FormManagementQuestionnaires']
      : ['FormManagementQuestionnaires', variables],
    fetcher<
      FormManagementQuestionnairesQuery,
      FormManagementQuestionnairesQueryVariables
    >(FormManagementQuestionnairesDocument, variables),
    options,
  );
export const FormManagementQuestionnaireByIdDocument = `
    query FormManagementQuestionnaireById($id: String!) {
  formManagementQuestionnaireById(id: $id) {
    id
    organizationId
    internalName
    publicTitle
    description
    introduction
    accessScope
    targetDepartmentIds
    languages {
      id
      code
      name
      isDefault
    }
    questionnaireTranslations {
      id
      languageCode
      languageName
      publicTitle
      description
    }
    version
    status
    isActive
    createdBy {
      id
      name
      email
    }
    masterQuestionnaireId
    formCategory {
      id
      categoryKey
      label
    }
    category
    categoryId
    autoReviewEnabled
    countries {
      countryCode
      countryName
    }
    createdAt
    updatedAt
  }
}
    `;
export const useFormManagementQuestionnaireByIdQuery = <
  TData = FormManagementQuestionnaireByIdQuery,
  TError = unknown,
>(
  variables: FormManagementQuestionnaireByIdQueryVariables,
  options?: UseQueryOptions<
    FormManagementQuestionnaireByIdQuery,
    TError,
    TData
  >,
) =>
  useQuery<FormManagementQuestionnaireByIdQuery, TError, TData>(
    ['FormManagementQuestionnaireById', variables],
    fetcher<
      FormManagementQuestionnaireByIdQuery,
      FormManagementQuestionnaireByIdQueryVariables
    >(FormManagementQuestionnaireByIdDocument, variables),
    options,
  );
export const DuplicateFormManagementQuestionnaireDocument = `
    mutation DuplicateFormManagementQuestionnaire($id: String!, $input: DuplicateQuestionnaireInput!) {
  duplicateFormManagementQuestionnaire(id: $id, input: $input) {
    id
    internalName
    publicTitle
    description
    accessScope
    languages {
      id
      code
      name
      isDefault
    }
    version
    status
    isActive
    createdBy {
      id
      name
      email
    }
    formCategory {
      id
      categoryKey
      label
    }
    category
    autoReviewEnabled
    createdAt
    updatedAt
  }
}
    `;
export const useDuplicateFormManagementQuestionnaireMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    DuplicateFormManagementQuestionnaireMutation,
    TError,
    DuplicateFormManagementQuestionnaireMutationVariables,
    TContext
  >,
) =>
  useMutation<
    DuplicateFormManagementQuestionnaireMutation,
    TError,
    DuplicateFormManagementQuestionnaireMutationVariables,
    TContext
  >(
    ['DuplicateFormManagementQuestionnaire'],
    (variables?: DuplicateFormManagementQuestionnaireMutationVariables) =>
      fetcher<
        DuplicateFormManagementQuestionnaireMutation,
        DuplicateFormManagementQuestionnaireMutationVariables
      >(DuplicateFormManagementQuestionnaireDocument, variables)(),
    options,
  );
export const UpdateFormManagementQuestionnaireStatusDocument = `
    mutation UpdateFormManagementQuestionnaireStatus($id: String!, $input: UpdateQuestionnaireStatusInput!) {
  updateFormManagementQuestionnaireStatus(id: $id, input: $input) {
    id
    internalName
    publicTitle
    description
    accessScope
    languages {
      id
      code
      name
      isDefault
    }
    version
    status
    isActive
    createdBy {
      id
      name
      email
    }
    formCategory {
      id
      categoryKey
      label
    }
    category
    autoReviewEnabled
    createdAt
    updatedAt
  }
}
    `;
export const useUpdateFormManagementQuestionnaireStatusMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateFormManagementQuestionnaireStatusMutation,
    TError,
    UpdateFormManagementQuestionnaireStatusMutationVariables,
    TContext
  >,
) =>
  useMutation<
    UpdateFormManagementQuestionnaireStatusMutation,
    TError,
    UpdateFormManagementQuestionnaireStatusMutationVariables,
    TContext
  >(
    ['UpdateFormManagementQuestionnaireStatus'],
    (variables?: UpdateFormManagementQuestionnaireStatusMutationVariables) =>
      fetcher<
        UpdateFormManagementQuestionnaireStatusMutation,
        UpdateFormManagementQuestionnaireStatusMutationVariables
      >(UpdateFormManagementQuestionnaireStatusDocument, variables)(),
    options,
  );
export const FormManagementQuestionsDocument = `
    query FormManagementQuestions($questionnaireId: String!) {
  formManagementQuestions(questionnaireId: $questionnaireId) {
    questions {
      id
      questionnaireId
      orderIndex
      questionText
      description
      questionType {
        id
        typeKey
        label
        allowsOptions
      }
      isRequired
      interestTypeId
      attachmentAllowed
      databaseFieldSubTypeId
      allowMultiSelect
      shouldAutoFlagIfAnswered
      translations {
        id
        languageCode
        questionText
        description
      }
      options {
        id
        optionText
        optionOrder
        navigationAction
        targetQuestionId
        shouldAutoFlag
        translations {
          id
          languageCode
          optionText
        }
      }
      dataGridConfig {
        columns {
          key
          label
          type
          required
          maxLength
          options
          min
          max
          translations {
            languageCode
            label
          }
        }
        minRows
        maxRows
        addRowLabel
        removeRowLabel
      }
      languageId
      createdAt
      updatedAt
    }
    count
  }
}
    `;
export const useFormManagementQuestionsQuery = <
  TData = FormManagementQuestionsQuery,
  TError = unknown,
>(
  variables: FormManagementQuestionsQueryVariables,
  options?: UseQueryOptions<FormManagementQuestionsQuery, TError, TData>,
) =>
  useQuery<FormManagementQuestionsQuery, TError, TData>(
    ['FormManagementQuestions', variables],
    fetcher<
      FormManagementQuestionsQuery,
      FormManagementQuestionsQueryVariables
    >(FormManagementQuestionsDocument, variables),
    options,
  );
export const FormManagementActivityLogDocument = `
    query FormManagementActivityLog($filters: OrgActivityLogFilterInput) {
  formManagementActivityLog(filters: $filters) {
    data {
      id
      timestamp
      entityType
      entityId
      entityName
      action
      eventDisplayName
      user {
        userId
        name
        email
      }
      parentEntityId
      parentEntityName
      formCategory {
        id
        categoryKey
        label
      }
      metadata
    }
    pagination {
      page
      limit
      totalItems
      totalPages
      hasNext
      hasPrevious
    }
  }
}
    `;
export const useFormManagementActivityLogQuery = <
  TData = FormManagementActivityLogQuery,
  TError = unknown,
>(
  variables?: FormManagementActivityLogQueryVariables,
  options?: UseQueryOptions<FormManagementActivityLogQuery, TError, TData>,
) =>
  useQuery<FormManagementActivityLogQuery, TError, TData>(
    variables === undefined
      ? ['FormManagementActivityLog']
      : ['FormManagementActivityLog', variables],
    fetcher<
      FormManagementActivityLogQuery,
      FormManagementActivityLogQueryVariables
    >(FormManagementActivityLogDocument, variables),
    options,
  );
export const FormManagementQuestionnaireActivityLogDocument = `
    query FormManagementQuestionnaireActivityLog($questionnaireId: String!, $filters: QuestionnaireActivityLogFilterInput) {
  formManagementQuestionnaireActivityLog(
    questionnaireId: $questionnaireId
    filters: $filters
  ) {
    data {
      id
      timestamp
      entityType
      entityId
      entityName
      action
      eventDisplayName
      user {
        userId
        name
        email
      }
      parentEntityId
      parentEntityName
      formCategory {
        id
        categoryKey
        label
      }
      metadata
    }
    pagination {
      page
      limit
      totalItems
      totalPages
      hasNext
      hasPrevious
    }
  }
}
    `;
export const useFormManagementQuestionnaireActivityLogQuery = <
  TData = FormManagementQuestionnaireActivityLogQuery,
  TError = unknown,
>(
  variables: FormManagementQuestionnaireActivityLogQueryVariables,
  options?: UseQueryOptions<
    FormManagementQuestionnaireActivityLogQuery,
    TError,
    TData
  >,
) =>
  useQuery<FormManagementQuestionnaireActivityLogQuery, TError, TData>(
    ['FormManagementQuestionnaireActivityLog', variables],
    fetcher<
      FormManagementQuestionnaireActivityLogQuery,
      FormManagementQuestionnaireActivityLogQueryVariables
    >(FormManagementQuestionnaireActivityLogDocument, variables),
    options,
  );
export const CreateFormManagementQuestionnaireDocument = `
    mutation CreateFormManagementQuestionnaire($input: CreateQuestionnaireInput!) {
  createFormManagementQuestionnaire(input: $input) {
    id
    organizationId
    internalName
    publicTitle
    description
    introduction
    accessScope
    targetDepartmentIds
    languages {
      id
      code
      name
      isDefault
    }
    questionnaireTranslations {
      id
      languageCode
      languageName
      publicTitle
      description
    }
    version
    status
    isActive
    createdBy {
      id
      name
      email
    }
    masterQuestionnaireId
    formCategory {
      id
      categoryKey
      label
    }
    category
    countries {
      countryCode
      countryName
    }
    createdAt
    updatedAt
  }
}
    `;
export const useCreateFormManagementQuestionnaireMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    CreateFormManagementQuestionnaireMutation,
    TError,
    CreateFormManagementQuestionnaireMutationVariables,
    TContext
  >,
) =>
  useMutation<
    CreateFormManagementQuestionnaireMutation,
    TError,
    CreateFormManagementQuestionnaireMutationVariables,
    TContext
  >(
    ['CreateFormManagementQuestionnaire'],
    (variables?: CreateFormManagementQuestionnaireMutationVariables) =>
      fetcher<
        CreateFormManagementQuestionnaireMutation,
        CreateFormManagementQuestionnaireMutationVariables
      >(CreateFormManagementQuestionnaireDocument, variables)(),
    options,
  );
export const UpdateFormManagementQuestionnaireDocument = `
    mutation UpdateFormManagementQuestionnaire($id: String!, $input: UpdateQuestionnaireInput!) {
  updateFormManagementQuestionnaire(id: $id, input: $input) {
    id
    organizationId
    internalName
    publicTitle
    description
    introduction
    accessScope
    targetDepartmentIds
    languages {
      id
      code
      name
      isDefault
    }
    questionnaireTranslations {
      id
      languageCode
      languageName
      publicTitle
      description
    }
    version
    status
    isActive
    createdBy {
      id
      name
      email
    }
    masterQuestionnaireId
    formCategory {
      id
      categoryKey
      label
    }
    category
    countries {
      countryCode
      countryName
    }
    createdAt
    updatedAt
  }
}
    `;
export const useUpdateFormManagementQuestionnaireMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateFormManagementQuestionnaireMutation,
    TError,
    UpdateFormManagementQuestionnaireMutationVariables,
    TContext
  >,
) =>
  useMutation<
    UpdateFormManagementQuestionnaireMutation,
    TError,
    UpdateFormManagementQuestionnaireMutationVariables,
    TContext
  >(
    ['UpdateFormManagementQuestionnaire'],
    (variables?: UpdateFormManagementQuestionnaireMutationVariables) =>
      fetcher<
        UpdateFormManagementQuestionnaireMutation,
        UpdateFormManagementQuestionnaireMutationVariables
      >(UpdateFormManagementQuestionnaireDocument, variables)(),
    options,
  );
export const DeleteFormManagementQuestionnaireDocument = `
    mutation DeleteFormManagementQuestionnaire($id: String!) {
  deleteFormManagementQuestionnaire(id: $id) {
    success
    message
  }
}
    `;
export const useDeleteFormManagementQuestionnaireMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    DeleteFormManagementQuestionnaireMutation,
    TError,
    DeleteFormManagementQuestionnaireMutationVariables,
    TContext
  >,
) =>
  useMutation<
    DeleteFormManagementQuestionnaireMutation,
    TError,
    DeleteFormManagementQuestionnaireMutationVariables,
    TContext
  >(
    ['DeleteFormManagementQuestionnaire'],
    (variables?: DeleteFormManagementQuestionnaireMutationVariables) =>
      fetcher<
        DeleteFormManagementQuestionnaireMutation,
        DeleteFormManagementQuestionnaireMutationVariables
      >(DeleteFormManagementQuestionnaireDocument, variables)(),
    options,
  );
export const TranslateFormDraftContentDocument = `
    mutation TranslateFormDraftContent($input: TranslateFormDraftContentInput!) {
  translateFormDraftContent(input: $input) {
    formTitle
    formDescription
    introduction
    warnings
    questions {
      orderIndex
      questionText
      description
      options {
        optionOrder
        optionText
      }
    }
  }
}
    `;
export const useTranslateFormDraftContentMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    TranslateFormDraftContentMutation,
    TError,
    TranslateFormDraftContentMutationVariables,
    TContext
  >,
) =>
  useMutation<
    TranslateFormDraftContentMutation,
    TError,
    TranslateFormDraftContentMutationVariables,
    TContext
  >(
    ['TranslateFormDraftContent'],
    (variables?: TranslateFormDraftContentMutationVariables) =>
      fetcher<
        TranslateFormDraftContentMutation,
        TranslateFormDraftContentMutationVariables
      >(TranslateFormDraftContentDocument, variables)(),
    options,
  );
export const BulkCreateFormManagementQuestionsDocument = `
    mutation BulkCreateFormManagementQuestions($questionnaireId: String!, $input: BulkUpsertQuestionsInput!) {
  bulkCreateFormManagementQuestions(
    questionnaireId: $questionnaireId
    input: $input
  ) {
    summary {
      created
      updated
      deleted
      total
    }
    questions {
      id
      questionnaireId
      orderIndex
      questionText
      description
      questionType {
        id
        typeKey
        label
        allowsOptions
      }
      isRequired
      interestTypeId
      attachmentAllowed
      databaseFieldSubTypeId
      allowMultiSelect
      shouldAutoFlagIfAnswered
      translations {
        id
        languageCode
        questionText
        description
      }
      options {
        id
        optionText
        optionOrder
        navigationAction
        targetQuestionId
        shouldAutoFlag
        translations {
          id
          languageCode
          optionText
        }
      }
      dataGridConfig {
        columns {
          key
          label
          type
          required
          maxLength
          options
          min
          max
          translations {
            languageCode
            label
          }
        }
        minRows
        maxRows
        addRowLabel
        removeRowLabel
      }
      languageId
      createdAt
      updatedAt
    }
  }
}
    `;
export const useBulkCreateFormManagementQuestionsMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    BulkCreateFormManagementQuestionsMutation,
    TError,
    BulkCreateFormManagementQuestionsMutationVariables,
    TContext
  >,
) =>
  useMutation<
    BulkCreateFormManagementQuestionsMutation,
    TError,
    BulkCreateFormManagementQuestionsMutationVariables,
    TContext
  >(
    ['BulkCreateFormManagementQuestions'],
    (variables?: BulkCreateFormManagementQuestionsMutationVariables) =>
      fetcher<
        BulkCreateFormManagementQuestionsMutation,
        BulkCreateFormManagementQuestionsMutationVariables
      >(BulkCreateFormManagementQuestionsDocument, variables)(),
    options,
  );
export const GetQuestionTypesDocument = `
    query GetQuestionTypes($formCategoryId: String) {
  getQuestionTypes(formCategoryId: $formCategoryId) {
    questionTypes {
      id
      typeKey
      label
      description
      allowsOptions
      databaseFieldSubTypes {
        id
        subTypeKey
        label
        description
      }
    }
    count
  }
}
    `;
export const useGetQuestionTypesQuery = <
  TData = GetQuestionTypesQuery,
  TError = unknown,
>(
  variables?: GetQuestionTypesQueryVariables,
  options?: UseQueryOptions<GetQuestionTypesQuery, TError, TData>,
) =>
  useQuery<GetQuestionTypesQuery, TError, TData>(
    variables === undefined
      ? ['GetQuestionTypes']
      : ['GetQuestionTypes', variables],
    fetcher<GetQuestionTypesQuery, GetQuestionTypesQueryVariables>(
      GetQuestionTypesDocument,
      variables,
    ),
    options,
  );
export const CreateGroupDocument = `
    mutation CreateGroup($parameters: GroupCreationType!) {
  createGroup(parameters: $parameters) {
    id
    name
    description
    createdBy
    attributes
  }
}
    `;
export const useCreateGroupMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    CreateGroupMutation,
    TError,
    CreateGroupMutationVariables,
    TContext
  >,
) =>
  useMutation<
    CreateGroupMutation,
    TError,
    CreateGroupMutationVariables,
    TContext
  >(
    ['CreateGroup'],
    (variables?: CreateGroupMutationVariables) =>
      fetcher<CreateGroupMutation, CreateGroupMutationVariables>(
        CreateGroupDocument,
        variables,
      )(),
    options,
  );
export const DeleteGroupDocument = `
    mutation DeleteGroup($id: String!) {
  deleteGroup(id: $id)
}
    `;
export const useDeleteGroupMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    DeleteGroupMutation,
    TError,
    DeleteGroupMutationVariables,
    TContext
  >,
) =>
  useMutation<
    DeleteGroupMutation,
    TError,
    DeleteGroupMutationVariables,
    TContext
  >(
    ['DeleteGroup'],
    (variables?: DeleteGroupMutationVariables) =>
      fetcher<DeleteGroupMutation, DeleteGroupMutationVariables>(
        DeleteGroupDocument,
        variables,
      )(),
    options,
  );
export const GroupUserCountDocument = `
    query GroupUserCount($groupUserCountId: String!) {
  groupUserCount(id: $groupUserCountId)
}
    `;
export const useGroupUserCountQuery = <
  TData = GroupUserCountQuery,
  TError = unknown,
>(
  variables: GroupUserCountQueryVariables,
  options?: UseQueryOptions<GroupUserCountQuery, TError, TData>,
) =>
  useQuery<GroupUserCountQuery, TError, TData>(
    ['GroupUserCount', variables],
    fetcher<GroupUserCountQuery, GroupUserCountQueryVariables>(
      GroupUserCountDocument,
      variables,
    ),
    options,
  );
export const GroupsDocument = `
    query Groups {
  orgGroups {
    id
    name
    description
    createdBy
    attributes
    createdAt
    CreatedBy {
      displayName
      name
    }
    ActiveCMCount
    ActiveCoiReviewerCount
    hasNonCOIReviewerMembers
  }
}
    `;
export const useGroupsQuery = <TData = GroupsQuery, TError = unknown>(
  variables?: GroupsQueryVariables,
  options?: UseQueryOptions<GroupsQuery, TError, TData>,
) =>
  useQuery<GroupsQuery, TError, TData>(
    variables === undefined ? ['Groups'] : ['Groups', variables],
    fetcher<GroupsQuery, GroupsQueryVariables>(GroupsDocument, variables),
    options,
  );
export const GroupsAttributesDataDocument = `
    query GroupsAttributesData {
  groupsAttributesData {
    department
    country
    site
    team
    systemRoles
  }
}
    `;
export const useGroupsAttributesDataQuery = <
  TData = GroupsAttributesDataQuery,
  TError = unknown,
>(
  variables?: GroupsAttributesDataQueryVariables,
  options?: UseQueryOptions<GroupsAttributesDataQuery, TError, TData>,
) =>
  useQuery<GroupsAttributesDataQuery, TError, TData>(
    variables === undefined
      ? ['GroupsAttributesData']
      : ['GroupsAttributesData', variables],
    fetcher<GroupsAttributesDataQuery, GroupsAttributesDataQueryVariables>(
      GroupsAttributesDataDocument,
      variables,
    ),
    options,
  );
export const UpdateGroupDocument = `
    mutation UpdateGroup($parameters: GroupUpdateType!) {
  updateGroup(parameters: $parameters) {
    attributes
    id
    name
    description
  }
}
    `;
export const useUpdateGroupMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    UpdateGroupMutation,
    TError,
    UpdateGroupMutationVariables,
    TContext
  >,
) =>
  useMutation<
    UpdateGroupMutation,
    TError,
    UpdateGroupMutationVariables,
    TContext
  >(
    ['UpdateGroup'],
    (variables?: UpdateGroupMutationVariables) =>
      fetcher<UpdateGroupMutation, UpdateGroupMutationVariables>(
        UpdateGroupDocument,
        variables,
      )(),
    options,
  );
export const AdoptionMetricsDocument = `
    query AdoptionMetrics {
  adoptionMetrics {
    category
    value
    description
    type
  }
}
    `;
export const useAdoptionMetricsQuery = <
  TData = AdoptionMetricsQuery,
  TError = unknown,
>(
  variables?: AdoptionMetricsQueryVariables,
  options?: UseQueryOptions<AdoptionMetricsQuery, TError, TData>,
) =>
  useQuery<AdoptionMetricsQuery, TError, TData>(
    variables === undefined
      ? ['AdoptionMetrics']
      : ['AdoptionMetrics', variables],
    fetcher<AdoptionMetricsQuery, AdoptionMetricsQueryVariables>(
      AdoptionMetricsDocument,
      variables,
    ),
    options,
  );
export const GetCasesPerWeekBarStackedDocument = `
    query GetCasesPerWeekBarStacked($casesType: barStackedCasesFiltersTypes!, $timeframe: TimeframeInput, $departments: [String!], $sites: [String!], $countries: [String!], $caseCountryCodes: [String!], $caseRegionIds: [String!], $categories: [String!]) {
  getCasesPerWeekBarStacked(
    CasesType: $casesType
    Timeframe: $timeframe
    departments: $departments
    sites: $sites
    countries: $countries
    caseCountryCodes: $caseCountryCodes
    caseRegionIds: $caseRegionIds
    categories: $categories
  ) {
    data {
      bar
      closed
      open
      total
    }
    stackLabels
    xTitle
    yTitle
  }
}
    `;
export const useGetCasesPerWeekBarStackedQuery = <
  TData = GetCasesPerWeekBarStackedQuery,
  TError = unknown,
>(
  variables: GetCasesPerWeekBarStackedQueryVariables,
  options?: UseQueryOptions<GetCasesPerWeekBarStackedQuery, TError, TData>,
) =>
  useQuery<GetCasesPerWeekBarStackedQuery, TError, TData>(
    ['GetCasesPerWeekBarStacked', variables],
    fetcher<
      GetCasesPerWeekBarStackedQuery,
      GetCasesPerWeekBarStackedQueryVariables
    >(GetCasesPerWeekBarStackedDocument, variables),
    options,
  );
export const GetIssueCategoriesByIntakeMethodGraphDocument = `
    query GetIssueCategoriesByIntakeMethodGraph($timeframe: TimeframeInput, $sites: [String!], $countries: [String!], $caseCountryCodes: [String!], $caseRegionIds: [String!], $departments: [String!], $categories: [String!]) {
  getIssueCategoriesByIntakeMethodGraph(
    Timeframe: $timeframe
    sites: $sites
    countries: $countries
    caseCountryCodes: $caseCountryCodes
    caseRegionIds: $caseRegionIds
    departments: $departments
    categories: $categories
  ) {
    data {
      categories {
        category
        total
      }
      donutSegment
      total
    }
    xTitle
    yTitle
    centerText
    maxCategoryTotal
  }
}
    `;
export const useGetIssueCategoriesByIntakeMethodGraphQuery = <
  TData = GetIssueCategoriesByIntakeMethodGraphQuery,
  TError = unknown,
>(
  variables?: GetIssueCategoriesByIntakeMethodGraphQueryVariables,
  options?: UseQueryOptions<
    GetIssueCategoriesByIntakeMethodGraphQuery,
    TError,
    TData
  >,
) =>
  useQuery<GetIssueCategoriesByIntakeMethodGraphQuery, TError, TData>(
    variables === undefined
      ? ['GetIssueCategoriesByIntakeMethodGraph']
      : ['GetIssueCategoriesByIntakeMethodGraph', variables],
    fetcher<
      GetIssueCategoriesByIntakeMethodGraphQuery,
      GetIssueCategoriesByIntakeMethodGraphQueryVariables
    >(GetIssueCategoriesByIntakeMethodGraphDocument, variables),
    options,
  );
export const GetSubstantiationStatusCountDocument = `
    query GetSubstantiationStatusCount($departments: [String!], $sites: [String!], $countries: [String!], $caseCountryCodes: [String!], $caseRegionIds: [String!], $timeframe: TimeframeInput, $categories: [String!]) {
  getSubstantiationStatusCount(
    departments: $departments
    sites: $sites
    countries: $countries
    caseCountryCodes: $caseCountryCodes
    caseRegionIds: $caseRegionIds
    Timeframe: $timeframe
    categories: $categories
  ) {
    data {
      bar
      label
      value
    }
    xTitle
    yTitle
  }
}
    `;
export const useGetSubstantiationStatusCountQuery = <
  TData = GetSubstantiationStatusCountQuery,
  TError = unknown,
>(
  variables?: GetSubstantiationStatusCountQueryVariables,
  options?: UseQueryOptions<GetSubstantiationStatusCountQuery, TError, TData>,
) =>
  useQuery<GetSubstantiationStatusCountQuery, TError, TData>(
    variables === undefined
      ? ['GetSubstantiationStatusCount']
      : ['GetSubstantiationStatusCount', variables],
    fetcher<
      GetSubstantiationStatusCountQuery,
      GetSubstantiationStatusCountQueryVariables
    >(GetSubstantiationStatusCountDocument, variables),
    options,
  );
export const GetIssueCategoriesByDepartmentGraphDocument = `
    query GetIssueCategoriesByDepartmentGraph($timeframe: TimeframeInput, $sites: [String!], $countries: [String!], $caseCountryCodes: [String!], $caseRegionIds: [String!], $departments: [String!], $categories: [String!]) {
  getIssueCategoriesByDepartmentGraph(
    Timeframe: $timeframe
    sites: $sites
    countries: $countries
    caseCountryCodes: $caseCountryCodes
    caseRegionIds: $caseRegionIds
    departments: $departments
    categories: $categories
  ) {
    data {
      categories {
        category
        total
      }
      donutSegment
      total
    }
    xTitle
    yTitle
    centerText
    maxCategoryTotal
  }
}
    `;
export const useGetIssueCategoriesByDepartmentGraphQuery = <
  TData = GetIssueCategoriesByDepartmentGraphQuery,
  TError = unknown,
>(
  variables?: GetIssueCategoriesByDepartmentGraphQueryVariables,
  options?: UseQueryOptions<
    GetIssueCategoriesByDepartmentGraphQuery,
    TError,
    TData
  >,
) =>
  useQuery<GetIssueCategoriesByDepartmentGraphQuery, TError, TData>(
    variables === undefined
      ? ['GetIssueCategoriesByDepartmentGraph']
      : ['GetIssueCategoriesByDepartmentGraph', variables],
    fetcher<
      GetIssueCategoriesByDepartmentGraphQuery,
      GetIssueCategoriesByDepartmentGraphQueryVariables
    >(GetIssueCategoriesByDepartmentGraphDocument, variables),
    options,
  );
export const GetReportsPerCategoryPerMonthGraphDocument = `
    query GetReportsPerCategoryPerMonthGraph($dateGroup: String!, $categories: [String!], $departments: [String!], $sites: [String!], $countries: [String!], $caseCountryCodes: [String!], $caseRegionIds: [String!], $timeframe: TimeframeInput) {
  getReportsPerCategoryPerMonthGraph(
    dateGroup: $dateGroup
    categories: $categories
    departments: $departments
    sites: $sites
    countries: $countries
    caseCountryCodes: $caseCountryCodes
    caseRegionIds: $caseRegionIds
    Timeframe: $timeframe
  ) {
    data {
      linePlot {
        count
        month
      }
      category
    }
    xTitle
    yTitle
  }
}
    `;
export const useGetReportsPerCategoryPerMonthGraphQuery = <
  TData = GetReportsPerCategoryPerMonthGraphQuery,
  TError = unknown,
>(
  variables: GetReportsPerCategoryPerMonthGraphQueryVariables,
  options?: UseQueryOptions<
    GetReportsPerCategoryPerMonthGraphQuery,
    TError,
    TData
  >,
) =>
  useQuery<GetReportsPerCategoryPerMonthGraphQuery, TError, TData>(
    ['GetReportsPerCategoryPerMonthGraph', variables],
    fetcher<
      GetReportsPerCategoryPerMonthGraphQuery,
      GetReportsPerCategoryPerMonthGraphQueryVariables
    >(GetReportsPerCategoryPerMonthGraphDocument, variables),
    options,
  );
export const InsightsOrganisationDataDocument = `
    query InsightsOrganisationData {
  organisation {
    id
    name
    insightsDepartments
    createdAt
    insightsReportCategories
    insightsCountries
    insightsSites
    insightsCaseCountryRegions {
      regions {
        id
        name
        countryCodes
      }
      countries {
        code
        name
      }
    }
    oldestReportSubmittedDate
    insightsCategories
  }
}
    `;
export const useInsightsOrganisationDataQuery = <
  TData = InsightsOrganisationDataQuery,
  TError = unknown,
>(
  variables?: InsightsOrganisationDataQueryVariables,
  options?: UseQueryOptions<InsightsOrganisationDataQuery, TError, TData>,
) =>
  useQuery<InsightsOrganisationDataQuery, TError, TData>(
    variables === undefined
      ? ['InsightsOrganisationData']
      : ['InsightsOrganisationData', variables],
    fetcher<
      InsightsOrganisationDataQuery,
      InsightsOrganisationDataQueryVariables
    >(InsightsOrganisationDataDocument, variables),
    options,
  );
export const GetTotalCasesHeroMetricDocument = `
    query GetTotalCasesHeroMetric($timeframe: TimeframeInput, $sites: [String!], $countries: [String!], $caseCountryCodes: [String!], $caseRegionIds: [String!]) {
  getTotalCasesHeroMetric(
    Timeframe: $timeframe
    sites: $sites
    countries: $countries
    caseCountryCodes: $caseCountryCodes
    caseRegionIds: $caseRegionIds
  ) {
    category
    tooltip
    descriptor
    subCategory {
      category
      count
    }
  }
}
    `;
export const useGetTotalCasesHeroMetricQuery = <
  TData = GetTotalCasesHeroMetricQuery,
  TError = unknown,
>(
  variables?: GetTotalCasesHeroMetricQueryVariables,
  options?: UseQueryOptions<GetTotalCasesHeroMetricQuery, TError, TData>,
) =>
  useQuery<GetTotalCasesHeroMetricQuery, TError, TData>(
    variables === undefined
      ? ['GetTotalCasesHeroMetric']
      : ['GetTotalCasesHeroMetric', variables],
    fetcher<
      GetTotalCasesHeroMetricQuery,
      GetTotalCasesHeroMetricQueryVariables
    >(GetTotalCasesHeroMetricDocument, variables),
    options,
  );
export const GetDepartmentWithMostCasesHeroMetricDocument = `
    query GetDepartmentWithMostCasesHeroMetric($timeframe: TimeframeInput, $sites: [String!], $countries: [String!], $caseCountryCodes: [String!], $caseRegionIds: [String!]) {
  getDepartmentWithMostCasesHeroMetric(
    Timeframe: $timeframe
    sites: $sites
    countries: $countries
    caseCountryCodes: $caseCountryCodes
    caseRegionIds: $caseRegionIds
  ) {
    category
    tooltip
    descriptor
    subCategory {
      category
      count
    }
  }
}
    `;
export const useGetDepartmentWithMostCasesHeroMetricQuery = <
  TData = GetDepartmentWithMostCasesHeroMetricQuery,
  TError = unknown,
>(
  variables?: GetDepartmentWithMostCasesHeroMetricQueryVariables,
  options?: UseQueryOptions<
    GetDepartmentWithMostCasesHeroMetricQuery,
    TError,
    TData
  >,
) =>
  useQuery<GetDepartmentWithMostCasesHeroMetricQuery, TError, TData>(
    variables === undefined
      ? ['GetDepartmentWithMostCasesHeroMetric']
      : ['GetDepartmentWithMostCasesHeroMetric', variables],
    fetcher<
      GetDepartmentWithMostCasesHeroMetricQuery,
      GetDepartmentWithMostCasesHeroMetricQueryVariables
    >(GetDepartmentWithMostCasesHeroMetricDocument, variables),
    options,
  );
export const GetTimeToResolutionHeroMetricDocument = `
    query GetTimeToResolutionHeroMetric($timeframe: TimeframeInput, $sites: [String!], $countries: [String!], $caseCountryCodes: [String!], $caseRegionIds: [String!]) {
  getTimeToResolutionHeroMetric(
    Timeframe: $timeframe
    sites: $sites
    countries: $countries
    caseCountryCodes: $caseCountryCodes
    caseRegionIds: $caseRegionIds
  ) {
    category
    tooltip
    subCategory {
      category
      count
    }
  }
}
    `;
export const useGetTimeToResolutionHeroMetricQuery = <
  TData = GetTimeToResolutionHeroMetricQuery,
  TError = unknown,
>(
  variables?: GetTimeToResolutionHeroMetricQueryVariables,
  options?: UseQueryOptions<GetTimeToResolutionHeroMetricQuery, TError, TData>,
) =>
  useQuery<GetTimeToResolutionHeroMetricQuery, TError, TData>(
    variables === undefined
      ? ['GetTimeToResolutionHeroMetric']
      : ['GetTimeToResolutionHeroMetric', variables],
    fetcher<
      GetTimeToResolutionHeroMetricQuery,
      GetTimeToResolutionHeroMetricQueryVariables
    >(GetTimeToResolutionHeroMetricDocument, variables),
    options,
  );
export const GetLocationWithMostCasesHeroMetricDocument = `
    query GetLocationWithMostCasesHeroMetric($timeframe: TimeframeInput, $sites: [String!], $countries: [String!], $caseCountryCodes: [String!], $caseRegionIds: [String!]) {
  getLocationWithMostCasesHeroMetric(
    Timeframe: $timeframe
    sites: $sites
    countries: $countries
    caseCountryCodes: $caseCountryCodes
    caseRegionIds: $caseRegionIds
  ) {
    tooltip
    descriptor
    category
    subCategory {
      count
      category
    }
  }
}
    `;
export const useGetLocationWithMostCasesHeroMetricQuery = <
  TData = GetLocationWithMostCasesHeroMetricQuery,
  TError = unknown,
>(
  variables?: GetLocationWithMostCasesHeroMetricQueryVariables,
  options?: UseQueryOptions<
    GetLocationWithMostCasesHeroMetricQuery,
    TError,
    TData
  >,
) =>
  useQuery<GetLocationWithMostCasesHeroMetricQuery, TError, TData>(
    variables === undefined
      ? ['GetLocationWithMostCasesHeroMetric']
      : ['GetLocationWithMostCasesHeroMetric', variables],
    fetcher<
      GetLocationWithMostCasesHeroMetricQuery,
      GetLocationWithMostCasesHeroMetricQueryVariables
    >(GetLocationWithMostCasesHeroMetricDocument, variables),
    options,
  );
export const GetTimeInStatusHeroMetricDocument = `
    query GetTimeInStatusHeroMetric($status: String!, $timeframe: TimeframeInput, $sites: [String!], $countries: [String!], $caseCountryCodes: [String!], $caseRegionIds: [String!]) {
  getTimeInStatusHeroMetric(
    status: $status
    Timeframe: $timeframe
    sites: $sites
    countries: $countries
    caseCountryCodes: $caseCountryCodes
    caseRegionIds: $caseRegionIds
  ) {
    category
    tooltip
    subCategory {
      category
      count
    }
  }
}
    `;
export const useGetTimeInStatusHeroMetricQuery = <
  TData = GetTimeInStatusHeroMetricQuery,
  TError = unknown,
>(
  variables: GetTimeInStatusHeroMetricQueryVariables,
  options?: UseQueryOptions<GetTimeInStatusHeroMetricQuery, TError, TData>,
) =>
  useQuery<GetTimeInStatusHeroMetricQuery, TError, TData>(
    ['GetTimeInStatusHeroMetric', variables],
    fetcher<
      GetTimeInStatusHeroMetricQuery,
      GetTimeInStatusHeroMetricQueryVariables
    >(GetTimeInStatusHeroMetricDocument, variables),
    options,
  );
export const GetCasesOver90DaysHeroMetricDocument = `
    query GetCasesOver90DaysHeroMetric($timeframe: TimeframeInput, $sites: [String!], $countries: [String!], $caseCountryCodes: [String!], $caseRegionIds: [String!]) {
  getCasesOver90DaysHeroMetric(
    Timeframe: $timeframe
    sites: $sites
    countries: $countries
    caseCountryCodes: $caseCountryCodes
    caseRegionIds: $caseRegionIds
  ) {
    category
    tooltip
    subCategory {
      category
      count
    }
  }
}
    `;
export const useGetCasesOver90DaysHeroMetricQuery = <
  TData = GetCasesOver90DaysHeroMetricQuery,
  TError = unknown,
>(
  variables?: GetCasesOver90DaysHeroMetricQueryVariables,
  options?: UseQueryOptions<GetCasesOver90DaysHeroMetricQuery, TError, TData>,
) =>
  useQuery<GetCasesOver90DaysHeroMetricQuery, TError, TData>(
    variables === undefined
      ? ['GetCasesOver90DaysHeroMetric']
      : ['GetCasesOver90DaysHeroMetric', variables],
    fetcher<
      GetCasesOver90DaysHeroMetricQuery,
      GetCasesOver90DaysHeroMetricQueryVariables
    >(GetCasesOver90DaysHeroMetricDocument, variables),
    options,
  );
export const GetMonthWithMostReportsHeroMetricDocument = `
    query GetMonthWithMostReportsHeroMetric($timeframe: TimeframeInput, $sites: [String!], $countries: [String!], $caseCountryCodes: [String!], $caseRegionIds: [String!]) {
  getMonthWithMostReportsHeroMetric(
    Timeframe: $timeframe
    sites: $sites
    countries: $countries
    caseCountryCodes: $caseCountryCodes
    caseRegionIds: $caseRegionIds
  ) {
    category
    descriptor
    subCategory {
      count
      category
    }
    tooltip
  }
}
    `;
export const useGetMonthWithMostReportsHeroMetricQuery = <
  TData = GetMonthWithMostReportsHeroMetricQuery,
  TError = unknown,
>(
  variables?: GetMonthWithMostReportsHeroMetricQueryVariables,
  options?: UseQueryOptions<
    GetMonthWithMostReportsHeroMetricQuery,
    TError,
    TData
  >,
) =>
  useQuery<GetMonthWithMostReportsHeroMetricQuery, TError, TData>(
    variables === undefined
      ? ['GetMonthWithMostReportsHeroMetric']
      : ['GetMonthWithMostReportsHeroMetric', variables],
    fetcher<
      GetMonthWithMostReportsHeroMetricQuery,
      GetMonthWithMostReportsHeroMetricQueryVariables
    >(GetMonthWithMostReportsHeroMetricDocument, variables),
    options,
  );
export const GetCategoryWithMostReportsHeroMetricDocument = `
    query GetCategoryWithMostReportsHeroMetric($timeframe: TimeframeInput, $sites: [String!], $countries: [String!], $caseCountryCodes: [String!], $caseRegionIds: [String!]) {
  getCategoryWithMostReportsHeroMetric(
    Timeframe: $timeframe
    sites: $sites
    countries: $countries
    caseCountryCodes: $caseCountryCodes
    caseRegionIds: $caseRegionIds
  ) {
    tooltip
    descriptor
    category
    subCategory {
      count
      category
    }
  }
}
    `;
export const useGetCategoryWithMostReportsHeroMetricQuery = <
  TData = GetCategoryWithMostReportsHeroMetricQuery,
  TError = unknown,
>(
  variables?: GetCategoryWithMostReportsHeroMetricQueryVariables,
  options?: UseQueryOptions<
    GetCategoryWithMostReportsHeroMetricQuery,
    TError,
    TData
  >,
) =>
  useQuery<GetCategoryWithMostReportsHeroMetricQuery, TError, TData>(
    variables === undefined
      ? ['GetCategoryWithMostReportsHeroMetric']
      : ['GetCategoryWithMostReportsHeroMetric', variables],
    fetcher<
      GetCategoryWithMostReportsHeroMetricQuery,
      GetCategoryWithMostReportsHeroMetricQueryVariables
    >(GetCategoryWithMostReportsHeroMetricDocument, variables),
    options,
  );
export const GetOrganisationalHeroMetricsDocument = `
    query GetOrganisationalHeroMetrics($timeframe: TimeframeInput, $sites: [String!], $countries: [String!], $caseCountryCodes: [String!], $caseRegionIds: [String!]) {
  getTotalCasesHeroMetric(
    Timeframe: $timeframe
    sites: $sites
    countries: $countries
    caseCountryCodes: $caseCountryCodes
    caseRegionIds: $caseRegionIds
  ) {
    category
    tooltip
    descriptor
    subCategory {
      category
      count
    }
  }
  getDepartmentWithMostCasesHeroMetric(
    Timeframe: $timeframe
    sites: $sites
    countries: $countries
    caseCountryCodes: $caseCountryCodes
    caseRegionIds: $caseRegionIds
  ) {
    category
    tooltip
    descriptor
    subCategory {
      category
      count
    }
  }
  getLocationWithMostCasesHeroMetric(
    Timeframe: $timeframe
    sites: $sites
    countries: $countries
    caseCountryCodes: $caseCountryCodes
    caseRegionIds: $caseRegionIds
  ) {
    tooltip
    descriptor
    category
    subCategory {
      count
      category
    }
  }
  getMonthWithMostReportsHeroMetric(
    Timeframe: $timeframe
    sites: $sites
    countries: $countries
    caseCountryCodes: $caseCountryCodes
    caseRegionIds: $caseRegionIds
  ) {
    category
    descriptor
    subCategory {
      count
      category
    }
    tooltip
  }
  getCategoryWithMostReportsHeroMetric(
    Timeframe: $timeframe
    sites: $sites
    countries: $countries
    caseCountryCodes: $caseCountryCodes
    caseRegionIds: $caseRegionIds
  ) {
    tooltip
    descriptor
    category
    subCategory {
      count
      category
    }
  }
}
    `;
export const useGetOrganisationalHeroMetricsQuery = <
  TData = GetOrganisationalHeroMetricsQuery,
  TError = unknown,
>(
  variables?: GetOrganisationalHeroMetricsQueryVariables,
  options?: UseQueryOptions<GetOrganisationalHeroMetricsQuery, TError, TData>,
) =>
  useQuery<GetOrganisationalHeroMetricsQuery, TError, TData>(
    variables === undefined
      ? ['GetOrganisationalHeroMetrics']
      : ['GetOrganisationalHeroMetrics', variables],
    fetcher<
      GetOrganisationalHeroMetricsQuery,
      GetOrganisationalHeroMetricsQueryVariables
    >(GetOrganisationalHeroMetricsDocument, variables),
    options,
  );
export const GetOperationalHeroMetricsDocument = `
    query GetOperationalHeroMetrics($firstStatus: String!, $secondStatus: String!, $thirdStatus: String!, $timeframe: TimeframeInput, $sites: [String!], $countries: [String!], $caseCountryCodes: [String!], $caseRegionIds: [String!]) {
  getTimeToResolutionHeroMetric(
    sites: $sites
    Timeframe: $timeframe
    countries: $countries
    caseCountryCodes: $caseCountryCodes
    caseRegionIds: $caseRegionIds
  ) {
    category
    tooltip
    subCategory {
      category
      count
    }
  }
  firstStatus: getTimeInStatusHeroMetric(
    status: $firstStatus
    Timeframe: $timeframe
    sites: $sites
    countries: $countries
    caseCountryCodes: $caseCountryCodes
    caseRegionIds: $caseRegionIds
  ) {
    category
    tooltip
    subCategory {
      category
      count
    }
  }
  secondStatus: getTimeInStatusHeroMetric(
    status: $secondStatus
    Timeframe: $timeframe
    sites: $sites
    countries: $countries
    caseCountryCodes: $caseCountryCodes
    caseRegionIds: $caseRegionIds
  ) {
    category
    tooltip
    subCategory {
      category
      count
    }
  }
  thirdStatus: getTimeInStatusHeroMetric(
    status: $thirdStatus
    Timeframe: $timeframe
    sites: $sites
    countries: $countries
    caseCountryCodes: $caseCountryCodes
    caseRegionIds: $caseRegionIds
  ) {
    category
    tooltip
    subCategory {
      category
      count
    }
  }
  getCasesOver90DaysHeroMetric(
    Timeframe: $timeframe
    sites: $sites
    countries: $countries
    caseCountryCodes: $caseCountryCodes
    caseRegionIds: $caseRegionIds
  ) {
    category
    tooltip
    subCategory {
      category
      count
    }
  }
}
    `;
export const useGetOperationalHeroMetricsQuery = <
  TData = GetOperationalHeroMetricsQuery,
  TError = unknown,
>(
  variables: GetOperationalHeroMetricsQueryVariables,
  options?: UseQueryOptions<GetOperationalHeroMetricsQuery, TError, TData>,
) =>
  useQuery<GetOperationalHeroMetricsQuery, TError, TData>(
    ['GetOperationalHeroMetrics', variables],
    fetcher<
      GetOperationalHeroMetricsQuery,
      GetOperationalHeroMetricsQueryVariables
    >(GetOperationalHeroMetricsDocument, variables),
    options,
  );
export const MonthlyReportsBySourceDocument = `
    query MonthlyReportsBySource($input: InsightsInput!) {
  monthlyReportsBySource(input: $input) {
    month
    app
    manualCaseCreation
    openReporting
    vaultTalk
    slack
    imported
  }
}
    `;
export const useMonthlyReportsBySourceQuery = <
  TData = MonthlyReportsBySourceQuery,
  TError = unknown,
>(
  variables: MonthlyReportsBySourceQueryVariables,
  options?: UseQueryOptions<MonthlyReportsBySourceQuery, TError, TData>,
) =>
  useQuery<MonthlyReportsBySourceQuery, TError, TData>(
    ['MonthlyReportsBySource', variables],
    fetcher<MonthlyReportsBySourceQuery, MonthlyReportsBySourceQueryVariables>(
      MonthlyReportsBySourceDocument,
      variables,
    ),
    options,
  );
export const ReportCountDocument = `
    query ReportCount($input: InsightsInput!) {
  reportCount(input: $input)
}
    `;
export const useReportCountQuery = <TData = ReportCountQuery, TError = unknown>(
  variables: ReportCountQueryVariables,
  options?: UseQueryOptions<ReportCountQuery, TError, TData>,
) =>
  useQuery<ReportCountQuery, TError, TData>(
    ['ReportCount', variables],
    fetcher<ReportCountQuery, ReportCountQueryVariables>(
      ReportCountDocument,
      variables,
    ),
    options,
  );
export const ReportYearsDocument = `
    query ReportYears {
  reportYears
}
    `;
export const useReportYearsQuery = <TData = ReportYearsQuery, TError = unknown>(
  variables?: ReportYearsQueryVariables,
  options?: UseQueryOptions<ReportYearsQuery, TError, TData>,
) =>
  useQuery<ReportYearsQuery, TError, TData>(
    variables === undefined ? ['ReportYears'] : ['ReportYears', variables],
    fetcher<ReportYearsQuery, ReportYearsQueryVariables>(
      ReportYearsDocument,
      variables,
    ),
    options,
  );
export const ReportsByCategoryDocument = `
    query ReportsByCategory($input: InsightsInput!) {
  reportsByCategory(input: $input) {
    category
    count
  }
}
    `;
export const useReportsByCategoryQuery = <
  TData = ReportsByCategoryQuery,
  TError = unknown,
>(
  variables: ReportsByCategoryQueryVariables,
  options?: UseQueryOptions<ReportsByCategoryQuery, TError, TData>,
) =>
  useQuery<ReportsByCategoryQuery, TError, TData>(
    ['ReportsByCategory', variables],
    fetcher<ReportsByCategoryQuery, ReportsByCategoryQueryVariables>(
      ReportsByCategoryDocument,
      variables,
    ),
    options,
  );
export const ReportsByDepartmentDocument = `
    query ReportsByDepartment($input: InsightsInput!) {
  reportsByDepartment(input: $input) {
    department
    count
  }
}
    `;
export const useReportsByDepartmentQuery = <
  TData = ReportsByDepartmentQuery,
  TError = unknown,
>(
  variables: ReportsByDepartmentQueryVariables,
  options?: UseQueryOptions<ReportsByDepartmentQuery, TError, TData>,
) =>
  useQuery<ReportsByDepartmentQuery, TError, TData>(
    ['ReportsByDepartment', variables],
    fetcher<ReportsByDepartmentQuery, ReportsByDepartmentQueryVariables>(
      ReportsByDepartmentDocument,
      variables,
    ),
    options,
  );
export const ReportsByStatusDocument = `
    query ReportsByStatus($input: InsightsInput!) {
  reportsByStatus(input: $input) {
    status
    count
  }
}
    `;
export const useReportsByStatusQuery = <
  TData = ReportsByStatusQuery,
  TError = unknown,
>(
  variables: ReportsByStatusQueryVariables,
  options?: UseQueryOptions<ReportsByStatusQuery, TError, TData>,
) =>
  useQuery<ReportsByStatusQuery, TError, TData>(
    ['ReportsByStatus', variables],
    fetcher<ReportsByStatusQuery, ReportsByStatusQueryVariables>(
      ReportsByStatusDocument,
      variables,
    ),
    options,
  );
export const ConnectSlackAccountDocument = `
    mutation ConnectSlackAccount($authCode: String!) {
  connectSlackAccount(authCode: $authCode)
}
    `;
export const useConnectSlackAccountMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    ConnectSlackAccountMutation,
    TError,
    ConnectSlackAccountMutationVariables,
    TContext
  >,
) =>
  useMutation<
    ConnectSlackAccountMutation,
    TError,
    ConnectSlackAccountMutationVariables,
    TContext
  >(
    ['ConnectSlackAccount'],
    (variables?: ConnectSlackAccountMutationVariables) =>
      fetcher<
        ConnectSlackAccountMutation,
        ConnectSlackAccountMutationVariables
      >(ConnectSlackAccountDocument, variables)(),
    options,
  );
export const GenerateInvestigationPlanDocument = `
    mutation GenerateInvestigationPlan($caseId: String!) {
  generateInvestigationPlan(caseId: $caseId) {
    generationStatus
    jobId
  }
}
    `;
export const useGenerateInvestigationPlanMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    GenerateInvestigationPlanMutation,
    TError,
    GenerateInvestigationPlanMutationVariables,
    TContext
  >,
) =>
  useMutation<
    GenerateInvestigationPlanMutation,
    TError,
    GenerateInvestigationPlanMutationVariables,
    TContext
  >(
    ['GenerateInvestigationPlan'],
    (variables?: GenerateInvestigationPlanMutationVariables) =>
      fetcher<
        GenerateInvestigationPlanMutation,
        GenerateInvestigationPlanMutationVariables
      >(GenerateInvestigationPlanDocument, variables)(),
    options,
  );
export const InvestigationPlanJobStatusDocument = `
    query InvestigationPlanJobStatus($caseId: String!) {
  investigationPlanJobStatus(caseId: $caseId) {
    status
    jobId
  }
}
    `;
export const useInvestigationPlanJobStatusQuery = <
  TData = InvestigationPlanJobStatusQuery,
  TError = unknown,
>(
  variables: InvestigationPlanJobStatusQueryVariables,
  options?: UseQueryOptions<InvestigationPlanJobStatusQuery, TError, TData>,
) =>
  useQuery<InvestigationPlanJobStatusQuery, TError, TData>(
    ['InvestigationPlanJobStatus', variables],
    fetcher<
      InvestigationPlanJobStatusQuery,
      InvestigationPlanJobStatusQueryVariables
    >(InvestigationPlanJobStatusDocument, variables),
    options,
  );
export const AcceptInvestigationPlanDocument = `
    mutation AcceptInvestigationPlan($caseId: String!, $planDocumentId: String!) {
  acceptInvestigationPlan(caseId: $caseId, planDocumentId: $planDocumentId) {
    success
    acceptedAt
  }
}
    `;
export const useAcceptInvestigationPlanMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    AcceptInvestigationPlanMutation,
    TError,
    AcceptInvestigationPlanMutationVariables,
    TContext
  >,
) =>
  useMutation<
    AcceptInvestigationPlanMutation,
    TError,
    AcceptInvestigationPlanMutationVariables,
    TContext
  >(
    ['AcceptInvestigationPlan'],
    (variables?: AcceptInvestigationPlanMutationVariables) =>
      fetcher<
        AcceptInvestigationPlanMutation,
        AcceptInvestigationPlanMutationVariables
      >(AcceptInvestigationPlanDocument, variables)(),
    options,
  );
export const UpdateInvestigationStepDocument = `
    mutation UpdateInvestigationStep($caseId: String!, $planDocumentId: String!, $stepId: String!, $status: InvestigationStepStatus!) {
  updateInvestigationStep(
    caseId: $caseId
    planDocumentId: $planDocumentId
    stepId: $stepId
    status: $status
  ) {
    success
    updatedStatus
  }
}
    `;
export const useUpdateInvestigationStepMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateInvestigationStepMutation,
    TError,
    UpdateInvestigationStepMutationVariables,
    TContext
  >,
) =>
  useMutation<
    UpdateInvestigationStepMutation,
    TError,
    UpdateInvestigationStepMutationVariables,
    TContext
  >(
    ['UpdateInvestigationStep'],
    (variables?: UpdateInvestigationStepMutationVariables) =>
      fetcher<
        UpdateInvestigationStepMutation,
        UpdateInvestigationStepMutationVariables
      >(UpdateInvestigationStepDocument, variables)(),
    options,
  );
export const InvestigationPlanDocumentDocument = `
    query InvestigationPlanDocument($caseId: String!) {
  investigationPlanDocument(caseId: $caseId) {
    id
    title
    value
    lastEdited
  }
}
    `;
export const useInvestigationPlanDocumentQuery = <
  TData = InvestigationPlanDocumentQuery,
  TError = unknown,
>(
  variables: InvestigationPlanDocumentQueryVariables,
  options?: UseQueryOptions<InvestigationPlanDocumentQuery, TError, TData>,
) =>
  useQuery<InvestigationPlanDocumentQuery, TError, TData>(
    ['InvestigationPlanDocument', variables],
    fetcher<
      InvestigationPlanDocumentQuery,
      InvestigationPlanDocumentQueryVariables
    >(InvestigationPlanDocumentDocument, variables),
    options,
  );
export const UpdateInvestigationChecklistDocument = `
    mutation UpdateInvestigationChecklist($caseId: String!, $planDocumentId: String!, $checklist: String!) {
  updateInvestigationChecklist(
    caseId: $caseId
    planDocumentId: $planDocumentId
    checklist: $checklist
  ) {
    success
  }
}
    `;
export const useUpdateInvestigationChecklistMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateInvestigationChecklistMutation,
    TError,
    UpdateInvestigationChecklistMutationVariables,
    TContext
  >,
) =>
  useMutation<
    UpdateInvestigationChecklistMutation,
    TError,
    UpdateInvestigationChecklistMutationVariables,
    TContext
  >(
    ['UpdateInvestigationChecklist'],
    (variables?: UpdateInvestigationChecklistMutationVariables) =>
      fetcher<
        UpdateInvestigationChecklistMutation,
        UpdateInvestigationChecklistMutationVariables
      >(UpdateInvestigationChecklistDocument, variables)(),
    options,
  );
export const GenerateJwtDocument = `
    query GenerateJwt($dynamicFormId: String) {
  generateJwt(dynamicFormId: $dynamicFormId) {
    jwt
  }
}
    `;
export const useGenerateJwtQuery = <TData = GenerateJwtQuery, TError = unknown>(
  variables?: GenerateJwtQueryVariables,
  options?: UseQueryOptions<GenerateJwtQuery, TError, TData>,
) =>
  useQuery<GenerateJwtQuery, TError, TData>(
    variables === undefined ? ['GenerateJwt'] : ['GenerateJwt', variables],
    fetcher<GenerateJwtQuery, GenerateJwtQueryVariables>(
      GenerateJwtDocument,
      variables,
    ),
    options,
  );
export const RequestMergeLinkDocument = `
    mutation requestMergeLink {
  requestMergeLinkToken
}
    `;
export const useRequestMergeLinkMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    RequestMergeLinkMutation,
    TError,
    RequestMergeLinkMutationVariables,
    TContext
  >,
) =>
  useMutation<
    RequestMergeLinkMutation,
    TError,
    RequestMergeLinkMutationVariables,
    TContext
  >(
    ['requestMergeLink'],
    (variables?: RequestMergeLinkMutationVariables) =>
      fetcher<RequestMergeLinkMutation, RequestMergeLinkMutationVariables>(
        RequestMergeLinkDocument,
        variables,
      )(),
    options,
  );
export const SubmitPublicTokenDocument = `
    mutation SubmitPublicToken($publicToken: String!) {
  submitPublicToken(publicToken: $publicToken)
}
    `;
export const useSubmitPublicTokenMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    SubmitPublicTokenMutation,
    TError,
    SubmitPublicTokenMutationVariables,
    TContext
  >,
) =>
  useMutation<
    SubmitPublicTokenMutation,
    TError,
    SubmitPublicTokenMutationVariables,
    TContext
  >(
    ['SubmitPublicToken'],
    (variables?: SubmitPublicTokenMutationVariables) =>
      fetcher<SubmitPublicTokenMutation, SubmitPublicTokenMutationVariables>(
        SubmitPublicTokenDocument,
        variables,
      )(),
    options,
  );
export const GetChannelEntriesDocument = `
    query GetChannelEntries($channel: String!) {
  getChannelEntries(channel: $channel) {
    id
    manager
    enteredChannel
    exitedChannel
    User {
      name
      displayName
    }
  }
}
    `;
export const useGetChannelEntriesQuery = <
  TData = GetChannelEntriesQuery,
  TError = unknown,
>(
  variables: GetChannelEntriesQueryVariables,
  options?: UseQueryOptions<GetChannelEntriesQuery, TError, TData>,
) =>
  useQuery<GetChannelEntriesQuery, TError, TData>(
    ['GetChannelEntries', variables],
    fetcher<GetChannelEntriesQuery, GetChannelEntriesQueryVariables>(
      GetChannelEntriesDocument,
      variables,
    ),
    options,
  );
export const GetUserChannelEntriesDocument = `
    query GetUserChannelEntries($channel: String!) {
  getUserChannelEntries(channel: $channel) {
    id
    manager
    enteredChannel
    exitedChannel
    User {
      name
      displayName
    }
  }
}
    `;
export const useGetUserChannelEntriesQuery = <
  TData = GetUserChannelEntriesQuery,
  TError = unknown,
>(
  variables: GetUserChannelEntriesQueryVariables,
  options?: UseQueryOptions<GetUserChannelEntriesQuery, TError, TData>,
) =>
  useQuery<GetUserChannelEntriesQuery, TError, TData>(
    ['GetUserChannelEntries', variables],
    fetcher<GetUserChannelEntriesQuery, GetUserChannelEntriesQueryVariables>(
      GetUserChannelEntriesDocument,
      variables,
    ),
    options,
  );
export const GetMessagesByReportDocument = `
    query GetMessagesByReport($report: String!, $translate: Boolean) {
  getMessagesByReport(report: $report, translate: $translate) {
    id
    value
    state
    channel
    author
    isReporter
    createdAt
    updatedAt
    translated
    deletedAt
    deletedBy
  }
}
    `;
export const useGetMessagesByReportQuery = <
  TData = GetMessagesByReportQuery,
  TError = unknown,
>(
  variables: GetMessagesByReportQueryVariables,
  options?: UseQueryOptions<GetMessagesByReportQuery, TError, TData>,
) =>
  useQuery<GetMessagesByReportQuery, TError, TData>(
    ['GetMessagesByReport', variables],
    fetcher<GetMessagesByReportQuery, GetMessagesByReportQueryVariables>(
      GetMessagesByReportDocument,
      variables,
    ),
    options,
  );
export const SoftDeleteMessagesByIdsDocument = `
    mutation SoftDeleteMessagesByIds($messageIds: [String!]!) {
  softDeleteMessagesByIds(messageIds: $messageIds)
}
    `;
export const useSoftDeleteMessagesByIdsMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    SoftDeleteMessagesByIdsMutation,
    TError,
    SoftDeleteMessagesByIdsMutationVariables,
    TContext
  >,
) =>
  useMutation<
    SoftDeleteMessagesByIdsMutation,
    TError,
    SoftDeleteMessagesByIdsMutationVariables,
    TContext
  >(
    ['SoftDeleteMessagesByIds'],
    (variables?: SoftDeleteMessagesByIdsMutationVariables) =>
      fetcher<
        SoftDeleteMessagesByIdsMutation,
        SoftDeleteMessagesByIdsMutationVariables
      >(SoftDeleteMessagesByIdsDocument, variables)(),
    options,
  );
export const SendMessageDocument = `
    mutation SendMessage($caseId: String!, $value: String!, $channel: String!) {
  sendMessage(caseId: $caseId, value: $value, channel: $channel) {
    id
    channel
    value
  }
}
    `;
export const useSendMessageMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    SendMessageMutation,
    TError,
    SendMessageMutationVariables,
    TContext
  >,
) =>
  useMutation<
    SendMessageMutation,
    TError,
    SendMessageMutationVariables,
    TContext
  >(
    ['SendMessage'],
    (variables?: SendMessageMutationVariables) =>
      fetcher<SendMessageMutation, SendMessageMutationVariables>(
        SendMessageDocument,
        variables,
      )(),
    options,
  );
export const GetUserMessagesByReportDocument = `
    query GetUserMessagesByReport($report: String!, $translate: Boolean) {
  getUserMessagesByReport(report: $report, translate: $translate) {
    id
    value
    state
    channel
    author
    isReporter
    createdAt
    updatedAt
    translated
    deletedAt
    deletedBy
  }
}
    `;
export const useGetUserMessagesByReportQuery = <
  TData = GetUserMessagesByReportQuery,
  TError = unknown,
>(
  variables: GetUserMessagesByReportQueryVariables,
  options?: UseQueryOptions<GetUserMessagesByReportQuery, TError, TData>,
) =>
  useQuery<GetUserMessagesByReportQuery, TError, TData>(
    ['GetUserMessagesByReport', variables],
    fetcher<
      GetUserMessagesByReportQuery,
      GetUserMessagesByReportQueryVariables
    >(GetUserMessagesByReportDocument, variables),
    options,
  );
export const MarkAllChannelMessagesAsReadDocument = `
    mutation MarkAllChannelMessagesAsRead($channel: String!, $translate: Boolean) {
  markAllChannelMessagesAsRead(channel: $channel, translate: $translate) {
    id
    value
    state
    channel
    author
    isReporter
    createdAt
    updatedAt
    translated
  }
}
    `;
export const useMarkAllChannelMessagesAsReadMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    MarkAllChannelMessagesAsReadMutation,
    TError,
    MarkAllChannelMessagesAsReadMutationVariables,
    TContext
  >,
) =>
  useMutation<
    MarkAllChannelMessagesAsReadMutation,
    TError,
    MarkAllChannelMessagesAsReadMutationVariables,
    TContext
  >(
    ['MarkAllChannelMessagesAsRead'],
    (variables?: MarkAllChannelMessagesAsReadMutationVariables) =>
      fetcher<
        MarkAllChannelMessagesAsReadMutation,
        MarkAllChannelMessagesAsReadMutationVariables
      >(MarkAllChannelMessagesAsReadDocument, variables)(),
    options,
  );
export const SendUserMessageDocument = `
    mutation SendUserMessage($value: String!, $channel: String!) {
  sendUserMessage(value: $value, channel: $channel) {
    id
    channel
    value
  }
}
    `;
export const useSendUserMessageMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    SendUserMessageMutation,
    TError,
    SendUserMessageMutationVariables,
    TContext
  >,
) =>
  useMutation<
    SendUserMessageMutation,
    TError,
    SendUserMessageMutationVariables,
    TContext
  >(
    ['SendUserMessage'],
    (variables?: SendUserMessageMutationVariables) =>
      fetcher<SendUserMessageMutation, SendUserMessageMutationVariables>(
        SendUserMessageDocument,
        variables,
      )(),
    options,
  );
export const NotificationsDocument = `
    query Notifications {
  notifications {
    id
    state
    kind
    createdAt
    assignedFrom
    report
    case
    details
    importType
  }
}
    `;
export const useNotificationsQuery = <
  TData = NotificationsQuery,
  TError = unknown,
>(
  variables?: NotificationsQueryVariables,
  options?: UseQueryOptions<NotificationsQuery, TError, TData>,
) =>
  useQuery<NotificationsQuery, TError, TData>(
    variables === undefined ? ['Notifications'] : ['Notifications', variables],
    fetcher<NotificationsQuery, NotificationsQueryVariables>(
      NotificationsDocument,
      variables,
    ),
    options,
  );
export const UpdateNotificationsDocument = `
    mutation UpdateNotifications($notifications: UpdateNotificationInput!) {
  updateNotifications(notifications: $notifications) {
    id
    state
    kind
    createdAt
    assignedFrom
    report
    case
  }
}
    `;
export const useUpdateNotificationsMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateNotificationsMutation,
    TError,
    UpdateNotificationsMutationVariables,
    TContext
  >,
) =>
  useMutation<
    UpdateNotificationsMutation,
    TError,
    UpdateNotificationsMutationVariables,
    TContext
  >(
    ['UpdateNotifications'],
    (variables?: UpdateNotificationsMutationVariables) =>
      fetcher<
        UpdateNotificationsMutation,
        UpdateNotificationsMutationVariables
      >(UpdateNotificationsDocument, variables)(),
    options,
  );
export const GetCoiDefaultGroupDocument = `
    query GetCoiDefaultGroup {
  getCoiDefaultGroup
}
    `;
export const useGetCoiDefaultGroupQuery = <
  TData = GetCoiDefaultGroupQuery,
  TError = unknown,
>(
  variables?: GetCoiDefaultGroupQueryVariables,
  options?: UseQueryOptions<GetCoiDefaultGroupQuery, TError, TData>,
) =>
  useQuery<GetCoiDefaultGroupQuery, TError, TData>(
    variables === undefined
      ? ['GetCoiDefaultGroup']
      : ['GetCoiDefaultGroup', variables],
    fetcher<GetCoiDefaultGroupQuery, GetCoiDefaultGroupQueryVariables>(
      GetCoiDefaultGroupDocument,
      variables,
    ),
    options,
  );
export const GetDefaultGroupDocument = `
    query GetDefaultGroup {
  getDefaultGroup
}
    `;
export const useGetDefaultGroupQuery = <
  TData = GetDefaultGroupQuery,
  TError = unknown,
>(
  variables?: GetDefaultGroupQueryVariables,
  options?: UseQueryOptions<GetDefaultGroupQuery, TError, TData>,
) =>
  useQuery<GetDefaultGroupQuery, TError, TData>(
    variables === undefined
      ? ['GetDefaultGroup']
      : ['GetDefaultGroup', variables],
    fetcher<GetDefaultGroupQuery, GetDefaultGroupQueryVariables>(
      GetDefaultGroupDocument,
      variables,
    ),
    options,
  );
export const GetOrganisationDocument = `
    query GetOrganisation {
  organisation {
    id
    slackIntegrations {
      id
      teamId
      workspaceName
      installedAt
    }
    hotlineNumbers {
      id
      phoneNumber
      country
      language
      flagIconCode
      defaultLanguage
    }
  }
}
    `;
export const useGetOrganisationQuery = <
  TData = GetOrganisationQuery,
  TError = unknown,
>(
  variables?: GetOrganisationQueryVariables,
  options?: UseQueryOptions<GetOrganisationQuery, TError, TData>,
) =>
  useQuery<GetOrganisationQuery, TError, TData>(
    variables === undefined
      ? ['GetOrganisation']
      : ['GetOrganisation', variables],
    fetcher<GetOrganisationQuery, GetOrganisationQueryVariables>(
      GetOrganisationDocument,
      variables,
    ),
    options,
  );
export const GetOrganisationRolesDocument = `
    query GetOrganisationRoles {
  getOrganisationRoles {
    id
    name
    label
    organisation
    description
    isSpecial
    updatedAt
    createdAt
    publicSystemPermissions {
      canCreateReport
      canBeAssignedAsCaseLead
      canBeAssignedToCaseTeam
    }
  }
}
    `;
export const useGetOrganisationRolesQuery = <
  TData = GetOrganisationRolesQuery,
  TError = unknown,
>(
  variables?: GetOrganisationRolesQueryVariables,
  options?: UseQueryOptions<GetOrganisationRolesQuery, TError, TData>,
) =>
  useQuery<GetOrganisationRolesQuery, TError, TData>(
    variables === undefined
      ? ['GetOrganisationRoles']
      : ['GetOrganisationRoles', variables],
    fetcher<GetOrganisationRolesQuery, GetOrganisationRolesQueryVariables>(
      GetOrganisationRolesDocument,
      variables,
    ),
    options,
  );
export const GetPrivacyStatementDocument = `
    query GetPrivacyStatement($slug: String!) {
  getPrivacyStatement(slug: $slug)
}
    `;
export const useGetPrivacyStatementQuery = <
  TData = GetPrivacyStatementQuery,
  TError = unknown,
>(
  variables: GetPrivacyStatementQueryVariables,
  options?: UseQueryOptions<GetPrivacyStatementQuery, TError, TData>,
) =>
  useQuery<GetPrivacyStatementQuery, TError, TData>(
    ['GetPrivacyStatement', variables],
    fetcher<GetPrivacyStatementQuery, GetPrivacyStatementQueryVariables>(
      GetPrivacyStatementDocument,
      variables,
    ),
    options,
  );
export const SetCoiDefaultGroupDocument = `
    mutation setCoiDefaultGroup($groupId: String) {
  setCoiDefaultGroup(groupId: $groupId)
}
    `;
export const useSetCoiDefaultGroupMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    SetCoiDefaultGroupMutation,
    TError,
    SetCoiDefaultGroupMutationVariables,
    TContext
  >,
) =>
  useMutation<
    SetCoiDefaultGroupMutation,
    TError,
    SetCoiDefaultGroupMutationVariables,
    TContext
  >(
    ['setCoiDefaultGroup'],
    (variables?: SetCoiDefaultGroupMutationVariables) =>
      fetcher<SetCoiDefaultGroupMutation, SetCoiDefaultGroupMutationVariables>(
        SetCoiDefaultGroupDocument,
        variables,
      )(),
    options,
  );
export const SetDefaultGroupDocument = `
    mutation setDefaultGroup($groupId: String) {
  setDefaultGroup(groupId: $groupId)
}
    `;
export const useSetDefaultGroupMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    SetDefaultGroupMutation,
    TError,
    SetDefaultGroupMutationVariables,
    TContext
  >,
) =>
  useMutation<
    SetDefaultGroupMutation,
    TError,
    SetDefaultGroupMutationVariables,
    TContext
  >(
    ['setDefaultGroup'],
    (variables?: SetDefaultGroupMutationVariables) =>
      fetcher<SetDefaultGroupMutation, SetDefaultGroupMutationVariables>(
        SetDefaultGroupDocument,
        variables,
      )(),
    options,
  );
export const ChangePasswordDocument = `
    mutation ChangePassword($input: UpdatePasswordInput!) {
  changePassword(input: $input) {
    id
  }
}
    `;
export const useChangePasswordMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    ChangePasswordMutation,
    TError,
    ChangePasswordMutationVariables,
    TContext
  >,
) =>
  useMutation<
    ChangePasswordMutation,
    TError,
    ChangePasswordMutationVariables,
    TContext
  >(
    ['ChangePassword'],
    (variables?: ChangePasswordMutationVariables) =>
      fetcher<ChangePasswordMutation, ChangePasswordMutationVariables>(
        ChangePasswordDocument,
        variables,
      )(),
    options,
  );
export const CreateResetDocument = `
    mutation CreateReset($email: String!) {
  createReset(email: $email)
}
    `;
export const useCreateResetMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    CreateResetMutation,
    TError,
    CreateResetMutationVariables,
    TContext
  >,
) =>
  useMutation<
    CreateResetMutation,
    TError,
    CreateResetMutationVariables,
    TContext
  >(
    ['CreateReset'],
    (variables?: CreateResetMutationVariables) =>
      fetcher<CreateResetMutation, CreateResetMutationVariables>(
        CreateResetDocument,
        variables,
      )(),
    options,
  );
export const ResetPasswordDocument = `
    mutation ResetPassword($password: String!, $token: String!) {
  resetPassword(password: $password, token: $token) {
    id
  }
}
    `;
export const useResetPasswordMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    ResetPasswordMutation,
    TError,
    ResetPasswordMutationVariables,
    TContext
  >,
) =>
  useMutation<
    ResetPasswordMutation,
    TError,
    ResetPasswordMutationVariables,
    TContext
  >(
    ['ResetPassword'],
    (variables?: ResetPasswordMutationVariables) =>
      fetcher<ResetPasswordMutation, ResetPasswordMutationVariables>(
        ResetPasswordDocument,
        variables,
      )(),
    options,
  );
export const RequestOpenReportingPasswordResetDocument = `
    mutation RequestOpenReportingPasswordReset($input: OprPasswordResetRequestInput!) {
  requestOpenReportingPasswordReset(input: $input)
}
    `;
export const useRequestOpenReportingPasswordResetMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    RequestOpenReportingPasswordResetMutation,
    TError,
    RequestOpenReportingPasswordResetMutationVariables,
    TContext
  >,
) =>
  useMutation<
    RequestOpenReportingPasswordResetMutation,
    TError,
    RequestOpenReportingPasswordResetMutationVariables,
    TContext
  >(
    ['RequestOpenReportingPasswordReset'],
    (variables?: RequestOpenReportingPasswordResetMutationVariables) =>
      fetcher<
        RequestOpenReportingPasswordResetMutation,
        RequestOpenReportingPasswordResetMutationVariables
      >(RequestOpenReportingPasswordResetDocument, variables)(),
    options,
  );
export const RelationshipTypeDocument = `
    query RelationshipType {
  getRelationshipType {
    id
    name
  }
}
    `;
export const useRelationshipTypeQuery = <
  TData = RelationshipTypeQuery,
  TError = unknown,
>(
  variables?: RelationshipTypeQueryVariables,
  options?: UseQueryOptions<RelationshipTypeQuery, TError, TData>,
) =>
  useQuery<RelationshipTypeQuery, TError, TData>(
    variables === undefined
      ? ['RelationshipType']
      : ['RelationshipType', variables],
    fetcher<RelationshipTypeQuery, RelationshipTypeQueryVariables>(
      RelationshipTypeDocument,
      variables,
    ),
    options,
  );
export const AddInternalNamedOffenderDocument = `
    mutation AddInternalNamedOffender($user: LinkInternalNamedOffender!, $reportId: String!, $caseId: String!) {
  addInternalNamedOffender(user: $user, reportId: $reportId, caseId: $caseId) {
    id
  }
}
    `;
export const useAddInternalNamedOffenderMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    AddInternalNamedOffenderMutation,
    TError,
    AddInternalNamedOffenderMutationVariables,
    TContext
  >,
) =>
  useMutation<
    AddInternalNamedOffenderMutation,
    TError,
    AddInternalNamedOffenderMutationVariables,
    TContext
  >(
    ['AddInternalNamedOffender'],
    (variables?: AddInternalNamedOffenderMutationVariables) =>
      fetcher<
        AddInternalNamedOffenderMutation,
        AddInternalNamedOffenderMutationVariables
      >(AddInternalNamedOffenderDocument, variables)(),
    options,
  );
export const AddExternalNamedOffenderDocument = `
    mutation AddExternalNamedOffender($user: LinkExternalNamedOffender!, $reportId: String!, $caseId: String!) {
  addExternalNamedOffender(user: $user, reportId: $reportId, caseId: $caseId) {
    id
  }
}
    `;
export const useAddExternalNamedOffenderMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    AddExternalNamedOffenderMutation,
    TError,
    AddExternalNamedOffenderMutationVariables,
    TContext
  >,
) =>
  useMutation<
    AddExternalNamedOffenderMutation,
    TError,
    AddExternalNamedOffenderMutationVariables,
    TContext
  >(
    ['AddExternalNamedOffender'],
    (variables?: AddExternalNamedOffenderMutationVariables) =>
      fetcher<
        AddExternalNamedOffenderMutation,
        AddExternalNamedOffenderMutationVariables
      >(AddExternalNamedOffenderDocument, variables)(),
    options,
  );
export const CreateDraftReportDocument = `
    mutation createDraftReport($source: String!) {
  createDraftReport(source: $source) {
    report {
      report
      assignee
      reporter
      id
    }
    caseId
  }
}
    `;
export const useCreateDraftReportMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    CreateDraftReportMutation,
    TError,
    CreateDraftReportMutationVariables,
    TContext
  >,
) =>
  useMutation<
    CreateDraftReportMutation,
    TError,
    CreateDraftReportMutationVariables,
    TContext
  >(
    ['createDraftReport'],
    (variables?: CreateDraftReportMutationVariables) =>
      fetcher<CreateDraftReportMutation, CreateDraftReportMutationVariables>(
        CreateDraftReportDocument,
        variables,
      )(),
    options,
  );
export const DeleteDraftReportDocument = `
    mutation deleteDraftReport($reportId: String!) {
  deleteDraftReport(reportId: $reportId)
}
    `;
export const useDeleteDraftReportMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    DeleteDraftReportMutation,
    TError,
    DeleteDraftReportMutationVariables,
    TContext
  >,
) =>
  useMutation<
    DeleteDraftReportMutation,
    TError,
    DeleteDraftReportMutationVariables,
    TContext
  >(
    ['deleteDraftReport'],
    (variables?: DeleteDraftReportMutationVariables) =>
      fetcher<DeleteDraftReportMutation, DeleteDraftReportMutationVariables>(
        DeleteDraftReportDocument,
        variables,
      )(),
    options,
  );
export const SubmitDraftReportDocument = `
    mutation submitDraftReport($reportId: String!, $submissionMode: Int!, $caseLead: Float, $autoAssignCaseManagerViaRouting: Boolean, $responseId: String, $attestationAccepted: Boolean, $questionnaireAnswers: [SaveAnswerInputType!]) {
  submitDraftReport(
    reportId: $reportId
    submissionMode: $submissionMode
    caseLead: $caseLead
    autoAssignCaseManagerViaRouting: $autoAssignCaseManagerViaRouting
    responseId: $responseId
    attestationAccepted: $attestationAccepted
    questionnaireAnswers: $questionnaireAnswers
  ) {
    id
    status
    readableId
    submissionMode
    reporter
    assignee
    source
    createdAt
  }
}
    `;
export const useSubmitDraftReportMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    SubmitDraftReportMutation,
    TError,
    SubmitDraftReportMutationVariables,
    TContext
  >,
) =>
  useMutation<
    SubmitDraftReportMutation,
    TError,
    SubmitDraftReportMutationVariables,
    TContext
  >(
    ['submitDraftReport'],
    (variables?: SubmitDraftReportMutationVariables) =>
      fetcher<SubmitDraftReportMutation, SubmitDraftReportMutationVariables>(
        SubmitDraftReportDocument,
        variables,
      )(),
    options,
  );
export const GetSubmissionDateDocument = `
    query GetSubmissionDate($report: String!) {
  getSubmissionDate(report: $report)
}
    `;
export const useGetSubmissionDateQuery = <
  TData = GetSubmissionDateQuery,
  TError = unknown,
>(
  variables: GetSubmissionDateQueryVariables,
  options?: UseQueryOptions<GetSubmissionDateQuery, TError, TData>,
) =>
  useQuery<GetSubmissionDateQuery, TError, TData>(
    ['GetSubmissionDate', variables],
    fetcher<GetSubmissionDateQuery, GetSubmissionDateQueryVariables>(
      GetSubmissionDateDocument,
      variables,
    ),
    options,
  );
export const CreateReportDocumentationUploadUrlDocument = `
    mutation CreateReportDocumentationUploadUrl($fileType: String!, $filename: String!, $reportId: String!, $uploadSource: UploadSource!, $size: Float) {
  createReportDocumentationUploadUrl(
    fileType: $fileType
    filename: $filename
    reportId: $reportId
    uploadSource: $uploadSource
    size: $size
  ) {
    s3path
    url
  }
}
    `;
export const useCreateReportDocumentationUploadUrlMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    CreateReportDocumentationUploadUrlMutation,
    TError,
    CreateReportDocumentationUploadUrlMutationVariables,
    TContext
  >,
) =>
  useMutation<
    CreateReportDocumentationUploadUrlMutation,
    TError,
    CreateReportDocumentationUploadUrlMutationVariables,
    TContext
  >(
    ['CreateReportDocumentationUploadUrl'],
    (variables?: CreateReportDocumentationUploadUrlMutationVariables) =>
      fetcher<
        CreateReportDocumentationUploadUrlMutation,
        CreateReportDocumentationUploadUrlMutationVariables
      >(CreateReportDocumentationUploadUrlDocument, variables)(),
    options,
  );
export const AddReportDocumentationUploadDocument = `
    mutation AddReportDocumentationUpload($documentation: DocumentationInput!, $report: String!, $event: String!, $uploadSource: UploadSource!) {
  addReportDocumentationUpload(
    documentation: $documentation
    report: $report
    event: $event
    uploadSource: $uploadSource
  ) {
    id
  }
}
    `;
export const useAddReportDocumentationUploadMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    AddReportDocumentationUploadMutation,
    TError,
    AddReportDocumentationUploadMutationVariables,
    TContext
  >,
) =>
  useMutation<
    AddReportDocumentationUploadMutation,
    TError,
    AddReportDocumentationUploadMutationVariables,
    TContext
  >(
    ['AddReportDocumentationUpload'],
    (variables?: AddReportDocumentationUploadMutationVariables) =>
      fetcher<
        AddReportDocumentationUploadMutation,
        AddReportDocumentationUploadMutationVariables
      >(AddReportDocumentationUploadDocument, variables)(),
    options,
  );
export const GetReportUploadReadUrlForReporterDocument = `
    mutation GetReportUploadReadURLForReporter($reportId: String!, $objectId: String!) {
  getReportUploadReadURLForReporter(reportId: $reportId, objectId: $objectId) {
    url
  }
}
    `;
export const useGetReportUploadReadUrlForReporterMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    GetReportUploadReadUrlForReporterMutation,
    TError,
    GetReportUploadReadUrlForReporterMutationVariables,
    TContext
  >,
) =>
  useMutation<
    GetReportUploadReadUrlForReporterMutation,
    TError,
    GetReportUploadReadUrlForReporterMutationVariables,
    TContext
  >(
    ['GetReportUploadReadURLForReporter'],
    (variables?: GetReportUploadReadUrlForReporterMutationVariables) =>
      fetcher<
        GetReportUploadReadUrlForReporterMutation,
        GetReportUploadReadUrlForReporterMutationVariables
      >(GetReportUploadReadUrlForReporterDocument, variables)(),
    options,
  );
export const ValidateBulkCaseUploadAndGenerateUrlDocument = `
    mutation ValidateBulkCaseUploadAndGenerateUrl($files: [BulkFileUploadInput!]!, $uploadSource: UploadSource!, $importedCaseIds: [String!]) {
  validateBulkCaseUploadAndGenerateUrl(
    files: $files
    uploadSource: $uploadSource
    importedCaseIds: $importedCaseIds
  ) {
    success
    successfulFiles
    totalFiles
    processedFolders {
      folderName
      caseId
      success
      files {
        filename
        filepath
        validated
        uploadStatus
        presignedUrl
        s3path
        mimeType
        size
        fileExtension
        error
      }
      error
    }
    message
  }
}
    `;
export const useValidateBulkCaseUploadAndGenerateUrlMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    ValidateBulkCaseUploadAndGenerateUrlMutation,
    TError,
    ValidateBulkCaseUploadAndGenerateUrlMutationVariables,
    TContext
  >,
) =>
  useMutation<
    ValidateBulkCaseUploadAndGenerateUrlMutation,
    TError,
    ValidateBulkCaseUploadAndGenerateUrlMutationVariables,
    TContext
  >(
    ['ValidateBulkCaseUploadAndGenerateUrl'],
    (variables?: ValidateBulkCaseUploadAndGenerateUrlMutationVariables) =>
      fetcher<
        ValidateBulkCaseUploadAndGenerateUrlMutation,
        ValidateBulkCaseUploadAndGenerateUrlMutationVariables
      >(ValidateBulkCaseUploadAndGenerateUrlDocument, variables)(),
    options,
  );
export const ReportsDocument = `
    query Reports($pagination: PaginationInputType!, $orderBy: OrderByInputType!, $searchBy: [SearchByInputType!], $fuzzy: FuzzySearchInputType) {
  reportsPaginated(
    pagination: $pagination
    orderBy: $orderBy
    searchBy: $searchBy
    fuzzy: $fuzzy
  ) {
    items {
      id
      createdAt
      status
      category
      ReportedCategory {
        id
        name
      }
      DeterminedCategory {
        id
        name
      }
      Assignee {
        id
        name
      }
      anonymous
      Reporter {
        name
      }
      source
      substantiation
      miReportSource
    }
    count
  }
}
    `;
export const useReportsQuery = <TData = ReportsQuery, TError = unknown>(
  variables: ReportsQueryVariables,
  options?: UseQueryOptions<ReportsQuery, TError, TData>,
) =>
  useQuery<ReportsQuery, TError, TData>(
    ['Reports', variables],
    fetcher<ReportsQuery, ReportsQueryVariables>(ReportsDocument, variables),
    options,
  );
export const UpdateSubstantiationStatusDocument = `
    mutation UpdateSubstantiationStatus($newSubstantiationStatus: String!, $report: String!, $caseId: String!) {
  updateSubstantiationStatus(
    newSubstantiationStatus: $newSubstantiationStatus
    report: $report
    caseId: $caseId
  ) {
    substantiation
  }
}
    `;
export const useUpdateSubstantiationStatusMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateSubstantiationStatusMutation,
    TError,
    UpdateSubstantiationStatusMutationVariables,
    TContext
  >,
) =>
  useMutation<
    UpdateSubstantiationStatusMutation,
    TError,
    UpdateSubstantiationStatusMutationVariables,
    TContext
  >(
    ['UpdateSubstantiationStatus'],
    (variables?: UpdateSubstantiationStatusMutationVariables) =>
      fetcher<
        UpdateSubstantiationStatusMutation,
        UpdateSubstantiationStatusMutationVariables
      >(UpdateSubstantiationStatusDocument, variables)(),
    options,
  );
export const ReassignReportAssigneeDocument = `
    mutation ReassignReportAssignee($newReportAssigneeId: Float!, $report: String!, $caseId: String!) {
  reassignReportAssignee(
    newReportAssigneeId: $newReportAssigneeId
    report: $report
    caseId: $caseId
  ) {
    assignee
  }
}
    `;
export const useReassignReportAssigneeMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    ReassignReportAssigneeMutation,
    TError,
    ReassignReportAssigneeMutationVariables,
    TContext
  >,
) =>
  useMutation<
    ReassignReportAssigneeMutation,
    TError,
    ReassignReportAssigneeMutationVariables,
    TContext
  >(
    ['ReassignReportAssignee'],
    (variables?: ReassignReportAssigneeMutationVariables) =>
      fetcher<
        ReassignReportAssigneeMutation,
        ReassignReportAssigneeMutationVariables
      >(ReassignReportAssigneeDocument, variables)(),
    options,
  );
export const UpdateReportedCategoryDocument = `
    mutation UpdateReportedCategory($reportedCategoryId: Int!, $report: String!) {
  updateReportedCategory(reportedCategoryId: $reportedCategoryId, report: $report) {
    reportedCategory
  }
}
    `;
export const useUpdateReportedCategoryMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateReportedCategoryMutation,
    TError,
    UpdateReportedCategoryMutationVariables,
    TContext
  >,
) =>
  useMutation<
    UpdateReportedCategoryMutation,
    TError,
    UpdateReportedCategoryMutationVariables,
    TContext
  >(
    ['UpdateReportedCategory'],
    (variables?: UpdateReportedCategoryMutationVariables) =>
      fetcher<
        UpdateReportedCategoryMutation,
        UpdateReportedCategoryMutationVariables
      >(UpdateReportedCategoryDocument, variables)(),
    options,
  );
export const UpdateDeterminedCategoryDocument = `
    mutation UpdateDeterminedCategory($determinedCategoryId: Int!, $report: String!) {
  updateDeterminedCategory(
    determinedCategoryId: $determinedCategoryId
    report: $report
  ) {
    determinedCategory
  }
}
    `;
export const useUpdateDeterminedCategoryMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateDeterminedCategoryMutation,
    TError,
    UpdateDeterminedCategoryMutationVariables,
    TContext
  >,
) =>
  useMutation<
    UpdateDeterminedCategoryMutation,
    TError,
    UpdateDeterminedCategoryMutationVariables,
    TContext
  >(
    ['UpdateDeterminedCategory'],
    (variables?: UpdateDeterminedCategoryMutationVariables) =>
      fetcher<
        UpdateDeterminedCategoryMutation,
        UpdateDeterminedCategoryMutationVariables
      >(UpdateDeterminedCategoryDocument, variables)(),
    options,
  );
export const UpdateMiReportSourceDocument = `
    mutation UpdateMiReportSource($miReportSource: MiReportSource!, $report: String!) {
  updateMiReportSource(miReportSource: $miReportSource, report: $report) {
    miReportSource
  }
}
    `;
export const useUpdateMiReportSourceMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateMiReportSourceMutation,
    TError,
    UpdateMiReportSourceMutationVariables,
    TContext
  >,
) =>
  useMutation<
    UpdateMiReportSourceMutation,
    TError,
    UpdateMiReportSourceMutationVariables,
    TContext
  >(
    ['UpdateMiReportSource'],
    (variables?: UpdateMiReportSourceMutationVariables) =>
      fetcher<
        UpdateMiReportSourceMutation,
        UpdateMiReportSourceMutationVariables
      >(UpdateMiReportSourceDocument, variables)(),
    options,
  );
export const ApplyReportDeletionsDocument = `
    mutation ApplyReportDeletions($reportId: String!, $data: DataDeletionType!) {
  applyReportDeletions(reportId: $reportId, data: $data)
}
    `;
export const useApplyReportDeletionsMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    ApplyReportDeletionsMutation,
    TError,
    ApplyReportDeletionsMutationVariables,
    TContext
  >,
) =>
  useMutation<
    ApplyReportDeletionsMutation,
    TError,
    ApplyReportDeletionsMutationVariables,
    TContext
  >(
    ['ApplyReportDeletions'],
    (variables?: ApplyReportDeletionsMutationVariables) =>
      fetcher<
        ApplyReportDeletionsMutation,
        ApplyReportDeletionsMutationVariables
      >(ApplyReportDeletionsDocument, variables)(),
    options,
  );
export const UserReportsDocument = `
    query UserReports {
  userReports {
    report
    reportReadableId
    status
    category
    reportedCategoryLocale {
      id
      name
    }
    submittedAt
    submissionMode
    unreadMessagesCount
  }
}
    `;
export const useUserReportsQuery = <TData = UserReportsQuery, TError = unknown>(
  variables?: UserReportsQueryVariables,
  options?: UseQueryOptions<UserReportsQuery, TError, TData>,
) =>
  useQuery<UserReportsQuery, TError, TData>(
    variables === undefined ? ['UserReports'] : ['UserReports', variables],
    fetcher<UserReportsQuery, UserReportsQueryVariables>(
      UserReportsDocument,
      variables,
    ),
    options,
  );
export const GetReportByIdDocument = `
    query GetReportById($reportId: String!) {
  getReportById(reportId: $reportId) {
    reportReadableId
    anonymous
    category
    unreadMessagesCount
    evidence {
      events {
        id
        report
      }
      evidence {
        id
        event
        type
        timestamp
        value
      }
    }
    perpetrators {
      id
      external
      name
      dataDeletedAt
    }
    postSubmissionFiles {
      id
      size
      fileExtension
      mimeType
      createdAt
      updatedAt
      s3path
      scanStatus
    }
    relationshipType
    report
    reportedCategoryLocale {
      id
      name
    }
    source
    status
    submissionMode
    submittedAt
  }
}
    `;
export const useGetReportByIdQuery = <
  TData = GetReportByIdQuery,
  TError = unknown,
>(
  variables: GetReportByIdQueryVariables,
  options?: UseQueryOptions<GetReportByIdQuery, TError, TData>,
) =>
  useQuery<GetReportByIdQuery, TError, TData>(
    ['GetReportById', variables],
    fetcher<GetReportByIdQuery, GetReportByIdQueryVariables>(
      GetReportByIdDocument,
      variables,
    ),
    options,
  );
export const UpdateReportRelationshipToOrganisationDocument = `
    mutation UpdateReportRelationshipToOrganisation($relationshipToOrganisation: Int!, $report: String!) {
  updateReportRelationshipToOrganisation(
    relationshipToOrganisation: $relationshipToOrganisation
    report: $report
  ) {
    id
  }
}
    `;
export const useUpdateReportRelationshipToOrganisationMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateReportRelationshipToOrganisationMutation,
    TError,
    UpdateReportRelationshipToOrganisationMutationVariables,
    TContext
  >,
) =>
  useMutation<
    UpdateReportRelationshipToOrganisationMutation,
    TError,
    UpdateReportRelationshipToOrganisationMutationVariables,
    TContext
  >(
    ['UpdateReportRelationshipToOrganisation'],
    (variables?: UpdateReportRelationshipToOrganisationMutationVariables) =>
      fetcher<
        UpdateReportRelationshipToOrganisationMutation,
        UpdateReportRelationshipToOrganisationMutationVariables
      >(UpdateReportRelationshipToOrganisationDocument, variables)(),
    options,
  );
export const UpdateSubmissionDateDocument = `
    mutation UpdateSubmissionDate($submittedAt: DateTimeISO!, $report: String!) {
  updateSubmissionDate(submittedAt: $submittedAt, report: $report)
}
    `;
export const useUpdateSubmissionDateMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateSubmissionDateMutation,
    TError,
    UpdateSubmissionDateMutationVariables,
    TContext
  >,
) =>
  useMutation<
    UpdateSubmissionDateMutation,
    TError,
    UpdateSubmissionDateMutationVariables,
    TContext
  >(
    ['UpdateSubmissionDate'],
    (variables?: UpdateSubmissionDateMutationVariables) =>
      fetcher<
        UpdateSubmissionDateMutation,
        UpdateSubmissionDateMutationVariables
      >(UpdateSubmissionDateDocument, variables)(),
    options,
  );
export const ApproveRetentionRuleDocument = `
    mutation ApproveRetentionRule($id: String!) {
  approveRetentionRule(id: $id) {
    id
    status
  }
}
    `;
export const useApproveRetentionRuleMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    ApproveRetentionRuleMutation,
    TError,
    ApproveRetentionRuleMutationVariables,
    TContext
  >,
) =>
  useMutation<
    ApproveRetentionRuleMutation,
    TError,
    ApproveRetentionRuleMutationVariables,
    TContext
  >(
    ['ApproveRetentionRule'],
    (variables?: ApproveRetentionRuleMutationVariables) =>
      fetcher<
        ApproveRetentionRuleMutation,
        ApproveRetentionRuleMutationVariables
      >(ApproveRetentionRuleDocument, variables)(),
    options,
  );
export const CancelRetentionQueueItemDocument = `
    mutation CancelRetentionQueueItem($queueItemId: String!) {
  cancelRetentionQueueItem(queueItemId: $queueItemId) {
    id
    caseId
    ruleId
    dueAt
    completedAt
    retentionApproved
    status
    createdAt
    updatedAt
  }
}
    `;
export const useCancelRetentionQueueItemMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    CancelRetentionQueueItemMutation,
    TError,
    CancelRetentionQueueItemMutationVariables,
    TContext
  >,
) =>
  useMutation<
    CancelRetentionQueueItemMutation,
    TError,
    CancelRetentionQueueItemMutationVariables,
    TContext
  >(
    ['CancelRetentionQueueItem'],
    (variables?: CancelRetentionQueueItemMutationVariables) =>
      fetcher<
        CancelRetentionQueueItemMutation,
        CancelRetentionQueueItemMutationVariables
      >(CancelRetentionQueueItemDocument, variables)(),
    options,
  );
export const CreateRetentionRuleDocument = `
    mutation CreateRetentionRule($parameters: CreateRetentionRuleInput!) {
  createRetentionRule(parameters: $parameters) {
    id
    organisationId
    authorId
    country
    countryRule
    conditions
    dateReference
    ruleType
    status
    createdAt
    updatedAt
  }
}
    `;
export const useCreateRetentionRuleMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    CreateRetentionRuleMutation,
    TError,
    CreateRetentionRuleMutationVariables,
    TContext
  >,
) =>
  useMutation<
    CreateRetentionRuleMutation,
    TError,
    CreateRetentionRuleMutationVariables,
    TContext
  >(
    ['CreateRetentionRule'],
    (variables?: CreateRetentionRuleMutationVariables) =>
      fetcher<
        CreateRetentionRuleMutation,
        CreateRetentionRuleMutationVariables
      >(CreateRetentionRuleDocument, variables)(),
    options,
  );
export const DeclineRetentionRuleDocument = `
    mutation DeclineRetentionRule($input: DeclineRetentionRuleInput!) {
  declineRetentionRule(input: $input) {
    id
    status
  }
}
    `;
export const useDeclineRetentionRuleMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    DeclineRetentionRuleMutation,
    TError,
    DeclineRetentionRuleMutationVariables,
    TContext
  >,
) =>
  useMutation<
    DeclineRetentionRuleMutation,
    TError,
    DeclineRetentionRuleMutationVariables,
    TContext
  >(
    ['DeclineRetentionRule'],
    (variables?: DeclineRetentionRuleMutationVariables) =>
      fetcher<
        DeclineRetentionRuleMutation,
        DeclineRetentionRuleMutationVariables
      >(DeclineRetentionRuleDocument, variables)(),
    options,
  );
export const GetFallbackRetentionRulesDocument = `
    query GetFallbackRetentionRules {
  getFallbackRetentionRules {
    id
    authorId
    organisationId
    fallbackRule
    countryRule
    conditions
    dateReference
    ruleType
    ruleApproved
    status
    requiresManualApproval
    createdAt
    updatedAt
  }
}
    `;
export const useGetFallbackRetentionRulesQuery = <
  TData = GetFallbackRetentionRulesQuery,
  TError = unknown,
>(
  variables?: GetFallbackRetentionRulesQueryVariables,
  options?: UseQueryOptions<GetFallbackRetentionRulesQuery, TError, TData>,
) =>
  useQuery<GetFallbackRetentionRulesQuery, TError, TData>(
    variables === undefined
      ? ['GetFallbackRetentionRules']
      : ['GetFallbackRetentionRules', variables],
    fetcher<
      GetFallbackRetentionRulesQuery,
      GetFallbackRetentionRulesQueryVariables
    >(GetFallbackRetentionRulesDocument, variables),
    options,
  );
export const GetRetentionRulesDocument = `
    query GetRetentionRules {
  getRetentionRules {
    country
    rules {
      id
      authorId
      organisationId
      fallbackRule
      countryRule
      conditions
      dateReference
      ruleType
      ruleApproved
      status
      requiresManualApproval
      createdAt
      updatedAt
    }
  }
}
    `;
export const useGetRetentionRulesQuery = <
  TData = GetRetentionRulesQuery,
  TError = unknown,
>(
  variables?: GetRetentionRulesQueryVariables,
  options?: UseQueryOptions<GetRetentionRulesQuery, TError, TData>,
) =>
  useQuery<GetRetentionRulesQuery, TError, TData>(
    variables === undefined
      ? ['GetRetentionRules']
      : ['GetRetentionRules', variables],
    fetcher<GetRetentionRulesQuery, GetRetentionRulesQueryVariables>(
      GetRetentionRulesDocument,
      variables,
    ),
    options,
  );
export const GetRetentionRulesCountDocument = `
    query GetRetentionRulesCount {
  getRetentionRulesCount
}
    `;
export const useGetRetentionRulesCountQuery = <
  TData = GetRetentionRulesCountQuery,
  TError = unknown,
>(
  variables?: GetRetentionRulesCountQueryVariables,
  options?: UseQueryOptions<GetRetentionRulesCountQuery, TError, TData>,
) =>
  useQuery<GetRetentionRulesCountQuery, TError, TData>(
    variables === undefined
      ? ['GetRetentionRulesCount']
      : ['GetRetentionRulesCount', variables],
    fetcher<GetRetentionRulesCountQuery, GetRetentionRulesCountQueryVariables>(
      GetRetentionRulesCountDocument,
      variables,
    ),
    options,
  );
export const GetRulesByStatusDocument = `
    query GetRulesByStatus($status: String!) {
  getRulesByStatus(status: $status) {
    id
    organisationId
    authorId
    country
    countryRule
    conditions
    dateReference
    ruleType
    status
    createdAt
    updatedAt
  }
}
    `;
export const useGetRulesByStatusQuery = <
  TData = GetRulesByStatusQuery,
  TError = unknown,
>(
  variables: GetRulesByStatusQueryVariables,
  options?: UseQueryOptions<GetRulesByStatusQuery, TError, TData>,
) =>
  useQuery<GetRulesByStatusQuery, TError, TData>(
    ['GetRulesByStatus', variables],
    fetcher<GetRulesByStatusQuery, GetRulesByStatusQueryVariables>(
      GetRulesByStatusDocument,
      variables,
    ),
    options,
  );
export const GetUpcomingRetentionActionsDocument = `
    query GetUpcomingRetentionActions {
  getUpcomingRetentionActions {
    id
    caseId
    dueAt
    status
    retentionApproved
    RetentionRule {
      id
      country
      countryRule
      conditions
      dateReference
      ruleType
      createdAt
      updatedAt
    }
    Case {
      id
      name
      readableId
    }
  }
}
    `;
export const useGetUpcomingRetentionActionsQuery = <
  TData = GetUpcomingRetentionActionsQuery,
  TError = unknown,
>(
  variables?: GetUpcomingRetentionActionsQueryVariables,
  options?: UseQueryOptions<GetUpcomingRetentionActionsQuery, TError, TData>,
) =>
  useQuery<GetUpcomingRetentionActionsQuery, TError, TData>(
    variables === undefined
      ? ['GetUpcomingRetentionActions']
      : ['GetUpcomingRetentionActions', variables],
    fetcher<
      GetUpcomingRetentionActionsQuery,
      GetUpcomingRetentionActionsQueryVariables
    >(GetUpcomingRetentionActionsDocument, variables),
    options,
  );
export const GetUpcomingRetentionActionsCountDocument = `
    query GetUpcomingRetentionActionsCount {
  getUpcomingRetentionActionsCount
}
    `;
export const useGetUpcomingRetentionActionsCountQuery = <
  TData = GetUpcomingRetentionActionsCountQuery,
  TError = unknown,
>(
  variables?: GetUpcomingRetentionActionsCountQueryVariables,
  options?: UseQueryOptions<
    GetUpcomingRetentionActionsCountQuery,
    TError,
    TData
  >,
) =>
  useQuery<GetUpcomingRetentionActionsCountQuery, TError, TData>(
    variables === undefined
      ? ['GetUpcomingRetentionActionsCount']
      : ['GetUpcomingRetentionActionsCount', variables],
    fetcher<
      GetUpcomingRetentionActionsCountQuery,
      GetUpcomingRetentionActionsCountQueryVariables
    >(GetUpcomingRetentionActionsCountDocument, variables),
    options,
  );
export const UpdateRetentionRuleDocument = `
    mutation UpdateRetentionRule($input: UpdateRetentionRuleInput!) {
  updateRetentionRule(input: $input) {
    id
    organisationId
    authorId
    country
    countryRule
    conditions
    dateReference
    ruleType
    status
    createdAt
    updatedAt
  }
}
    `;
export const useUpdateRetentionRuleMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateRetentionRuleMutation,
    TError,
    UpdateRetentionRuleMutationVariables,
    TContext
  >,
) =>
  useMutation<
    UpdateRetentionRuleMutation,
    TError,
    UpdateRetentionRuleMutationVariables,
    TContext
  >(
    ['UpdateRetentionRule'],
    (variables?: UpdateRetentionRuleMutationVariables) =>
      fetcher<
        UpdateRetentionRuleMutation,
        UpdateRetentionRuleMutationVariables
      >(UpdateRetentionRuleDocument, variables)(),
    options,
  );
export const UserCountriesDocument = `
    query UserCountries {
  organisation {
    userCountries
  }
}
    `;
export const useUserCountriesQuery = <
  TData = UserCountriesQuery,
  TError = unknown,
>(
  variables?: UserCountriesQueryVariables,
  options?: UseQueryOptions<UserCountriesQuery, TError, TData>,
) =>
  useQuery<UserCountriesQuery, TError, TData>(
    variables === undefined ? ['UserCountries'] : ['UserCountries', variables],
    fetcher<UserCountriesQuery, UserCountriesQueryVariables>(
      UserCountriesDocument,
      variables,
    ),
    options,
  );
export const CreateRoutingRuleDocument = `
    mutation CreateRoutingRule($parameters: CreateRoutingRule!) {
  createRoutingRule(parameters: $parameters) {
    id
  }
}
    `;
export const useCreateRoutingRuleMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    CreateRoutingRuleMutation,
    TError,
    CreateRoutingRuleMutationVariables,
    TContext
  >,
) =>
  useMutation<
    CreateRoutingRuleMutation,
    TError,
    CreateRoutingRuleMutationVariables,
    TContext
  >(
    ['CreateRoutingRule'],
    (variables?: CreateRoutingRuleMutationVariables) =>
      fetcher<CreateRoutingRuleMutation, CreateRoutingRuleMutationVariables>(
        CreateRoutingRuleDocument,
        variables,
      )(),
    options,
  );
export const DeleteRoutingRuleDocument = `
    mutation DeleteRoutingRule($deleteRoutingRuleId: String!) {
  deleteRoutingRule(id: $deleteRoutingRuleId)
}
    `;
export const useDeleteRoutingRuleMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    DeleteRoutingRuleMutation,
    TError,
    DeleteRoutingRuleMutationVariables,
    TContext
  >,
) =>
  useMutation<
    DeleteRoutingRuleMutation,
    TError,
    DeleteRoutingRuleMutationVariables,
    TContext
  >(
    ['DeleteRoutingRule'],
    (variables?: DeleteRoutingRuleMutationVariables) =>
      fetcher<DeleteRoutingRuleMutation, DeleteRoutingRuleMutationVariables>(
        DeleteRoutingRuleDocument,
        variables,
      )(),
    options,
  );
export const DisableRuleMutationDocument = `
    mutation DisableRuleMutation($disableRuleId: String!) {
  disableRule(id: $disableRuleId)
}
    `;
export const useDisableRuleMutationMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    DisableRuleMutationMutation,
    TError,
    DisableRuleMutationMutationVariables,
    TContext
  >,
) =>
  useMutation<
    DisableRuleMutationMutation,
    TError,
    DisableRuleMutationMutationVariables,
    TContext
  >(
    ['DisableRuleMutation'],
    (variables?: DisableRuleMutationMutationVariables) =>
      fetcher<
        DisableRuleMutationMutation,
        DisableRuleMutationMutationVariables
      >(DisableRuleMutationDocument, variables)(),
    options,
  );
export const RoutingRulesPaginatedDocument = `
    query RoutingRulesPaginated($pagination: PaginationInputType!, $orderBy: OrderByInputType!, $isCOI: Boolean) {
  routingRulesPaginated(pagination: $pagination, orderBy: $orderBy, isCOI: $isCOI) {
    count
    items {
      author
      createdAt
      destinationGroup
      disabled
      id
      name
      organisation
      priority
      rule
      updatedAt
      groupAssignment
      isCOI
      Author {
        name
        displayName
      }
    }
  }
}
    `;
export const useRoutingRulesPaginatedQuery = <
  TData = RoutingRulesPaginatedQuery,
  TError = unknown,
>(
  variables: RoutingRulesPaginatedQueryVariables,
  options?: UseQueryOptions<RoutingRulesPaginatedQuery, TError, TData>,
) =>
  useQuery<RoutingRulesPaginatedQuery, TError, TData>(
    ['RoutingRulesPaginated', variables],
    fetcher<RoutingRulesPaginatedQuery, RoutingRulesPaginatedQueryVariables>(
      RoutingRulesPaginatedDocument,
      variables,
    ),
    options,
  );
export const UpdateRoutingRuleDocument = `
    mutation UpdateRoutingRule($parameters: UpdateRoutingRule!) {
  updateRoutingRule(parameters: $parameters)
}
    `;
export const useUpdateRoutingRuleMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateRoutingRuleMutation,
    TError,
    UpdateRoutingRuleMutationVariables,
    TContext
  >,
) =>
  useMutation<
    UpdateRoutingRuleMutation,
    TError,
    UpdateRoutingRuleMutationVariables,
    TContext
  >(
    ['UpdateRoutingRule'],
    (variables?: UpdateRoutingRuleMutationVariables) =>
      fetcher<UpdateRoutingRuleMutation, UpdateRoutingRuleMutationVariables>(
        UpdateRoutingRuleDocument,
        variables,
      )(),
    options,
  );
export const UpdateRoutingRulePrioritiesDocument = `
    mutation UpdateRoutingRulePriorities($rules: [UpdateRoutingRulePriorities!]!) {
  updateRoutingRulePriorities(rules: $rules) {
    id
    priority
  }
}
    `;
export const useUpdateRoutingRulePrioritiesMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateRoutingRulePrioritiesMutation,
    TError,
    UpdateRoutingRulePrioritiesMutationVariables,
    TContext
  >,
) =>
  useMutation<
    UpdateRoutingRulePrioritiesMutation,
    TError,
    UpdateRoutingRulePrioritiesMutationVariables,
    TContext
  >(
    ['UpdateRoutingRulePriorities'],
    (variables?: UpdateRoutingRulePrioritiesMutationVariables) =>
      fetcher<
        UpdateRoutingRulePrioritiesMutation,
        UpdateRoutingRulePrioritiesMutationVariables
      >(UpdateRoutingRulePrioritiesDocument, variables)(),
    options,
  );
export const DeleteSessionDocument = `
    mutation DeleteSession {
  deleteSession {
    d1pLogoutUrl
  }
}
    `;
export const useDeleteSessionMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    DeleteSessionMutation,
    TError,
    DeleteSessionMutationVariables,
    TContext
  >,
) =>
  useMutation<
    DeleteSessionMutation,
    TError,
    DeleteSessionMutationVariables,
    TContext
  >(
    ['DeleteSession'],
    (variables?: DeleteSessionMutationVariables) =>
      fetcher<DeleteSessionMutation, DeleteSessionMutationVariables>(
        DeleteSessionDocument,
        variables,
      )(),
    options,
  );
export const AddTagToCaseDocument = `
    mutation AddTagToCase($caseId: String!, $tagId: String!) {
  addTagToCase(caseId: $caseId, tagId: $tagId) {
    name
    id
    tagType {
      colorId
      name
    }
  }
}
    `;
export const useAddTagToCaseMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    AddTagToCaseMutation,
    TError,
    AddTagToCaseMutationVariables,
    TContext
  >,
) =>
  useMutation<
    AddTagToCaseMutation,
    TError,
    AddTagToCaseMutationVariables,
    TContext
  >(
    ['AddTagToCase'],
    (variables?: AddTagToCaseMutationVariables) =>
      fetcher<AddTagToCaseMutation, AddTagToCaseMutationVariables>(
        AddTagToCaseDocument,
        variables,
      )(),
    options,
  );
export const CreateTagDocument = `
    mutation CreateTag($parameters: CreateTagType!) {
  createTag(parameters: $parameters) {
    id
    name
  }
}
    `;
export const useCreateTagMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    CreateTagMutation,
    TError,
    CreateTagMutationVariables,
    TContext
  >,
) =>
  useMutation<CreateTagMutation, TError, CreateTagMutationVariables, TContext>(
    ['CreateTag'],
    (variables?: CreateTagMutationVariables) =>
      fetcher<CreateTagMutation, CreateTagMutationVariables>(
        CreateTagDocument,
        variables,
      )(),
    options,
  );
export const DeleteAllTagsDocument = `
    mutation DeleteAllTags($tagType: String!) {
  deleteAllTags(tagType: $tagType)
}
    `;
export const useDeleteAllTagsMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    DeleteAllTagsMutation,
    TError,
    DeleteAllTagsMutationVariables,
    TContext
  >,
) =>
  useMutation<
    DeleteAllTagsMutation,
    TError,
    DeleteAllTagsMutationVariables,
    TContext
  >(
    ['DeleteAllTags'],
    (variables?: DeleteAllTagsMutationVariables) =>
      fetcher<DeleteAllTagsMutation, DeleteAllTagsMutationVariables>(
        DeleteAllTagsDocument,
        variables,
      )(),
    options,
  );
export const DeleteTagDocument = `
    mutation DeleteTag($tagId: String!) {
  deleteTag(tagId: $tagId)
}
    `;
export const useDeleteTagMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    DeleteTagMutation,
    TError,
    DeleteTagMutationVariables,
    TContext
  >,
) =>
  useMutation<DeleteTagMutation, TError, DeleteTagMutationVariables, TContext>(
    ['DeleteTag'],
    (variables?: DeleteTagMutationVariables) =>
      fetcher<DeleteTagMutation, DeleteTagMutationVariables>(
        DeleteTagDocument,
        variables,
      )(),
    options,
  );
export const GetOrganisationTagsDocument = `
    query GetOrganisationTags {
  getOrganisationTags {
    id
    name
    tagType {
      id
      status
      colorId
      name
    }
  }
}
    `;
export const useGetOrganisationTagsQuery = <
  TData = GetOrganisationTagsQuery,
  TError = unknown,
>(
  variables?: GetOrganisationTagsQueryVariables,
  options?: UseQueryOptions<GetOrganisationTagsQuery, TError, TData>,
) =>
  useQuery<GetOrganisationTagsQuery, TError, TData>(
    variables === undefined
      ? ['GetOrganisationTags']
      : ['GetOrganisationTags', variables],
    fetcher<GetOrganisationTagsQuery, GetOrganisationTagsQueryVariables>(
      GetOrganisationTagsDocument,
      variables,
    ),
    options,
  );
export const RemoveTagFromCaseDocument = `
    mutation RemoveTagFromCase($caseId: String!, $tagId: String!) {
  removeTagFromCase(caseId: $caseId, tagId: $tagId) {
    name
    id
    tagType {
      colorId
      name
    }
  }
}
    `;
export const useRemoveTagFromCaseMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    RemoveTagFromCaseMutation,
    TError,
    RemoveTagFromCaseMutationVariables,
    TContext
  >,
) =>
  useMutation<
    RemoveTagFromCaseMutation,
    TError,
    RemoveTagFromCaseMutationVariables,
    TContext
  >(
    ['RemoveTagFromCase'],
    (variables?: RemoveTagFromCaseMutationVariables) =>
      fetcher<RemoveTagFromCaseMutation, RemoveTagFromCaseMutationVariables>(
        RemoveTagFromCaseDocument,
        variables,
      )(),
    options,
  );
export const UpdateTagDocument = `
    mutation UpdateTag($parameters: UpdateTagType!) {
  updateTag(parameters: $parameters)
}
    `;
export const useUpdateTagMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    UpdateTagMutation,
    TError,
    UpdateTagMutationVariables,
    TContext
  >,
) =>
  useMutation<UpdateTagMutation, TError, UpdateTagMutationVariables, TContext>(
    ['UpdateTag'],
    (variables?: UpdateTagMutationVariables) =>
      fetcher<UpdateTagMutation, UpdateTagMutationVariables>(
        UpdateTagDocument,
        variables,
      )(),
    options,
  );
export const UpdateTagOrdersDocument = `
    mutation UpdateTagOrders($tags: [UpdateTagOrdersType!]!, $draggedTagId: String!) {
  updateTagOrders(tags: $tags, draggedTagId: $draggedTagId) {
    tagId
    order
  }
}
    `;
export const useUpdateTagOrdersMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateTagOrdersMutation,
    TError,
    UpdateTagOrdersMutationVariables,
    TContext
  >,
) =>
  useMutation<
    UpdateTagOrdersMutation,
    TError,
    UpdateTagOrdersMutationVariables,
    TContext
  >(
    ['UpdateTagOrders'],
    (variables?: UpdateTagOrdersMutationVariables) =>
      fetcher<UpdateTagOrdersMutation, UpdateTagOrdersMutationVariables>(
        UpdateTagOrdersDocument,
        variables,
      )(),
    options,
  );
export const GetOrganisationTagTypesDocument = `
    query getOrganisationTagTypes {
  getOrganisationTagTypes {
    id
    name
    colorId
    order
    status
    Author {
      displayName
      name
    }
    statusUpdatedAt
    Tags {
      id
      name
      order
      status
    }
    createdAt
  }
}
    `;
export const useGetOrganisationTagTypesQuery = <
  TData = GetOrganisationTagTypesQuery,
  TError = unknown,
>(
  variables?: GetOrganisationTagTypesQueryVariables,
  options?: UseQueryOptions<GetOrganisationTagTypesQuery, TError, TData>,
) =>
  useQuery<GetOrganisationTagTypesQuery, TError, TData>(
    variables === undefined
      ? ['getOrganisationTagTypes']
      : ['getOrganisationTagTypes', variables],
    fetcher<
      GetOrganisationTagTypesQuery,
      GetOrganisationTagTypesQueryVariables
    >(GetOrganisationTagTypesDocument, variables),
    options,
  );
export const UpdateTagTypeOrdersDocument = `
    mutation UpdateTagTypeOrders($tagTypes: [UpdateTagTypeOrdersType!]!, $draggedTagTypeId: String!) {
  updateTagTypeOrders(tagTypes: $tagTypes, draggedTagTypeId: $draggedTagTypeId) {
    id
    order
  }
}
    `;
export const useUpdateTagTypeOrdersMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateTagTypeOrdersMutation,
    TError,
    UpdateTagTypeOrdersMutationVariables,
    TContext
  >,
) =>
  useMutation<
    UpdateTagTypeOrdersMutation,
    TError,
    UpdateTagTypeOrdersMutationVariables,
    TContext
  >(
    ['UpdateTagTypeOrders'],
    (variables?: UpdateTagTypeOrdersMutationVariables) =>
      fetcher<
        UpdateTagTypeOrdersMutation,
        UpdateTagTypeOrdersMutationVariables
      >(UpdateTagTypeOrdersDocument, variables)(),
    options,
  );
export const UpdateTagTypeStatusDocument = `
    mutation UpdateTagTypeStatus($parameters: UpdateTagTypeStatusType!) {
  updateTagTypeStatus(parameters: $parameters)
}
    `;
export const useUpdateTagTypeStatusMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateTagTypeStatusMutation,
    TError,
    UpdateTagTypeStatusMutationVariables,
    TContext
  >,
) =>
  useMutation<
    UpdateTagTypeStatusMutation,
    TError,
    UpdateTagTypeStatusMutationVariables,
    TContext
  >(
    ['UpdateTagTypeStatus'],
    (variables?: UpdateTagTypeStatusMutationVariables) =>
      fetcher<
        UpdateTagTypeStatusMutation,
        UpdateTagTypeStatusMutationVariables
      >(UpdateTagTypeStatusDocument, variables)(),
    options,
  );
export const AddUploadsToReportDocument = `
    mutation AddUploadsToReport($uploadSource: UploadSource!, $uploads: [UploadInput!]!, $report: String!) {
  addUploadsToReport(
    uploadSource: $uploadSource
    uploads: $uploads
    report: $report
  ) {
    fileExtension
    s3path
    scanStatus
    size
    createdAt
  }
}
    `;
export const useAddUploadsToReportMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    AddUploadsToReportMutation,
    TError,
    AddUploadsToReportMutationVariables,
    TContext
  >,
) =>
  useMutation<
    AddUploadsToReportMutation,
    TError,
    AddUploadsToReportMutationVariables,
    TContext
  >(
    ['AddUploadsToReport'],
    (variables?: AddUploadsToReportMutationVariables) =>
      fetcher<AddUploadsToReportMutation, AddUploadsToReportMutationVariables>(
        AddUploadsToReportDocument,
        variables,
      )(),
    options,
  );
export const BulkReinviteDocument = `
    mutation BulkReinvite($usersToDeactivate: [BulkReinviteUpdateUser!]!, $usersToReinvite: [BulkReinviteUpdateUser!]!, $usersToCreate: [BulkReinviteCreateUser!]!, $usersToUpdate: [BulkReinviteUpdateUser!]!) {
  bulkReinvite(
    usersToDeactivate: $usersToDeactivate
    usersToReinvite: $usersToReinvite
    usersToCreate: $usersToCreate
    usersToUpdate: $usersToUpdate
  ) {
    createdUsers {
      eid
      email
    }
    deactivatedUsers {
      eid
      email
    }
    reinvitedUsers {
      eid
      email
    }
    updatedUsers {
      eid
      email
    }
  }
}
    `;
export const useBulkReinviteMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    BulkReinviteMutation,
    TError,
    BulkReinviteMutationVariables,
    TContext
  >,
) =>
  useMutation<
    BulkReinviteMutation,
    TError,
    BulkReinviteMutationVariables,
    TContext
  >(
    ['BulkReinvite'],
    (variables?: BulkReinviteMutationVariables) =>
      fetcher<BulkReinviteMutation, BulkReinviteMutationVariables>(
        BulkReinviteDocument,
        variables,
      )(),
    options,
  );
export const PutUserDocument = `
    mutation PutUser($userData: PutUserType!, $putUserId: Int) {
  putUser(userData: $userData, id: $putUserId) {
    id
  }
}
    `;
export const usePutUserMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    PutUserMutation,
    TError,
    PutUserMutationVariables,
    TContext
  >,
) =>
  useMutation<PutUserMutation, TError, PutUserMutationVariables, TContext>(
    ['PutUser'],
    (variables?: PutUserMutationVariables) =>
      fetcher<PutUserMutation, PutUserMutationVariables>(
        PutUserDocument,
        variables,
      )(),
    options,
  );
export const UpdateContactEmailDocument = `
    mutation UpdateContactEmail($contactEmail: String!, $userId: Int, $reportId: String) {
  updateContactEmail(
    id: $userId
    contactEmail: $contactEmail
    reportId: $reportId
  )
}
    `;
export const useUpdateContactEmailMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateContactEmailMutation,
    TError,
    UpdateContactEmailMutationVariables,
    TContext
  >,
) =>
  useMutation<
    UpdateContactEmailMutation,
    TError,
    UpdateContactEmailMutationVariables,
    TContext
  >(
    ['UpdateContactEmail'],
    (variables?: UpdateContactEmailMutationVariables) =>
      fetcher<UpdateContactEmailMutation, UpdateContactEmailMutationVariables>(
        UpdateContactEmailDocument,
        variables,
      )(),
    options,
  );
export const UsersPaginatedDocument = `
    query UsersPaginated($orderBy: OrderByInputType!, $pagination: PaginationInputType!) {
  usersPaginated(orderBy: $orderBy, pagination: $pagination) {
    items {
      id
      eid
      email
      name
      role
      site
      status
      available
      translationEnabled
      permissions
      department
      tags
      expiresAt
      country
      displayName
      source
      externalId
      givenName
      familyName
      organisation
      Accounts {
        id
        kind
        username
        user
      }
    }
    count
  }
}
    `;
export const useUsersPaginatedQuery = <
  TData = UsersPaginatedQuery,
  TError = unknown,
>(
  variables: UsersPaginatedQueryVariables,
  options?: UseQueryOptions<UsersPaginatedQuery, TError, TData>,
) =>
  useQuery<UsersPaginatedQuery, TError, TData>(
    ['UsersPaginated', variables],
    fetcher<UsersPaginatedQuery, UsersPaginatedQueryVariables>(
      UsersPaginatedDocument,
      variables,
    ),
    options,
  );
export const SearchUsersPaginatedDocument = `
    query SearchUsersPaginated($orderBy: OrderByInputType!, $pagination: PaginationInputType!, $searchBy: [SearchByInputType!]!, $fuzzy: FuzzySearchInputType) {
  searchUsersPaginated(
    orderBy: $orderBy
    pagination: $pagination
    searchBy: $searchBy
    fuzzy: $fuzzy
  ) {
    items {
      id
      eid
      email
      name
      role
      site
      available
      translationEnabled
      permissions
      department
      tags
      expiresAt
      country
      displayName
      source
      externalId
      givenName
      familyName
      organisation
      status
      uuid
      Accounts {
        id
        kind
        username
        user
        Roles {
          name
          SystemPermissions {
            permission
          }
        }
      }
      SystemRoles {
        id
        name
        label
      }
    }
    count
  }
}
    `;
export const useSearchUsersPaginatedQuery = <
  TData = SearchUsersPaginatedQuery,
  TError = unknown,
>(
  variables: SearchUsersPaginatedQueryVariables,
  options?: UseQueryOptions<SearchUsersPaginatedQuery, TError, TData>,
) =>
  useQuery<SearchUsersPaginatedQuery, TError, TData>(
    ['SearchUsersPaginated', variables],
    fetcher<SearchUsersPaginatedQuery, SearchUsersPaginatedQueryVariables>(
      SearchUsersPaginatedDocument,
      variables,
    ),
    options,
  );
export const MeDocument = `
    query Me {
  me {
    id
    eid
    email
    name
    role
    site
    available
    translationEnabled
    permissions
    department
    tags
    contactEmail
    expiresAt
    country
    displayName
    source
    externalId
    status
    organisation
    uuid
    Organisation {
      id
      expiryPeriod
      name
    }
    accounts {
      id
      Roles {
        name
        SystemPermissions {
          permission
        }
      }
      kind
    }
  }
}
    `;
export const useMeQuery = <TData = MeQuery, TError = unknown>(
  variables?: MeQueryVariables,
  options?: UseQueryOptions<MeQuery, TError, TData>,
) =>
  useQuery<MeQuery, TError, TData>(
    variables === undefined ? ['Me'] : ['Me', variables],
    fetcher<MeQuery, MeQueryVariables>(MeDocument, variables),
    options,
  );
export const UpdateReporterUserSettingsDocument = `
    mutation UpdateReporterUserSettings($patchData: ReporterUserSettingsType!) {
  updateReporterUserSettings(patchData: $patchData) {
    id
  }
}
    `;
export const useUpdateReporterUserSettingsMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    UpdateReporterUserSettingsMutation,
    TError,
    UpdateReporterUserSettingsMutationVariables,
    TContext
  >,
) =>
  useMutation<
    UpdateReporterUserSettingsMutation,
    TError,
    UpdateReporterUserSettingsMutationVariables,
    TContext
  >(
    ['UpdateReporterUserSettings'],
    (variables?: UpdateReporterUserSettingsMutationVariables) =>
      fetcher<
        UpdateReporterUserSettingsMutation,
        UpdateReporterUserSettingsMutationVariables
      >(UpdateReporterUserSettingsDocument, variables)(),
    options,
  );
export const GetOrganisationMetaDataDocument = `
    query GetOrganisationMetaData {
  getOrganisationMetaData {
    userType
    organization
    division
  }
}
    `;
export const useGetOrganisationMetaDataQuery = <
  TData = GetOrganisationMetaDataQuery,
  TError = unknown,
>(
  variables?: GetOrganisationMetaDataQueryVariables,
  options?: UseQueryOptions<GetOrganisationMetaDataQuery, TError, TData>,
) =>
  useQuery<GetOrganisationMetaDataQuery, TError, TData>(
    variables === undefined
      ? ['GetOrganisationMetaData']
      : ['GetOrganisationMetaData', variables],
    fetcher<
      GetOrganisationMetaDataQuery,
      GetOrganisationMetaDataQueryVariables
    >(GetOrganisationMetaDataDocument, variables),
    options,
  );
export const ValidateUsersCsvUploadDocument = `
    mutation ValidateUsersCsvUpload($sheetId: Int!, $embedId: Int!, $newUsers: [BulkReinviteCreateUser!]!) {
  validateUsersCsvUpload(
    sheetId: $sheetId
    embedId: $embedId
    newUsers: $newUsers
  ) {
    totalUsersInCSV
    usersToCreate {
      country
      department
      eid
      email
      name
      role
      site
      terminationDate
    }
    usersToDeactivate {
      country
      department
      eid
      email
      name
      id
      role
      site
      terminationDate
    }
    usersToReinvite {
      country
      department
      eid
      email
      id
      name
      role
      site
      terminationDate
    }
    usersToUpdate {
      country
      eid
      department
      email
      id
      name
      role
      site
      terminationDate
    }
  }
}
    `;
export const useValidateUsersCsvUploadMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    ValidateUsersCsvUploadMutation,
    TError,
    ValidateUsersCsvUploadMutationVariables,
    TContext
  >,
) =>
  useMutation<
    ValidateUsersCsvUploadMutation,
    TError,
    ValidateUsersCsvUploadMutationVariables,
    TContext
  >(
    ['ValidateUsersCsvUpload'],
    (variables?: ValidateUsersCsvUploadMutationVariables) =>
      fetcher<
        ValidateUsersCsvUploadMutation,
        ValidateUsersCsvUploadMutationVariables
      >(ValidateUsersCsvUploadDocument, variables)(),
    options,
  );
export const ValidateCasesCsvUploadDocument = `
    mutation ValidateCasesCsvUpload($sheetId: Int!, $embedId: Int!, $newCases: [BulkImportCases!], $newCasesDynamic: [BulkImportCasesDynamic!], $importFileName: String!, $columnMapping: [ColumnMappingInput!]!, $dynamicCategory: String, $dynamicFormId: String) {
  validateCasesCsvUpload(
    sheetId: $sheetId
    embedId: $embedId
    newCases: $newCases
    newCasesDynamic: $newCasesDynamic
    importFileName: $importFileName
    columnMapping: $columnMapping
    dynamicCategory: $dynamicCategory
    dynamicFormId: $dynamicFormId
  ) {
    totalCasesInCSV
    importFileName
    casesToCreate {
      caseName
      caseImportedId
      caseCreatedDate
      caseReadDate
      caseSubmissionDate
      caseInvestigatingDate
      caseClosedDate
      caseLeadName
      caseLeadUserId
      caseCategories
      caseStatus
      substantiationStatus
      originalIntakeMethod
      isAnonymous
      reporterName
      reporterEmail
      reporterEid
      reporterUserId
      namedOffenderExternalUsers
      namedOffenderInternalUsers
      eventDate
      eventTime
      eventLocation
      eventDescription
      eventWitnesses
      eventEmotions
      countryName
      countryCode
      regionName
      regionId
      caseSummary
      dynamicFields
    }
    duplicateCases {
      id
      name
      importedId
      status
      CaseAttribute {
        createdAt
        readAt
        investigatingAt
        closedAt
      }
    }
  }
}
    `;
export const useValidateCasesCsvUploadMutation = <
  TError = unknown,
  TContext = unknown,
>(
  options?: UseMutationOptions<
    ValidateCasesCsvUploadMutation,
    TError,
    ValidateCasesCsvUploadMutationVariables,
    TContext
  >,
) =>
  useMutation<
    ValidateCasesCsvUploadMutation,
    TError,
    ValidateCasesCsvUploadMutationVariables,
    TContext
  >(
    ['ValidateCasesCsvUpload'],
    (variables?: ValidateCasesCsvUploadMutationVariables) =>
      fetcher<
        ValidateCasesCsvUploadMutation,
        ValidateCasesCsvUploadMutationVariables
      >(ValidateCasesCsvUploadDocument, variables)(),
    options,
  );
